import {
  GetIpCurrent,
  addAtendimento,
  addMessage,
  addMessageNew,
  removeConversation,
  InsertAnswerACK,
  InsertPausaRV,
  InsertPausaDB,
  ShowVisibleNextAtd,
  refreshUsersAgents,
  GetTimeAtd,
  InterationNotifier,
  clearReturnClient,
  createStatusAgent,
  addListCallQueue,
  editListCallQueue,
  deleteListCallQueue,
  returnListCallQueue,
  returnListCallQueueObs,
  refreshReturnClient,
  GetAnotations,
  GetMarkstar,
  GetHistory,
  createQueuePermission,
  typingadd,
  typingedit,
  editAtendimentoClient,
  MsgIdReturn,
  addAtdSimult,
  RemoveAtd,
  removeAtdUnique,
  GetServiceGroup,
  RemoveCallQueueReturn,
  addChat,
  addChatSimult,
  editAtendimento,
  editAtdSimult,
  InsertUserServiceLogin,
  MsgIdReturn2,
  UpdateByeAttendant,
  incrementInfoUsers,
  InsertRegisterNotifier,
  capturaFila,
  GetFileShared,
  ConnectionsAPI,
  addMonitoring,
  clientusermonitorsin,
  removeUserMonitoring,
  ByeClientMonitoring,
  EditCursoUserMonitoringSimult,
  EditCursoUserMonitoring,
  editAtendimentoVoz,
  editmultiplesatdVoz,
  editQtdMsg,
  RefreshStatusQueue,
  ActionRefreshNoAnswer,
  UpdateByeAttendantCdr,
  UpdateByeAttendantRecuperation,
  endCall,
  editChatInternal,
  editChat,
  CallButtonAccept,
  CallButtonReject,
  CallButtonMute,
  ShowInfoDisplay,
  ChangeStatusCallback,
  RefreshQueueid,
  ListCallQueue,
  GetInsertCallHistory,
  BlockScreen,
  EditBlockUser,
  EnableCall,
  EditInfoCli,
  AddConferenceExt,
  editChatInternalLine,
  endCallLine,
  editChatLine,
  listDevice,
  listDeviceDefault,
  EditSuperInfo,
  EditAcwContact,
  EditIndicatorsUser,
  handleConfirmEnableNc2Redux,
  nc2ScheduleNumbersUser,
  nc2ScheduleReasonsUser,
  gerarProtocolosaida,
  UpdateChamadasRecuperadas,
  UpdateUserLoginResponse,
  getDataTachado,
  changeProtocol,
  setLoginNc2,
  changeNumberDisponiblesChannel,
  changeServiceAtd,
  changeBlockStatus,
  InteracoesContactNumberPeer,
  UpdateRgBlockReturn,
  changePermissionsBlock,
  getDataTachadowebrtc,
  InsertUserLogin,
  UpdateIdleUser,
  addInteractionIngDesk,
  removeInteractionIngDesk,
  refreshUsersAgentsJsonV2,
  UpdateByeAttendantNew,
  GetServiceGroupJson,
  handleDataCsatNPS,
  handleDataStatusOperators,
  handleDataIntentions,
  changeLoginComplete,
  handleDataPerfomance,
  handleDataPerfomanceCompare,
  tratarAfterCallWork,
  UpdatePauseFutureRV,
  getDeviceMicrofone,
  getDeviceAudio,
  getDeviceRing,
  changeAtdIngDeskSuccess,
  isSaveInteractionIngDesk,
  changeAtdIngDesk,
  BlockFuture,
  EditFutureBreak,
  getPesquisaSatisfacao,
  addChatSimultAtd,
  clearQtdMsg,
  AddMessageMail,
  EditSubjectMail,
  AddAttachmentsMail,
  addAnswerHidden,
  changeGroupsRow,
  InsertActivityCDR,
  EditAcwContactDisabled,
  EditIsTabulatorToClassification,
  LogoutInGestor,
  tratarAfterCallWorkCDR,
  tratarAfterCallWorkTransfer,
  DeleteMsgId,
  InsertPausaQAT,
  CallParkCapture,
  InsertPausaRVATD,
  removeContactIdsToQuarentine,
  addListQuarentineCallQueue,
  CloseAttendant,
  UpdateByeAttendantQuarentine,
  removeItemFromListQuarentineCallQueue,
  addCcontactIdsToQuarentine,
  addOneMoreUnreadedMessage,
  ClearAtdSimult,
  ClearAtd,
  ClearQuarentine,
  setIsReconnectModalActive,
  getNumberOfUnreadedMessages,
  changeNumberOfUnreadedMessagesOfAnItem,
  ClearMessageALL,
  editQtdMsgMonitoring,
  editTotalQtdMsgMonitoring,
  clearQtdMsgMonitoring,
  editIsFromStandbyMonitoring,
  addEnterpriseAdditionalInfos,
  addContactAdditionalInfos,
  AddMessagesInBatch,
  AddMessagesInBatchReverseMode,
  ChangeLastCdrClicked,
  registerInteractionOnIngDesk,
  habilitarBotaoAtenderStandby,
  InsertPausaRVV2,
  removeItemFromListQuarentineCallQueueWithCdr,
  changeResponsavelPor,
  editChannelsDetailsAtd,
} from ".";

import Moment from "moment";
import axios from "axios";
import { webphone_api } from "../actions/webphone_api";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import React from "react";
import ReconnectingWebSocket from "reconnecting-websocket";
import DeleteCallModal from "../modals/DeleteCallModal";
import MicroModal from "micromodal";
import { nc2Service } from "./nc2service";
import interactioningdesk from "../reducers/interactioningdesk";
import LOGOINGWEB from "../build/images/logo_ingweb_notify.svg";
import mountCallsStatus from "./mountCallsStatus";
import UserPhoto from "../components/UserPhoto/userphoto";
import { ReactComponent as IconClose } from "../build/images/closecircle22px.svg";
import { ReactComponent as IconRecuseCall } from "../build/images/infouser-icons/call.svg";
import { ReactComponent as IconMute } from "../build/images/infouser-icons/volume-slash.svg";
import { ReactComponent as IconAnswerCall } from "../build/images/attendanceIcons/call-calling.svg";
import { RequisitionError } from "../utils/requisitionError";
import { formatMimeType56 } from "../utils/formatMimetype56";
import { reqServiceSingleton } from "../utils/reqServices";
import { voiceService } from "../utils/voiceService";
import { reconnectionHandler } from "../utils/reconnectionHandler";
import { tabulationHandler } from "../utils/tabulationHandler";
import { noReadHandler } from "../utils/noReadHandler";
import { pinHandler } from "../utils/pinHandler";
import { verifyIfIsAfterStatusPause } from "../utils/statusUtils";
import { formatTextAndUnicode } from "../utils/formatTextAndUnicode";

//require('log-timestamp');
//var Mutex = require('async-mutex').Mutex;

//const mutex = new Mutex();
const { connection_platform } = require("../services/api");
const mkdirp = require("mkdirp");
const { meses, log_full_ingenium, voz } = require("../services/data");

const h2p = require("html2plaintext");

const iplocal = connection_platform.ip_intern;
//const portims = connection_platform.port_socket_intern;

var port = localStorage.getItem("port");
var ipcurrent = "";
var qtde_fila = "";
var filaPermissao = "";
var callhistory = [];
var touser = "";
var queueidfila = 0;
var customerwait = 0;
var ramaluser = "";
var gethostname = window.location.hostname;
var pathname = localStorage.getItem("pathname");
var socket = null;
var perfilUser = "";
var acessoFila = "";
var stringGrupoFila = "";
var stringSubMonitoria = "";
var cdrparkid;
var durationans = 0;
var durationoutans = 0;
var ramalMonitoring = 0;
// var checkVersion = false;
var versaoInstalada = "";
var checkStatus = false;
var checkAudio = true;
var checkphone = true;
var EXTERNCODE = "{EXTERNCODE}";
var arrayinfoTo = [];
var checkNc2 = false;
var ramaldisconnect = [];
var checkCapturaFila = [];
var atendimentoOnCdr = [];
var dateOnCdr = [];
var checkcdracw = [];
var randomAtd = [];
var statusIntervalAgent = "";
var requestStatusAgent = "";
var isLogged = false;
var checkSkill = true;
var checkLoginInitial = true;
var checkAnswerInitial = 0;
var checkPlayIn = true;
var verificationMidiaVoz = false;
//var checkInsertFutPause = false;
var countFuturePause = 0;
var descfuturepause = "";
var statusAgentIMSDN = "";
var stAgIMSDN = "";
var qtdeMsgCDR = 0;
var concatenatedInfo = [];
var checkUserStatusEnd = false;
var checkRegisterInitial = false;
let heartbeatInterval = null;
let isWhatsVoz = false;
//var checktesteAllan = 1;

// if(gethostname === 'localhost' ||connection_platform.ip_intern ===gethostname)
// 	pathname = iplocal;
// else
//   pathname = gethostname;

// if(connection_platform.client_differentip === true)
//   pathname = connection_platform.ip_extern;

// if (window.location.hostname === 'localhost' || window.location.hostname === iplocal){
// 	ipcurrent = iplocal;
// }else{
// 	ipcurrent = connection_platform.ip_extern+':'+connection_platform.port_apache_view_extern;
// 	port = connection_platform.port_backend_extern;
// }

export const getCallFromQuarentineV2 = (contactId, infoUsers, call) => {
  return (dispatch, getState) => {
    let username = infoUsers.username;
    const userid = infoUsers.id;
    const isJson = (item) => {
      item = typeof item != "string" ? JSON.stringify(item) : item;

      try {
        item = JSON.parse(item);
      } catch (e) {
        return false;
      }

      if (typeof item === "object" && item != null) {
        return true;
      }

      return false;
    };
    const tel = contactId.telefone.includes("TELEFONE: ")
      ? contactId.telefone
      : "TELEFONE: " + contactId.telefone;

    const novadata = [
      "ANSWEBCHAT",
      contactId.serverid,
      "USERNAME",
      "IMS-Chat",
      "CONTACTID",
      contactId.idatendimento,
      "TO",
      infoUsers.id,
      "SRV",
      undefined,
      "SRVIN",
      contactId.subservico,
      "MEDIAID",
      contactId.idmidia,
      "DIRECTION",
      contactId.direction,
      "CONTACTNAME",
      tel + "~¿",
      "DATA",
      contactId.menubot,
      "SRVINNAME",
      contactId.servico,
      "DATETIME",
      contactId.datatimeatd,
      "REATD",
      contactId.recuperation,
      "ATDID",
      contactId.serviceatd,
      "FROMPEER",
      "0",
      "PEERNAME",
      "",
      "ATDTIME",
      call.dateTime,
      "PROFILEPHOTO",
      contactId.pathfile,
      "JSON",
      "",
      "",
      "",
      "",
      "",
    ];

    const { informationusers, status, ipcurrent } = getState();
    let criticidade = "Insucesso: Desistência!";

    let telefone = novadata[17].split("~¿");
    let cliente = novadata[19].split("~¿");
    var servico = "";
    // var servico = novadata[21].split(":");

    if (novadata[21].includes(":")) {
      servico = novadata[21].split(":")[1];
    } else {
      servico = novadata[21];
    }
    cliente = cliente[0].split(": ");
    let telefonefilt = telefone[0].split(": ");
    let MenuBot = [];
    let mtnow = "newatd";
    let numprotocolo = "";
    let score_class2 = contactId.classScore ? contactId.classScore : "";
    let score_value2 = contactId.score ? contactId.score : "";
    let nps_call = false;

    let actualUrl = `${connection_platform.type_connect}://${pathname}:${port}/conn/getmidiasnumber?number=${telefonefilt[1]}`;
    actualUrl = `${connection_platform.type_connect}://${pathname}:${port}/conn/getmidiasnumberv2?number=${telefonefilt[1]}`;
    
     setTimeout(function () {
      axios.get(actualUrl).then((response) => {
        if (response.data !== "") {
            dispatch(changeNumberDisponiblesChannel(novadata[5], response.data));
        }
      });
     }, 5000);

    if (cliente[0] === "Nome") {
      cliente = cliente[1];
    } else {
      cliente = telefonefilt[1];
    }

    if (novadata[19]) {
      MenuBot = novadata[19];
      MenuBot = MenuBot.split("~¿");
      if (MenuBot.length != 0) {
        MenuBot.forEach((obj) => {
          var value = obj.split(":");
          if (
            value[0] === "Nome na Agenda" &&
            Array.isArray(value) &&
            value.length >= 2
          ) {
            cliente = value[1];
          }
          if (
            value[0] === "DisplayName" &&
            Array.isArray(value) &&
            value.length >= 2
          ) {
            cliente = value[1];
          }
        });
      }
    }

    // cliente = contactId.cliente ? contactId.cliente : cliente;
    // console.log("raimundo_neto_getCallFromQuarentine", { cliente });

    let chamado = "";
    let chamador = "";

    if (novadata[15] === "2" || novadata[15] === 2) {
      chamado = telefonefilt[1];
      chamador = ramaluser;
      username = chamado.replace(/\D+/g, "");
    } else {
      chamado = novadata[21];
      chamador = telefone[0];
      username = chamador.replace(/\D+/g, "");
    }

    let valorDiferencaZap = parseInt(Math.abs(Math.round(ipcurrent.difftime)));

    let timecomplete = Moment().format("YYYY/MM/DD HH:mm:ss");

    if (parseInt(ipcurrent.difftime) < 0) {
      timecomplete = Moment()
        .subtract(valorDiferencaZap, "seconds")
        .format("YYYY/MM/DD HH:mm:ss");
    } else {
      timecomplete = Moment()
        .add(valorDiferencaZap, "seconds")
        .format("YYYY/MM/DD HH:mm:ss");
    }
    let statusagent = status.reason;

    callhistory[novadata[5].toString()] = [
      novadata[5].toString(),
      novadata[7],
      novadata[23],
      chamador,
      chamado,
      true,
      "",
      timecomplete,
      "Desconectado por origem",
      "",
      statusagent,
      0,
      "",
      "",
      novadata[15],
      novadata[13],
    ];
    const sendMessagesWhenGetCallFromQuarentine = () => {
      let dia = Moment().format("DD");
      let mes = Moment().format("MM");
      let ano = Moment().format("YYYY");
      console.log("INGENIUM_SUPERVISOR : ", informationusers);

      let direction = `${connection_platform.type_connect}://${pathname}:${port}/conn/carregamento-new?cdr=${novadata[5]}&idgroup=${informationusers.idgroup}&supervisor=${informationusers.supervisor}`;
      let timehistory = novadata[23];
      timehistory = Moment(timehistory, "DD/MM/YYYY HH:mm:ss").format(
        "YYYY-MM-DD HH:mm:ss",
      );

      let isLoadingMessage = true;

      if (isLoadingMessage) {
        axios
          .get(direction)
          .then((response) => {
            let resposta = response.data;

            qtdeMsgCDR = 0;

            resposta.forEach(function (obj, index) {
              if (obj.mimetypeid === 56) {
                obj.messagem = formatMimeType56(obj, "");
                obj.mimetypeid = 1;
              }
              const { messages } = getState();
              const hasMessages = !!messages;
              const cdr = novadata[5];
              const hasThisAtt =
                hasMessages &&
                typeof messages === "object" &&
                (cdr in messages || parseInt(cdr) in messages);
              if (hasThisAtt) {
                let messagesOfThisatt = messages[cdr];
                const hasMessagesOfThisatt =
                  !!messagesOfThisatt && Array.isArray(messagesOfThisatt);
                if (!hasMessagesOfThisatt) {
                  messagesOfThisatt = messages[parseInt(cdr)];
                }
                const verifyIfHasMessages =
                  !!messagesOfThisatt &&
                  Array.isArray(messagesOfThisatt) &&
                  messagesOfThisatt.length > 0;
                if (verifyIfHasMessages) {
                  const hasThisMessageInMessages = !!messagesOfThisatt.find(
                    (messageInfos) => {
                      return (
                        parseInt(obj.id) === parseInt(messageInfos.messageid)
                      );
                    },
                  );
                  if (hasThisMessageInMessages) {
                    dispatch(DeleteMsgId(parseInt(obj.id), parseInt(cdr)));
                  }
                }
              }
              dia = obj.diaenvio;
              mes = obj.mesenvio;
              mes = meses.indexOf(mes);
              dia = dia + " de " + meses[mes - 1];
              if (ano < obj.anoenvio || ano > obj.anoenvio)
                dia = dia + " de " + obj.anoenvio;

              let statusmsg = "enviado";
              if (
                obj.dateerror !== null &&
                connection_platform.isStatusOfErrorInSendMessage
              )
                statusmsg = "error";
              else if (obj.dateread !== null) statusmsg = "visto";
              else if (
                obj.datedelivered !== null ||
                !connection_platform.isStatusOfErrorInSendMessage
              )
                statusmsg = "entregue";

              if (obj.datereading === null && obj.datereading !== undefined) {
                qtdeMsgCDR++;

                setTimeout(function () {
                  dispatch(editQtdMsg(novadata[5]));
                }, 500);
              }

              if (connection_platform.attendance_screen_new) {
                if (
                  !!obj &&
                  !!obj.messagem &&
                  typeof obj.messagem === "string"
                ) {
                  obj.messagem = obj.messagem.replace(
                    /\\U([0-9a-fA-F]{8})/g,
                    (match, hex) => {
                      return String.fromCodePoint(parseInt(hex, 16));
                    },
                  );
                  if (
                    !isJson(obj.messagem) &&
                    obj.messagem.trimStart().startsWith("{")
                  ) {
                    const sanitized = obj.messagem
                      .replace(/\r\n/g, "\\n")
                      .replace(/\r/g, "\\r")
                      .replace(/\n/g, "\\n");
                    if (isJson(sanitized)) obj.messagem = sanitized;
                  }
                }
                if (isJson(obj.messagem) === true) {
                  let json = JSON.parse(obj.messagem);
                  let options = json.options;
                  let buttons = json.buttons;
                  let items = json.items;

                  if (json.menuid) {
                    let i = 1;
                    var opcoes = [];
                    for (i in options) {
                      opcoes.push(i + " - " + options[i][1]);
                    }

                    dispatch(
                      addMessage(
                        obj.id,
                        h2p(json.msg) + "§" + h2p(opcoes.join("  §  ")),
                        "Me",
                        obj.horaenvio,
                        novadata[5],
                        "2",
                        statusmsg,
                        obj.favorite,
                        dia,
                        obj.username,
                        "",
                        obj.destiny,
                        obj.mon_type_id,
                        obj.replyid,
                        "",
                        obj.title,
                        obj.anoenvio,
                        obj.data_hora_envio,
                      ),
                    );
                  } else if (json.botid) {
                    let opcoes = "";
                    let filepath = null;
                    let msg = prepararParaJson(json.msg);
                    msg = msg.replace(/\r\n/gi, "§");

                    if (items) {
                      opcoes = JSON.stringify(items).replace(/"/gi, "'");
                    } else if (buttons) {
                      opcoes = JSON.stringify(buttons).replace(/"/gi, "'");
                    }

                    if (json.link) {
                      filepath = json.FILEPATH || json.link;
                    }

                    dispatch(
                      addMessage(
                        obj.id,
                        msg + "~¿" + filepath,
                        "Me",
                        obj.horaenvio,
                        novadata[5],
                        "2",
                        statusmsg,
                        obj.favorite,
                        dia,
                        obj.username,
                        "",
                        obj.destiny,
                        obj.mon_type_id,
                        obj.replyid,
                        obj.mimetypeid + "§" + opcoes + "§" + json.botid,
                        obj.title,
                        obj.anoenvio,
                        obj.data_hora_envio,
                      ),
                    );
                  } else if (json.LONGITUDE || json.longitude) {
                    let longitude = "";
                    let latitude = "";
                    let name = "";
                    let address = "";

                    if (json.LONGITUDE) {
                      longitude = json.LONGITUDE;
                      latitude = json.LATITUDE;
                      name = json.NAME;
                      address = json.ADDRESS;
                    } else {
                      longitude = json.longitude;
                      latitude = json.latitude;
                      name = json.name;
                      address = json.address;
                    }
                    // var msg = json.msg;
                    // msg = msg.replace(/\r\n/gi, '§');
                    dispatch(
                      addMessage(
                        obj.id,
                        address +
                          "~¿" +
                          name +
                          "~¿" +
                          longitude +
                          "~¿" +
                          latitude,
                        obj.agente ? "Me" : "username",
                        obj.horaenvio,
                        novadata[5],
                        "4",
                        statusmsg,
                        obj.favorite,
                        dia,
                        obj.username,
                        "",
                        obj.destiny,
                        obj.mon_type_id,
                        obj.replyid,
                        "",
                        obj.title,
                        obj.anoenvio,
                        obj.data_hora_envio,
                      ),
                    );
                  } else if (json.URL) {
                    let opcoes = "";
                    let filepath = null;
                    if (json.FILEPATH) {
                      filepath = json.FILEPATH;
                    }
                    if (json.HSM_BUTTONS) {
                      const buttons = json.HSM_BUTTONS;
                      const buttonsFormated = [];
                      for (const btn of buttons) {
                        const objBtn = {
                          payload: btn.payload.index,
                          text: btn.payload.value,
                        };

                        buttonsFormated.push(objBtn);
                      }
                      opcoes = JSON.stringify(buttonsFormated).replace(
                        /"/gi,
                        "'",
                      );
                    }
                    // var msg = json.msg;
                    // msg = msg.replace(/\r\n/gi, '§');
                    dispatch(
                      addMessage(
                        obj.id,
                        json.URL + "~¿" + filepath,
                        "Me",
                        obj.horaenvio,
                        novadata[5],
                        "2",
                        statusmsg,
                        obj.favorite,
                        dia,
                        obj.username,
                        "",
                        obj.destiny,
                        obj.mon_type_id,
                        obj.replyid,
                        obj.mimetypeid + "§" + opcoes,
                        obj.title,
                        obj.anoenvio,
                        obj.data_hora_envio,
                      ),
                    );
                  } else if (parseInt(json.MIMETYPE) === 30) {
                    let msgFormatted = json.MSG;
                    msgFormatted = msgFormatted.replace(/<+/g, "*");
                    msgFormatted = msgFormatted.replace(/>+/g, "*");
                    dispatch(
                      addMessage(
                        obj.id,
                        h2p(msgFormatted),
                        "Me",
                        obj.horaenvio,
                        novadata[5],
                        "2",
                        statusmsg,
                        obj.favorite,
                        dia,
                        obj.username,
                        "",
                        obj.destiny,
                        obj.mon_type_id,
                        obj.replyid,
                        "hsm§",
                        obj.title,
                        obj.anoenvio,
                        obj.data_hora_envio,
                      ),
                    );
                  } else if (obj.typename === "contact") {
                    const msgArray = Array.isArray(json) ? json : [json];

                    msgArray.forEach((msg, index) => {
                      addMessage(
                        index === 0 ? obj.id : obj.id + `v_${index}`,
                        JSON.stringify(msg).replace(/"/gi, "'"),
                        obj.agente ? "Me" : obj.username,
                        obj.horaenvio,
                        novadata[5],
                        "11",
                        statusmsg,
                        obj.favorite,
                        dia,
                        obj.username,
                        "",
                        obj.destiny,
                        obj.mon_type_id,
                        obj.replyid,
                        "",
                        obj.title,
                        obj.anoenvio,
                        obj.data_hora_envio,
                      );
                    });
                  } else {
                    dispatch(
                      addMessage(
                        obj.id,
                        h2p(json.msg),
                        obj.agente ? "Me" : obj.username,
                        obj.horaenvio,
                        novadata[5],
                        "0",
                        statusmsg,
                        obj.favorite,
                        dia,
                        obj.username,
                        "",
                        obj.destiny,
                        obj.mon_type_id,
                        obj.replyid,
                        "",
                        obj.title,
                        obj.anoenvio,
                        obj.data_hora_envio,
                      ),
                    );
                  }
                } else {
                  obj.messagem = obj.messagem.replace(/"/gm, '\\"');
                  if (obj.agente === false) {
                    if (obj.mimetypeid < 3) {
                      var msg = obj.messagem;
                      msg = msg.replace(/\\\\n/gi, "\r\n");
                      msg = msg.replace(/"/gi, "'");
                      msg = msg.replace(/"/gm, '\\"');

                      dispatch(
                        addMessage(
                          obj.id,
                          msg,
                          obj.username,
                          obj.horaenvio,
                          novadata[5],
                          "0",
                          statusmsg,
                          obj.favorite,
                          dia,
                          obj.username,
                          "",
                          obj.destiny,
                          obj.mon_type_id,
                          obj.replyid,
                          "",
                          obj.title,
                          obj.anoenvio,
                          obj.data_hora_envio,
                        ),
                      );
                    } else if (obj.mimetypeid === 45) {
                      let recipients = [];
                      let msgIdMail = null;
                      axios
                        .get(
                          `${connection_platform.type_connect}://${pathname}:${port}/conn/list-infomail-byid?id=${obj.id}`,
                        )
                        .then((response) => {
                          if (response.data !== "") {
                            let retorno = response.data[0].email.split("Â¿");
                            retorno.map((todo) => {
                              let stringSplit = todo.split("Â§");
                              let type = 0;
                              if (stringSplit[1] === "4") {
                                type = 0;
                              } else if (stringSplit[1] === "2") {
                                type = 2;
                              } else if (stringSplit[1] === "1") {
                                type = 1;
                              } else if (stringSplit[1] === "3") {
                                type = 3;
                              }
                              msgIdMail = response.data[0].externalcode;
                              recipients.push({
                                label: stringSplit[0],
                                type: type,
                              });
                            });
                            dispatch(
                              AddMessageMail(
                                obj.client,
                                recipients,
                                obj.messagem,
                                [],
                                obj.data_hora_envio,
                                novadata[5],
                                obj.id,
                                obj.favorite,
                                obj.id,
                                obj.caption,
                                msgIdMail,
                                obj.agente,
                              ),
                            );
                          }
                        });
                      console.log("2342#%:235");
                      axios
                        .get(
                          `${connection_platform.type_connect}://${pathname}:${port}/conn/getattachmentemail?id=${obj.id}`,
                        )
                        .then((response) => {
                          dispatch(AddAttachmentsMail(obj.id, response.data));
                        });
                      // dispatch(
                      //   EditInfoCli(
                      //     novadata[5],
                      //     obj.caption,
                      //     `Assunto: ${obj.caption}`,
                      //     obj.caption
                      //   )
                      // );
                      if (index === 0) {
                        setTimeout(() => {
                          dispatch(EditSubjectMail(novadata[5], obj.caption));
                        }, 1000);
                      }
                    } else {
                      let tamanhoimagem = dbfileSize(obj.filesize);
                      dispatch(
                        addMessage(
                          obj.id,
                          obj.thumbnail +
                            "~¿" +
                            obj.caption +
                            "~¿" +
                            obj.messagem +
                            "~¿" +
                            tamanhoimagem,
                          obj.username,
                          obj.horaenvio,
                          novadata[5],
                          "1",
                          statusmsg,
                          obj.favorite,
                          dia,
                          obj.username,
                          "",
                          obj.destiny,
                          obj.mon_type_id,
                          obj.replyid,
                          "",
                          obj.title,
                          obj.anoenvio,
                          obj.data_hora_envio,
                        ),
                      );
                    }
                  } else {
                    if (obj.mimetypeid < 3) {
                      let message_fd = obj.messagem;
                      message_fd = message_fd.replace(/\n|\r\n/gi, "¿");
                      dispatch(
                        addMessage(
                          obj.id,
                          message_fd,
                          "Me",
                          obj.horaenvio,
                          novadata[5],
                          "0",
                          statusmsg,
                          obj.favorite,
                          dia,
                          obj.username,
                          "",
                          obj.destiny,
                          obj.mon_type_id,
                          obj.replyid,
                          "",
                          obj.title,
                          obj.anoenvio,
                          obj.data_hora_envio,
                        ),
                      );
                    } else if (obj.mimetypeid === 45) {
                      let recipients = [];
                      let msgIdMail = null;
                      axios
                        .get(
                          `${connection_platform.type_connect}://${pathname}:${port}/conn/list-infomail-byid?id=${obj.id}`,
                        )
                        .then((response) => {
                          if (response.data !== "") {
                            let retorno = response.data[0].email.split("Â¿");
                            retorno.map((todo) => {
                              let stringSplit = todo.split("Â§");
                              let type = 0;
                              if (stringSplit[1] === "4") {
                                type = 0;
                              } else if (stringSplit[1] === "2") {
                                type = 2;
                              } else if (stringSplit[1] === "1") {
                                type = 1;
                              } else if (stringSplit[1] === "3") {
                                type = 3;
                              }
                              msgIdMail = response.data[0].externalcode;
                              recipients.push({
                                label: stringSplit[0],
                                type: type,
                              });
                            });
                          }
                        });
                      console.log("2342#%:235");
                      dispatch(
                        AddMessageMail(
                          obj.client,
                          recipients,
                          obj.messagem,
                          [],
                          obj.data_hora_envio,
                          novadata[5],
                          obj.id,
                          obj.favorite,
                          obj.id,
                          obj.caption,
                          msgIdMail,
                          obj.agente,
                        ),
                      );
                      axios
                        .get(
                          `${connection_platform.type_connect}://${pathname}:${port}/conn/getattachmentemail?id=${obj.id}`,
                        )
                        .then((response) => {
                          dispatch(AddAttachmentsMail(obj.id, response.data));
                        });
                      // dispatch(
                      //   EditInfoCli(
                      //     novadata[5],
                      //     obj.caption,
                      //     `Assunto: ${obj.caption}`,
                      //     obj.caption
                      //   )
                      // );
                      if (index === 0) {
                        setTimeout(() => {
                          dispatch(EditSubjectMail(novadata[5], obj.caption));
                        }, 1000);
                      }
                    } else {
                      let tamanhoimagem = dbfileSize(obj.filesize);

                      dispatch(
                        addMessage(
                          obj.id,
                          obj.thumbnail +
                            "~¿" +
                            obj.caption +
                            "~¿" +
                            obj.messagem +
                            "~¿" +
                            tamanhoimagem,
                          "Me",
                          obj.horaenvio,
                          novadata[5],
                          "1",
                          statusmsg,
                          obj.favorite,
                          dia,
                          obj.username,
                          "",
                          obj.destiny,
                          obj.mon_type_id,
                          obj.replyid,
                          "",
                          obj.title,
                          obj.anoenvio,
                          obj.data_hora_envio,
                        ),
                      );
                    }
                  }
                }
              }

              if (!connection_platform.attendance_screen_new) {
                if (isJson(obj.messagem) === true) {
                  let json = JSON.parse(obj.messagem);
                  let options = json.options;

                  if (json.menuid) {
                    let i = 1;
                    var opcoes = [];
                    for (i in options) {
                      opcoes.push(i + " - " + options[i][1]);
                    }
                    dispatch(
                      addMessage(
                        obj.id,
                        h2p(json.msg) + "§" + h2p(opcoes.join("  §  ")),
                        "Me",
                        obj.horaenvio,
                        novadata[5],
                        "2",
                        statusmsg,
                        obj.favorite,
                        dia,
                        username,
                        "",
                        obj.destiny,
                        "",
                        obj.replyid,
                        "",
                        obj.title,
                        obj.anoenvio,
                        obj.data_hora_envio,
                      ),
                    );
                  } else if (json.botid) {
                    var msg = json.msg;
                    msg = msg.replace(/\r\n/gi, "§");
                    dispatch(
                      addMessage(
                        obj.id,
                        msg,
                        "Me",
                        obj.horaenvio,
                        novadata[5],
                        "2",
                        statusmsg,
                        obj.favorite,
                        dia,
                        username,
                        "",
                        obj.destiny,
                        "",
                        obj.replyid,
                        "",
                        obj.title,
                        obj.anoenvio,
                        obj.data_hora_envio,
                      ),
                    );
                  } else if (json.LONGITUDE || json.longitude) {
                    let longitude = "";
                    let latitude = "";
                    let name = "";
                    let address = "";

                    if (json.LONGITUDE) {
                      longitude = json.LONGITUDE;
                      latitude = json.LATITUDE;
                      name = json.NAME;
                      address = json.ADDRESS;
                    } else {
                      longitude = json.longitude;
                      latitude = json.latitude;
                      name = json.name;
                      address = json.address;
                    }
                    // var msg = json.msg;
                    // msg = msg.replace(/\r\n/gi, '§');
                    dispatch(
                      addMessage(
                        obj.id,
                        address +
                          "~¿" +
                          name +
                          "~¿" +
                          longitude +
                          "~¿" +
                          latitude,
                        obj.agente ? "Me" : "username",
                        obj.horaenvio,
                        novadata[5],
                        "4",
                        statusmsg,
                        obj.favorite,
                        dia,
                        username,
                        "",
                        obj.destiny,
                        "",
                        obj.replyid,
                        "",
                        obj.title,
                        obj.anoenvio,
                        obj.data_hora_envio,
                      ),
                    );
                  } else if (parseInt(json.MIMETYPE) === 30) {
                    let msgFormatted = json.MSG;
                    msgFormatted = msgFormatted.replace(/<+/g, "*");
                    msgFormatted = msgFormatted.replace(/>+/g, "*");
                    dispatch(
                      addMessage(
                        obj.id,
                        h2p(msgFormatted),
                        "Me",
                        obj.horaenvio,
                        novadata[5],
                        "0",
                        statusmsg,
                        obj.favorite,
                        dia,
                        username,
                        "",
                        obj.destiny,
                        "",
                        obj.replyid,
                        "",
                        obj.title,
                        obj.anoenvio,
                        obj.data_hora_envio,
                      ),
                    );
                  } else if (json.URL) {
                    // var msg = json.msg;
                    // msg = msg.replace(/\r\n/gi, '§');
                    dispatch(
                      addMessage(
                        obj.id,
                        h2p(json.URL),
                        "Me",
                        obj.horaenvio,
                        novadata[5],
                        "0",
                        statusmsg,
                        obj.favorite,
                        dia,
                        username,
                        "",
                        obj.destiny,
                        "",
                        obj.replyid,
                        "",
                        obj.title,
                        obj.anoenvio,
                        obj.data_hora_envio,
                      ),
                    );
                  } else {
                    dispatch(
                      addMessage(
                        obj.id,
                        h2p(json.msg),
                        "Me",
                        obj.horaenvio,
                        novadata[5],
                        "0",
                        statusmsg,
                        obj.favorite,
                        dia,
                        username,
                        "",
                        obj.destiny,
                        "",
                        obj.replyid,
                        "",
                        obj.title,
                        obj.anoenvio,
                        obj.data_hora_envio,
                      ),
                    );
                  }
                } else {
                  obj.messagem = obj.messagem.replace(/"/gm, '\\"');
                  if (obj.agente === false) {
                    if (obj.mimetypeid < 3) {
                      var msg = obj.messagem;
                      msg = msg.replace(/\\\\n/gi, "\r\n");
                      msg = msg.replace(/"/gm, '\\"');
                      dispatch(
                        addMessage(
                          obj.id,
                          msg,
                          obj.username,
                          obj.horaenvio,
                          novadata[5],
                          "0",
                          statusmsg,
                          obj.favorite,
                          dia,
                          username,
                          "",
                          obj.destiny,
                          "",
                          obj.replyid,
                          "",
                          obj.title,
                          obj.anoenvio,
                          obj.data_hora_envio,
                        ),
                      );
                    } else {
                      let tamanhoimagem = dbfileSize(obj.filesize);
                      dispatch(
                        addMessage(
                          obj.id,
                          obj.thumbnail +
                            "~¿" +
                            obj.caption +
                            "~¿" +
                            obj.messagem +
                            "~¿" +
                            tamanhoimagem,
                          obj.username,
                          obj.horaenvio,
                          novadata[5],
                          "1",
                          statusmsg,
                          obj.favorite,
                          dia,
                          username,
                          "",
                          obj.destiny,
                          "",
                          obj.replyid,
                          "",
                          obj.title,
                          obj.anoenvio,
                          obj.data_hora_envio,
                        ),
                      );
                    }
                  } else {
                    if (obj.mimetypeid < 3) {
                      let message_fd = obj.messagem;
                      message_fd = message_fd.replace(/\n|\r\n/gi, "¿");
                      dispatch(
                        addMessage(
                          obj.id,
                          message_fd,
                          "Me",
                          obj.horaenvio,
                          novadata[5],
                          "0",
                          statusmsg,
                          obj.favorite,
                          dia,
                          "username",
                          "",
                          obj.destiny,
                          "",
                          obj.replyid,
                          "",
                          obj.title,
                          obj.anoenvio,
                        ),
                      );
                    } else {
                      let tamanhoimagem = dbfileSize(obj.filesize);

                      dispatch(
                        addMessage(
                          obj.id,
                          obj.thumbnail +
                            "~¿" +
                            obj.caption +
                            "~¿" +
                            obj.messagem +
                            "~¿" +
                            tamanhoimagem,
                          "Me",
                          obj.horaenvio,
                          novadata[5],
                          "1",
                          statusmsg,
                          obj.favorite,
                          dia,
                          "username",
                          "",
                          obj.destiny,
                          "",
                          obj.replyid,
                          "",
                          obj.title,
                          obj.anoenvio,
                          obj.data_hora_envio,
                        ),
                      );
                    }
                  }
                }
              }
            });

            dispatch(typingadd(novadata[5], 0));
          })
          .catch((error) => {
            throw error;
          });
      }
    };
    if (parseInt(novadata[25]) === 1 || parseInt(novadata[25]) === "1") {
      axios
        .get(
          `${
            connection_platform.type_connect
          }://${pathname}:${port}/conn/getprotocolbyecdr?cdrid=${parseInt(
            novadata[5],
          )}`,
        )
        .then((response) => {
          numprotocolo = "";
          if (response.data.length !== 0) {
            if (
              response.data[0].protocolo !== "" &&
              response.data[0].protocolo !== undefined
            ) {
              numprotocolo = response.data[0].protocolo;
            }
          }

          dispatch(
            addAtendimento(
              novadata[5],
              cliente,
              telefonefilt[1],
              novadata[21],
              novadata[23],
              criticidade,
              novadata[19],
              novadata[11],
              novadata[27],
              novadata[25],
              novadata[33],
              novadata[15],
              novadata[13],
              timecomplete,
              statusagent,
              "0",
              0,
              novadata[1],
              0,
              novadata[35],
              "",
              servico,
              "",
              "",
              numprotocolo, //25
              "",
              "",
              "",
              "",
              "",
              "",
              score_class2,
              score_value2,
              nps_call,
            ),
          );
          InteracoesContactNumberPeer(
            telefonefilt[1],
            informationusers.idgroup,
          );
          dispatch(UpdateRgBlockReturn(informationusers));
          mtnow = "new";

          dispatch(
            addAtdSimult(
              novadata[5],
              cliente,
              telefonefilt[1],
              novadata[21],
              novadata[23],
              criticidade,
              novadata[19],
              novadata[11],
              novadata[27],
              novadata[25],
              novadata[33],
              novadata[15],
              novadata[13],
              timecomplete,
              statusagent,
              "0",
              0,
              novadata[1],
              0,
              novadata[35],
              mtnow,
              "",
              servico,
              "",
              "",
              numprotocolo, //26
              "",
              "",
              "",
              "",
              score_class2,
              score_value2,
              nps_call,
            ),
          );
          dispatch(
            createStatusAgent(
              "Atendimento",
              "S.(" + telefonefilt[1] + ")",
              Moment().format("DD/MM/YYYY HH:mm:ss"),
            ),
          );
          sendMessagesWhenGetCallFromQuarentine();
        });
    } else {
      axios
        .get(
          `${
            connection_platform.type_connect
          }://${pathname}:${port}/conn/getprotocolbyecdr?cdrid=${parseInt(
            novadata[5],
          )}`,
        )
        .then((response) => {
          numprotocolo = "";
          if (response.data.length !== 0) {
            if (
              response.data[0].protocolo !== "" &&
              response.data[0].protocolo !== undefined
            ) {
              numprotocolo = response.data[0].protocolo;
            }
          }
          dispatch(
            addAtendimento(
              novadata[5].toString(),
              cliente,
              telefonefilt[1],
              novadata[21],
              novadata[23],
              criticidade,
              novadata[19],
              novadata[11],
              novadata[27],
              novadata[25],
              novadata[33],
              novadata[15],
              novadata[13],
              timecomplete,
              statusagent,
              "0",
              0,
              novadata[1],
              0,
              novadata[35],
              "",
              servico,
              "",
              "",
              numprotocolo, //26
              "",
              "",
              "",
              "",
              "",
              "",
              score_class2,
              score_value2,
              nps_call,
            ),
          );
          InteracoesContactNumberPeer(
            telefonefilt[1],
            informationusers.idgroup,
          );
          dispatch(UpdateRgBlockReturn(informationusers));
          mtnow = "new";
          dispatch(
            addAtdSimult(
              novadata[5],
              cliente,
              telefonefilt[1],
              novadata[21],
              novadata[23],
              criticidade,
              novadata[19],
              novadata[11],
              novadata[27],
              novadata[25],
              novadata[33],
              novadata[15],
              novadata[13],
              timecomplete,
              statusagent,
              "0",
              0,
              novadata[1],
              0,
              novadata[35],
              mtnow,
              "",
              servico,
              "",
              "",
              numprotocolo, //26
              "",
              "",
              "",
              "",
              score_class2,
              score_value2,
              nps_call,
            ),
          );
          dispatch(
            createStatusAgent(
              "Atendimento",
              "S.(" + telefonefilt[1] + ")",
              Moment().format("DD/MM/YYYY HH:mm:ss"),
            ),
          );
          // socket.send(
          //   "ANSWEBCHATACK\r\n" +
          //     userid +
          //     "\r\nCONTACTID\r\n" +
          //     novadata[5] +
          //     "\r\nTo\r\n" +
          //     novadata[1] +
          //     "\r\nSRV\r\n1\r\nSRVIN\r\n" +
          //     novadata[11] +
          //     "\r\nATDID\r\n" +
          //     novadata[27] +
          //     "\r\n\r\n"
          // );
          sendMessagesWhenGetCallFromQuarentine();
        });
    }
  };
};

function stopHeartbeat() {
  clearInterval(heartbeatInterval);
}

function startHeartbeat() {
  stopHeartbeat();

  heartbeatInterval = setInterval(() => {
    if (socket.readyState === WebSocket.OPEN) {
      try {
        console.log("🟡 Enviando ping... INGENIUMPING");
        socket.send("PING\r\n\r\n");
      } catch (err) {
        console.log(
          "💥 Erro ao enviar ping. Forçando reconexão... INGENIUMPING",
        );
        socket.close(); // aciona onclose e reconecta
      }
    } else {
      console.log(
        "🔄 WebSocket não está aberto INGENIUMPING. Estado:",
        socket.readyState,
      );
    }
  }, 31000); // envia ping a cada 31s
}

function isMobileDevice() {
  // Verificar se o navegador está em um dispositivo móvel através do User-Agent
  const userAgent = navigator.userAgent;
  const mobileDeviceRegex =
    /Mobi|Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
  return mobileDeviceRegex.test(userAgent);
}

function enviarLogErroInsert(dados) {
  axios
    .post(
      `${connection_platform.type_connect}://${pathname}:${port}/conn/loginsertdebug`,
      dados,
    )
    .then(() => {
      console.log("LOG DEBUG enviado");
    })
    .catch((e) => {
      console.error("Erro ao enviar log debug", e);
    });
}

export const sendToQuarentineZone = (contactid, infousers) => {
  const userid = infousers.id;
  const serverid = contactid.serverid;
  const idatendimento = contactid.serviceatd;
  const cdr = contactid.idatendimento;
  const arrayjson =
    '{"CDR": ' + cdr + ', "ATDID":' + idatendimento + ', "ACTION":' + 1 + "}";
  socket.send(
    "REQSTANDBY\r\n" +
      userid +
      "\r\nTOUSER\r\n" +
      serverid +
      "\r\nJSON\r\n" +
      arrayjson +
      "\r\n\r\n",
  );
};

export const removeOfQuarentineZone = async (contactid, infousers) => {
  const userid = infousers.id;
  const serverid = contactid.serverid;
  const idatendimento = contactid.serviceatd;
  const cdr = contactid.idatendimento;
  const arrayjson =
    '{"CDR": ' + cdr + ', "ATDID":' + idatendimento + ', "ACTION":' + 0 + "}";
  socket.send(
    "REQSTANDBY\r\n" +
      userid +
      "\r\nTOUSER\r\n" +
      serverid +
      "\r\nJSON\r\n" +
      arrayjson +
      "\r\n\r\n",
  );
};

export const endCallOnQuarentine = (infousers, contactid) => {
  socket.send(
    "WSIBYE\r\n" +
      infousers.id +
      "\r\nTOUSER\r\n" +
      contactid.serverid +
      "\r\nTOCLIENT\r\n" +
      contactid.idatendimento +
      "\r\n\r\n",
  );
};

export const transferCallOnQuarentine = (
  infousers,
  contactid,
  idAgentToTransfer,
) => {
  const userid = infousers.id;
  const serverid = contactid.serverid;
  const cdrId = contactid.idatendimento;
  socket.send(
    "CHATTRANSFER\r\n" +
      userid +
      "\r\nCONTACTID\r\n" +
      cdrId +
      "\r\nTO\r\n" +
      serverid +
      "\r\nTOAGENT\r\n" +
      idAgentToTransfer +
      "\r\n\r\n",
  );
};

export const dtmf = (number) => {
  webphone_api.dtmf(number);
};

export const InsertPauseSocket = (
  infousers,
  pausa,
  datalogin,
  idpausa,
  status,
  dispatch,
  getState,
) => {
  BlockUser(infousers, pausa, datalogin, idpausa, status, dispatch, getState);
};

export const CaptureCallSocket = (infousers) => {
  webphone_api.call(55);
};

export const editAgentSocket = (
  infousers,
  pausa,
  datalogin,
  idpausa,
  status,
  dispatch,
  getState,
) => {
  BlockUser(infousers, pausa, datalogin, idpausa, status, dispatch, getState);
};

export const sendIPSocket = (imsdnpri, imsdnsec, portims) => {
  var urls = [];
  if (imsdnsec != null) {
    if (portims !== "")
      urls = [
        connection_platform.type_socket + "://" + imsdnpri + ":" + portims,
        connection_platform.type_socket + "://" + imsdnsec + ":" + portims,
      ];
    else
      urls = [
        connection_platform.type_socket + "://" + imsdnpri,
        connection_platform.type_socket + "://" + imsdnsec,
      ];
  } else {
    if (portims !== "")
      urls = [
        connection_platform.type_socket + "://" + imsdnpri + ":" + portims,
      ];
    else urls = [connection_platform.type_socket + "://" + imsdnpri];
  }

  let urlIndex = 0;
  const urlProvider = () => urls[urlIndex++ % urls.length];

  // socket = new ReconnectingWebSocket(urlProvider, [], {
  //   constructor: WebSocket,
  //   connectionTimeout: 10000, // in milliseconds
  //   reconnectInterval: 10000,
  //   maxRetries: Infinity,
  // });

  socket = new ReconnectingWebSocket(urlProvider, [], {
    constructor: WebSocket,
    connectionTimeout: 30000, // in milliseconds
    reconnectInterval: 30000,
    maxRetries: 10,
  });

  if (connection_platform.waitToSendReq.isToActive) {
    const originalSend = socket.send.bind(socket);
    reqServiceSingleton.setSocket(socket);
    socket.send = function (data) {
      try {
        const isReq =
          Boolean(data) &&
          typeof data === "string" &&
          data.startsWith("REQ\r\n");

        if (
          isReq &&
          reqServiceSingleton.isAlreadySended === false &&
          reqServiceSingleton.isFirstReq === false
        ) {
          reqServiceSingleton.setLastReq(data);
        } else {
          originalSend(data);
        }
        if (isReq && reqServiceSingleton.isFirstReq === true) {
          reqServiceSingleton.setIsFirstReqToFalse();
        }
      } catch (error) {
        console.log("reqService ERROR 1785", error);
        originalSend(data);
      }
    };
  }

  ipcurrent = iplocal;
};

export const ReqSocketLogout = (
  infousers,
  statusagent,
  ipcurrent,
  atdsimult,
) => {
  SocketLogout(infousers, statusagent, ipcurrent, atdsimult);
};

export const StopMonitoring = (userid, userout) => {
  StopMonitoringUser(userid, userout);
};

function StopMonitoringUser(userid, userout) {
  webphone_api.setsipheader("");
  webphone_api.setsipheader("X-BargeIn: no");
  socket.send(
    "WSIMONITOR\r\n" +
      userid +
      "\r\nTOUSER\r\n" +
      userout +
      "\r\nTYPE\r\n0\r\n\r\n",
  );
}

function prepararParaJson(texto) {
  return (
    texto
      // Verifica e escapa barras invertidas somente se não estiverem escapadas
      .replace(/(?<!\\)\\/g, "\\\\")
      // Verifica e escapa aspas duplas somente se não estiverem escapadas
      .replace(/(?<!\\)"/g, '\\"')
      // Verifica e escapa quebras de linha somente se não estiverem escapadas
      .replace(/(?<!\\)\n/g, "\\n")
      // Verifica e escapa retornos de carro somente se não estiverem escapadas
      .replace(/(?<!\\)\r/g, "\\r")
  );
}

function envioStatusAgente(origem, sipid) {
  statusIntervalAgent = setInterval(() => {
    socket.send(requestStatusAgent);
    console.log(
      "INGENIUM_ENVIOSTATUS :",
      new Date().toLocaleString(),
      stAgIMSDN,
    );

    if (stAgIMSDN != null && stAgIMSDN !== undefined && stAgIMSDN !== "") {
      axios.get(
        `${connection_platform.type_connect}://${pathname}:${port}/conn/checkstatussip?sipid=${sipid}&status=${stAgIMSDN}`,
      );
    }

    if (voz === true && verificationMidiaVoz === true) {
      if (!webphone_api.isregistered()) {
        webphone_api.start();
      }
    }
    //     }, 10000);
    // }, 300000);
  }, 600000);
}

export const RefreshNoAnswerCall = (cdrid, queueid, infousers, queue) => {
  RefreshNoAnswer(cdrid, queueid, infousers, queue);
};

function RefreshNoAnswer(cdrid, queueid, infousers, queue) {
  socket.send(
    "CALLQUEUE\r\n" +
      infousers.id +
      "\r\nQUEUEID\r\n" +
      queueid +
      "\r\nCDRID\r\n" +
      cdrid +
      "\r\nTP\r\nNANS\r\nTMCBACK\r\n0\r\nCQUEUE\r\n0\r\nUSERNAME\r\n" +
      infousers.username +
      "\r\n\r\n",
  );
  socket.send(
    "WSIBYE\r\n" +
      infousers.id +
      "\r\nTOUSER\r\n" +
      queue.scriptid +
      "\r\nTOCLIENT\r\n" +
      cdrid +
      "\r\n\r\n",
  );
}

function spawnNotification(opcoes) {
  var n = new Notification(opcoes.title, opcoes.opt);
}

function SocketLogout(infousers, statusagent, ipcurrent, atdsimult) {
  let timelogout = Moment().format("DD/MM/YYYY HH:mm:ss") + "-00:00:00";
  let status = " ";
  let timeBlockIni = Moment(
    statusagent.datestatus,
    "DD/MM/YYYY HH:mm:ss",
  ).format("YYYY/MM/DD HH:mm:ss");
  let timeBlockEnd = Moment().format("YYYY/MM/DD HH:mm:ss");

  let valorDiferenca = parseInt(Math.abs(Math.round(ipcurrent.difftime)));

  if (parseInt(ipcurrent.difftime) < 0) {
    timeBlockEnd = Moment()
      .subtract(valorDiferenca, "seconds")
      .format("YYYY/MM/DD HH:mm:ss");
  } else {
    timeBlockEnd = Moment()
      .add(valorDiferenca, "seconds")
      .format("YYYY/MM/DD HH:mm:ss");
  }

  let duracao = Moment(timeBlockEnd).diff(timeBlockIni, "seconds");
  let intmans = infousers.intmans != null ? infousers.intmans : 0;
  let outtmans = infousers.outtmans != null ? infousers.outtmans : 0;
  let tmlogin = infousers.tmlogin != null ? infousers.tmlogin : 0;

  let strPauseFuture = infousers.blockfuture ? 1 : 0;
  let descPauseFuture = infousers.blockfuture ? descfuturepause : " ";
  if (status === undefined || status === "undefined") {
    status = " ";
  }
  let data_hora_atual = Moment().format("YYYY/MM/DD HH:mm:ss");
  let duracaoLoginAtual = Moment(data_hora_atual).diff(
    infousers.datalogin,
    "seconds",
  );
  let duracaoLoginFinal =
    parseInt(duracaoLoginAtual) + parseInt(infousers.tmlogin);

  let arrayAtdJson = [];
  if (atdsimult) {
    atdsimult.map((atd) => {
      //if (atd.telefone !== contactid.telefone) {
      arrayAtdJson.push({
        idmidia: atd.idmidia,
        telefone: atd.telefone,
      });
    });
  }

  let jsonChannelPhoneCall = mountCallsStatus(arrayAtdJson);

  socket.send(
    "REQ\r\n" +
      infousers.id +
      "\r\nUSERNAME\r\n" +
      infousers.username +
      "\r\nDISPLAYNAME\r\n" +
      infousers.displayname +
      "\r\nEXTEN\r\n" +
      infousers.ramal +
      "\r\nREASON\r\n" +
      status +
      "\r\nSTATUS\r\n" +
      status +
      "\r\nSTATUSID\r\n4\r\nHOUR\r\n" +
      timelogout +
      "\r\nDESCRIPTION\r\n \r\nEMAIL\r\n \r\nGROUP\r\n" +
      infousers.idgroup +
      "\r\nDTL\r\n" +
      timelogout +
      "\r\nGROUPNAME\r\n" +
      infousers.grupo +
      "\r\nPSDCOUNT\r\n" +
      (parseInt(infousers.psdcount) + 1) +
      "\r\nPSDTMA\r\n" +
      (parseInt(infousers.psdtma) + parseInt(duracao)) +
      "\r\nMNGGROUP\r\n-1\r\nINCALLCOUNT\r\n" +
      infousers.incallcount +
      "\r\nINANSCOUNT\r\n" +
      infousers.inanscount +
      "\r\nINTMANS\r\n" +
      intmans +
      "\r\nINSLA\r\n100\r\nOUTCALLCOUNT\r\n" +
      infousers.outcallcount +
      "\r\nOUTANSCOUNT\r\n" +
      infousers.outanscount +
      "\r\nOUTTMANS\r\n" +
      outtmans +
      "\r\nOUTSLA\r\n100\r\nTMLOGIN\r\n" +
      duracaoLoginFinal +
      "\r\nJSON\r\n" +
      jsonChannelPhoneCall +
      "\r\nCOUNTFPAUSE\r\n" +
      parseInt(infousers.psdfbreak) +
      "\r\nFUTUREPAUSE\r\n" +
      strPauseFuture +
      "\r\nDESCFUTUREPAUSE\r\n" +
      descPauseFuture +
      "\r\nINITIALLOGIN\r\n0\r\n\r\n",
  );
  statusAgentIMSDN = status;

  stAgIMSDN = status;
  console.log("INGENIUM_ENVIOSTATUS :", new Date().toLocaleString(), stAgIMSDN);
  requestStatusAgent =
    "REQ\r\n" +
    infousers.id +
    "\r\nUSERNAME\r\n" +
    infousers.username +
    "\r\nDISPLAYNAME\r\n" +
    infousers.displayname +
    "\r\nEXTEN\r\n" +
    infousers.ramal +
    "\r\nREASON\r\n" +
    status +
    "\r\nSTATUS\r\n" +
    status +
    "\r\nSTATUSID\r\n4\r\nHOUR\r\n" +
    timelogout +
    "\r\nDESCRIPTION\r\n \r\nEMAIL\r\n \r\nGROUP\r\n" +
    infousers.idgroup +
    "\r\nDTL\r\n" +
    timelogout +
    "\r\nGROUPNAME\r\n" +
    infousers.grupo +
    "\r\nPSDCOUNT\r\n" +
    (parseInt(infousers.psdcount) + 1) +
    "\r\nPSDTMA\r\n" +
    (parseInt(infousers.psdtma) + parseInt(duracao)) +
    "\r\nMNGGROUP\r\n-1\r\nINCALLCOUNT\r\n" +
    infousers.incallcount +
    "\r\nINANSCOUNT\r\n" +
    infousers.inanscount +
    "\r\nINTMANS\r\n" +
    intmans +
    "\r\nINSLA\r\n100\r\nOUTCALLCOUNT\r\n" +
    infousers.outcallcount +
    "\r\nOUTANSCOUNT\r\n" +
    infousers.outanscount +
    "\r\nOUTTMANS\r\n" +
    outtmans +
    "\r\nOUTSLA\r\n100\r\nTMLOGIN\r\n" +
    duracaoLoginFinal +
    "\r\nJSON\r\n" +
    jsonChannelPhoneCall +
    "\r\nCOUNTFPAUSE\r\n" +
    parseInt(infousers.psdfbreak) +
    "\r\nFUTUREPAUSE\r\n" +
    strPauseFuture +
    "\r\nDESCFUTUREPAUSE\r\n" +
    descPauseFuture +
    "\r\nINITIALLOGIN\r\n0\r\n\r\n";
  clearInterval(statusIntervalAgent);
  envioStatusAgente(529, infousers.sipid);
}

export const RequestCallParkSocket = (
  infousers,
  scriptid,
  cdrid,
  mediaid,
  status,
  dispatch,
  getState,
) => {
  checkCapturaFila[cdrid] = true;

  if (parseInt(status.afterIdReason) > 0) {
    dispatch(BlockFuture(true));
  }

  dispatch(capturaFila(true));
  RequestCallPark(infousers, scriptid, cdrid, mediaid);
};

export const RequestCallParkTransferSocket = (
  agent,
  scriptid,
  cdrid,
  mediaid,
  iduser,
  dispatch,
) => {
  checkCapturaFila[cdrid] = true;
  dispatch(capturaFila(true));
  RequestCallParkTransfer(agent, scriptid, cdrid, mediaid, iduser);
};

export const EfectBlockUserSocket = (
  infouser,
  userout,
  act,
  reason,
  agents,
) => {
  EfectBlockUser(infouser, userout, act, reason, agents);
};

export const SharedScreen = (chamado) => {
  webphone_api.screenshare(chamado);
};

export const SuperInfoPause = (iduser) => {
  InfoSuperPause(iduser);
};

function InfoSuperPause(iduser) {
  socket.send("SUPERINFO\r\n" + iduser + "\r\nTMOUT\r\n00:01:00\r\n\r\n");
}

export const ActiveConfSocketVoz = (
  outband,
  infouser,
  trunk,
  mediaid,
  chamado,
  addtech,
  scriptrunk,
  operator,
  returning,
  queueid,
  recvcount,
  callback_count,
  tech,
  idgrupo_rota,
  idgrupo_transb,
  dispatch,
  ipcurrent,
  cdrold,
  rotaencontrada,
  ContactId,
  atdsimult,
) => {
  var DDD = "";
  var calledDigitado = chamado;
  var rotaTransbordo = idgrupo_transb;
  var callback_count = callback_count + 1;

  var numDigitado = chamado;

  if (chamado.length === 12 || chamado.length === 13) {
    if (chamado.substr(0, 2) === "55") {
      chamado = chamado.substr(2, chamado.length - 1);
    }
  }
  if (chamado.length === 10 || chamado.length === 11) {
    DDD = chamado.substr(0, 2);
    chamado = chamado.substr(2, chamado.length - 1);
    if (chamado.length === 8) {
      if (parseInt(chamado[0]) >= 6 && parseInt(chamado[0]) <= 9)
        chamado = "9" + chamado;
    }
    chamado = DDD + chamado;
  } else if (chamado.length === 8 || chamado.length === 9) {
    if (chamado.length === 8) {
      if (parseInt(chamado[0]) >= 6 && parseInt(chamado[0]) <= 9)
        chamado = "9" + chamado;
    }
    chamado = DDD + chamado;
    calledDigitado = DDD + chamado;
  }

  // axios
  //   .get(
  //     `${connection_platform.type_connect}://${pathname}:${port}/conn/insertactivecall?idtrunk=${trunk}&servicecode=${outband.idservice}&idmidia=${mediaid}&caller=${infouser.ramal}&called='${numDigitado}'&idcustomer=${outband.idcustomer}&iddirection=${outband.iddirection}`
  //   )
  //   .then((response) => {
  queueidfila = queueid;
  // let retorno = response.data.id;
  let retorno = calledDigitado;
  operator = operator == null ? "" : operator;

  if (retorno) {
    let addtechnology = addtech != null ? addtech : "";
    let retornoatt = calledDigitado;
    let strChamado =
      chamado.length > 4 ? operator + chamado + addtechnology : chamado;

    if (mediaid === 1 || mediaid === 16) {
      rotaTransbordo = rotaTransbordo != null ? rotaTransbordo : 0;
      webphone_api.setsipheader("");
      webphone_api.setsipheader("X-BargeIn: no");
      if (webphone_api.isonhold()) webphone_api.hold(false);

      if (rotaencontrada == true) {
        let operatorManage = mediaid === 16 ? "" : operator;
        isWhatsVoz = mediaid === 16 ? true : false;
        if (connection_platform.client_webrtc) {
          let chamadotmf = "";

          for (var i = 0; i < chamado.length; i++) {
            chamadotmf += " " + chamado[i];
          }
          let ramalinicial = infouser.ramal;
          let ramaldtmf = "";

          for (var z = 0; z < ramalinicial.length; z++) {
            ramaldtmf += " " + ramalinicial[z];
          }

          //webphone_api.dtmf("#" + chamadotmf + "        C");
          webphone_api.dtmf(
            "# " + ramaldtmf + " B " + chamadotmf + "        C",
          );

          dispatch(AddConferenceExt(retornoatt, ContactId));

          // arrayinfoTo[response.data.id] =
          arrayinfoTo[calledDigitado] =
            operatorManage +
            chamado +
            addtechnology +
            "-" +
            trunk +
            "-" +
            retorno +
            "-" +
            tech +
            "-" +
            idgrupo_rota +
            "-" +
            rotaTransbordo +
            "-";
        } else {
          dispatch(AddConferenceExt(retornoatt, ContactId));
          webphone_api.conference(
            operatorManage +
              chamado +
              addtechnology +
              "-" +
              trunk +
              "-" +
              retorno +
              "-" +
              tech +
              "-" +
              idgrupo_rota +
              "-" +
              rotaTransbordo +
              "-",
          );
          webphone_api.setline(
            operatorManage +
              chamado +
              addtechnology +
              "-" +
              trunk +
              "-" +
              retorno +
              "-" +
              tech +
              "-" +
              idgrupo_rota +
              "-" +
              rotaTransbordo +
              "-",
          );
          // arrayinfoTo[response.data.id] =
          arrayinfoTo[calledDigitado] =
            operatorManage +
            chamado +
            addtechnology +
            "-" +
            trunk +
            "-" +
            retorno +
            "-" +
            tech +
            "-" +
            idgrupo_rota +
            "-" +
            rotaTransbordo +
            "-";
        }
      } else {
        //webphone_api.setline(1);
        dispatch(AddConferenceExt(retornoatt, ContactId));

        //webphone_api.conference(chamado)
        webphone_api.conference(
          operator +
            chamado +
            addtechnology +
            "-" +
            trunk +
            "-" +
            retorno +
            "-" +
            tech +
            "-" +
            idgrupo_rota +
            "-" +
            rotaTransbordo +
            "-",
        );
        webphone_api.setline(
          operator +
            chamado +
            addtechnology +
            "-" +
            trunk +
            "-" +
            retorno +
            "-" +
            tech +
            "-" +
            idgrupo_rota +
            "-" +
            rotaTransbordo +
            "-",
        );
        // arrayinfoTo[response.data.id] =
        arrayinfoTo[calledDigitado] =
          operator +
          chamado +
          addtechnology +
          "-" +
          trunk +
          "-" +
          retorno +
          "-" +
          tech +
          "-" +
          idgrupo_rota +
          "-" +
          rotaTransbordo +
          "-";
      }
      if (outband.hasprotocol === true) {
        dispatch(gerarProtocolosaida(retorno));
      }

      let datatime = Moment().format("DD/MM/YYYY HH:mm:ss");

      let valorDiferenca = parseInt(Math.abs(Math.round(ipcurrent.difftime)));

      if (parseInt(ipcurrent.difftime) < 0) {
        datatime = Moment()
          .subtract(valorDiferenca, "seconds")
          .format("DD/MM/YYYY HH:mm:ss");
      } else {
        datatime = Moment()
          .add(valorDiferenca, "seconds")
          .format("DD/MM/YYYY HH:mm:ss");
      }
      if (chamado.length > 4) {
        let arrayAtdJson = [];
        let existNumberAndChannel = false;
        atdsimult.map((atd) => {
          if (
            parseInt(atd.idmidia) === 1 &&
            parseInt(atd.telefone) === parseInt(chamado)
          )
            existNumberAndChannel = true;

          arrayAtdJson.push({
            idmidia: atd.idmidia,
            telefone: atd.telefone,
          });
        });
        if (!existNumberAndChannel) {
          arrayAtdJson.push({
            idmidia: parseInt(mediaid),
            telefone: chamado,
          });
        }
        let jsonChannelPhoneCall = mountCallsStatus(arrayAtdJson);

        let data_hora_atual = Moment().format("YYYY/MM/DD HH:mm:ss");
        let duracaoLoginAtual = Moment(data_hora_atual).diff(
          infouser.datalogin,
          "seconds",
        );
        let duracaoLoginFinal =
          parseInt(duracaoLoginAtual) + parseInt(infouser.tmlogin);
        let strPauseFuture = infouser.blockfuture ? 1 : 0;
        let descPauseFuture = infouser.blockfuture ? descfuturepause : " ";
        socket.send(
          "REQ\r\n" +
            infouser.id +
            "\r\nUSERNAME\r\n" +
            infouser.username +
            "\r\nDISPLAYNAME\r\n" +
            infouser.displayname +
            "\r\nEXTEN\r\n" +
            infouser.ramal +
            "\r\nREASON\r\n" +
            chamado +
            "\r\nSTATUS\r\nAT\r\nSTATUSID\r\n-1\r\nHOUR\r\n" +
            datatime +
            "-00:00:00\r\nDESCRIPTION\r\n" +
            chamado +
            "\r\nEMAIL\r\n \r\nGROUP\r\n" +
            infouser.idgroup +
            "\r\nDTL\r\n" +
            datatime +
            "\r\nGROUPNAME\r\n" +
            infouser.grupo +
            "\r\nPSDCOUNT\r\n" +
            infouser.psdcount +
            "\r\nPSDTMA\r\n" +
            parseInt(infouser.psdtma) +
            "\r\nMNGGROUP\r\n-1\r\nINCALLCOUNT\r\n" +
            infouser.incallcount +
            "\r\nINANSCOUNT\r\n" +
            infouser.inanscount +
            "\r\nINTMANS\r\n" +
            infouser.intmans +
            "\r\nINSLA\r\n100\r\nOUTCALLCOUNT\r\n" +
            (parseInt(infouser.outcallcount) + 1) +
            "\r\nOUTANSCOUNT\r\n" +
            (parseInt(infouser.outanscount) + 1) +
            "\r\nOUTTMANS\r\n" +
            infouser.outtmans +
            "\r\nCOUNTFPAUSE\r\n" +
            parseInt(infouser.psdfbreak) +
            "\r\nOUTSLA\r\n100\r\nDESCFUTUREPAUSE\r\n" +
            descPauseFuture +
            "\r\nINITIALLOGIN\r\n0\r\nTMLOGIN\r\n" +
            duracaoLoginFinal +
            "\r\nCDRID\r\n" +
            retorno +
            "\r\nJSON\r\n" +
            jsonChannelPhoneCall +
            "\r\nMEDIAID\r\n1\r\nFUTUREPAUSE\r\n" +
            strPauseFuture +
            "\r\nSRVIN\r\n\r\n\r\n",
        );
        statusAgentIMSDN = "AT";
        stAgIMSDN = "AT";
        console.log(
          "INGENIUM_ENVIOSTATUS :",
          new Date().toLocaleString(),
          stAgIMSDN,
        );
        requestStatusAgent =
          "REQ\r\n" +
          infouser.id +
          "\r\nUSERNAME\r\n" +
          infouser.username +
          "\r\nDISPLAYNAME\r\n" +
          infouser.displayname +
          "\r\nEXTEN\r\n" +
          infouser.ramal +
          "\r\nREASON\r\n" +
          chamado +
          "\r\nSTATUS\r\nAT\r\nSTATUSID\r\n-1\r\nHOUR\r\n" +
          datatime +
          "-00:00:00\r\nDESCRIPTION\r\n" +
          chamado +
          "\r\nEMAIL\r\n \r\nGROUP\r\n" +
          infouser.idgroup +
          "\r\nDTL\r\n" +
          datatime +
          "\r\nGROUPNAME\r\n" +
          infouser.grupo +
          "\r\nPSDCOUNT\r\n" +
          infouser.psdcount +
          "\r\nPSDTMA\r\n" +
          parseInt(infouser.psdtma) +
          "\r\nMNGGROUP\r\n-1\r\nINCALLCOUNT\r\n" +
          infouser.incallcount +
          "\r\nINANSCOUNT\r\n" +
          infouser.inanscount +
          "\r\nINTMANS\r\n" +
          infouser.intmans +
          "\r\nINSLA\r\n100\r\nOUTCALLCOUNT\r\n" +
          (parseInt(infouser.outcallcount) + 1) +
          "\r\nOUTANSCOUNT\r\n" +
          (parseInt(infouser.outanscount) + 1) +
          "\r\nOUTTMANS\r\n" +
          infouser.outtmans +
          "\r\nCOUNTFPAUSE\r\n" +
          parseInt(infouser.psdfbreak) +
          "\r\nOUTSLA\r\n100\r\nDESCFUTUREPAUSE\r\n" +
          descPauseFuture +
          "\r\nINITIALLOGIN\r\n0\r\nTMLOGIN\r\n" +
          duracaoLoginFinal +
          "\r\nCDRID\r\n" +
          retorno +
          "\r\nJSON\r\n" +
          jsonChannelPhoneCall +
          "\r\nMEDIAID\r\n1\r\nFUTUREPAUSE\r\n" +
          strPauseFuture +
          "r\nSRVIN\r\n\r\n\r\n";
        clearInterval(statusIntervalAgent);
        envioStatusAgente(1002, infouser.sipid);

        if (queueid != "" && queueid > 0) {
          dispatch(RefreshQueueid(retorno, queueid));
          socket.send(
            "CALLQUEUE\r\n" +
              infouser.id +
              "\r\nQUEUEID\r\n" +
              queueid +
              "\r\nCDRID\r\n" +
              cdrold +
              "\r\nTP\r\nCBACK\r\nTMCBACK\r\n0\r\nDT\r\n(null)\r\nCQUEUE\r\n0\r\nUSERNAME\r\n" +
              infouser.username +
              "\r\nCBACKCOUNT\r\n" +
              parseInt(callback_count) +
              "\r\nCDRIDNEW\r\n" +
              "" +
              "\r\n\r\n",
          );
        }
      }
    }
    //})
  }
  //});
};

export const ActiveCallSocketVoz = (
  outband,
  infouser,
  trunk,
  mediaid,
  chamado,
  addtech,
  scriptrunk,
  operator,
  returning,
  queueid,
  recvcount,
  callback_count,
  tech,
  idgrupo_rota,
  idgrupo_transb,
  dispatch,
  ipcurrent,
  cdrold,
  rotaencontrada,
  atdsimult,
  cdrFather,
  dataToRegisterInteractionOnIngDesk = null,
) => {
  var DDD = "";
  var calledDigitado = chamado;
  var rotaTransbordo = idgrupo_transb;
  var callback_count = callback_count + 1;

  var numDigitado = chamado;

  if (chamado.length === 12 || chamado.length === 13) {
    if (chamado.substr(0, 2) === "55") {
      chamado = chamado.substr(2, chamado.length - 1);
    }
  }
  if (chamado.length === 10 || chamado.length === 11) {
    DDD = chamado.substr(0, 2);
    chamado = chamado.substr(2, chamado.length - 1);
    if (chamado.length === 8) {
      if (parseInt(chamado[0]) >= 6 && parseInt(chamado[0]) <= 9)
        chamado = "9" + chamado;
    }
    chamado = DDD + chamado;
  } else if (chamado.length === 8 || chamado.length === 9) {
    if (chamado.length === 8) {
      if (parseInt(chamado[0]) >= 6 && parseInt(chamado[0]) <= 9)
        chamado = "9" + chamado;
    }
    chamado = DDD + chamado;
    calledDigitado = DDD + chamado;
  }
  if (webphone_api.isregistered()) {
    axios
      .get(
        `${connection_platform.type_connect}://${pathname}:${port}/conn/${
          cdrFather ? "insertactivecallfather" : "insertactivecall"
        }?idtrunk=${trunk}&servicecode=${
          outband.idservice
        }&idmidia=${mediaid}&caller=${
          infouser.ramal
        }&called='${numDigitado}'&idcustomer=${
          outband.idcustomer
        }&iddirection=${outband.iddirection}&idfather=${cdrFather}`,
      )
      .then((response) => {
        queueidfila = queueid;
        let retorno = response.data.id;
        operator = operator == null ? "" : operator;
        if (retorno) {
          if (
            Boolean(dataToRegisterInteractionOnIngDesk) &&
            Boolean(dispatch) &&
            typeof dispatch === "function"
          ) {
            dispatch(
              registerInteractionOnIngDesk(
                retorno,
                dataToRegisterInteractionOnIngDesk,
              ),
            );
          }
          let addtechnology = addtech != null ? addtech : "";
          let retornoatt = response.data.id;
          let strChamado =
            chamado.length > 4 ? operator + chamado + addtechnology : chamado;

          if (mediaid === 1 || mediaid === 16) {
            rotaTransbordo = rotaTransbordo != null ? rotaTransbordo : 0;
            webphone_api.setsipheader("");
            webphone_api.setsipheader("X-BargeIn: no");
            if (rotaencontrada == true) {
              let operatorManage = mediaid === 16 ? "" : operator;
              isWhatsVoz = mediaid === 16 ? true : false;

              webphone_api.call(
                operatorManage +
                  chamado +
                  addtechnology +
                  "-" +
                  trunk +
                  "-" +
                  retorno +
                  "-" +
                  tech +
                  "-" +
                  idgrupo_rota +
                  "-" +
                  rotaTransbordo +
                  "-",
              );
              webphone_api.setline(
                operatorManage +
                  chamado +
                  addtechnology +
                  "-" +
                  trunk +
                  "-" +
                  retorno +
                  "-" +
                  tech +
                  "-" +
                  idgrupo_rota +
                  "-" +
                  rotaTransbordo +
                  "-",
              );
              arrayinfoTo[response.data.id] =
                operatorManage +
                chamado +
                addtechnology +
                "-" +
                trunk +
                "-" +
                retorno +
                "-" +
                tech +
                "-" +
                idgrupo_rota +
                "-" +
                rotaTransbordo +
                "-";
              //}
            } else {
              // agents.map(agent =>{
              // 	if(parseInt(chamado)==parseInt(agent.ramal)){
              // 		displayname = agent.label;
              // 		iduser = agent.value;
              // 		agentSelect = agent;
              // 	}
              // });

              webphone_api.call(chamado);
              webphone_api.setline(chamado);
            }

            if (outband.hasprotocol === true) {
              dispatch(gerarProtocolosaida(retorno));
            }
            let datatime = Moment().format("DD/MM/YYYY HH:mm:ss");

            let valorDiferenca = parseInt(
              Math.abs(Math.round(ipcurrent.difftime)),
            );

            if (parseInt(ipcurrent.difftime) < 0) {
              datatime = Moment()
                .subtract(valorDiferenca, "seconds")
                .format("DD/MM/YYYY HH:mm:ss");
            } else {
              datatime = Moment()
                .add(valorDiferenca, "seconds")
                .format("DD/MM/YYYY HH:mm:ss");
            }
            if (chamado.length > 4) {
              console.log("INGENIUM_STATUSCALL_1_100", chamado);
              let arrayAtdJson = [];
              let existNumberAndChannel = false;
              console.log("INGENIUM_STATUSCALL_1_100", atdsimult);
              atdsimult.map((atd) => {
                if (
                  (parseInt(atd.idmidia) === 1 ||
                    parseInt(atd.idmidia) === 16) &&
                  parseInt(atd.telefone) === parseInt(chamado)
                )
                  existNumberAndChannel = true;

                arrayAtdJson.push({
                  idmidia: atd.idmidia,
                  telefone: atd.telefone,
                });
              });
              console.log("INGENIUM_STATUSCALL_1_100", arrayAtdJson);
              if (!existNumberAndChannel) {
                arrayAtdJson.push({
                  idmidia: parseInt(mediaid),
                  telefone: chamado,
                });
              }
              console.log("INGENIUM_STATUSCALL_1_100", arrayAtdJson);
              let jsonChannelPhoneCall = mountCallsStatus(arrayAtdJson);

              console.log("INGENIUM_STATUSCALL_1_100", jsonChannelPhoneCall);
              let data_hora_atual = Moment().format("YYYY/MM/DD HH:mm:ss");
              let duracaoLoginAtual = Moment(data_hora_atual).diff(
                infouser.datalogin,
                "seconds",
              );
              let strPauseFuture = infouser.blockfuture ? 1 : 0;
              let descPauseFuture = infouser.blockfuture
                ? descfuturepause
                : " ";
              let duracaoLoginFinal =
                parseInt(duracaoLoginAtual) + parseInt(infouser.tmlogin);
              socket.send(
                "REQ\r\n" +
                  infouser.id +
                  "\r\nUSERNAME\r\n" +
                  infouser.username +
                  "\r\nDISPLAYNAME\r\n" +
                  infouser.displayname +
                  "\r\nEXTEN\r\n" +
                  infouser.ramal +
                  "\r\nREASON\r\n" +
                  chamado +
                  "\r\nSTATUS\r\nAT\r\nSTATUSID\r\n-1\r\nHOUR\r\n" +
                  datatime +
                  "-00:00:00\r\nDESCRIPTION\r\n" +
                  chamado +
                  "\r\nEMAIL\r\n \r\nGROUP\r\n" +
                  infouser.idgroup +
                  "\r\nDTL\r\n" +
                  datatime +
                  "\r\nGROUPNAME\r\n" +
                  infouser.grupo +
                  "\r\nPSDCOUNT\r\n" +
                  infouser.psdcount +
                  "\r\nPSDTMA\r\n" +
                  parseInt(infouser.psdtma) +
                  "\r\nMNGGROUP\r\n-1\r\nINCALLCOUNT\r\n" +
                  infouser.incallcount +
                  "\r\nINANSCOUNT\r\n" +
                  infouser.inanscount +
                  "\r\nINTMANS\r\n" +
                  infouser.intmans +
                  "\r\nINSLA\r\n100\r\nOUTCALLCOUNT\r\n" +
                  (parseInt(infouser.outcallcount) + 1) +
                  "\r\nOUTANSCOUNT\r\n" +
                  (parseInt(infouser.outanscount) + 1) +
                  "\r\nOUTTMANS\r\n" +
                  infouser.outtmans +
                  "\r\nCOUNTFPAUSE\r\n" +
                  parseInt(infouser.psdfbreak) +
                  "\r\nOUTSLA\r\n100\r\nDESCFUTUREPAUSE\r\n" +
                  descPauseFuture +
                  "\r\nINITIALLOGIN\r\n0\r\nTMLOGIN\r\n" +
                  duracaoLoginFinal +
                  "\r\nJSON\r\n" +
                  jsonChannelPhoneCall +
                  "\r\nCDRID\r\n" +
                  retorno +
                  "\r\nMEDIAID\r\n" +
                  parseInt(mediaid) +
                  "\r\nFUTUREPAUSE\r\n" +
                  strPauseFuture +
                  "\r\nSRVIN\r\n \r\nDIRECTIONCHND\r\n" +
                  outband.iddirection +
                  "\r\n\r\n",
              );
              statusAgentIMSDN = "AT";
              stAgIMSDN = "AT";
              console.log(
                "INGENIUM_ENVIOSTATUS :",
                new Date().toLocaleString(),
                stAgIMSDN,
              );
              requestStatusAgent =
                "REQ\r\n" +
                infouser.id +
                "\r\nUSERNAME\r\n" +
                infouser.username +
                "\r\nDISPLAYNAME\r\n" +
                infouser.displayname +
                "\r\nEXTEN\r\n" +
                infouser.ramal +
                "\r\nREASON\r\n" +
                chamado +
                "\r\nSTATUS\r\nAT\r\nSTATUSID\r\n-1\r\nHOUR\r\n" +
                datatime +
                "-00:00:00\r\nDESCRIPTION\r\n" +
                chamado +
                "\r\nEMAIL\r\n \r\nGROUP\r\n" +
                infouser.idgroup +
                "\r\nDTL\r\n" +
                datatime +
                "\r\nGROUPNAME\r\n" +
                infouser.grupo +
                "\r\nPSDCOUNT\r\n" +
                infouser.psdcount +
                "\r\nPSDTMA\r\n" +
                parseInt(infouser.psdtma) +
                "\r\nMNGGROUP\r\n-1\r\nINCALLCOUNT\r\n" +
                infouser.incallcount +
                "\r\nINANSCOUNT\r\n" +
                infouser.inanscount +
                "\r\nINTMANS\r\n" +
                infouser.intmans +
                "\r\nINSLA\r\n100\r\nOUTCALLCOUNT\r\n" +
                (parseInt(infouser.outcallcount) + 1) +
                "\r\nOUTANSCOUNT\r\n" +
                (parseInt(infouser.outanscount) + 1) +
                "\r\nOUTTMANS\r\n" +
                infouser.outtmans +
                "\r\nCOUNTFPAUSE\r\n" +
                parseInt(infouser.psdfbreak) +
                "\r\nOUTSLA\r\n100\r\nDESCFUTUREPAUSE\r\n" +
                descPauseFuture +
                "\r\nINITIALLOGIN\r\n0\r\nTMLOGIN\r\n" +
                duracaoLoginFinal +
                "\r\nJSON\r\n" +
                jsonChannelPhoneCall +
                "\r\nCDRID\r\n" +
                retorno +
                "\r\nMEDIAID\r\n" +
                parseInt(mediaid) +
                "\r\nFUTUREPAUSE\r\n" +
                strPauseFuture +
                "\r\nSRVIN\r\n \r\nDIRECTIONCHND\r\n" +
                outband.iddirection +
                "\r\n\r\n";
              clearInterval(statusIntervalAgent);
              envioStatusAgente(1374, infouser.sipid);

              if (queueid != "" && queueid > 0) {
                dispatch(RefreshQueueid(retorno, queueid));
                socket.send(
                  "CALLQUEUE\r\n" +
                    infouser.id +
                    "\r\nQUEUEID\r\n" +
                    queueid +
                    "\r\nCDRID\r\n" +
                    cdrold +
                    "\r\nTP\r\nCBACK\r\nTMCBACK\r\n0\r\nDT\r\n(null)\r\nCQUEUE\r\n0\r\nUSERNAME\r\n" +
                    infouser.username +
                    "\r\nCBACKCOUNT\r\n" +
                    parseInt(callback_count) +
                    "\r\nCDRIDNEW\r\n" +
                    response.data.id +
                    "\r\n\r\n",
                );
              }
            }
          }
          //})
        }
      });
  }
};

function makeid(length) {
  var text = "";
  var possible =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz052341234789";
  for (var i = 0; i < length; i++) {
    text += possible.charAt(Math.floor(Math.random() * possible.length));
  }
  return text;
}

export function EhNumeroInternacional(numeroDigitado, idMidia) {
  try {
    const idsMidiasPermitidasParaChamadaInternacional = [1, 5, 12, 8];
    const temIdMidia =
      (Boolean(idMidia) || idMidia === 0) &&
      idsMidiasPermitidasParaChamadaInternacional.includes(parseInt(idMidia));
    if (!temIdMidia) return false;
    const temNumeroDigitado =
      Boolean(numeroDigitado) && typeof numeroDigitado === "string";
    if (!temNumeroDigitado) return false;
    return numeroDigitado.startsWith("00");
  } catch (error) {
    return false;
  }
}

export function formatarNomeDoContato(nome) {
  try {
    const ehNumeroInternacional = EhNumeroInternacional(nome, 5);
    if (!ehNumeroInternacional) return formatTextAndUnicode(nome);
    const numeroFormatado = nome.slice(2);
    return formatTextAndUnicode(numeroFormatado);
  } catch (error) {
    return nome;
  }
}

function normalizarNumeroBrasil(numero) {
  if (!numero) return numero;

  numero = numero.trim();

  // 1 - Internacional (00) → não mexe
  if (numero.startsWith("00")) {
    return numero;
  }

  // 2 - Corrigir duplicidade de 55 (ex: 555571999650675)
  // Se começar com 5555... e for muito grande, remove um 55
  if (numero.startsWith("5555") && numero.length > 13) {
    numero = numero.substring(2); // remove um "55"
  }

  // 3 - Se começa com 55 e já tem tamanho válido → não mexe
  if (numero.startsWith("55") && numero.length >= 12) {
    return numero;
  }

  // 4 - Se NÃO começa com 55 e tem mais de 10 dígitos → adiciona 55
  if (!numero.startsWith("55") && numero.length > 10) {
    return "55" + numero;
  }

  return numero;
}

export const ActiveCallSocket = (
  cdrid,
  mediaid,
  atdid,
  chamado,
  idservice,
  idtrunk,
  iduser,
  username,
  addtech,
  scriptrunk,
  operatorRaw,
  returning,
  infousers,
  queueid,
  recvcount,
  callback_count,
  calledDigitado,
  cdrold,
  rawNumber,
) => {
  var callback_count = callback_count + 1;
  queueidfila = queueid;
  let chamadoFim = chamado;
  const ehNumeroInternacional = EhNumeroInternacional(rawNumber, mediaid);
  const operator = ehNumeroInternacional ? "" : operatorRaw;
  if (parseInt(mediaid) === 5 && chamado.substr(0, 2) === "00") {
    chamadoFim = chamado.substr(2, chamado.length - 1);
  }

  axios
    .get(
      `${
        connection_platform.type_connect
      }://${pathname}:${port}/conn/getnumberclientv2?number=${
        ehNumeroInternacional ? rawNumber : chamadoFim
      }&midiaid=${mediaid}`,
    )
    .then((response) => {
      let addtechnology = addtech != null ? addtech : "";
      let createjsonactcall = "";
      let operatorVerify =
        operator === null ||
        operator === "null" ||
        operator === undefined ||
        operator === ""
          ? ""
          : operator;
      if (
        response.data.nickname &&
        parseInt(mediaid) !== 2 &&
        parseInt(mediaid) !== 5 &&
        chamado.substr(0, 2) !== "00"
      ) {
        chamado = response.data.nickname;
        createjsonactcall =
          '{"CDR":' +
          cdrid +
          ',"MEDIAID":' +
          mediaid +
          ',"ATDID": ' +
          atdid +
          ',"DST":"' +
          chamado +
          addtechnology +
          '","SRVID":' +
          idservice +
          ',"SUBSRVID":' +
          infousers.serviceout +
          ',"TRUNKID":' +
          idtrunk +
          ',"URL":" ","MIMETYPE":" ","CHECK":0}';
      } else if (
        response.data.nickname &&
        parseInt(mediaid) === 5 &&
        addtech !== ""
      ) {
        console.log("CAIUAQUI");
        chamado = response.data.nickname;
        let numeroTratado = normalizarNumeroBrasil(chamado);

        console.log("INGENIUM_WSIOUT:", chamado, numeroTratado, addtechnology);

        createjsonactcall =
          '{"CDR":' +
          cdrid +
          ',"MEDIAID":' +
          mediaid +
          ',"ATDID": ' +
          atdid +
          ',"DST":"' +
          numeroTratado +
          addtechnology +
          '","SRVID":' +
          idservice +
          ',"SUBSRVID":' +
          infousers.serviceout +
          ',"TRUNKID":' +
          idtrunk +
          ',"URL":" ","MIMETYPE":" ","CHECK":0}';
      } else if (parseInt(mediaid) === 2) {
        createjsonactcall =
          '{"CDR":' +
          cdrid +
          ',"MEDIAID":' +
          mediaid +
          ',"ATDID": ' +
          atdid +
          ',"DST":"' +
          calledDigitado +
          '","SRVID":' +
          idservice +
          ',"SUBSRVID":' +
          infousers.serviceout +
          ',"TRUNKID":' +
          idtrunk +
          ',"URL":" ","MIMETYPE":" ","CHECK":1}';
      } else if (parseInt(mediaid) === 5 && chamado.substr(0, 2) === "00") {
        console.log("CAIUAQUI");
        chamado = chamado.substr(2, chamado.length - 1);
        calledDigitado = calledDigitado.substr(2, calledDigitado.length - 1);
        createjsonactcall =
          '{"CDR":' +
          cdrid +
          ',"MEDIAID":' +
          mediaid +
          ',"ATDID": ' +
          atdid +
          ',"DST":"' +
          calledDigitado +
          addtechnology +
          '","SRVID":' +
          idservice +
          ',"SUBSRVID":' +
          infousers.serviceout +
          ',"TRUNKID":' +
          idtrunk +
          ',"URL":" ","MIMETYPE":" ","CHECK":1}';
      } else if (parseInt(mediaid) === 12) {
        createjsonactcall =
          '{"CDR":' +
          cdrid +
          ',"MEDIAID":' +
          mediaid +
          ',"ATDID": ' +
          atdid +
          ',"DST":"' +
          operatorVerify +
          calledDigitado +
          addtechnology +
          '","SRVID":' +
          idservice +
          ',"SUBSRVID":' +
          infousers.serviceout +
          ',"TRUNKID":' +
          idtrunk +
          ',"URL":" ","MIMETYPE":" ","CHECK":0}';
      } else {
        let numeroTratado = calledDigitado;
        if (parseInt(mediaid) === 5) {
          numeroTratado = normalizarNumeroBrasil(calledDigitado);
        } else {
          numeroTratado = calledDigitado;
        }
        console.log(
          "INGENIUM_WSIOUT:",
          operator,
          calledDigitado,
          numeroTratado,
          addtechnology,
        );
        let checkSend =
          parseInt(mediaid) === 4 ||
          parseInt(mediaid) === 6 ||
          parseInt(mediaid) === 8
            ? "0"
            : "1";

        createjsonactcall =
          '{"CDR":' +
          cdrid +
          ',"MEDIAID":' +
          mediaid +
          ',"ATDID": ' +
          atdid +
          ',"DST":"' +
          operatorVerify +
          calledDigitado +
          addtechnology +
          '","SRVID":' +
          idservice +
          ',"SUBSRVID":' +
          infousers.serviceout +
          ',"TRUNKID":' +
          idtrunk +
          ',"URL":" ","MIMETYPE":" ","CHECK":' +
          checkSend +
          "}";
      }

      socket.send(
        "WSIOUT\r\n" +
          iduser +
          "\r\nTOUSER\r\n" +
          scriptrunk +
          "\r\nJSON\r\n" +
          createjsonactcall +
          "\r\nUSERNAME\r\n" +
          username +
          "\r\n\r\n",
      );
    });

  if (returning === true) {
    ChangeStatusCallback(queueid, username);
    socket.send(
      "CALLQUEUE\r\n" +
        infousers.id +
        "\r\nQUEUEID\r\n" +
        queueid +
        "\r\nCDRID\r\n" +
        cdrold +
        "\r\nTP\r\nCBACK\r\nTMCBACK\r\n0\r\nDT\r\n(null)\r\nCQUEUE\r\n0\r\nUSERNAME\r\n" +
        infousers.username +
        "\r\nCBACKCOUNT\r\n" +
        parseInt(callback_count) +
        "\r\nCDRIDNEW\r\n" +
        cdrid +
        "\r\n\r\n",
    );
  }
};

export const SendSocketClearReturn = (
  callback_count,
  recvcount,
  cdrid,
  cdridnew,
  queueid,
  iduser,
  username,
  tipocback,
  media,
  caller,
  called,
  srvin,
) => {
  SendClearReturnIn(
    callback_count,
    recvcount,
    cdrid,
    cdridnew,
    queueid,
    iduser,
    username,
    tipocback,
    media,
    caller,
    called,
    srvin,
  );
};

export const SendSocketIvrCall = (cdr, serviceinid, userid) => {
  SendSocketIvrCallTransfer(cdr, serviceinid, userid);
};

export const DeleteListCall = (infousers, queueid, cdrid) => {
  DeleteCall(infousers, queueid, cdrid);
};

function DeleteCall(infousers, queueid, cdrid) {
  socket.send(
    "CALLQUEUE\r\n" +
      infousers.id +
      "\r\nQUEUEID\r\n" +
      queueid +
      "\r\nCDRID\r\n" +
      cdrid +
      "\r\nTP\r\nRM\r\nTMCBACK\r\n0\r\nCQUEUE\r\n0\r\nUSERNAME\r\n" +
      infousers.username +
      "\r\n\r\n",
  );
}

export const sendFurtClient = (infousers, queueid, cdrid) => {
  sendMsgfurt(infousers, queueid, cdrid);
};

function sendMsgfurt(infousers, cdrid, iduserout) {
  let msg = "TRANSFERCLP:" + cdrid;
  socket.send(
    "USRMSGLOG\r\n" +
      infousers.id +
      "\r\nTYPE\r\n0\r\nTOUSER\r\n" +
      iduserout +
      "\r\nCALLID\r\n" +
      makeid(32) +
      "\r\nUSERNAME\r\n" +
      infousers.username +
      "\r\nMSG\r\n" +
      msg +
      "\r\nWRNG\r\n0\r\n",
  );
}

export const SendSocketConferenceCall = (contactId, chat, dispatch) => {
  if (connection_platform.client_webrtc) {
    if (parseInt(contactId.idmidia) === 1) {
      let ramal = chat.ramal;
      let ramaldtmf = "";

      for (var i = 0; i < ramal.length; i++) {
        ramaldtmf += " " + ramal[i];
      }
      webphone_api.dtmf("#" + ramaldtmf + "        C");
    }
  } else {
    if (chat.voz === true) {
      webphone_api.conference(chat.line, true);
      let datatime = Moment().format("YYYY/MM/DD HH:mm:ss");
      //setTimeout(function(){ dispatch(addChat(chat.iduserout,chat.agent,true,true,chat.ramal,datatime)); }, 2000);
    } else {
      webphone_api.conference(chat.ramal);
      dispatch(editChatInternal(chat.iduserout, true, true));
    }
    webphone_api.setline(parseInt(contactId.line));
    if (webphone_api.isonhold()) webphone_api.hold(false);
  }

  //webphone_api.conference('', false);
};

export const SendSocketTransferCallMonitorIn = (
  iduser,
  cdrid,
  iduserin,
  userout,
  serverid,
  usermon,
  UsersAgents,
  telcliente,
) => {
  SendSocketTransferCallMonitor(
    iduser,
    cdrid,
    iduserin,
    userout,
    serverid,
    usermon,
    UsersAgents,
    telcliente,
  );
};

export const SendSocketTransferCallIn = (
  infousers,
  ContactId,
  agent,
  atdsimult,
  outservices,
  servicegroup,
  dispatch,
  ipcurrent,
  module,
) => {
  SendSocketTransferCall(
    infousers.id,
    ContactId.idatendimento,
    ContactId.direction,
    ContactId.subservico,
    ContactId.serviceatd,
    agent.iduser,
    agent.username,
    atdsimult,
    ContactId.serverid,
    infousers,
  );
  let contador_telefone = ContactId.telefone;
  let moduloUsuario = 0;
  //const {UsersAgents} = getState();

  if (agent.usedmodule) moduloUsuario = agent.usedmodule;
  else moduloUsuario = module;

  if (
    infousers.tmoutacw !== 0 &&
    ContactId.acw !== true &&
    parseInt(ContactId.idmidia) !== 1
  ) {
    dispatch(EditAcwContact(ContactId.idatendimento));
    dispatch(
      tratarAfterCallWorkTransfer(
        infousers.tmoutacw,
        parseInt(ContactId.serviceatd),
      ),
    );
    dispatch(
      createStatusAgent(
        "Aftercallwork",
        ContactId.telefone,
        Moment().format("DD/MM/YYYY HH:mm:ss"),
      ),
    );
  }

  ChangeIndicatorsUser(dispatch, ContactId, infousers, ipcurrent);
  let idservice = outservices;
  let comando = "";
  let datatime = Moment().format("YYYY/MM/DD HH:mm:ss");
  if (parseInt(ContactId.idmidia) === 1 && ContactId.respatendente === false) {
    if (outservices === undefined) {
      idservice = 0;
    } else {
      idservice = outservices.idservice;
    }

    if (ContactId.direction === 1) idservice = 1;
    else idservice = 4;

    //setTimeout(() => {
    //dispatch(RemoveAtd(ContactId.idatendimento));
    //}, 500)

    if (agent.line !== undefined && parseInt(agent.line) > 0) {
      webphone_api.setline(parseInt(agent.line));
      //webphone_api.hangup();
    }
    webphone_api.setline(parseInt(ContactId.line));

    if (parseInt(moduloUsuario) !== 2) {
      webphone_api.setparameter("transfertype", 1);
    }

    if (agent.line !== undefined && parseInt(agent.line) > 0) {
      if (parseInt(ContactId.direction) === 1) {
        if (parseInt(moduloUsuario) !== 0) comando = `${agent.ramal}`;
        else
          comando = `${agent.ramal}=${ContactId.idatendimento}=${idservice}=${ContactId.nomesubservico}+0++0=cfct=${ContactId.telefone}+${infousers.ramal}=${ContactId.serviceatd}=1=1=1=1=1=1=1=2=1=1=0=1=0=${ContactId.idsubservico}=2=`;
      } else if (parseInt(ContactId.direction) === 2) {
        if (parseInt(moduloUsuario) !== 0) comando = `${agent.ramal}`;
        else
          comando = `${agent.ramal}=${ContactId.idatendimento}=${idservice}=+0++0=cfct=${infousers.ramal}+${ContactId.telefone}=${ContactId.serviceatd}=1=1=1=1=1=1=1=2=1=1=0=1=0=${ContactId.idsubservico}=2=`;
      }
    } else {
      if (parseInt(ContactId.direction) === 1) {
        comando = `${agent.ramal}=${ContactId.idatendimento}=${idservice}=${ContactId.nomesubservico}+0++0=cfbt=${ContactId.telefone}+${infousers.ramal}=${ContactId.serviceatd}=1=1=1=1=1=1=1=2=1=1=0=1=0=${ContactId.idsubservico}=2=`;
      } else if (parseInt(ContactId.direction) === 2) {
        comando = `${agent.ramal}=${ContactId.idatendimento}=${idservice}=+0++0=cfbt=${infousers.ramal}+${ContactId.telefone}=${ContactId.serviceatd}=1=1=1=1=1=1=1=2=1=1=0=1=0=${ContactId.idsubservico}=2=`;
      }
    }

    webphone_api.transfer(comando);

    setTimeout(() => {
      webphone_api.hangup();
    }, 1000);

    if (parseInt(moduloUsuario) !== 2) {
      webphone_api.setparameter("transfertype", -1);
    }
  } else if (parseInt(ContactId.idmidia) === 1) {
    webphone_api.hangup();
  }
};

function ChangeIndicatorsUser(
  dispatch,
  atendimento,
  informationusers,
  ipcurrent,
) {
  let now = Moment().format("YYYY/MM/DD HH:mm:ss");

  let valorDiferenca = parseInt(Math.abs(Math.round(ipcurrent.difftime)));

  if (parseInt(ipcurrent.difftime) < 0) {
    now = Moment()
      .subtract(valorDiferenca, "seconds")
      .format("YYYY/MM/DD HH:mm:ss");
  } else {
    now = Moment().add(valorDiferenca, "seconds").format("YYYY/MM/DD HH:mm:ss");
  }

  let duracaodocall = Moment(now).diff(
    atendimento.timecomplete,
    "seconds",
    true,
  );

  dispatch(
    EditIndicatorsUser(
      parseInt(atendimento.direction) === 2
        ? duracaodocall + parseInt(informationusers.outtmans)
        : parseInt(informationusers.outtmans),
      parseInt(atendimento.direction) === 1
        ? duracaodocall + parseInt(informationusers.intmans)
        : parseInt(informationusers.intmans),
    ),
  );
}

export const SendSocketTransferClient = (simult, ContactId) => {
  // InviteMessage(contactid, infousers, msg, makeid, hsm, paramshsm, idreplyop);

  if (parseInt(simult.direction) === 1) {
    webphone_api.setline(parseInt(simult.line));
    webphone_api.transfer(ContactId.infoinitcall);
  } else {
    webphone_api.setline(parseInt(ContactId.line));
    webphone_api.transfer(simult.infoinitcall);
  }

  setTimeout(() => {
    webphone_api.hangup();
  }, 1000);

  axios.get(
    `${connection_platform.type_connect}://${pathname}:${port}/conn/insertattendantactivity?idatt=${simult.serviceatd}&idfunc=5&observation=${ContactId.telefone}`,
  );
  axios.get(
    `${connection_platform.type_connect}://${pathname}:${port}/conn/insertattendantactivity?idatt=${ContactId.serviceatd}&idfunc=5&observation=${simult.telefone}`,
  );

  return true;
};

export const InviteMessages = (
  contactid,
  infousers,
  msg,
  author,
  makeid,
  hsm,
  paramshsm,
  idreplyop,
  checkparam,
  checkparam2,
  variables,
) => {
  InviteMessage(
    contactid,
    infousers,
    msg,
    makeid,
    hsm,
    paramshsm,
    idreplyop,
    checkparam,
    checkparam2,
    variables,
  );
  return true;
};

export const InviteMessagesMonitoring = (
  contactid,
  infousers,
  msg,
  author,
  makeid,
  line,
) => {
  InviteMessagesMonitoringUser(contactid, infousers, msg, makeid, line);
  return true;
};

export const InviteChatGroups = (
  infousers,
  msgsocket,
  makeid,
  groupsSelecGrupo,
  warning,
) => {
  InviteChatGroup(infousers, msgsocket, makeid, groupsSelecGrupo, warning);
  return true;
};

export const InviteChats = (iduserout, infousers, msg, author, makeid) => {
  InviteChat(iduserout, infousers, msg, makeid);
  return true;
};

export const ChangeAtendimento = (
  infouser,
  atendimento,
  atdsimultaneo,
  ipcurrent,
  currentStatus,
) => {
  ChangeAtdnow(
    infouser,
    atendimento,
    atdsimultaneo,
    ipcurrent,
    currentStatus,
    true,
  );
};

export const sendtypinwebsocket = (typing, infousers, contactid) => {
  sendtypingwebsocket(typing, infousers, contactid);
};

export const sendtypinwebsocketchat = (typing, infousers, chat) => {
  sendtypingwebsocketchat(typing, infousers, chat);
};

export const SendFile = (
  contactid,
  infousers,
  msg,
  caption,
  makeid,
  replyid,
) => {
  UrlFileSend(contactid, infousers, msg, caption, makeid, replyid);
};

export const SendFileMonitoring = (
  contactid,
  infousers,
  msg,
  caption,
  makeid,
  line,
) => {
  UrlFileSendMonitoring(contactid, infousers, msg, caption, makeid, line);
};

export const SendFileForward = (infousers, contactid, msg, makeid) => {
  UrlFileSendForwad(infousers, contactid, msg, makeid);
};

export const InsertIdleSocket = (
  infousers,
  pausa,
  datalogin,
  idpausa,
  status,
  statusagent,
  dispatch,
  getState,
  ipcurrent,
  chatsimult,
) => {
  IdleSocket(
    infousers,
    pausa,
    datalogin,
    idpausa,
    status,
    statusagent,
    dispatch,
    getState,
    ipcurrent,
    chatsimult,
  );
};

export const InitialMonitoring = (userid, userout, line, ramal) => {
  Monitoring(userid, userout, line, ramal);
};

function Monitoring(userid, userout, line, ramal) {
  webphone_api.hangup();

  setTimeout(function () {
    switch (line) {
      case "1":
        // ESCUTA SIGILOSA
        // webphone_api.hangup();
        //webphone_api.setparameter('autohold', 3);
        webphone_api.setsipheader("X-BargeIn: yes");
        webphone_api.conference(ramal + "/sigilo/1/");
        break;
      case "2":
        // SUSSURO
        //webphone_api.hangup();
        //webphone_api.setparameter('autohold', 3);
        webphone_api.setsipheader("");
        // webphone_api.setsipheader('X-BargeIn: no');
        webphone_api.conference(ramal + "/itw/1/");
        break;
      case "3":
        // INTERCALAR
        //webphone_api.hangup();
        webphone_api.setsipheader("");
        //webphone_api.conference(ramal+"/itv/1/");
        webphone_api.call(ramal + "/itv/1/");
        break;
      default:
        break;
    }
    socket.send(
      "WSIMONITOR\r\n" +
        userid +
        "\r\nTOUSER\r\n" +
        userout +
        "\r\nTYPE\r\n" +
        line +
        "\r\n\r\n",
    );
  }, 500);
}

export const CarregarChatSocket = (
  resposta,
  dispatch,
  informationusers,
  currentscreen,
  chatsimult,
  atdsimult,
) => {
  CarregarChat(
    resposta,
    dispatch,
    informationusers,
    currentscreen,
    chatsimult,
    atdsimult,
  );
};

function CarregarChat(
  resposta,
  dispatch,
  informationusers,
  currentscreen,
  chatsimult,
  atdsimult,
) {
  let user = 0;
  resposta.forEach(function (obj) {
    let dia = obj.diaenvio;
    let mes = obj.mesenvio;
    let erro = 0;
    let ano = Moment().format("YYYY");
    mes = meses.indexOf(mes);
    dia = dia + " de " + meses[mes - 1];
    let msg = obj.msg.replace(/(?:\r\n|\r|\n)/gm, "\\n");
    let datatime = Moment().format("YYYY/MM/DD HH:mm:ss");
    if (parseInt(user) === parseInt(obj.userid)) {
      dispatch(
        addMessage(
          obj.id,
          h2p(msg),
          obj.usuarioorigem,
          obj.horaenvio,
          obj.userid,
          "0",
          "visto",
          true,
          dia,
        ),
      );
      axios.get(
        `${connection_platform.type_connect}://${pathname}:${port}/conn/updatechatread?chatid=${obj.id}`,
      );
    } else {
      axios.get(
        `${connection_platform.type_connect}://${pathname}:${port}/conn/updatechatreadgeral?userid=${informationusers.id}`,
      );
      dispatch(
        addChatSimult(
          parseInt(obj.userid),
          obj.displayname,
          false,
          0,
          0,
          datatime,
        ),
      );
      dispatch(
        addChat(parseInt(obj.userid), obj.displayname, false, 0, 0, datatime),
      );
      dispatch(typingadd(parseInt(obj.userid), 0));
      dispatch(
        addMessage(
          obj.id,
          h2p(msg),
          obj.usuarioorigem,
          obj.horaenvio,
          obj.userid,
          "0",
          "visto",
          true,
          dia,
        ),
      );
      axios.get(
        `${connection_platform.type_connect}://${pathname}:${port}/conn/updatechatread?chatid=${obj.id}`,
      );
    }
    user = obj.userid;
    let data = Moment();
    dispatch(InterationNotifier(obj.displayname + ": " + msg, "chat", obj.id));
    if (
      currentscreen.screen != "Equipes" &&
      currentscreen.screen != "Clientes" &&
      currentscreen.screen != "Atendentes" &&
      currentscreen.screen != "Monitorias"
    ) {
      dispatch(
        InsertRegisterNotifier(
          ": " + msg,
          "mensagemchat",
          data,
          obj.displayname,
          obj.msg,
          "1",
          obj.id,
          obj.userid,
        ),
      );
    }

    if (currentscreen.screen === "Clientes" && atdsimult.length === 0) {
      dispatch(
        InsertRegisterNotifier(
          ": ",
          "mensagemchat",
          data,
          obj.displayname,
          obj.msg,
          "1",
          obj.id,
          obj.userid,
        ),
      );
    }
    socket.send(
      "USRMSGLOGREAD\r\n" +
        informationusers.id +
        "\r\nTOUSER\r\n" +
        obj.userid +
        "\r\nCALLID\r\n" +
        makeid(32) +
        "\r\nUSERNAME\r\n" +
        informationusers.username +
        "\r\nMSGID\r\n" +
        obj.id +
        "\r\nWRNG\r\n0\r\n",
    );
  });
}

function UrlFileSendForwad(infousers, contactid, msg, makeid) {
  socket.send(
    "WSIMSGLOG\r\n" +
      infousers.id +
      "\r\nTYPE\r\n1\r\nTOUSER\r\n" +
      contactid.serverid +
      "\r\nTOCLIENT\r\n" +
      contactid.idatendimento +
      "\r\nCALLID\r\n" +
      makeid +
      "\r\nUSERNAME\r\n" +
      infousers.displayname +
      "\r\nMSG\r\n" +
      msg +
      "\r\n\r\n",
  );
}

function UrlFileSend(infousers, contactid, msg, caption, makeid, idreplyop) {
  let separador = msg.split(".");
  var mimetype = "";
  let msgreplyadd = "";
  if (parseInt(idreplyop) > 0) msgreplyadd = "\r\nREPLYID\r\n" + idreplyop;
  switch (separador[1].toLowerCase()) {
    case "jpeg":
    case "png":
    case "jpg":
      mimetype = "image/jpeg";
      break;

    case "pdf":
      mimetype = "application/pdf";
      break;

    case "xls":
      mimetype = "application/vnd.ms-excel";
      break;

    case "xlsx":
      mimetype =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
      break;

    case "doc":
      mimetype = "application/msword";
      break;

    case "docx":
      mimetype =
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
      break;

    case "ppt":
      mimetype = "application/vnd.ms-powerpoint";
      break;

    case "pptx":
      mimetype =
        "application/vnd.openxmlformats-officedocument.presentationml.presentation";
      break;

    case "wav":
      mimetype = "audio/wav";
      break;

    case "mp3":
      // mimetype = "audio/mp3";
      mimetype = "audio/mpeg";
      break;

    case "ogg":
      mimetype = "audio/ogg";
      break;

    case "mpeg":
      mimetype = "audio/mpeg";
      break;

    case "mp4":
      mimetype = "video/mp4";
      break;

    case "xlsm":
      mimetype = "application/vnd.ms-excel.sheet.macroEnabled.12";
      break;

    case "zip":
      mimetype = "application/x-zip-compressed";
      break;
    default:
      axios
        .get(
          `${connection_platform.type_connect}://${pathname}:${port}/conn/getmimetype?subtype=` +
            separador[1].toLowerCase(),
        )
        .then((response) => {
          mimetype =
            response.data.length > 0 && response.data[0].template !== undefined
              ? response.data[0].template
              : "";
        });
  }

  caption = escape(caption);
  caption = caption.replace(/%u/gi, "\\u");
  caption = unescape(caption);

  setTimeout(() => {
    let createjson =
      '{"CDR":' +
      contactid.idatendimento +
      ',"URL":"' +
      msg +
      '", "THUMBNAIL":"", "CAPTION":"' +
      caption +
      '","MIMETYPE":"' +
      mimetype +
      '"}';
    socket.send(
      "WSIMSGLOG\r\n" +
        infousers.id +
        "\r\nTYPE\r\n1\r\nTOUSER\r\n" +
        contactid.serverid +
        "\r\nTOCLIENT\r\n" +
        contactid.idatendimento +
        "\r\nCALLID\r\n" +
        makeid +
        "\r\nUSERNAME\r\n" +
        infousers.displayname +
        "\r\nMSG\r\n" +
        createjson +
        "" +
        msgreplyadd +
        "\r\n\r\n",
    );
  }, 500);
}

function UrlFileSendMonitoring(
  infousers,
  contactid,
  msg,
  caption,
  makeid,
  line,
) {
  let separador = msg.split(".");
  var mimetype = "";
  switch (separador[1].toLowerCase()) {
    case "jpeg":
    case "png":
    case "jpg":
      mimetype = "image/jpeg";
      break;

    case "pdf":
      mimetype = "application/pdf";
      break;

    case "xls":
      mimetype = "application/vnd.ms-excel";
      break;

    case "xlsx":
      mimetype =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
      break;

    case "doc":
      mimetype = "application/msword";
      break;

    case "docx":
      mimetype =
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
      break;

    case "ppt":
      mimetype = "application/vnd.ms-powerpoint";
      break;

    case "pptx":
      mimetype =
        "application/vnd.openxmlformats-officedocument.presentationml.presentation";
      break;

    case "wav":
      mimetype = "audio/wav";
      break;

    case "mp3":
      mimetype = "audio/mp3";
      break;

    case "ogg":
      mimetype = "audio/ogg";
      break;

    case "mpeg":
      mimetype = "audio/mpeg";
      break;

    case "mp4":
      mimetype = "video/mp4";
      break;

    case "xlsm":
      mimetype = "application/vnd.ms-excel.sheet.macroEnabled.12";
      break;

    case "zip":
      mimetype = "application/x-zip-compressed";
      break;

    default:
      axios
        .get(
          `${connection_platform.type_connect}://${pathname}:${port}/conn/getmimetype?subtype=` +
            separador[1].toLowerCase(),
        )
        .then((response) => {
          mimetype =
            response.data[0] && response.data[0].template !== undefined
              ? response.data[0].template
              : mimetype;
        });
  }
  setTimeout(() => {
    let createjson =
      '{"CDR":' +
      contactid.idatendimento +
      ',"URL":"' +
      msg +
      '", "THUMBNAIL":"", "CAPTION":"' +
      caption +
      '","MIMETYPE":"' +
      mimetype +
      '"}';
    socket.send(
      "WSIMSGLOG\r\n" +
        infousers.id +
        "\r\nTYPE\r\n1\r\nTOUSER\r\n" +
        contactid.serverid +
        "\r\nTOCLIENT\r\n" +
        contactid.idatendimento +
        "\r\nCALLID\r\n" +
        makeid +
        "\r\nUSERNAME\r\n" +
        infousers.displayname +
        "\r\nMSG\r\n" +
        createjson +
        "\r\nMONUSER\r\n" +
        infousers.id +
        "\r\nTMON\r\n" +
        line +
        "\r\n\r\n",
    );
  }, 500);
}

export const SendByeAttendant = (
  getState,
  contactid,
  infousers,
  dispatch,
  reason,
  atdsimult,
  status,
  payload,
) => {
  ByeClient(
    getState,
    contactid,
    infousers,
    dispatch,
    reason,
    atdsimult,
    status,
    payload,
    contactid,
  );
  const { listcallqueue, informationusers, queuepermission, displaynextatd } =
    getState();

  VerifiedReturn(
    listcallqueue,
    informationusers,
    queuepermission,
    displaynextatd,
    contactid,
    dispatch,
    atdsimult,
    reason,
  );
};

export const SendAttendant = (
  proximoatd,
  mensagem,
  contactid,
  infousers,
  dispatch,
  ipcurrent,
  future,
  atdsimult,
) => {
  ProximoAtdSimult(
    proximoatd,
    mensagem,
    contactid,
    infousers,
    dispatch,
    ipcurrent, //future,
    atdsimult,
  );
};

function SendClearReturnIn(
  callback_count,
  recvcount,
  cdrid,
  cdridnew,
  queueid,
  iduser,
  username,
  tipocback,
  media,
  caller,
  called,
  srvin,
) {
  if (tipocback === "RM") {
    axios.get(
      `${connection_platform.type_connect}://${pathname}:${port}/conn/clearqueue?cdr=${cdrid}&queueid=${queueidfila}&novocdr=${cdridnew}&usuario=${iduser}&opcao=t&media=${media}`,
    );
    queueidfila = 0;
    socket.send(
      "CALLQUEUE\r\n" +
        iduser +
        "\r\nQUEUEID\r\n" +
        queueid +
        "\r\nCDRID\r\n" +
        cdrid +
        "\r\nTP\r\n" +
        tipocback +
        "\r\nCBACKCOUNT\r\n" +
        parseInt(callback_count) +
        "\r\nTMCBACK\r\n0\r\nCQUEUE\r\n0\r\nUSERNAME\r\n" +
        username +
        "\r\nCDRIDNEW\r\n" +
        cdridnew +
        "\r\n\r\n",
    );
  } else if (tipocback === "NANS") {
    axios.get(
      `${connection_platform.type_connect}://${pathname}:${port}/conn/clearqueue?cdr=${cdrid}&queueid=${queueidfila}&novocdr=${cdridnew}&usuario=${iduser}&opcao=f&media=${media}`,
    );
    queueidfila = 0;
    callback_count++;
    var reason = username + "-" + "Sem Sucesso;";
    socket.send(
      "CALLQUEUE\r\n" +
        iduser +
        "\r\nQUEUEID\r\n" +
        queueid +
        "\r\nCDRID\r\n" +
        cdrid +
        "\r\nTP\r\n" +
        tipocback +
        "\r\nCBACKCOUNT\r\n" +
        parseInt(callback_count) +
        "\r\nTMCBACK\r\n0\r\nCQUEUE\r\n0\r\nREASON\r\n" +
        reason +
        "\r\nUSERNAME\r\n" +
        username +
        "\r\nCDRIDNEW\r\n" +
        cdridnew +
        "\r\n\r\n",
    );
  }
}

function VerifiedReturn(
  listcallqueue,
  informationusers,
  queuepermission,
  displaynextatd,
  contactid,
  dispatch,
  atdsimult,
  reason,
) {
  var queuepermission = queuepermission.queuepermission;
  var display = displaynextatd.displaynextatdtemp;
  var auxtemp = false;
  var customerwait = true;
  var queueid = contactid.queueid;
  var active = false;

  if (listcallqueue.length != 0) {
    for (let i = 0; i < listcallqueue.length; i++) {
      if (queueid === listcallqueue[i].queueid) {
        var recvcount = listcallqueue[i].recvcount;
        var cbackcount = listcallqueue[i].callback_count;
        var cdridnew = contactid.idatendimento;
        var cdrid = listcallqueue[i].cdrid;
        var queueid = listcallqueue[i].queueid;
        var caller = listcallqueue[i].caller;
        var called = listcallqueue[i].called;
        var media = listcallqueue[i].mediaid;
        var username = informationusers.username;
        var respatendente = listcallqueue[i].respatendente;
        var respclient = listcallqueue[i].respclient;
        var srvin = listcallqueue[i].serviceinid;
        var iduser = informationusers.id;
        active = true;
      }

      if (parseInt(listcallqueue[i].caller) === parseInt(contactid.servico)) {
        var recvcount = listcallqueue[i].recvcount;
        var cbackcount = listcallqueue[i].callback_count;
        var cdridnew = contactid.idatendimento;
        var cdrid = listcallqueue[i].cdrid;
        var queueid = listcallqueue[i].queueid;
        var caller = listcallqueue[i].caller;
        var called = listcallqueue[i].called;
        var media = listcallqueue[i].mediaid;
        var username = informationusers.username;
        var respatendente = listcallqueue[i].respatendente;
        var respclient = listcallqueue[i].respclient;
        var srvin = listcallqueue[i].serviceinid;
        var iduser = informationusers.id;
        var statusqueue = listcallqueue[i].status;
        active = true;
      }
    }

    for (let i = 0; i < queuepermission.length; i++) {
      if (parseInt(queuepermission[i].serviceinid) === parseInt(srvin)) {
        var customerwait = queuepermission[i].customer_wait;
      }
    }

    if (respclient === 1) auxtemp = true;

    if (respatendente === 1 && customerwait === false) auxtemp = true;

    if (active === true) {
      if (auxtemp === true) {
        var tipocback = "RM";
      } else {
        var tipocback = "NANS";
      }

      if (tipocback === "RM") {
        dispatch(deleteListCallQueue(queueid));
        axios.get(
          `${connection_platform.type_connect}://${pathname}:${port}/conn/clearqueue?cdr=${cdrid}&queueid=${queueid}&novocdr=${cdridnew}&usuario=${iduser}&opcao=t&media=${media}`,
        );
        queueidfila = 0;
        socket.send(
          "CALLQUEUE\r\n" +
            iduser +
            "\r\nQUEUEID\r\n" +
            queueid +
            "\r\nCDRID\r\n" +
            cdrid +
            "\r\nTP\r\n" +
            tipocback +
            "\r\nCBACKCOUNT\r\n" +
            parseInt(cbackcount) +
            "\r\nTMCBACK\r\n0\r\nCQUEUE\r\n0\r\nUSERNAME\r\n" +
            username +
            "\r\nCDRIDNEW\r\n" +
            cdridnew +
            "\r\n\r\n",
        );
      } else if (tipocback === "NANS" && parseInt(statusqueue) !== 1) {
        dispatch(clearReturnClient(caller, "0"));
        dispatch(returnListCallQueue("CBACK", queueid, "0", cbackcount));
        axios.get(
          `${connection_platform.type_connect}://${pathname}:${port}/conn/clearqueue?cdr=${cdrid}&queueid=${queueid}&novocdr=${cdridnew}&usuario=${iduser}&opcao=f&media=${media}`,
        );
        queueidfila = 0;
        cbackcount++;
        var reason = username + "-" + "Sem Sucesso;";
        socket.send(
          "CALLQUEUE\r\n" +
            iduser +
            "\r\nQUEUEID\r\n" +
            queueid +
            "\r\nCDRID\r\n" +
            cdrid +
            "\r\nTP\r\n" +
            tipocback +
            "\r\nCBACKCOUNT\r\n" +
            parseInt(cbackcount) +
            "\r\nTMCBACK\r\n0\r\nCQUEUE\r\n0\r\nREASON\r\n" +
            reason +
            "\r\nUSERNAME\r\n" +
            username +
            "\r\nCDRIDNEW\r\n" +
            cdridnew +
            "\r\n\r\n",
        );
      }
    }
  }

  if (informationusers.tmoutacw === 0 && reason !== "quarentine") {
    dispatch(ShowVisibleNextAtd(display, display));
  }

  if (contactid.acw === true && localStorage.getItem("url_iframe") === "") {
    dispatch(ShowVisibleNextAtd(display, display));
  }

  if (
    contactid.acw === true &&
    atdsimult.length === 1 &&
    localStorage.getItem("url_iframe") !== ""
  ) {
    dispatch(ShowVisibleNextAtd(display, display));
  }

  // if(informationusers.tmoutacw !== 0 && parseInt(contactid.idmidia) !== 1)
  // 	dispatch(ShowVisibleNextAtd(display,display))
}

function RequestCallPark(infouser, scriptid, cdrid, mediaid) {
  socket.send(
    "CALLPARK\r\n" +
      infouser.id +
      "\r\nSCRIPT\r\n" +
      scriptid +
      "\r\nCDRID\r\n" +
      cdrid +
      "\r\nMEDIA\r\n" +
      mediaid +
      "\r\nUSERNAME\r\n" +
      infouser.username +
      "\r\nDISPLAYNAME\r\n" +
      infouser.displayname +
      "\r\nEXTEN\r\n" +
      infouser.ramal +
      "\r\n\r\n",
  );
  cdrparkid = cdrid;
  InsertActivityCDR(cdrid, 12, infouser.id, "Captura de chamada pelo agente");
}

function RequestCallParkTransfer(agent, scriptid, cdrid, mediaid, iduser) {
  socket.send(
    "CALLPARK\r\n" +
      iduser +
      "\r\nSCRIPT\r\n" +
      scriptid +
      "\r\nCDRID\r\n" +
      cdrid +
      "\r\nMEDIA\r\n" +
      mediaid +
      "\r\nUSERNAME\r\n" +
      agent.username +
      "\r\nDISPLAYNAME\r\n" +
      agent.label +
      "\r\nEXTEN\r\n" +
      agent.ramal +
      "\r\nMONUSER\r\n" +
      iduser +
      "\r\nGROUPNAME\r\n" +
      agent.desc_grupo +
      "\r\nTOAGENT\r\n" +
      agent.iduser +
      "\r\n\r\n",
  );
  InsertActivityCDR(cdrid, 13, iduser, "Distribuicao de chamadas pelo gestor");
  cdrparkid = cdrid;
}

function EfectBlockUser(infouser, userout, act, reason, agents) {
  socket.send(
    "SUP_ACT\r\n" +
      infouser.id +
      "\r\nTOUSER\r\n" +
      userout +
      "\r\nUSERNAME\r\n" +
      infouser.username +
      "\r\nACT\r\n" +
      act +
      "\r\nREASON\r\n" +
      reason +
      "\r\n\r\n",
  );

  if (parseInt(act) == 2) {
    let jsonagentdisconnect = agents.filter(
      (agente) => agente.iduser === userout,
    );

    let agentdisconnect = jsonagentdisconnect ? jsonagentdisconnect[0] : null;

    let timelogout = Moment().format("DD/MM/YYYY HH:mm:ss") + "-00:00:00";
    if (agentdisconnect != null) {
      socket.send(
        "REQ\r\n" +
          agentdisconnect.iduser +
          "\r\nUSERNAME\r\n" +
          agentdisconnect.username +
          "\r\nDISPLAYNAME\r\n" +
          agentdisconnect.username +
          "\r\nEXTEN\r\n" +
          agentdisconnect.ramal +
          "\r\nREASON\r\n \r\nSTATUS\r\n \r\nSTATUSID\r\n4\r\nHOUR\r\n" +
          timelogout +
          "\r\nDESCRIPTION\r\n \r\nEMAIL\r\n \r\nGROUP\r\n" +
          agentdisconnect.id_grupo +
          "\r\nDTL\r\n" +
          timelogout +
          "\r\nGROUPNAME\r\n" +
          agentdisconnect.desc_grupo +
          "\r\nPSDCOUNT\r\n" +
          parseInt(agentdisconnect.psdcount) +
          "\r\nPSDTMA\r\n" +
          parseInt(agentdisconnect.psdtma) +
          "\r\nMNGGROUP\r\n-1\r\nINCALLCOUNT\r\n" +
          agentdisconnect.incallcount +
          "\r\nINANSCOUNT\r\n" +
          agentdisconnect.inanscount +
          "\r\nINTMANS\r\n" +
          parseInt(agentdisconnect.intmans) +
          "\r\nINSLA\r\n100\r\nOUTCALLCOUNT\r\n" +
          agentdisconnect.outcallcount +
          "\r\nOUTANSCOUNT\r\n" +
          agentdisconnect.outanscount +
          "\r\nOUTTMANS\r\n" +
          agentdisconnect.outtmans +
          "\r\nOUTSLA\r\n100\r\nTMLOGIN\r\n" +
          agentdisconnect.tmlogin +
          "\r\nJSON\r\n \r\nCOUNTFPAUSE\r\n \r\nFUTUREPAUSE\r\n0\r\nDESCFUTUREPAUSE\r\n \r\nINITIALLOGIN\r\n0\r\n\r\n",
      );

      LogoutInGestor(agentdisconnect.iduser);
    }
  }
}

function SendSocketIvrCallTransfer(contactid, serviceinid, infousers) {
  let userid = infousers.id;
  let cdr = contactid.idatendimento;
  let comando = "";

  var arrayjson = '{"CDR": ' + cdr + ', "ARRAYSUBSRV":[' + serviceinid + "]}";
  // SE FOR VOZ ELE NÃO PRECISA ENVIAR O WEBSOCKET

  axios.get(
    `${connection_platform.type_connect}://${pathname}:${port}/conn/insertattendantactivity?idatt=${contactid.serviceatd}&idfunc=11&idsrvin=${serviceinid}`,
  );
  //axios.get(`${connection_platform.type_connect}://${pathname}:${port}/conn/insertivrcalltransfer?idatt=${contactid.serviceatd}&srvid=${serviceinid}`)

  if (parseInt(contactid.idmidia) === 1) {
    //webphone_api.setparameter('transfertype', 3);
    var servicoSolicitado = "";
    if (parseInt(contactid.direction) == 1) {
      servicoSolicitado = infousers.idin;
    } else {
      servicoSolicitado = infousers.idout;
    }

    if (contactid.direction == 1) {
      comando = `${serviceinid}cfg=${cdr}=${servicoSolicitado}=${contactid.nomesubservico}+1++0=ivr=${contactid.telefone}+${contactid.mcdu}=${infousers.username}+${serviceinid}=${contactid.serviceatd}=1=1=1=1=1=1=1=1=1=1=0=1=${serviceinid}=0=0=`;
    } else {
      comando = `${serviceinid}cfg=${cdr}=${servicoSolicitado}=+0++0=ivr=${infousers.ramal}+${contactid.telefone}=${infousers.username}+${serviceinid}=${contactid.serviceatd}=1=1=1=1=1=1=1=1=1=1=0=1=${serviceinid}=13=2=`;
    }

    webphone_api.transfer(comando);
    webphone_api.setparameter("transfertype", 1);
  } else {
    socket.send(
      "RETURNBOT\r\n" +
        userid +
        "\r\nTOIMSCHAT\r\n" +
        contactid.serverid +
        "\r\nJSON\r\n" +
        arrayjson +
        "\r\n\r\n",
    );
  }
}

function sendtypingwebsocket(typing, infousers, contactid) {
  socket.send(
    "WSITYPING\r\n" +
      infousers.id +
      "\r\nTOUSER\r\n" +
      contactid.serverid +
      "\r\nTOCLIENT\r\n" +
      contactid.idatendimento +
      "\r\nTYPING\r\n" +
      typing +
      "\r\nUSERNAME\r\n" +
      infousers.username +
      "\r\n\r\n",
  );
}

function sendtypingwebsocketchat(typing, infousers, chat) {
  socket.send(
    "USRTYPING\r\n" +
      infousers.id +
      "\r\nTOUSER\r\n" +
      chat.iduserout +
      "\r\nTYPING\r\n" +
      typing +
      "\r\nUSERNAME\r\n" +
      infousers.username +
      "\r\n\r\n",
  );
}

function RegisterReqSocket(
  userid,
  displayname,
  idgroup,
  ramal,
  grupo,
  username,
  sipid,
  callpark,
  qtdequeue,
  supervisor,
  strSubMonit,
  strGrp,
  inanscount,
  incallcount,
  intmans,
  outanscount,
  outcallcount,
  outtmans,
  psdcount,
  psdtma,
  tmlogin,
  ipcurrent,
  blockscreen,
  user_midias,
) {
  ramaluser = ramal;
  let post = Moment().format("DD/MM/YYYY HH:mm:ss");
  let valorDiferenca = parseInt(Math.abs(Math.round(ipcurrent.data)));
  let datalogin = Moment().format("DD/MM/YYYY HH:mm:ss");

  if (parseInt(ipcurrent.data) < 0) {
    post = Moment()
      .subtract(valorDiferenca, "seconds")
      .format("DD/MM/YYYY HH:mm:ss");
  } else {
    post = Moment()
      .add(valorDiferenca, "seconds")
      .format("DD/MM/YYYY HH:mm:ss");
  }

  acessoFila = callpark === true ? 1 : 0;
  perfilUser = supervisor === true ? 7 : 1;
  stringGrupoFila = strGrp;
  stringSubMonitoria = strSubMonit;
  qtde_fila = qtdequeue;

  let foundMidia = user_midias.find((element) => element == 1);

  verificationMidiaVoz = user_midias.includes(1);

  envioStatusAgente(2859, sipid);
  startHeartbeat();
  socket.send(
    "REGISTER\r\n" +
      userid +
      "\r\nTYPE\r\n" +
      perfilUser +
      "\r\nCPARK\r\n" +
      acessoFila +
      "\r\nGRP\r\n" +
      stringGrupoFila +
      "&\r\nSUBSRV\r\n" +
      stringSubMonitoria +
      "&\r\nMOD\r\n0\r\nRECONN\r\n0\r\n\r\n",
  );
  if (checkRegisterInitial) {
    socket.send(
      "REQ\r\n" +
        userid +
        "\r\nUSERNAME\r\n" +
        username +
        "\r\nDISPLAYNAME\r\n" +
        displayname +
        "\r\nEXTEN\r\n" +
        ramal +
        "\r\nREASON\r\n \r\nSTATUS\r\nLV\r\nSTATUSID\r\n-1\r\nHOUR\r\n" +
        post +
        "-00:00:00\r\nDESCRIPTION\r\n \r\nEMAIL\r\n \r\nGROUP\r\n" +
        idgroup +
        "\r\nDTL\r\n" +
        datalogin +
        "\r\nGROUPNAME\r\n" +
        grupo +
        "\r\nPSDCOUNT\r\n" +
        parseInt(psdcount) +
        "\r\nPSDTMA\r\n" +
        parseInt(psdtma) +
        "\r\nMNGGROUP\r\n-1\r\nINCALLCOUNT\r\n" +
        parseInt(incallcount) +
        "\r\nINANSCOUNT\r\n" +
        parseInt(inanscount) +
        "\r\nINTMANS\r\n" +
        parseInt(intmans) +
        "\r\nINSLA\r\n100\r\nOUTCALLCOUNT\r\n" +
        parseInt(outcallcount) +
        "\r\nOUTANSCOUNT\r\n" +
        parseInt(outanscount) +
        "\r\nOUTTMANS\r\n" +
        parseInt(outtmans) +
        "\r\nOUTSLA\r\n100\r\nTMLOGIN\r\n" +
        parseInt(tmlogin) +
        "\r\nJSON\r\n \r\nCOUNTFPAUSE\r\n0\r\nFUTUREPAUSE\r\n0\r\nDESCFUTUREPAUSE\r\n \r\nINITIALLOGIN\r\n1\r\n\r\n",
    );
  }

  if (blockscreen === true) {
    if (foundMidia !== 1) {
      setTimeout(() => {
        socket.send(
          "REQ\r\n" +
            userid +
            "\r\nUSERNAME\r\n" +
            username +
            "\r\nDISPLAYNAME\r\n" +
            displayname +
            "\r\nEXTEN\r\n" +
            ramal +
            "\r\nREASON\r\nBloqueado pelo Supervisor\r\nSTATUS\r\nBQSUPER\r\nSTATUSID\r\n-1\r\nHOUR\r\n" +
            post +
            "-00:00:00\r\nDESCRIPTION\r\n \r\nEMAIL\r\n \r\nGROUP\r\n" +
            idgroup +
            "\r\nDTL\r\n" +
            post +
            "\r\nGROUPNAME\r\n" +
            grupo +
            "\r\nPSDCOUNT\r\n" +
            parseInt(psdcount) +
            "\r\nPSDTMA\r\n" +
            parseInt(psdtma) +
            "\r\nMNGGROUP\r\n-1\r\nINCALLCOUNT\r\n" +
            parseInt(incallcount) +
            "\r\nINANSCOUNT\r\n" +
            parseInt(inanscount) +
            "\r\nINTMANS\r\n" +
            parseInt(intmans) +
            "\r\nINSLA\r\n100\r\nOUTCALLCOUNT\r\n" +
            parseInt(outcallcount) +
            "\r\nOUTANSCOUNT\r\n" +
            parseInt(outanscount) +
            "\r\nOUTTMANS\r\n" +
            parseInt(outtmans) +
            "\r\nOUTSLA\r\n100\r\nTMLOGIN\r\n" +
            parseInt(tmlogin) +
            "\r\nCOUNTFPAUSE\r\n" +
            parseInt(countFuturePause) +
            "\r\nDESCFUTUREPAUSE\r\n \r\nINITIALLOGIN\r\n1\r\nFUTUREPAUSE\r\n0\r\nMOD\r\n0\r\n\r\n",
        );
      }, 500);
      statusAgentIMSDN = "BQSUPER";
      stAgIMSDN = "BQSUPER";
      console.log(
        "INGENIUM_ENVIOSTATUS :",
        new Date().toLocaleString(),
        stAgIMSDN,
      );
      requestStatusAgent =
        "REQ\r\n" +
        userid +
        "\r\nUSERNAME\r\n" +
        username +
        "\r\nDISPLAYNAME\r\n" +
        displayname +
        "\r\nEXTEN\r\n" +
        ramal +
        "\r\nREASON\r\nBloqueado pelo Supervisor\r\nSTATUS\r\nBQSUPER\r\nSTATUSID\r\n-1\r\nHOUR\r\n" +
        post +
        "-00:00:00\r\nDESCRIPTION\r\n \r\nEMAIL\r\n \r\nGROUP\r\n" +
        idgroup +
        "\r\nDTL\r\n" +
        post +
        "\r\nGROUPNAME\r\n" +
        grupo +
        "\r\nPSDCOUNT\r\n" +
        parseInt(psdcount) +
        "\r\nPSDTMA\r\n" +
        parseInt(psdtma) +
        "\r\nMNGGROUP\r\n-1\r\nINCALLCOUNT\r\n" +
        parseInt(incallcount) +
        "\r\nINANSCOUNT\r\n" +
        parseInt(inanscount) +
        "\r\nINTMANS\r\n" +
        parseInt(intmans) +
        "\r\nINSLA\r\n100\r\nOUTCALLCOUNT\r\n" +
        parseInt(outcallcount) +
        "\r\nOUTANSCOUNT\r\n" +
        parseInt(outanscount) +
        "\r\nOUTTMANS\r\n" +
        parseInt(outtmans) +
        "\r\nOUTSLA\r\n100\r\nTMLOGIN\r\n" +
        parseInt(tmlogin) +
        "\r\nCOUNTFPAUSE\r\n" +
        parseInt(countFuturePause) +
        "\r\nDESCFUTUREPAUSE\r\n \r\nINITIALLOGIN\r\n0\r\nFUTUREPAUSE\r\n0\r\nMOD\r\n0\r\n\r\n";
      clearInterval(statusIntervalAgent);
      envioStatusAgente(3003, sipid);
    }
  } else {
    if (foundMidia !== 1) {
      setTimeout(() => {
        socket.send(
          "REQ\r\n" +
            userid +
            "\r\nUSERNAME\r\n" +
            username +
            "\r\nDISPLAYNAME\r\n" +
            displayname +
            "\r\nEXTEN\r\n" +
            ramal +
            "\r\nREASON\r\n \r\nSTATUS\r\nLV\r\nSTATUSID\r\n-1\r\nHOUR\r\n" +
            post +
            "-00:00:00\r\nDESCRIPTION\r\n \r\nEMAIL\r\n \r\nGROUP\r\n" +
            idgroup +
            "\r\nDTL\r\n" +
            post +
            "\r\nGROUPNAME\r\n" +
            grupo +
            "\r\nPSDCOUNT\r\n" +
            parseInt(psdcount) +
            "\r\nPSDTMA\r\n" +
            parseInt(psdtma) +
            "\r\nMNGGROUP\r\n-1\r\nINCALLCOUNT\r\n" +
            parseInt(incallcount) +
            "\r\nINANSCOUNT\r\n" +
            parseInt(inanscount) +
            "\r\nINTMANS\r\n" +
            parseInt(intmans) +
            "\r\nINSLA\r\n100\r\nOUTCALLCOUNT\r\n" +
            parseInt(outcallcount) +
            "\r\nOUTANSCOUNT\r\n" +
            parseInt(outanscount) +
            "\r\nOUTTMANS\r\n" +
            parseInt(outtmans) +
            "\r\nOUTSLA\r\n100\r\nTMLOGIN\r\n" +
            parseInt(tmlogin) +
            "\r\nCOUNTFPAUSE\r\n" +
            parseInt(countFuturePause) +
            "\r\nJSON\r\n \r\nFUTUREPAUSE\r\n0\r\nDESCFUTUREPAUSE\r\n \r\nINITIALLOGIN\r\n1\r\n\r\n",
        );
      }, 1500);
      statusAgentIMSDN = "LV";
      stAgIMSDN = "LV";
      console.log(
        "INGENIUM_ENVIOSTATUS :",
        new Date().toLocaleString(),
        stAgIMSDN,
      );
      requestStatusAgent =
        "REQ\r\n" +
        userid +
        "\r\nUSERNAME\r\n" +
        username +
        "\r\nDISPLAYNAME\r\n" +
        displayname +
        "\r\nEXTEN\r\n" +
        ramal +
        "\r\nREASON\r\n \r\nSTATUS\r\nLV\r\nSTATUSID\r\n-1\r\nHOUR\r\n" +
        post +
        "-00:00:00\r\nDESCRIPTION\r\n \r\nEMAIL\r\n \r\nGROUP\r\n" +
        idgroup +
        "\r\nDTL\r\n" +
        post +
        "\r\nGROUPNAME\r\n" +
        grupo +
        "\r\nPSDCOUNT\r\n" +
        parseInt(psdcount) +
        "\r\nPSDTMA\r\n" +
        parseInt(psdtma) +
        "\r\nMNGGROUP\r\n-1\r\nINCALLCOUNT\r\n" +
        parseInt(incallcount) +
        "\r\nINANSCOUNT\r\n" +
        parseInt(inanscount) +
        "\r\nINTMANS\r\n" +
        parseInt(intmans) +
        "\r\nINSLA\r\n100\r\nOUTCALLCOUNT\r\n" +
        parseInt(outcallcount) +
        "\r\nOUTANSCOUNT\r\n" +
        parseInt(outanscount) +
        "\r\nOUTTMANS\r\n" +
        parseInt(outtmans) +
        "\r\nOUTSLA\r\n100\r\nTMLOGIN\r\n" +
        parseInt(tmlogin) +
        "\r\nCOUNTFPAUSE\r\n" +
        parseInt(countFuturePause) +
        "\r\nJSON\r\n \r\nFUTUREPAUSE\r\n0\r\nDESCFUTUREPAUSE\r\n \r\nINITIALLOGIN\r\n0\r\n\r\n";
      clearInterval(statusIntervalAgent);
      envioStatusAgente(3132, sipid);
    }
  }
  socket.send("REQAGENTSTATUS\r\n" + userid + "\r\n\r\n");

  if (supervisor)
    socket.send("MSS_GETINFO\r\n" + userid + "\rSRVIN\r\n-1\r\n\r\n");
}

function checkLoginSendIdle(user_midias, numberAnswers, infousers) {
  let foundMidia = user_midias.find((element) => element == 1);
  const myInterval = setInterval(() => {
    if (foundMidia !== 1 && numberAnswers === 0) {
      UpdateIdleUser(infousers.sipid);
      clearInterval(myInterval);
    }

    if (
      foundMidia === 1 &&
      numberAnswers === 0 &&
      checkLoginInitial === false
    ) {
      UpdateIdleUser(infousers.sipid);
      clearInterval(myInterval);
    }
  }, [2000]);
}

export const checkLStatusstAgIMSDN = (statusIMSDN) => {
  stAgIMSDN = statusIMSDN;
  console.log("INGENIUM_ENVIOSTATUS :", new Date().toLocaleString(), stAgIMSDN);
};

export const changeDisplayByeChat = (cdrid, serverid, iduser, infouser) => {
  InsertActivityCDR(cdrid, 14, infouser.id, "Desconectado pelo gestor");

  //console.log("INGENIUM_WSIBYE_GESTOR: ", iduser);
  //AQUI DEVERA TER ALGO IGUAL ONDE USA A FUNCAO removerNumeroDoJsoncall.
  //PRECISO PEGAR O TELEFONE DO CLIENTE

  socket.send(
    "WSIBYE\r\n" +
      infouser.id +
      "\r\nTOUSER\r\n" +
      serverid +
      "\r\nMONUSER\r\n" +
      infouser.id +
      "\r\nTMON\r\n" +
      "1" +
      "\r\nTOCLIENT\r\n" +
      cdrid +
      "\r\n\r\n",
  );
};
export const sendPauseFuture = (
  infousers,
  stauspf,
  atendimento,
  descpausa,
  idpausa,
  ipcurrent,
  dispatch,
  tipo,
  isToBlockInsertFutureBreak = false,
) => {
  let post = Moment().format("DD/MM/YYYY HH:mm:ss");
  let datalogin = Moment().format("DD/MM/YYYY HH:mm:ss");
  let tmlogin = infousers.tmlogin != null ? infousers.tmlogin : 0;
  //let futurepause = stauspf === "RV" ? 1 : 0;
  let futurepause = tipo === 1 ? 0 : 1;
  let pausafutura = descpausa !== null ? descpausa : "";

  //countFuturePause = stauspf === "RV" ? (parseInt(infousers.psdfbreak)+1) : countFuturePause;

  countFuturePause =
    tipo === 0 ? parseInt(infousers.psdfbreak) + 1 : countFuturePause;

  descfuturepause = descpausa !== null ? descpausa : "";

  dispatch(EditFutureBreak(countFuturePause));

  if (atendimento !== undefined) {
    let data_hora_atual = Moment().format("YYYY/MM/DD HH:mm:ss");
    let duracaoLoginAtual = Moment(data_hora_atual).diff(
      infousers.datalogin,
      "seconds",
    );

    if (
      idpausa !== null &&
      parseInt(idpausa) >= 1 &&
      tipo === 0 &&
      !isToBlockInsertFutureBreak
    ) {
      axios
        .get(
          `${connection_platform.type_connect}://${pathname}:${port}/conn/insertfuturebreak?idreasonblock=${idpausa}&iduser=${infousers.id}&idlogin=${ipcurrent.idlogin}`,
        )
        .then((response) => {
          if (response.data === true) {
            stAgIMSDN = "RV";
            console.log(
              "INGENIUM_ENVIOSTATUS :",
              new Date().toLocaleString(),
              stAgIMSDN,
            );

            //aqui vou mdnar para o imsdn apenas para alterar a variavel lá para RV
          }
        });
    } else if (tipo === 1) {
      axios
        .get(
          `${connection_platform.type_connect}://${pathname}:${port}/conn/updatecancelfuturebreak?iduser=${infousers.id}`,
        )
        .then((response) => {
          if (response.data === true) {
            //checkInsertFutPause = false;
            //aqui vou mdnar para o imsdn apenas para alterar a variavel lá para (VER STATUS)
            stAgIMSDN = "AT";
            console.log(
              "INGENIUM_ENVIOSTATUS :",
              new Date().toLocaleString(),
              stAgIMSDN,
            );
          }
        })
        .catch((error) => {
          dispatch(
            InterationNotifier(
              "Erro ao atualizar seu status. Tente novamente ou contacte o administrador do sistema!!",
              "errordb",
            ),
          );
          axios
            .get(
              `${connection_platform.type_connect}://${pathname}:${port}/conn/updatecancelfuturebreak?iduser=${infousers.id}`,
            )
            .then((response) => {
              if (response.data === true) {
                stAgIMSDN = "AT";
                //aqui vou mdnar para o imsdn apenas para alterar a variavel lá para (VER STATUS)
                console.log(
                  "INGENIUM_ENVIOSTATUS :",
                  new Date().toLocaleString(),
                  stAgIMSDN,
                );
              }
            });
          dispatch(BlockFuture(true));
        });
    }
    let duracaoLoginFinal =
      parseInt(duracaoLoginAtual) + parseInt(infousers.tmlogin);

    let telefonecheck =
      atendimento.telefone !== undefined ? atendimento.telefone : null;
    let servicocheck =
      atendimento.servico !== undefined ? atendimento.servico : null;
    let postcheck = post !== undefined ? post : null;

    statusAgentIMSDN = "AT";
    stAgIMSDN = "AT";
    console.log(
      "INGENIUM_ENVIOSTATUS :",
      new Date().toLocaleString(),
      stAgIMSDN,
    );
    requestStatusAgent =
      "REQ\r\n" +
      infousers.id +
      "\r\nUSERNAME\r\n" +
      infousers.username +
      "\r\nDISPLAYNAME\r\n" +
      infousers.displayname +
      "\r\nEXTEN\r\n" +
      infousers.ramal +
      "\r\nREASON\r\n" +
      telefonecheck +
      "\r\nSTATUS\r\nAT\r\nSTATUSID\r\n-1\r\nHOUR\r\n" +
      postcheck +
      "-00:00:00\r\nDESCRIPTION\r\n" +
      servicocheck +
      "\r\nEMAIL\r\n \r\nGROUP\r\n" +
      infousers.idgroup +
      "\r\nDTL\r\n" +
      datalogin +
      "\r\nGROUPNAME\r\n" +
      infousers.grupo +
      "\r\nPSDCOUNT\r\n" +
      parseInt(infousers.psdcount) +
      "\r\nPSDTMA\r\n" +
      parseInt(infousers.psdtma) +
      "\r\nMNGGROUP\r\n-1\r\nINCALLCOUNT\r\n" +
      parseInt(infousers.incallcount) +
      "\r\nINANSCOUNT\r\n" +
      parseInt(infousers.inanscount) +
      "\r\nINTMANS\r\n" +
      parseInt(durationans) +
      "\r\nINSLA\r\n100\r\nOUTCALLCOUNT\r\n" +
      parseInt(infousers.outcallcount) +
      "\r\nOUTANSCOUNT\r\n" +
      parseInt(infousers.outanscount) +
      "\r\nOUTTMANS\r\n" +
      parseInt(infousers.outtmans) +
      "\r\nOUTSLA\r\n100\r\nTMLOGIN\r\n" +
      parseInt(duracaoLoginFinal) +
      "\r\nFUTUREPAUSE\r\n" +
      parseInt(futurepause) +
      "\r\nDESCFUTUREPAUSE\r\n" +
      pausafutura +
      "\r\nCOUNTFPAUSE\r\n" +
      parseInt(countFuturePause) +
      "\r\nTMFUTUREPAUSE\r\n" +
      post +
      "\r\nJSON\r\n \r\nINITIALLOGIN\r\n0\r\n\r\n";
    socket.send(
      "REQ\r\n" +
        infousers.id +
        "\r\nUSERNAME\r\n" +
        infousers.username +
        "\r\nDISPLAYNAME\r\n" +
        infousers.displayname +
        "\r\nEXTEN\r\n" +
        infousers.ramal +
        "\r\nREASON\r\n" +
        telefonecheck +
        "\r\nSTATUS\r\nAT\r\nSTATUSID\r\n-1\r\nHOUR\r\n" +
        postcheck +
        "-00:00:00\r\nDESCRIPTION\r\n" +
        servicocheck +
        "\r\nEMAIL\r\n \r\nGROUP\r\n" +
        infousers.idgroup +
        "\r\nDTL\r\n" +
        datalogin +
        "\r\nGROUPNAME\r\n" +
        infousers.grupo +
        "\r\nPSDCOUNT\r\n" +
        parseInt(infousers.psdcount) +
        "\r\nPSDTMA\r\n" +
        parseInt(infousers.psdtma) +
        "\r\nMNGGROUP\r\n-1\r\nINCALLCOUNT\r\n" +
        parseInt(infousers.incallcount) +
        "\r\nINANSCOUNT\r\n" +
        parseInt(infousers.inanscount) +
        "\r\nINTMANS\r\n" +
        parseInt(durationans) +
        "\r\nINSLA\r\n100\r\nOUTCALLCOUNT\r\n" +
        parseInt(infousers.outcallcount) +
        "\r\nOUTANSCOUNT\r\n" +
        parseInt(infousers.outanscount) +
        "\r\nOUTTMANS\r\n" +
        parseInt(infousers.outtmans) +
        "\r\nOUTSLA\r\n100\r\nTMLOGIN\r\n" +
        parseInt(duracaoLoginFinal) +
        "\r\nFUTUREPAUSE\r\n" +
        parseInt(futurepause) +
        "\r\nDESCFUTUREPAUSE\r\n" +
        pausafutura +
        "\r\nCOUNTFPAUSE\r\n" +
        parseInt(countFuturePause) +
        "\r\nTMFUTUREPAUSE\r\n" +
        post +
        "\r\nJSON\r\n \r\nINITIALLOGIN\r\n0\r\n\r\n",
    );

    //}
  }
};

function checkStatusAndReason(infousers, data) {
  // Verifica se o status é "Pausado" e se o reason está preenchido
  if (data.status === "Pausado" && data.reason) {
    let datalogin = Moment().format("DD/MM/YYYY HH:mm:ss");
    let timeBlock = Moment().format("DD/MM/YYYY HH:mm:ss") + "-00:00:00";
    let strPauseFuture = infousers.blockfuture ? 1 : 0;
    let descPauseFuture = infousers.blockfuture ? descfuturepause : " ";
    let intmans = infousers.intmans != null ? infousers.intmans : 0;
    let outtmans = infousers.outtmans != null ? infousers.outtmans : 0;
    let duracaoLoginAtual = Moment(data_hora_atual).diff(
      infousers.datalogin,
      "seconds",
    );
    let duracaoLoginFinal =
      parseInt(duracaoLoginAtual) + parseInt(infousers.tmlogin);
    let data_hora_atual = Moment().format("YYYY/MM/DD HH:mm:ss");

    socket.send(
      "REQ\r\n" +
        infousers.id +
        "\r\nUSERNAME\r\n" +
        infousers.username +
        "\r\nDISPLAYNAME\r\n" +
        infousers.displayname +
        "\r\nEXTEN\r\n" +
        infousers.ramal +
        "\r\nREASON\r\n" +
        data.reason +
        "\r\nSTATUS\r\nBQ\r\nSTATUSID\r\n" +
        data.idreason +
        "\r\nHOUR\r\n" +
        timeBlock +
        "\r\nDESCRIPTION\r\n \r\nEMAIL\r\n \r\nGROUP\r\n" +
        infousers.idgroup +
        "\r\nDTL\r\n" +
        datalogin +
        "\r\nGROUPNAME\r\n" +
        infousers.grupo +
        "\r\nPSDCOUNT\r\n" +
        (parseInt(infousers.psdcount) + 1) +
        "\r\nPSDTMA\r\n" +
        parseInt(infousers.psdtma) +
        "\r\nMNGGROUP\r\n-1\r\nINCALLCOUNT\r\n" +
        parseInt(infousers.incallcount) +
        "\r\nINANSCOUNT\r\n" +
        parseInt(infousers.inanscount) +
        "\r\nINTMANS\r\n" +
        parseInt(intmans) +
        "\r\nINSLA\r\n100\r\nOUTCALLCOUNT\r\n" +
        parseInt(infousers.outcallcount) +
        "\r\nOUTANSCOUNT\r\n" +
        parseInt(infousers.outanscount) +
        "\r\nOUTTMANS\r\n" +
        parseInt(outtmans) +
        "\r\nOUTSLA\r\n100\r\nTMLOGIN\r\n" +
        parseInt(duracaoLoginFinal) +
        "\r\nCOUNTFPAUSE\r\n" +
        parseInt(infousers.psdfbreak) +
        "\r\nFUTUREPAUSE\r\n" +
        strPauseFuture +
        "\r\nDESCFUTUREPAUSE\r\n" +
        descPauseFuture +
        "\r\nJSON\r\n \r\nINITIALLOGIN\r\n0\r\n\r\n",
    );
    statusAgentIMSDN = "BQ";
    stAgIMSDN = "BQ";
    console.log(
      "INGENIUM_ENVIOSTATUS :",
      new Date().toLocaleString(),
      stAgIMSDN,
    );
    requestStatusAgent =
      "REQ\r\n" +
      infousers.id +
      "\r\nUSERNAME\r\n" +
      infousers.username +
      "\r\nDISPLAYNAME\r\n" +
      infousers.displayname +
      "\r\nEXTEN\r\n" +
      infousers.ramal +
      "\r\nREASON\r\n" +
      data.reason +
      "\r\nSTATUS\r\nBQ\r\nSTATUSID\r\n" +
      data.idreason +
      "\r\nHOUR\r\n" +
      timeBlock +
      "\r\nDESCRIPTION\r\n \r\nEMAIL\r\n \r\nGROUP\r\n" +
      infousers.idgroup +
      "\r\nDTL\r\n" +
      datalogin +
      "\r\nGROUPNAME\r\n" +
      infousers.grupo +
      "\r\nPSDCOUNT\r\n" +
      (parseInt(infousers.psdcount) + 1) +
      "\r\nPSDTMA\r\n" +
      parseInt(infousers.psdtma) +
      "\r\nMNGGROUP\r\n-1\r\nINCALLCOUNT\r\n" +
      parseInt(infousers.incallcount) +
      "\r\nINANSCOUNT\r\n" +
      parseInt(infousers.inanscount) +
      "\r\nINTMANS\r\n" +
      parseInt(intmans) +
      "\r\nINSLA\r\n100\r\nOUTCALLCOUNT\r\n" +
      parseInt(infousers.outcallcount) +
      "\r\nOUTANSCOUNT\r\n" +
      parseInt(infousers.outanscount) +
      "\r\nOUTTMANS\r\n" +
      parseInt(outtmans) +
      "\r\nOUTSLA\r\n100\r\nTMLOGIN\r\n" +
      parseInt(duracaoLoginFinal) +
      "\r\nCOUNTFPAUSE\r\n" +
      parseInt(infousers.psdfbreak) +
      "\r\nFUTUREPAUSE\r\n" +
      strPauseFuture +
      "\r\nDESCFUTUREPAUSE\r\n" +
      descPauseFuture +
      "\r\nJSON\r\n \r\nINITIALLOGIN\r\n0\r\n\r\n";
    clearInterval(statusIntervalAgent);
    envioStatusAgente(4782, infousers.sipid);
  }
}

function sendRegister(infousers, status, dispatch) {
  if (!isLogged) {
    let post = Moment().format("DD/MM/YYYY HH:mm:ss");
    let datalogin = Moment().format("DD/MM/YYYY HH:mm:ss");
    let tmlogin = infousers.tmlogin != null ? infousers.tmlogin : 0;
    let durationans = infousers.intmans;

    let data_hora_atual = Moment().format("YYYY/MM/DD HH:mm:ss");
    let duracaoLoginAtual = Moment(data_hora_atual).diff(
      infousers.datalogin,
      "seconds",
    );
    let duracaoLoginFinal =
      parseInt(duracaoLoginAtual) + parseInt(infousers.tmlogin);
    let strPauseFuture = infousers.blockfuture ? 1 : 0;
    let descPauseFuture = infousers.blockfuture ? descfuturepause : " ";

    if (infousers.blockscreen === true) {
      setTimeout(() => {
        socket.send(
          "REQ\r\n" +
            infousers.id +
            "\r\nUSERNAME\r\n" +
            infousers.username +
            "\r\nDISPLAYNAME\r\n" +
            infousers.displayname +
            "\r\nEXTEN\r\n" +
            infousers.ramal +
            "\r\nREASON\r\nBloqueado pelo Supervisor\r\nSTATUS\r\nBQSUPER\r\nSTATUSID\r\n-1\r\nHOUR\r\n" +
            post +
            "-00:00:00\r\nDESCRIPTION\r\n \r\nEMAIL\r\n \r\nGROUP\r\n" +
            infousers.idgroup +
            "\r\nDTL\r\n" +
            datalogin +
            "\r\nGROUPNAME\r\n" +
            infousers.grupo +
            "\r\nPSDCOUNT\r\n" +
            parseInt(infousers.psdcount) +
            "\r\nPSDTMA\r\n" +
            parseInt(infousers.psdtma) +
            "\r\nMNGGROUP\r\n-1\r\nINCALLCOUNT\r\n" +
            parseInt(infousers.incallcount) +
            "\r\nINANSCOUNT\r\n" +
            parseInt(infousers.inanscount) +
            "\r\nINTMANS\r\n" +
            parseInt(durationans) +
            "\r\nINSLA\r\n100\r\nOUTCALLCOUNT\r\n" +
            parseInt(infousers.outcallcount) +
            "\r\nOUTANSCOUNT\r\n" +
            parseInt(infousers.outanscount) +
            "\r\nOUTTMANS\r\n" +
            parseInt(infousers.outtmans) +
            "\r\nOUTSLA\r\n100\r\nTMLOGIN\r\n" +
            parseInt(duracaoLoginFinal) +
            "\r\nCOUNTFPAUSE\r\n" +
            parseInt(infousers.psdfbreak) +
            "\r\nFUTUREPAUSE\r\n" +
            strPauseFuture +
            "\r\nDESCFUTUREPAUSE\r\n" +
            descPauseFuture +
            "\r\nJSON\r\n \r\nINITIALLOGIN\r\n1\r\n\r\n",
        );
      }, 2000);
      statusAgentIMSDN = "BQSUPER";
      stAgIMSDN = "BQSUPER";
      console.log(
        "INGENIUM_ENVIOSTATUS :",
        new Date().toLocaleString(),
        stAgIMSDN,
      );
      requestStatusAgent =
        "REQ\r\n" +
        infousers.id +
        "\r\nUSERNAME\r\n" +
        infousers.username +
        "\r\nDISPLAYNAME\r\n" +
        infousers.displayname +
        "\r\nEXTEN\r\n" +
        infousers.ramal +
        "\r\nREASON\r\nBloqueado pelo Supervisor\r\nSTATUS\r\nBQSUPER\r\nSTATUSID\r\n-1\r\nHOUR\r\n" +
        post +
        "-00:00:00\r\nDESCRIPTION\r\n \r\nEMAIL\r\n \r\nGROUP\r\n" +
        infousers.idgroup +
        "\r\nDTL\r\n" +
        datalogin +
        "\r\nGROUPNAME\r\n" +
        infousers.grupo +
        "\r\nPSDCOUNT\r\n" +
        parseInt(infousers.psdcount) +
        "\r\nPSDTMA\r\n" +
        parseInt(infousers.psdtma) +
        "\r\nMNGGROUP\r\n-1\r\nINCALLCOUNT\r\n" +
        parseInt(infousers.incallcount) +
        "\r\nINANSCOUNT\r\n" +
        parseInt(infousers.inanscount) +
        "\r\nINTMANS\r\n" +
        parseInt(durationans) +
        "\r\nINSLA\r\n100\r\nOUTCALLCOUNT\r\n" +
        parseInt(infousers.outcallcount) +
        "\r\nOUTANSCOUNT\r\n" +
        parseInt(infousers.outanscount) +
        "\r\nOUTTMANS\r\n" +
        parseInt(infousers.outtmans) +
        "\r\nOUTSLA\r\n100\r\nTMLOGIN\r\n" +
        parseInt(duracaoLoginFinal) +
        "\r\nCOUNTFPAUSE\r\n" +
        parseInt(infousers.psdfbreak) +
        "\r\nFUTUREPAUSE\r\n" +
        strPauseFuture +
        "\r\nDESCFUTUREPAUSE\r\n" +
        descPauseFuture +
        "\r\nINITIALLOGIN\r\n0\r\n\r\n";
    } else {
      setTimeout(() => {
        socket.send(
          "REQ\r\n" +
            infousers.id +
            "\r\nUSERNAME\r\n" +
            infousers.username +
            "\r\nDISPLAYNAME\r\n" +
            infousers.displayname +
            "\r\nEXTEN\r\n" +
            infousers.ramal +
            "\r\nREASON\r\n \r\nSTATUS\r\nLV\r\nSTATUSID\r\n-1\r\nHOUR\r\n" +
            post +
            "-00:00:00\r\nDESCRIPTION\r\n \r\nEMAIL\r\n \r\nGROUP\r\n" +
            infousers.idgroup +
            "\r\nDTL\r\n" +
            datalogin +
            "\r\nGROUPNAME\r\n" +
            infousers.grupo +
            "\r\nPSDCOUNT\r\n" +
            parseInt(infousers.psdcount) +
            "\r\nPSDTMA\r\n" +
            parseInt(infousers.psdtma) +
            "\r\nMNGGROUP\r\n-1\r\nINCALLCOUNT\r\n" +
            parseInt(infousers.incallcount) +
            "\r\nINANSCOUNT\r\n" +
            parseInt(infousers.inanscount) +
            "\r\nINTMANS\r\n" +
            parseInt(durationans) +
            "\r\nINSLA\r\n100\r\nOUTCALLCOUNT\r\n" +
            parseInt(infousers.outcallcount) +
            "\r\nOUTANSCOUNT\r\n" +
            parseInt(infousers.outanscount) +
            "\r\nOUTTMANS\r\n" +
            parseInt(infousers.outtmans) +
            "\r\nOUTSLA\r\n100\r\nTMLOGIN\r\n" +
            parseInt(duracaoLoginFinal) +
            "\r\nCOUNTFPAUSE\r\n" +
            parseInt(infousers.psdfbreak) +
            "\r\nFUTUREPAUSE\r\n" +
            strPauseFuture +
            "\r\nDESCFUTUREPAUSE\r\n" +
            descPauseFuture +
            "\r\nJSON\r\n \r\nINITIALLOGIN\r\n1\r\n\r\n",
        );
        checkRegisterInitial = true;
      }, 2000);
      statusAgentIMSDN = "LV";
      stAgIMSDN = "LV";
      console.log(
        "INGENIUM_ENVIOSTATUS :",
        new Date().toLocaleString(),
        stAgIMSDN,
      );
      requestStatusAgent =
        "REQ\r\n" +
        infousers.id +
        "\r\nUSERNAME\r\n" +
        infousers.username +
        "\r\nDISPLAYNAME\r\n" +
        infousers.displayname +
        "\r\nEXTEN\r\n" +
        infousers.ramal +
        "\r\nREASON\r\n \r\nSTATUS\r\nLV\r\nSTATUSID\r\n-1\r\nHOUR\r\n" +
        post +
        "-00:00:00\r\nDESCRIPTION\r\n \r\nEMAIL\r\n \r\nGROUP\r\n" +
        infousers.idgroup +
        "\r\nDTL\r\n" +
        datalogin +
        "\r\nGROUPNAME\r\n" +
        infousers.grupo +
        "\r\nPSDCOUNT\r\n" +
        parseInt(infousers.psdcount) +
        "\r\nPSDTMA\r\n" +
        parseInt(infousers.psdtma) +
        "\r\nMNGGROUP\r\n-1\r\nINCALLCOUNT\r\n" +
        parseInt(infousers.incallcount) +
        "\r\nINANSCOUNT\r\n" +
        parseInt(infousers.inanscount) +
        "\r\nINTMANS\r\n" +
        parseInt(durationans) +
        "\r\nINSLA\r\n100\r\nOUTCALLCOUNT\r\n" +
        parseInt(infousers.outcallcount) +
        "\r\nOUTANSCOUNT\r\n" +
        parseInt(infousers.outanscount) +
        "\r\nOUTTMANS\r\n" +
        parseInt(infousers.outtmans) +
        "\r\nOUTSLA\r\n100\r\nTMLOGIN\r\n" +
        parseInt(duracaoLoginFinal) +
        "\r\nCOUNTFPAUSE\r\n" +
        parseInt(infousers.psdfbreak) +
        "\r\nFUTUREPAUSE\r\n" +
        strPauseFuture +
        "\r\nDESCFUTUREPAUSE\r\n" +
        descPauseFuture +
        "\r\nJSON\r\n \r\nINITIALLOGIN\r\n0\r\n\r\n";
    }
    clearInterval(statusIntervalAgent);
    envioStatusAgente(3686, infousers.sipid);

    setTimeout(() => {
      checkStatusAndReason(infousers, status);
    }, 800);
    isLogged = true;
  }
}

function IdleSocket(
  infousers,
  pausa,
  datalogin,
  idpausa,
  status,
  statusagent,
  dispatch,
  getState,
  ipcurrent,
  chatsimult,
) {
  let timeBlock = Moment().format("DD/MM/YYYY HH:mm:ss") + "-00:00:00";
  let timeBlockEnd = Moment().format("YYYY/MM/DD HH:mm:ss");
  let valorDiferenca = parseInt(Math.abs(Math.round(ipcurrent.difftime)));
  let timeBlockIni = Moment(
    statusagent.datestatus,
    "DD/MM/YYYY HH:mm:ss",
  ).format("YYYY/MM/DD HH:mm:ss");

  let strPauseFuture = infousers.blockfuture ? 1 : 0;
  let descPauseFuture = infousers.blockfuture ? descfuturepause : " ";

  if (parseInt(ipcurrent.difftime) < 0) {
    timeBlock =
      Moment()
        .subtract(valorDiferenca, "seconds")
        .format("DD/MM/YYYY HH:mm:ss") + "-00:00:00";
    timeBlockIni = Moment(timeBlockIni)
      .subtract(valorDiferenca, "seconds")
      .format("YYYY/MM/DD HH:mm:ss");
    timeBlockEnd = Moment()
      .subtract(valorDiferenca, "seconds")
      .format("YYYY/MM/DD HH:mm:ss");
  } else {
    timeBlock =
      Moment().add(valorDiferenca, "seconds").format("DD/MM/YYYY HH:mm:ss") +
      "-00:00:00";
    timeBlockIni = Moment(timeBlockIni)
      .add(valorDiferenca, "seconds")
      .format("YYYY/MM/DD HH:mm:ss");
    timeBlockEnd = Moment()
      .add(valorDiferenca, "seconds")
      .format("YYYY/MM/DD HH:mm:ss");
  }

  if (!connection_platform.isToAvoidSendInsertpausaslvTwice) {
    dispatch(InsertPausaDB(infousers, status));
  }

  let valorLineInternal = chatsimult.filter((chat) => chat.voz === true);

  if (connection_platform.isToAvoidSendInsertpausaslvTwice) {
    const isToReturn = !(valorLineInternal && valorLineInternal.length !== 0); // parâmetro que vai ser utilizado para evitar chamar /insertpausaslv duas vezes seguidas
    dispatch(InsertPausaDB(infousers, status, isToReturn));
  }

  if (valorLineInternal && valorLineInternal.length !== 0) {
    InsertPausaQAT(infousers.sipid, infousers.id, dispatch);

    let data_hora_atual = Moment().format("YYYY/MM/DD HH:mm:ss");
    let duracaoLoginAtual = Moment(data_hora_atual).diff(
      infousers.datalogin,
      "seconds",
    );
    let post = Moment().format("DD/MM/YYYY HH:mm:ss");
    let duracaoLoginFinal =
      parseInt(duracaoLoginAtual) + parseInt(infousers.tmlogin);
    setTimeout(() => {
      dispatch(
        createStatusAgent(
          "Atendimento",
          "CONSULTA",
          Moment().format("DD/MM/YYYY HH:mm:ss"),
        ),
      );
    }, 1500);
    socket.send(
      "REQ\r\n" +
        infousers.id +
        "\r\nUSERNAME\r\n" +
        infousers.username +
        "\r\nDISPLAYNAME\r\n" +
        infousers.displayname +
        "\r\nEXTEN\r\n" +
        infousers.ramal +
        "\r\nREASON\r\n" +
        valorLineInternal[0].ramal +
        "\r\nSTATUS\r\nQAT\r\nSTATUSID\r\n-1\r\nHOUR\r\n" +
        post +
        "-00:00:00\r\nDESCRIPTION\r\nConsulta com " +
        valorLineInternal[0].agent +
        "\r\nEMAIL\r\n \r\nGROUP\r\n" +
        infousers.idgroup +
        "\r\nDTL\r\n" +
        post +
        "\r\nGROUPNAME\r\n" +
        infousers.grupo +
        "\r\nPSDCOUNT\r\n" +
        parseInt(infousers.psdcount) +
        "\r\nPSDTMA\r\n" +
        parseInt(infousers.psdtma) +
        "\r\nMNGGROUP\r\n-1\r\nINCALLCOUNT\r\n" +
        parseInt(infousers.incallcount) +
        "\r\nINANSCOUNT\r\n" +
        parseInt(infousers.inanscount) +
        "\r\nINTMANS\r\n" +
        parseInt(infousers.intmans) +
        "\r\nINSLA\r\n100\r\nOUTCALLCOUNT\r\n" +
        parseInt(infousers.outcallcount) +
        "\r\nOUTANSCOUNT\r\n" +
        parseInt(infousers.outanscount) +
        "\r\nOUTTMANS\r\n" +
        parseInt(infousers.outtmans) +
        "\r\nOUTSLA\r\n100\r\nTMLOGIN\r\n" +
        parseInt(duracaoLoginFinal) +
        "\r\nCOUNTFPAUSE\r\n" +
        parseInt(infousers.psdfbreak) +
        "\r\nFUTUREPAUSE\r\n" +
        strPauseFuture +
        "\r\nDESCFUTUREPAUSE\r\n" +
        descPauseFuture +
        "\r\nINITIALLOGIN\r\n0\r\n\r\n",
    );
    statusAgentIMSDN = "QAT";
    stAgIMSDN = "QAT";
    console.log(
      "INGENIUM_ENVIOSTATUS :",
      new Date().toLocaleString(),
      stAgIMSDN,
    );
    requestStatusAgent =
      "REQ\r\n" +
      infousers.id +
      "\r\nUSERNAME\r\n" +
      infousers.username +
      "\r\nDISPLAYNAME\r\n" +
      infousers.displayname +
      "\r\nEXTEN\r\n" +
      infousers.ramal +
      "\r\nREASON\r\n" +
      valorLineInternal[0].ramal +
      "\r\nSTATUS\r\nQAT\r\nSTATUSID\r\n-1\r\nHOUR\r\n" +
      post +
      "-00:00:00\r\nDESCRIPTION\r\nConsulta com " +
      valorLineInternal[0].agent +
      "\r\nEMAIL\r\n \r\nGROUP\r\n" +
      infousers.idgroup +
      "\r\nDTL\r\n" +
      post +
      "\r\nGROUPNAME\r\n" +
      infousers.grupo +
      "\r\nPSDCOUNT\r\n" +
      parseInt(infousers.psdcount) +
      "\r\nPSDTMA\r\n" +
      parseInt(infousers.psdtma) +
      "\r\nMNGGROUP\r\n-1\r\nINCALLCOUNT\r\n" +
      parseInt(infousers.incallcount) +
      "\r\nINANSCOUNT\r\n" +
      parseInt(infousers.inanscount) +
      "\r\nINTMANS\r\n" +
      parseInt(infousers.intmans) +
      "\r\nINSLA\r\n100\r\nOUTCALLCOUNT\r\n" +
      parseInt(infousers.outcallcount) +
      "\r\nOUTANSCOUNT\r\n" +
      parseInt(infousers.outanscount) +
      "\r\nOUTTMANS\r\n" +
      parseInt(infousers.outtmans) +
      "\r\nOUTSLA\r\n100\r\nTMLOGIN\r\n" +
      parseInt(duracaoLoginFinal) +
      "\r\nCOUNTFPAUSE\r\n" +
      parseInt(infousers.psdfbreak) +
      "\r\nFUTUREPAUSE\r\n" +
      strPauseFuture +
      "\r\nDESCFUTUREPAUSE\r\n" +
      descPauseFuture +
      "\r\nINITIALLOGIN\r\n0\r\n\r\n";
    clearInterval(statusIntervalAgent);
    envioStatusAgente(7247, infousers.sipid);
  } else {
    console.log("INSERTPAUSASLV_EVENT", new Date().toISOString(), {
      source: "websocket",
      userId: infousers.id,
      sipid: infousers.sipid,
    });
    axios
      .get(
        `${connection_platform.type_connect}://${pathname}:${port}/conn/insertpausaslv?sipid=${infousers.sipid}&iduser=${infousers.id}`,
      )
      .then((response) => {
        if (response.data === true) {
          let duracao = Moment(timeBlockEnd).diff(timeBlockIni, "seconds");
          let tmlogin = infousers.tmlogin != null ? infousers.tmlogin : 0;
          durationans = durationans == 0 ? infousers.intmans : durationans;
          durationoutans =
            durationoutans == 0 ? infousers.outtmans : durationoutans;

          let data_hora_atual = Moment().format("YYYY/MM/DD HH:mm:ss");
          let duracaoLoginAtual = Moment(data_hora_atual).diff(
            infousers.datalogin,
            "seconds",
          );
          let duracaoLoginFinal =
            parseInt(duracaoLoginAtual) + parseInt(infousers.tmlogin);

          if (statusagent.status === "Pausado") {
            dispatch(
              incrementInfoUsers(
                infousers.email,
                infousers.password,
                infousers.id,
                infousers.displayname,
                infousers.grupo,
                infousers.ramal,
                infousers.idgroup,
                infousers.username,
                infousers.idsupervisao,
                infousers.sipid,
                infousers.acessofila,
                infousers.semdefinicao,
                infousers.supervisor,
                infousers.inanscount,
                infousers.incallcount,
                durationans,
                infousers.outanscount,
                infousers.outcallcount,
                durationoutans,
                infousers.psdcount,
                parseInt(infousers.psdtma) + parseInt(duracao),
                tmlogin,
                infousers.atdauto,
                infousers.idin,
                infousers.idout,
              ),
            );
            if (status === undefined || status === "undefined") {
              status = "LV";
            }
            socket.send(
              "REQ\r\n" +
                infousers.id +
                "\r\nUSERNAME\r\n" +
                infousers.username +
                "\r\nDISPLAYNAME\r\n" +
                infousers.displayname +
                "\r\nEXTEN\r\n" +
                infousers.ramal +
                "\r\nREASON\r\n" +
                pausa +
                "\r\nSTATUS\r\n" +
                status +
                "\r\nSTATUSID\r\n" +
                idpausa +
                "\r\nHOUR\r\n" +
                timeBlock +
                "\r\nDESCRIPTION\r\n \r\nEMAIL\r\n \r\nGROUP\r\n" +
                infousers.idgroup +
                "\r\nDTL\r\n" +
                datalogin +
                "\r\nGROUPNAME\r\n" +
                infousers.grupo +
                "\r\nPSDCOUNT\r\n" +
                parseInt(infousers.psdcount) +
                "\r\nPSDTMA\r\n" +
                (parseInt(infousers.psdtma) + parseInt(duracao)) +
                "\r\nMNGGROUP\r\n-1\r\nINCALLCOUNT\r\n" +
                parseInt(infousers.incallcount) +
                "\r\nINANSCOUNT\r\n" +
                parseInt(infousers.inanscount) +
                "\r\nINTMANS\r\n" +
                parseInt(infousers.intmans) + //parseInt(durationans) +
                "\r\nINSLA\r\n100\r\nOUTCALLCOUNT\r\n" +
                parseInt(infousers.outcallcount) +
                "\r\nOUTANSCOUNT\r\n" +
                parseInt(infousers.outanscount) +
                "\r\nOUTTMANS\r\n" +
                parseInt(durationoutans) +
                "\r\nOUTSLA\r\n100\r\nTMLOGIN\r\n" +
                parseInt(duracaoLoginFinal) +
                "\r\nCOUNTFPAUSE\r\n" +
                parseInt(infousers.psdfbreak) +
                "\r\nFUTUREPAUSE\r\n" +
                strPauseFuture +
                "\r\nDESCFUTUREPAUSE\r\n" +
                descPauseFuture +
                "\r\nJSON\r\n \r\nINITIALLOGIN\r\n0\r\n\r\n",
            );
            statusAgentIMSDN = status;
            stAgIMSDN = status;
            console.log(
              "INGENIUM_ENVIOSTATUS :",
              new Date().toLocaleString(),
              stAgIMSDN,
            );
            requestStatusAgent =
              "REQ\r\n" +
              infousers.id +
              "\r\nUSERNAME\r\n" +
              infousers.username +
              "\r\nDISPLAYNAME\r\n" +
              infousers.displayname +
              "\r\nEXTEN\r\n" +
              infousers.ramal +
              "\r\nREASON\r\n" +
              pausa +
              "\r\nSTATUS\r\n" +
              status +
              "\r\nSTATUSID\r\n" +
              idpausa +
              "\r\nHOUR\r\n" +
              timeBlock +
              "\r\nDESCRIPTION\r\n \r\nEMAIL\r\n \r\nGROUP\r\n" +
              infousers.idgroup +
              "\r\nDTL\r\n" +
              datalogin +
              "\r\nGROUPNAME\r\n" +
              infousers.grupo +
              "\r\nPSDCOUNT\r\n" +
              parseInt(infousers.psdcount) +
              "\r\nPSDTMA\r\n" +
              (parseInt(infousers.psdtma) + parseInt(duracao)) +
              "\r\nMNGGROUP\r\n-1\r\nINCALLCOUNT\r\n" +
              parseInt(infousers.incallcount) +
              "\r\nINANSCOUNT\r\n" +
              parseInt(infousers.inanscount) +
              "\r\nINTMANS\r\n" +
              parseInt(infousers.intmans) + //parseInt(durationans) +
              "\r\nINSLA\r\n100\r\nOUTCALLCOUNT\r\n" +
              parseInt(infousers.outcallcount) +
              "\r\nOUTANSCOUNT\r\n" +
              parseInt(infousers.outanscount) +
              "\r\nOUTTMANS\r\n" +
              parseInt(durationoutans) +
              "\r\nOUTSLA\r\n100\r\nTMLOGIN\r\n" +
              parseInt(duracaoLoginFinal) +
              "\r\nCOUNTFPAUSE\r\n" +
              parseInt(infousers.psdfbreak) +
              "\r\nFUTUREPAUSE\r\n" +
              strPauseFuture +
              "\r\nDESCFUTUREPAUSE\r\n" +
              descPauseFuture +
              "\r\nJSON\r\n \r\nINITIALLOGIN\r\n0\r\n\r\n";
            clearInterval(statusIntervalAgent);
            envioStatusAgente(3941, infousers.sipid);
          } else {
            socket.send(
              "REQ\r\n" +
                infousers.id +
                "\r\nUSERNAME\r\n" +
                infousers.username +
                "\r\nDISPLAYNAME\r\n" +
                infousers.displayname +
                "\r\nEXTEN\r\n" +
                infousers.ramal +
                "\r\nREASON\r\n" +
                pausa +
                "\r\nSTATUS\r\n" +
                status +
                "\r\nSTATUSID\r\n" +
                idpausa +
                "\r\nHOUR\r\n" +
                timeBlock +
                "\r\nDESCRIPTION\r\n \r\nEMAIL\r\n \r\nGROUP\r\n" +
                infousers.idgroup +
                "\r\nDTL\r\n" +
                datalogin +
                "\r\nGROUPNAME\r\n" +
                infousers.grupo +
                "\r\nPSDCOUNT\r\n" +
                parseInt(infousers.psdcount) +
                "\r\nPSDTMA\r\n" +
                parseInt(infousers.psdtma) +
                "\r\nMNGGROUP\r\n-1\r\nINCALLCOUNT\r\n" +
                parseInt(infousers.incallcount) +
                "\r\nINANSCOUNT\r\n" +
                parseInt(infousers.inanscount) +
                "\r\nINTMANS\r\n" +
                parseInt(infousers.intmans) + //parseInt(durationans) +
                "\r\nINSLA\r\n100\r\nOUTCALLCOUNT\r\n" +
                parseInt(infousers.outcallcount) +
                "\r\nOUTANSCOUNT\r\n" +
                parseInt(infousers.outanscount) +
                "\r\nOUTTMANS\r\n" +
                parseInt(infousers.outtmans) +
                "\r\nOUTSLA\r\n100\r\nTMLOGIN\r\n" +
                parseInt(duracaoLoginFinal) +
                "\r\nCOUNTFPAUSE\r\n" +
                parseInt(infousers.psdfbreak) +
                "\r\nFUTUREPAUSE\r\n" +
                strPauseFuture +
                "\r\nDESCFUTUREPAUSE\r\n" +
                descPauseFuture +
                "\r\nJSON\r\n \r\nINITIALLOGIN\r\n0\r\n\r\n",
            );
            if (status === undefined || status === "undefined") {
              status = "LV";
            }
            statusAgentIMSDN = status;
            stAgIMSDN = status;
            console.log(
              "INGENIUM_ENVIOSTATUS :",
              new Date().toLocaleString(),
              stAgIMSDN,
            );
            requestStatusAgent =
              "REQ\r\n" +
              infousers.id +
              "\r\nUSERNAME\r\n" +
              infousers.username +
              "\r\nDISPLAYNAME\r\n" +
              infousers.displayname +
              "\r\nEXTEN\r\n" +
              infousers.ramal +
              "\r\nREASON\r\n" +
              pausa +
              "\r\nSTATUS\r\n" +
              status +
              "\r\nSTATUSID\r\n" +
              idpausa +
              "\r\nHOUR\r\n" +
              timeBlock +
              "\r\nDESCRIPTION\r\n \r\nEMAIL\r\n \r\nGROUP\r\n" +
              infousers.idgroup +
              "\r\nDTL\r\n" +
              datalogin +
              "\r\nGROUPNAME\r\n" +
              infousers.grupo +
              "\r\nPSDCOUNT\r\n" +
              parseInt(infousers.psdcount) +
              "\r\nPSDTMA\r\n" +
              parseInt(infousers.psdtma) +
              "\r\nMNGGROUP\r\n-1\r\nINCALLCOUNT\r\n" +
              parseInt(infousers.incallcount) +
              "\r\nINANSCOUNT\r\n" +
              parseInt(infousers.inanscount) +
              "\r\nINTMANS\r\n" +
              parseInt(infousers.intmans) + //parseInt(durationans) +
              "\r\nINSLA\r\n100\r\nOUTCALLCOUNT\r\n" +
              parseInt(infousers.outcallcount) +
              "\r\nOUTANSCOUNT\r\n" +
              parseInt(infousers.outanscount) +
              "\r\nOUTTMANS\r\n" +
              parseInt(infousers.outtmans) +
              "\r\nOUTSLA\r\n100\r\nTMLOGIN\r\n" +
              parseInt(duracaoLoginFinal) +
              "\r\nCOUNTFPAUSE\r\n" +
              parseInt(infousers.psdfbreak) +
              "\r\nFUTUREPAUSE\r\n" +
              strPauseFuture +
              "\r\nDESCFUTUREPAUSE\r\n" +
              descPauseFuture +
              "\r\nJSON\r\n \r\nINITIALLOGIN\r\n0\r\n\r\n";
            clearInterval(statusIntervalAgent);
            envioStatusAgente(4087, infousers.sipid);
          }

          if (
            connection_platform.nc2_integration === true &&
            connection_platform.nc2_users.indexOf(infousers.ramal) !== -1
          ) {
            if (
              statusagent.status === "Pausado" &&
              infousers.login_nc2 === true
            )
              nc2Service.nc2GravaFimPausa(infousers.ramal, "1");

            if (infousers.login_nc2 === true)
              nc2Service.nc2AlteraStatus(infousers.ramal, "0");
          }

          durationans = 0;
          durationoutans = 0;
        }
      })
      .catch((error) => {
        setTimeout(() => {
          console.log("INSERTPAUSASLV_EVENT", new Date().toISOString(), {
            source: "websocket",
            userId: infousers.id,
            sipid: infousers.sipid,
            retry: true,
          });
          axios
            .get(
              `${connection_platform.type_connect}://${pathname}:${port}/conn/insertpausaslv?sipid=${infousers.sipid}&iduser=${infousers.id}`,
            )
            .then((response) => {
              if (response.data === true) {
                let duracao = Moment(timeBlockEnd).diff(
                  timeBlockIni,
                  "seconds",
                );
                let tmlogin = infousers.tmlogin != null ? infousers.tmlogin : 0;
                durationans =
                  durationans == 0 ? infousers.intmans : durationans;
                durationoutans =
                  durationoutans == 0 ? infousers.outtmans : durationoutans;

                let data_hora_atual = Moment().format("YYYY/MM/DD HH:mm:ss");
                let duracaoLoginAtual = Moment(data_hora_atual).diff(
                  infousers.datalogin,
                  "seconds",
                );
                let duracaoLoginFinal =
                  parseInt(duracaoLoginAtual) + parseInt(infousers.tmlogin);

                if (statusagent.status === "Pausado") {
                  dispatch(
                    incrementInfoUsers(
                      infousers.email,
                      infousers.password,
                      infousers.id,
                      infousers.displayname,
                      infousers.grupo,
                      infousers.ramal,
                      infousers.idgroup,
                      infousers.username,
                      infousers.idsupervisao,
                      infousers.sipid,
                      infousers.acessofila,
                      infousers.semdefinicao,
                      infousers.supervisor,
                      infousers.inanscount,
                      infousers.incallcount,
                      durationans,
                      infousers.outanscount,
                      infousers.outcallcount,
                      durationoutans,
                      infousers.psdcount,
                      parseInt(infousers.psdtma) + parseInt(duracao),
                      tmlogin,
                      infousers.atdauto,
                      infousers.idin,
                      infousers.idout,
                    ),
                  );
                  if (status === undefined || status === "undefined") {
                    status = "LV";
                  }
                  socket.send(
                    "REQ\r\n" +
                      infousers.id +
                      "\r\nUSERNAME\r\n" +
                      infousers.username +
                      "\r\nDISPLAYNAME\r\n" +
                      infousers.displayname +
                      "\r\nEXTEN\r\n" +
                      infousers.ramal +
                      "\r\nREASON\r\n" +
                      pausa +
                      "\r\nSTATUS\r\n" +
                      status +
                      "\r\nSTATUSID\r\n" +
                      idpausa +
                      "\r\nHOUR\r\n" +
                      timeBlock +
                      "\r\nDESCRIPTION\r\n \r\nEMAIL\r\n \r\nGROUP\r\n" +
                      infousers.idgroup +
                      "\r\nDTL\r\n" +
                      datalogin +
                      "\r\nGROUPNAME\r\n" +
                      infousers.grupo +
                      "\r\nPSDCOUNT\r\n" +
                      parseInt(infousers.psdcount) +
                      "\r\nPSDTMA\r\n" +
                      (parseInt(infousers.psdtma) + parseInt(duracao)) +
                      "\r\nMNGGROUP\r\n-1\r\nINCALLCOUNT\r\n" +
                      parseInt(infousers.incallcount) +
                      "\r\nINANSCOUNT\r\n" +
                      parseInt(infousers.inanscount) +
                      "\r\nINTMANS\r\n" +
                      parseInt(infousers.intmans) + //parseInt(durationans) +
                      "\r\nINSLA\r\n100\r\nOUTCALLCOUNT\r\n" +
                      parseInt(infousers.outcallcount) +
                      "\r\nOUTANSCOUNT\r\n" +
                      parseInt(infousers.outanscount) +
                      "\r\nOUTTMANS\r\n" +
                      parseInt(durationoutans) +
                      "\r\nOUTSLA\r\n100\r\nTMLOGIN\r\n" +
                      parseInt(duracaoLoginFinal) +
                      "\r\nCOUNTFPAUSE\r\n" +
                      parseInt(infousers.psdfbreak) +
                      "\r\nFUTUREPAUSE\r\n" +
                      strPauseFuture +
                      "\r\nDESCFUTUREPAUSE\r\n" +
                      descPauseFuture +
                      "\r\nJSON\r\n \r\nINITIALLOGIN\r\n0\r\n\r\n",
                  );
                  statusAgentIMSDN = status;
                  stAgIMSDN = status;
                  console.log(
                    "INGENIUM_ENVIOSTATUS :",
                    new Date().toLocaleString(),
                    stAgIMSDN,
                  );
                  requestStatusAgent =
                    "REQ\r\n" +
                    infousers.id +
                    "\r\nUSERNAME\r\n" +
                    infousers.username +
                    "\r\nDISPLAYNAME\r\n" +
                    infousers.displayname +
                    "\r\nEXTEN\r\n" +
                    infousers.ramal +
                    "\r\nREASON\r\n" +
                    pausa +
                    "\r\nSTATUS\r\n" +
                    status +
                    "\r\nSTATUSID\r\n" +
                    idpausa +
                    "\r\nHOUR\r\n" +
                    timeBlock +
                    "\r\nDESCRIPTION\r\n \r\nEMAIL\r\n \r\nGROUP\r\n" +
                    infousers.idgroup +
                    "\r\nDTL\r\n" +
                    datalogin +
                    "\r\nGROUPNAME\r\n" +
                    infousers.grupo +
                    "\r\nPSDCOUNT\r\n" +
                    parseInt(infousers.psdcount) +
                    "\r\nPSDTMA\r\n" +
                    (parseInt(infousers.psdtma) + parseInt(duracao)) +
                    "\r\nMNGGROUP\r\n-1\r\nINCALLCOUNT\r\n" +
                    parseInt(infousers.incallcount) +
                    "\r\nINANSCOUNT\r\n" +
                    parseInt(infousers.inanscount) +
                    "\r\nINTMANS\r\n" +
                    parseInt(infousers.intmans) + //parseInt(durationans) +
                    "\r\nINSLA\r\n100\r\nOUTCALLCOUNT\r\n" +
                    parseInt(infousers.outcallcount) +
                    "\r\nOUTANSCOUNT\r\n" +
                    parseInt(infousers.outanscount) +
                    "\r\nOUTTMANS\r\n" +
                    parseInt(durationoutans) +
                    "\r\nOUTSLA\r\n100\r\nTMLOGIN\r\n" +
                    parseInt(duracaoLoginFinal) +
                    "\r\nCOUNTFPAUSE\r\n" +
                    parseInt(infousers.psdfbreak) +
                    "\r\nFUTUREPAUSE\r\n" +
                    strPauseFuture +
                    "\r\nDESCFUTUREPAUSE\r\n" +
                    descPauseFuture +
                    "\r\nJSON\r\n \r\nINITIALLOGIN\r\n0\r\n\r\n";
                  clearInterval(statusIntervalAgent);
                  envioStatusAgente(4313, infousers.sipid);
                } else {
                  socket.send(
                    "REQ\r\n" +
                      infousers.id +
                      "\r\nUSERNAME\r\n" +
                      infousers.username +
                      "\r\nDISPLAYNAME\r\n" +
                      infousers.displayname +
                      "\r\nEXTEN\r\n" +
                      infousers.ramal +
                      "\r\nREASON\r\n" +
                      pausa +
                      "\r\nSTATUS\r\n" +
                      status +
                      "\r\nSTATUSID\r\n" +
                      idpausa +
                      "\r\nHOUR\r\n" +
                      timeBlock +
                      "\r\nDESCRIPTION\r\n \r\nEMAIL\r\n \r\nGROUP\r\n" +
                      infousers.idgroup +
                      "\r\nDTL\r\n" +
                      datalogin +
                      "\r\nGROUPNAME\r\n" +
                      infousers.grupo +
                      "\r\nPSDCOUNT\r\n" +
                      parseInt(infousers.psdcount) +
                      "\r\nPSDTMA\r\n" +
                      parseInt(infousers.psdtma) +
                      "\r\nMNGGROUP\r\n-1\r\nINCALLCOUNT\r\n" +
                      parseInt(infousers.incallcount) +
                      "\r\nINANSCOUNT\r\n" +
                      parseInt(infousers.inanscount) +
                      "\r\nINTMANS\r\n" +
                      parseInt(infousers.intmans) + //parseInt(durationans) +
                      "\r\nINSLA\r\n100\r\nOUTCALLCOUNT\r\n" +
                      parseInt(infousers.outcallcount) +
                      "\r\nOUTANSCOUNT\r\n" +
                      parseInt(infousers.outanscount) +
                      "\r\nOUTTMANS\r\n" +
                      parseInt(infousers.outtmans) +
                      "\r\nOUTSLA\r\n100\r\nTMLOGIN\r\n" +
                      parseInt(duracaoLoginFinal) +
                      "\r\nCOUNTFPAUSE\r\n" +
                      parseInt(infousers.psdfbreak) +
                      "\r\nFUTUREPAUSE\r\n" +
                      strPauseFuture +
                      "\r\nDESCFUTUREPAUSE\r\n" +
                      descPauseFuture +
                      "\r\nJSON\r\n \r\nINITIALLOGIN\r\n0\r\n\r\n",
                  );
                  if (status === undefined || status === "undefined") {
                    status = "LV";
                  }
                  statusAgentIMSDN = status;
                  stAgIMSDN = status;
                  console.log(
                    "INGENIUM_ENVIOSTATUS :",
                    new Date().toLocaleString(),
                    stAgIMSDN,
                  );
                  requestStatusAgent =
                    "REQ\r\n" +
                    infousers.id +
                    "\r\nUSERNAME\r\n" +
                    infousers.username +
                    "\r\nDISPLAYNAME\r\n" +
                    infousers.displayname +
                    "\r\nEXTEN\r\n" +
                    infousers.ramal +
                    "\r\nREASON\r\n" +
                    pausa +
                    "\r\nSTATUS\r\n" +
                    status +
                    "\r\nSTATUSID\r\n" +
                    idpausa +
                    "\r\nHOUR\r\n" +
                    timeBlock +
                    "\r\nDESCRIPTION\r\n \r\nEMAIL\r\n \r\nGROUP\r\n" +
                    infousers.idgroup +
                    "\r\nDTL\r\n" +
                    datalogin +
                    "\r\nGROUPNAME\r\n" +
                    infousers.grupo +
                    "\r\nPSDCOUNT\r\n" +
                    parseInt(infousers.psdcount) +
                    "\r\nPSDTMA\r\n" +
                    parseInt(infousers.psdtma) +
                    "\r\nMNGGROUP\r\n-1\r\nINCALLCOUNT\r\n" +
                    parseInt(infousers.incallcount) +
                    "\r\nINANSCOUNT\r\n" +
                    parseInt(infousers.inanscount) +
                    "\r\nINTMANS\r\n" +
                    parseInt(infousers.intmans) + //parseInt(durationans) +
                    "\r\nINSLA\r\n100\r\nOUTCALLCOUNT\r\n" +
                    parseInt(infousers.outcallcount) +
                    "\r\nOUTANSCOUNT\r\n" +
                    parseInt(infousers.outanscount) +
                    "\r\nOUTTMANS\r\n" +
                    parseInt(infousers.outtmans) +
                    "\r\nOUTSLA\r\n100\r\nTMLOGIN\r\n" +
                    parseInt(duracaoLoginFinal) +
                    "\r\nCOUNTFPAUSE\r\n" +
                    parseInt(infousers.psdfbreak) +
                    "\r\nFUTUREPAUSE\r\n" +
                    strPauseFuture +
                    "\r\nDESCFUTUREPAUSE\r\n" +
                    descPauseFuture +
                    "\r\nJSON\r\n \r\nINITIALLOGIN\r\n0\r\n\r\n";
                  clearInterval(statusIntervalAgent);
                  envioStatusAgente(4459, infousers.sipid);
                }

                if (
                  connection_platform.nc2_integration === true &&
                  connection_platform.nc2_users.indexOf(infousers.ramal) !== -1
                ) {
                  if (
                    statusagent.status === "Pausado" &&
                    infousers.login_nc2 === true
                  )
                    nc2Service.nc2GravaFimPausa(infousers.ramal, "1");

                  if (infousers.login_nc2 === true)
                    nc2Service.nc2AlteraStatus(infousers.ramal, "0");
                }

                durationans = 0;
                durationoutans = 0;
              }
            });
        }, 10000);
      });
  }
}

export const GetListCallQueue = (IdUser) => {
  return (dispatch) => {
    return axios
      .get(
        `${connection_platform.type_connect}://${pathname}:${port}/conn/getlistcallqueue?userid=${IdUser}`,
      )
      .then((response) => {
        filaPermissao = response.data;
        dispatch(createQueuePermission(response.data));
      });
  };
};

export const RegisterReqWebSocket = (
  dispatch,
  userid,
  displayname,
  idgroup,
  ramal,
  grupo,
  username,
  sipid,
  callpark,
  qtdequeue,
  supervisor,
  strSubMonit,
  strGrp,
  inanscount,
  incallcount,
  intmans,
  outanscount,
  outcallcount,
  outtmans,
  psdcount,
  psdtma,
  tmlogin,
  ipcurrent,
  blockscreen,
  user_midias,
  datalogin,
) => {
  //setTimeout(() => {

  RegisterReqSocket(
    userid,
    displayname,
    idgroup,
    ramal,
    grupo,
    username,
    sipid,
    callpark,
    qtdequeue,
    supervisor,
    strSubMonit,
    strGrp,
    inanscount,
    incallcount,
    intmans,
    outanscount,
    outcallcount,
    outtmans,
    psdcount,
    psdtma,
    tmlogin,
    ipcurrent,
    blockscreen,
    user_midias,
    datalogin,
  );

  //}, 5000);
};

export const LoginNc2Dial = (informationusers, dispatch) => {
  if (
    connection_platform.nc2_integration === true &&
    connection_platform.nc2_users.indexOf(informationusers.ramal) !== -1 &&
    informationusers.login_nc2 === false
  ) {
    setTimeout(() => {
      nc2Service.nc2Login(informationusers.ramal);
      nc2Service.nc2MonitoraService(informationusers.ramal, dispatch);
      dispatch(setLoginNc2(true));
    }, 1500);
  }
};

function BlockUser(
  infousers,
  pausa,
  datalogin,
  idpausa,
  status,
  dispatch,
  getState,
) {
  const { ipcurrent, reasonsblock } = getState();
  let timeBlock = Moment().format("DD/MM/YYYY HH:mm:ss") + "-00:00:00";
  let intmans = infousers.intmans != null ? infousers.intmans : 0;
  let outtmans = infousers.outtmans != null ? infousers.outtmans : 0;

  let tmlogin = infousers.tmlogin != null ? infousers.tmlogin : 0;

  let valorDiferenca = parseInt(Math.abs(Math.round(ipcurrent.difftime)));

  let strPauseFuture = 0;
  let descPauseFuture = " ";
  descfuturepause = "";

  if (parseInt(ipcurrent.difftime) < 0) {
    timeBlock = Moment()
      .subtract(valorDiferenca, "seconds")
      .format("DD/MM/YYYY HH:mm:ss");
  } else {
    timeBlock = Moment()
      .add(valorDiferenca, "seconds")
      .format("DD/MM/YYYY HH:mm:ss");
  }
  dispatch(
    incrementInfoUsers(
      infousers.email,
      infousers.password,
      infousers.id,
      infousers.displayname,
      infousers.grupo,
      infousers.ramal,
      infousers.idgroup,
      infousers.username,
      infousers.idsupervisao,
      infousers.sipid,
      infousers.acessofila,
      infousers.semdefinicao,
      infousers.supervisor,
      infousers.inanscount,
      infousers.incallcount,
      intmans,
      infousers.outanscount,
      infousers.outcallcount,
      outtmans,
      parseInt(infousers.psdcount) + 1,
      infousers.psdtma,
      tmlogin,
      infousers.atdauto,
      infousers.idin,
      infousers.idout,
    ),
  );
  if (status === undefined || status === "undefined") {
    status = "BQ";
  }

  let data_hora_atual = Moment().format("YYYY/MM/DD HH:mm:ss");
  let duracaoLoginAtual = Moment(data_hora_atual).diff(
    infousers.datalogin,
    "seconds",
  );
  let duracaoLoginFinal =
    parseInt(duracaoLoginAtual) + parseInt(infousers.tmlogin);

  if (!checkLoginInitial) {
    socket.send(
      "REQ\r\n" +
        infousers.id +
        "\r\nUSERNAME\r\n" +
        infousers.username +
        "\r\nDISPLAYNAME\r\n" +
        infousers.displayname +
        "\r\nEXTEN\r\n" +
        infousers.ramal +
        "\r\nREASON\r\n" +
        pausa +
        "\r\nSTATUS\r\n" +
        status +
        "\r\nSTATUSID\r\n" +
        idpausa +
        "\r\nHOUR\r\n" +
        timeBlock +
        "\r\nDESCRIPTION\r\n \r\nEMAIL\r\n \r\nGROUP\r\n" +
        infousers.idgroup +
        "\r\nDTL\r\n" +
        datalogin +
        "\r\nGROUPNAME\r\n" +
        infousers.grupo +
        "\r\nPSDCOUNT\r\n" +
        (parseInt(infousers.psdcount) + 1) +
        "\r\nPSDTMA\r\n" +
        parseInt(infousers.psdtma) +
        "\r\nMNGGROUP\r\n-1\r\nINCALLCOUNT\r\n" +
        parseInt(infousers.incallcount) +
        "\r\nINANSCOUNT\r\n" +
        parseInt(infousers.inanscount) +
        "\r\nINTMANS\r\n" +
        parseInt(intmans) +
        "\r\nINSLA\r\n100\r\nOUTCALLCOUNT\r\n" +
        parseInt(infousers.outcallcount) +
        "\r\nOUTANSCOUNT\r\n" +
        parseInt(infousers.outanscount) +
        "\r\nOUTTMANS\r\n" +
        parseInt(outtmans) +
        "\r\nOUTSLA\r\n100\r\nTMLOGIN\r\n" +
        parseInt(duracaoLoginFinal) +
        "\r\nCOUNTFPAUSE\r\n" +
        parseInt(infousers.psdfbreak) +
        "\r\nFUTUREPAUSE\r\n" +
        strPauseFuture +
        "\r\nDESCFUTUREPAUSE\r\n" +
        descPauseFuture +
        "\r\nJSON\r\n \r\nINITIALLOGIN\r\n0\r\n\r\n",
    );
  }
  statusAgentIMSDN = status;
  stAgIMSDN = status;
  console.log("INGENIUM_ENVIOSTATUS :", new Date().toLocaleString(), stAgIMSDN);
  requestStatusAgent =
    "REQ\r\n" +
    infousers.id +
    "\r\nUSERNAME\r\n" +
    infousers.username +
    "\r\nDISPLAYNAME\r\n" +
    infousers.displayname +
    "\r\nEXTEN\r\n" +
    infousers.ramal +
    "\r\nREASON\r\n" +
    pausa +
    "\r\nSTATUS\r\n" +
    status +
    "\r\nSTATUSID\r\n" +
    idpausa +
    "\r\nHOUR\r\n" +
    timeBlock +
    "\r\nDESCRIPTION\r\n \r\nEMAIL\r\n \r\nGROUP\r\n" +
    infousers.idgroup +
    "\r\nDTL\r\n" +
    datalogin +
    "\r\nGROUPNAME\r\n" +
    infousers.grupo +
    "\r\nPSDCOUNT\r\n" +
    (parseInt(infousers.psdcount) + 1) +
    "\r\nPSDTMA\r\n" +
    parseInt(infousers.psdtma) +
    "\r\nMNGGROUP\r\n-1\r\nINCALLCOUNT\r\n" +
    parseInt(infousers.incallcount) +
    "\r\nINANSCOUNT\r\n" +
    parseInt(infousers.inanscount) +
    "\r\nINTMANS\r\n" +
    parseInt(intmans) +
    "\r\nINSLA\r\n100\r\nOUTCALLCOUNT\r\n" +
    parseInt(infousers.outcallcount) +
    "\r\nOUTANSCOUNT\r\n" +
    parseInt(infousers.outanscount) +
    "\r\nOUTTMANS\r\n" +
    parseInt(outtmans) +
    "\r\nOUTSLA\r\n100\r\nTMLOGIN\r\n" +
    parseInt(duracaoLoginFinal) +
    "\r\nCOUNTFPAUSE\r\n" +
    parseInt(infousers.psdfbreak) +
    "\r\nFUTUREPAUSE\r\n" +
    strPauseFuture +
    "\r\nDESCFUTUREPAUSE\r\n" +
    descPauseFuture +
    "\r\nJSON\r\n \r\nINITIALLOGIN\r\n0\r\n\r\n";
  clearInterval(statusIntervalAgent);
  envioStatusAgente(4782, infousers.sipid);

  const result = reasonsblock.reasons.filter((reason) => reason.id === idpausa);

  if (result.length !== 0) {
    dispatch(
      changePermissionsBlock(result[0].perm_ativo, result[0].calls_capture),
    );
  }

  setTimeout(() => {
    if (
      connection_platform.nc2_integration === true &&
      connection_platform.nc2_users.indexOf(infousers.ramal) !== -1 &&
      infousers.login_nc2 === true
    )
      nc2Service.nc2AlteraStatus(infousers.ramal, "2");
  }, 1000);
}

function SendSocketTransferCall(
  iduser,
  cdrid,
  servico,
  serviceinid,
  idatendimento,
  iduserin,
  userout,
  atdsimult,
  serverid,
  informationusers,
) {
  touser = userout;
  socket.send(
    "CHATTRANSFER\r\n" +
      iduser +
      "\r\nCONTACTID\r\n" +
      cdrid +
      "\r\nTO\r\n" +
      serverid +
      "\r\nTOAGENT\r\n" +
      iduserin +
      "\r\n\r\n",
  );

  let qtdatd = atdsimult.filter(
    (atd) => parseInt(atd.idatendimento) !== parseInt(cdrid),
  );

  if (qtdatd.length === 0) {
    let post = Moment().format("DD/MM/YYYY HH:mm:ss");
    let data_hora_atual = Moment().format("YYYY/MM/DD HH:mm:ss");
    let duracaoLoginAtual = Moment(data_hora_atual).diff(
      informationusers.datalogin,
      "seconds",
    );
    let duracaoLoginFinal =
      parseInt(duracaoLoginAtual) + parseInt(informationusers.tmlogin);

    // dispatch(
    //   createStatusAgent(
    //     "Encerrou",
    //     qtdatd.cliente,
    //     Moment().format("DD/MM/YYYY HH:mm:ss"),
    //     -5
    //   )
    // );
    socket.send(
      "REQ\r\n" +
        iduser +
        "\r\nUSERNAME\r\n" +
        informationusers.username +
        "\r\nDISPLAYNAME\r\n" +
        informationusers.displayname +
        "\r\nEXTEN\r\n" +
        informationusers.ramal +
        "\r\nREASON\r\n \r\nSTATUS\r\nLV\r\nSTATUSID\r\n-1\r\nHOUR\r\n" +
        post +
        "-00:00:00\r\nDESCRIPTION\r\n \r\nEMAIL\r\n \r\nGROUP\r\n" +
        informationusers.idgroup +
        "\r\nDTL\r\n" +
        post +
        "\r\nGROUPNAME\r\n" +
        informationusers.grupo +
        "\r\nPSDCOUNT\r\n" +
        parseInt(informationusers.psdcount) +
        "\r\nPSDTMA\r\n" +
        parseInt(informationusers.psdtma) +
        "\r\nMNGGROUP\r\n-1\r\nINCALLCOUNT\r\n" +
        parseInt(informationusers.incallcount) +
        "\r\nINANSCOUNT\r\n" +
        parseInt(informationusers.inanscount) +
        "\r\nINTMANS\r\n" +
        parseInt(informationusers.intmans) +
        "\r\nINSLA\r\n100\r\nOUTCALLCOUNT\r\n" +
        parseInt(informationusers.outcallcount) +
        "\r\nOUTANSCOUNT\r\n" +
        parseInt(informationusers.outanscount) +
        "\r\nOUTTMANS\r\n" +
        parseInt(informationusers.outtmans) +
        "\r\nOUTSLA\r\n100\r\nTMLOGIN\r\n" +
        parseInt(duracaoLoginFinal) +
        "\r\nCOUNTFPAUSE\r\n" +
        parseInt(informationusers.psdfbreak) +
        "\r\nJSON\r\n \r\nFUTUREPAUSE\r\n0\r\nDESCFUTUREPAUSE\r\n \r\nINITIALLOGIN\r\n0\r\n\r\n",
    );
    statusAgentIMSDN = "LV";
    stAgIMSDN = "LV";
    console.log(
      "INGENIUM_ENVIOSTATUS :",
      new Date().toLocaleString(),
      stAgIMSDN,
    );
    requestStatusAgent =
      "REQ\r\n" +
      iduser +
      "\r\nUSERNAME\r\n" +
      informationusers.username +
      "\r\nDISPLAYNAME\r\n" +
      informationusers.displayname +
      "\r\nEXTEN\r\n" +
      informationusers.ramal +
      "\r\nREASON\r\n \r\nSTATUS\r\nLV\r\nSTATUSID\r\n-1\r\nHOUR\r\n" +
      post +
      "-00:00:00\r\nDESCRIPTION\r\n \r\nEMAIL\r\n \r\nGROUP\r\n" +
      informationusers.idgroup +
      "\r\nDTL\r\n" +
      post +
      "\r\nGROUPNAME\r\n" +
      informationusers.grupo +
      "\r\nPSDCOUNT\r\n" +
      parseInt(informationusers.psdcount) +
      "\r\nPSDTMA\r\n" +
      parseInt(informationusers.psdtma) +
      "\r\nMNGGROUP\r\n-1\r\nINCALLCOUNT\r\n" +
      parseInt(informationusers.incallcount) +
      "\r\nINANSCOUNT\r\n" +
      parseInt(informationusers.inanscount) +
      "\r\nINTMANS\r\n" +
      parseInt(informationusers.intmans) +
      "\r\nINSLA\r\n100\r\nOUTCALLCOUNT\r\n" +
      parseInt(informationusers.outcallcount) +
      "\r\nOUTANSCOUNT\r\n" +
      parseInt(informationusers.outanscount) +
      "\r\nOUTTMANS\r\n" +
      parseInt(informationusers.outtmans) +
      "\r\nOUTSLA\r\n100\r\nTMLOGIN\r\n" +
      parseInt(duracaoLoginFinal) +
      "\r\nCOUNTFPAUSE\r\n" +
      parseInt(informationusers.psdfbreak) +
      "\r\nJSON\r\n \r\nFUTUREPAUSE\r\n0\r\nDESCFUTUREPAUSE\r\n \r\nINITIALLOGIN\r\n0\r\n\r\n";
    clearInterval(statusIntervalAgent);
    envioStatusAgente(14891, informationusers.sipid);
  }
}

function removerNumeroDoJsoncall(jsoncall, numeroParaRemover) {
  if (!jsoncall || typeof jsoncall !== "string") return "";

  // se nao tem "¿", retorna vazio direto
  if (!jsoncall.includes("¿")) return "";

  return jsoncall
    .split("¿")
    .filter((parte) => !parte.includes(numeroParaRemover))
    .join("¿");
}

function SendSocketTransferCallMonitor(
  iduser,
  cdrid,
  iduserin,
  userout,
  serverid,
  usermon,
  UsersAgents,
  telcliente,
) {
  touser = userout;

  InsertActivityCDR(cdrid, 15, iduser, "Transferido pelo gestor");

  let userOrigin = UsersAgents.find(
    (filt) => parseInt(filt.iduser) === parseInt(usermon),
  );

  console.log("INGENIUMCHECKTTANSFER userOrigin: ", userOrigin);
  console.log("INGENIUMCHECKTTANSFER STATUS: ", userOrigin.status);
  console.log("INGENIUMCHECKTTANSFER_JSON CALL: ", userOrigin.jsoncall);

  let quantidade = 0;

  if (
    userOrigin &&
    typeof userOrigin.jsoncall === "string" &&
    userOrigin.jsoncall.trim() !== ""
  ) {
    quantidade = userOrigin.jsoncall
      .split("¿")
      .filter((p) => p.trim() !== "").length;
  }

  console.log("INGENIUMCHECKTTANSFER_JSON CALL LENGTH:", quantidade);

  if (
    userOrigin &&
    (userOrigin.status === null ||
      userOrigin.status === "" ||
      (typeof userOrigin.status === "string" &&
        userOrigin.status.trim() === "null"))
  ) {
    let post = Moment().format("DD/MM/YYYY HH:mm:ss");
    console.log("INGENIUMCHECKTTANSFER_TELCLIENTE: ", telcliente);

    let resultado = removerNumeroDoJsoncall(userOrigin.jsoncall, telcliente);
    console.log("INGENIUMCHECKTTANSFER_RESULTADO: ", resultado);
    socket.send(
      "REQ\r\n" +
        userOrigin.iduser +
        "\r\nUSERNAME\r\n" +
        userOrigin.username +
        "\r\nDISPLAYNAME\r\n" +
        userOrigin.label +
        "\r\nEXTEN\r\n" +
        userOrigin.ramal +
        "\r\nREASON\r\n \r\nSTATUS\r\n \r\nSTATUSID\r\n-1\r\nHOUR\r\n" +
        post +
        "-00:00:00\r\nDESCRIPTION\r\n \r\nEMAIL\r\n \r\nGROUP\r\n" +
        userOrigin.id_grupo +
        "\r\nDTL\r\n" +
        post +
        "\r\nGROUPNAME\r\n" +
        userOrigin.desc_grupo +
        "\r\nJSON\r\n" +
        resultado +
        "\r\nMNGGROUP\r\n-1\r\nINITIALLOGIN\r\n0\r\n\r\n",
    );
  } else if (parseInt(quantidade) === 1) {
    let post = Moment().format("DD/MM/YYYY HH:mm:ss");
    console.log("INGENIUMCHECKTTANSFER TELCLIENTE: ", telcliente);

    let resultado = removerNumeroDoJsoncall(userOrigin.jsoncall, telcliente);
    console.log("INGENIUMCHECKTTANSFER RESULTADO: ", resultado);

    socket.send(
      "REQ\r\n" +
        userOrigin.iduser +
        "\r\nUSERNAME\r\n" +
        userOrigin.username +
        "\r\nDISPLAYNAME\r\n" +
        userOrigin.label +
        "\r\nEXTEN\r\n" +
        userOrigin.ramal +
        "\r\nREASON\r\n \r\nSTATUS\r\nLV\r\nSTATUSID\r\n-1\r\nHOUR\r\n" +
        post +
        "-00:00:00\r\nDESCRIPTION\r\n \r\nEMAIL\r\n \r\nGROUP\r\n" +
        userOrigin.id_grupo +
        "\r\nDTL\r\n" +
        post +
        "\r\nGROUPNAME\r\n" +
        userOrigin.desc_grupo +
        "\r\nJSON\r\n" +
        resultado +
        "\r\nMNGGROUP\r\n-1\r\nINITIALLOGIN\r\n0\r\n\r\n",
    );
  }

  socket.send(
    "CHATTRANSFER\r\n" +
      iduser +
      "\r\nCONTACTID\r\n" +
      cdrid +
      "\r\nTO\r\n" +
      serverid +
      "\r\nTOAGENT\r\n" +
      parseInt(iduserin) +
      "\r\nMONUSER\r\n" +
      iduser +
      "\r\n\r\n",
  );
}

function InviteMessagesMonitoringUser(infousers, contactid, msg, makeid, line) {
  socket.send(
    "WSIMSGLOG\r\n" +
      infousers.id +
      "\r\nTYPE\r\n0\r\nTOUSER\r\n" +
      contactid.serverid +
      "\r\nTOCLIENT\r\n" +
      contactid.idatendimento +
      "\r\nCALLID\r\n" +
      makeid +
      "\r\nUSERNAME\r\n" +
      infousers.displayname +
      "\r\nMSG\r\n" +
      msg +
      "\r\nMONUSER\r\n" +
      infousers.id +
      "\r\nTMON\r\n" +
      line +
      "\r\n\r\n",
  );
}

// function InviteMessage (infousers,contactid,msg, makeid, hsm, paramshsm ,idreplyop, checkparam, checkparam2, variables){
// 	msg = escape(msg)
// 	msg = msg.replace(/%u/gi, "\\u");
// 	msg = unescape(msg)
// 	msg = msg.replace(/\\"/gm, '"');
// 	let cliente = contactid.cliente;
// 	let msgreplyadd = ''
// 	cliente = cliente.replace(/ /, "");

// 	if(hsm !== true){
// 		if(parseInt(idreplyop) > 0)
// 			msgreplyadd = '\r\nREPLYID\r\n'+idreplyop

// 		socket.send("WSIMSGLOG\r\n"+infousers.id+"\r\nTYPE\r\n0\r\nTOUSER\r\n"+contactid.serverid+"\r\nTOCLIENT\r\n"+contactid.idatendimento+"\r\nCALLID\r\n"+makeid+"\r\nUSERNAME\r\n"+infousers.displayname+"\r\nMSG\r\n"+msg+""+msgreplyadd+"\r\n\r\n");
// 	}else{
// 		let parametro0 = "";
// 		let parametro1 = "";
// 		let parametro2 = "";

// 			// if(checkparam===true)
// 			// parametro1 = '"default":"'+cliente+'"';

// 			// if(checkparam2===true)
// 			// parametro2 = parametro1 === "" ? '"default":"'+infousers.displayname+'"':',"default":"'+infousers.displayname+'"';

// 			// if(checkparam===true || checkparam2===true)
// 		 	// parametro0 = ',"PARAM":{'+parametro1+parametro2+'}';

// 			 parametro0 = ',"PARAM":{'

// 			 variables.forEach((variable, index) => {
// 				 parametro0 = index === 0 ? parametro0+'"default":"'+variable.value+'"':parametro0+',"default":"'+variable.value+'"';
// 			 })

// 			 parametro0 = parametro0+'}'

// 		let createjson = '{"MSG":"'+msg+'","NAMESPACE":"'+paramshsm.namespace+'", "ELEMENT_NAME":"'+paramshsm.element_name+'","MIMETYPE":"'+paramshsm.mimetypeid+'"'+parametro0+'}';

// 		socket.send("WSIMSGLOG\r\n"+infousers.id+"\r\nTYPE\r\n5\r\nTOUSER\r\n"+contactid.serverid+"\r\nTOCLIENT\r\n"+contactid.idatendimento+"\r\nCALLID\r\n"+makeid+"\r\nUSERNAME\r\n"+infousers.displayname+"\r\nMSG\r\n"+createjson+"\r\n\r\n");
// 	}
// };

function InviteMessage(
  infousers,
  contactid,
  msg,
  makeid,
  hsm,
  paramshsm,
  idreplyop,
  checkparam,
  checkparam2,
  variables,
) {
  msg = escape(msg);
  msg = msg.replace(/%u/gi, "\\u");
  msg = unescape(msg);
  msg = msg.replace(/\\"/gm, '"');
  let cliente = contactid.cliente;
  let msgreplyadd = "";
  cliente = cliente.replace(/ /, "");

  if (hsm !== true) {
    if (parseInt(idreplyop) > 0) msgreplyadd = "\r\nREPLYID\r\n" + idreplyop;

    socket.send(
      "WSIMSGLOG\r\n" +
        infousers.id +
        "\r\nTYPE\r\n0\r\nTOUSER\r\n" +
        contactid.serverid +
        "\r\nTOCLIENT\r\n" +
        contactid.idatendimento +
        "\r\nCALLID\r\n" +
        makeid +
        "\r\nUSERNAME\r\n" +
        infousers.displayname +
        "\r\nMSG\r\n" +
        msg +
        "" +
        msgreplyadd +
        "\r\n\r\n",
    );
  } else {
    let parametro0 = "";
    let parametro1 = "";
    let parametro2 = "";
    let createjson = "";

    parametro0 = ',"PARAM":{';

    variables.forEach((variable, index) => {
      parametro0 =
        index === 0
          ? parametro0 + '"default":"' + variable.value + '"'
          : parametro0 + ',"default":"' + variable.value + '"';
    });

    parametro0 = parametro0 + "}";

    parametro0 = escape(parametro0);
    parametro0 = parametro0.replace(/%u/gi, "\\u");
    parametro0 = unescape(parametro0);

    if (parseInt(paramshsm.mimetypeid) === 30) {
      createjson =
        '{"MSG":"' +
        msg +
        '","NAMESPACE":"' +
        paramshsm.namespace +
        '", "ELEMENT_NAME":"' +
        paramshsm.element_name +
        '","MIMETYPE":"' +
        paramshsm.mimetypeid +
        '"' +
        parametro0 +
        "}";
    } else if (parseInt(paramshsm.mimetypeid) === 31) {
      createjson =
        '{"URL":"' +
        msg +
        '","NAMESPACE":"' +
        paramshsm.namespace +
        '", "ELEMENT_NAME":"' +
        paramshsm.element_name +
        '"' +
        parametro0 +
        ',"HSM_MIMETYPE":"' +
        paramshsm.typename +
        '","FILEPATH":"' +
        paramshsm.filepath +
        '"}';
    } else if (
      parseInt(paramshsm.mimetypeid) === 38 ||
      parseInt(paramshsm.mimetypeid) === 33
    ) {
      createjson =
        '{"URL":"' +
        msg +
        '","NAMESPACE":"' +
        paramshsm.namespace +
        '", "ELEMENT_NAME":"' +
        paramshsm.element_name +
        '"' +
        parametro0 +
        ',"HSM_MIMETYPE":"' +
        paramshsm.typename +
        '","FILEPATH":"' +
        paramshsm.filepath +
        '","HSM_BUTTONS": [' +
        paramshsm.buttons_or_list +
        "]}";
    }

    socket.send(
      "WSIMSGLOG\r\n" +
        infousers.id +
        "\r\nTYPE\r\n5\r\nTOUSER\r\n" +
        contactid.serverid +
        "\r\nTOCLIENT\r\n" +
        contactid.idatendimento +
        "\r\nCALLID\r\n" +
        makeid +
        "\r\nUSERNAME\r\n" +
        infousers.displayname +
        "\r\nMSG\r\n" +
        createjson +
        "\r\n\r\n",
    );
  }
}

function InviteChat(infousers, iduserout, msg, makeid) {
  socket.send(
    "USRMSGLOG\r\n" +
      infousers.id +
      "\r\nTYPE\r\n0\r\nTOUSER\r\n" +
      iduserout +
      "\r\nCALLID\r\n" +
      makeid +
      "\r\nUSERNAME\r\n" +
      infousers.username +
      "\r\nMSG\r\n" +
      msg +
      "\r\nWRNG\r\n0\r\n",
  );
}

export const SendReqAfterCallWork = (informationusers, contactid) => {
  sendReqAfterCallWork(informationusers, contactid);
};

export const SendReadingMsg = (atendimento, informationusers) => {
  if (
    parseInt(atendimento.qtdmessage) > 0 &&
    parseInt(atendimento.idmidia) !== 1 &&
    atendimento.serverid !== "" &&
    atendimento.serverid
  ) {
    let jsonAtdAtual2 =
      "WSIMSGLOGREAD\r\n" +
      informationusers.id +
      "\r\nCALLID\r\nXXXXXXXXXXXXXXXXXXX\r\nTOUSER\r\n" +
      atendimento.serverid +
      "\r\nTOCLIENT\r\n" +
      atendimento.idatendimento +
      "\r\nMSGID\r\n-1\r\nRESULT\r\n" +
      `{'CDRID':${atendimento.idatendimento}}` +
      "\r\n\r\n";
    socket.send(jsonAtdAtual2);
  }
};

export const dispareReadingMsg = (atendimento, informationusers) => {
  return (dispatch, getState) => {
    dispatch(clearQtdMsg(atendimento.idatendimento));
    let jsonAtdAtual2 =
      "WSIMSGLOGREAD\r\n" +
      informationusers.id +
      "\r\nCALLID\r\nXXXXXXXXXXXXXXXXXXX\r\nTOUSER\r\n" +
      atendimento.serverid +
      "\r\nTOCLIENT\r\n" +
      atendimento.idatendimento +
      "\r\nMSGID\r\n-1\r\nRESULT\r\n" +
      `{'CDRID':${atendimento.idatendimento}}` +
      "\r\n\r\n";
    socket.send(jsonAtdAtual2);
  };
};

function sendReqAfterCallWork(informationusers, contactid) {
  let post = Moment().format("DD/MM/YYYY HH:mm:ss");

  let data_hora_atual = Moment().format("YYYY/MM/DD HH:mm:ss");
  let duracaoLoginAtual = Moment(data_hora_atual).diff(
    informationusers.datalogin,
    "seconds",
  );
  let duracaoLoginFinal =
    parseInt(duracaoLoginAtual) + parseInt(informationusers.tmlogin);
  let strPauseFuture = informationusers.blockfuture ? 1 : 0;
  let descPauseFuture = informationusers.blockfuture ? descfuturepause : " ";

  socket.send(
    "REQ\r\n" +
      informationusers.id +
      "\r\nUSERNAME\r\n" +
      informationusers.username +
      "\r\nDISPLAYNAME\r\n" +
      informationusers.displayname +
      "\r\nEXTEN\r\n" +
      informationusers.ramal +
      "\r\nREASON\r\n \r\nSTATUS\r\nACW\r\nSTATUSID\r\n-1\r\nHOUR\r\n" +
      post +
      "-00:00:00\r\nDESCRIPTION\r\n \r\nEMAIL\r\n \r\nGROUP\r\n" +
      informationusers.idgroup +
      "\r\nDTL\r\n" +
      post +
      "\r\nGROUPNAME\r\n" +
      informationusers.grupo +
      "\r\nPSDCOUNT\r\n" +
      parseInt(informationusers.psdcount) +
      "\r\nPSDTMA\r\n" +
      parseInt(informationusers.psdtma) +
      "\r\nMNGGROUP\r\n-1\r\nINCALLCOUNT\r\n" +
      parseInt(informationusers.incallcount) +
      "\r\nINANSCOUNT\r\n" +
      parseInt(informationusers.inanscount) +
      "\r\nINTMANS\r\n" +
      parseInt(informationusers.intmans) +
      "\r\nINSLA\r\n100\r\nOUTCALLCOUNT\r\n" +
      parseInt(informationusers.outcallcount) +
      "\r\nOUTANSCOUNT\r\n" +
      parseInt(informationusers.outanscount) +
      "\r\nOUTTMANS\r\n" +
      parseInt(informationusers.outtmans) +
      "\r\nOUTSLA\r\n100\r\nTMLOGIN\r\n" +
      parseInt(duracaoLoginFinal) +
      "\r\nMEDIAID\r\n" +
      parseInt(contactid.idmidia) +
      "\r\nTELEFONE\r\n" +
      parseInt(contactid.telefone) +
      "\r\nCOUNTFPAUSE\r\n" +
      parseInt(informationusers.psdfbreak) +
      "\r\nFUTUREPAUSE\r\n" +
      strPauseFuture +
      "\r\nDESCFUTUREPAUSE\r\n" +
      descPauseFuture +
      "\r\nINITIALLOGIN\r\n0\r\n\r\n",
  );
  statusAgentIMSDN = "ACW";
  stAgIMSDN = "ACW";
  console.log("INGENIUM_ENVIOSTATUS :", new Date().toLocaleString(), stAgIMSDN);
  requestStatusAgent =
    "REQ\r\n" +
    informationusers.id +
    "\r\nUSERNAME\r\n" +
    informationusers.username +
    "\r\nDISPLAYNAME\r\n" +
    informationusers.displayname +
    "\r\nEXTEN\r\n" +
    informationusers.ramal +
    "\r\nREASON\r\n \r\nSTATUS\r\nACW\r\nSTATUSID\r\n-1\r\nHOUR\r\n" +
    post +
    "-00:00:00\r\nDESCRIPTION\r\n \r\nEMAIL\r\n \r\nGROUP\r\n" +
    informationusers.idgroup +
    "\r\nDTL\r\n" +
    post +
    "\r\nGROUPNAME\r\n" +
    informationusers.grupo +
    "\r\nPSDCOUNT\r\n" +
    parseInt(informationusers.psdcount) +
    "\r\nPSDTMA\r\n" +
    parseInt(informationusers.psdtma) +
    "\r\nMNGGROUP\r\n-1\r\nINCALLCOUNT\r\n" +
    parseInt(informationusers.incallcount) +
    "\r\nINANSCOUNT\r\n" +
    parseInt(informationusers.inanscount) +
    "\r\nINTMANS\r\n" +
    parseInt(informationusers.intmans) +
    "\r\nINSLA\r\n100\r\nOUTCALLCOUNT\r\n" +
    parseInt(informationusers.outcallcount) +
    "\r\nOUTANSCOUNT\r\n" +
    parseInt(informationusers.outanscount) +
    "\r\nOUTTMANS\r\n" +
    parseInt(informationusers.outtmans) +
    "\r\nOUTSLA\r\n100\r\nTMLOGIN\r\n" +
    parseInt(duracaoLoginFinal) +
    "\r\nMEDIAID\r\n" +
    parseInt(contactid.idmidia) +
    "\r\nTELEFONE\r\n" +
    parseInt(contactid.telefone) +
    "\r\nCOUNTFPAUSE\r\n" +
    parseInt(informationusers.psdfbreak) +
    "\r\nFUTUREPAUSE\r\n" +
    strPauseFuture +
    "\r\nDESCFUTUREPAUSE\r\n" +
    descPauseFuture +
    "\r\nINITIALLOGIN\r\n0\r\n\r\n";
}

function InviteChatGroup(
  infousers,
  msgsocket,
  makeid,
  groupsSelecGrupo,
  warning,
) {
  groupsSelecGrupo = groupsSelecGrupo.join();
  groupsSelecGrupo = groupsSelecGrupo.replace(/,/gi, "&");
  if (warning === true) {
    warning = "1";
  } else {
    warning = "2";
  }
  socket.send(
    "GRPMSGLOG\r\n" +
      infousers.id +
      "\r\nTYPE\r\n0\r\nGROUPS\r\n" +
      groupsSelecGrupo +
      "\r\nCALLID\r\n" +
      makeid +
      "\r\nUSERNAME\r\n" +
      infousers.username +
      "\r\nMSG\r\n" +
      msgsocket +
      "\r\nWRNG\r\n" +
      warning +
      "\r\n",
  );
}

function ChangeCallHold(atdsimultaneo, local) {
  // atdsimultaneo.map((atd) => {
  //   if (parseInt(atd.idmidia) === 1) {
  //     webphone_api.setline(atd.line);
  //     if(!webphone_api.isonhold()){
  //       // webphone_api.hold(true);
  //     }
  //   }
  // });
}

function verifyIfStatusChanged(status, proximoatd) {
  try {
    let newStatus = "Atendimento";
    if (Boolean(proximoatd) && proximoatd.acw) {
      newStatus = "Aftercallwork";
    }
    if (!Boolean(status))
      return {
        isChanged: false,
        newStatus: newStatus === "Atendimento" ? "AT" : "ACW",
      };
    return {
      isChanged: status.status !== newStatus,
      newStatus: newStatus === "Atendimento" ? "AT" : "ACW",
    };
  } catch (error) {
    return { isChanged: false, newStatus: "AT" };
  }
}

function ChangeAtdnow(
  infousers,
  proximoatd,
  atdsimultaneo,
  ipcurrent,
  currentStatus = null,
  isFromClick = false,
) {
  let datatime = proximoatd.datatimeatd;
  let date1 = Moment().format("YYYY/MM/DD HH:mm:ss");
  let date2 = Moment(proximoatd.datatimeatd).format("YYYY/MM/DD HH:mm:ss");
  let valorDiferenca = parseInt(Math.abs(Math.round(ipcurrent.difftime)));

  let qtdeVoz = atdsimultaneo.filter(
    (filt) => parseInt(filt.idmidia) === 1 || parseInt(filt.idmidia) === 16,
  );
  let strPauseFuture = infousers.blockfuture ? 1 : 0;
  let descPauseFuture = infousers.blockfuture ? descfuturepause : " ";

  if (qtdeVoz.length > 1) {
    if (
      parseInt(proximoatd.idmidia) === 1 ||
      parseInt(proximoatd.idmidia) === 16
    ) {
      atdsimultaneo.map((atd) => {
        if (proximoatd.line !== undefined && parseInt(proximoatd.line) !== 0) {
          if (
            parseInt(atd.line) !== parseInt(proximoatd.line) &&
            (parseInt(proximoatd.idmidia) === 1 ||
              parseInt(proximoatd.idmidia) === 16)
          ) {
            webphone_api.setline(parseInt(atd.line));
            webphone_api.hold(true);
          }
        }
      });
    }
  }

  datatime = Moment(datatime, "DD/MM/YYYY HH:mm:ss").format(
    "DD/MM/YYYY HH:mm:ss",
  );

  if (parseInt(ipcurrent.difftime) < 0) {
    // datatime = Moment(datatime).subtract(valorDiferenca,'seconds').format('DD/MM/YYYY HH:mm');
    date1 = Moment()
      .subtract(valorDiferenca, "seconds")
      .format("YYYY/MM/DD HH:mm:ss");
  } else {
    // datatime = Moment(datatime).add(valorDiferenca,'seconds').format('DD/MM/YYYY HH:mm');
    date1 = Moment()
      .add(valorDiferenca, "seconds")
      .format("YYYY/MM/DD HH:mm:ss");
  }

  let diff = Moment(date1).diff(date2, "seconds");

  let convertido = Moment("2015-01-01")
    .startOf("day")
    .seconds(diff)
    .format("HH:mm:ss");
  let jsonChannelPhoneCall = mountCallsStatus(atdsimultaneo);

  let data_hora_atual = Moment().format("YYYY/MM/DD HH:mm:ss");
  let duracaoLoginAtual = Moment(data_hora_atual).diff(
    infousers.datalogin,
    "seconds",
  );
  let duracaoLoginFinal =
    parseInt(duracaoLoginAtual) + parseInt(infousers.tmlogin);

  const statusChanged = verifyIfStatusChanged(currentStatus, proximoatd);

  if (
    !connection_platform.waitToSendReq.isToDisableReqOnChangeAtd ||
    !isFromClick
  ) {
    socket.send(
      "REQ\r\n" +
        infousers.id +
        "\r\nUSERNAME\r\n" +
        infousers.username +
        "\r\nDISPLAYNAME\r\n" +
        infousers.displayname +
        "\r\nEXTEN\r\n" +
        infousers.ramal +
        "\r\nREASON\r\n" +
        proximoatd.telefone +
        "\r\nSTATUS\r\nAT\r\nSTATUSID\r\n-1\r\nHOUR\r\n" +
        datatime +
        "-" +
        convertido +
        "\r\nDESCRIPTION\r\n" +
        proximoatd.nomesubservico +
        "\r\nEMAIL\r\n \r\nGROUP\r\n" +
        infousers.idgroup +
        "\r\nDTL\r\n" +
        datatime +
        "\r\nGROUPNAME\r\n" +
        infousers.grupo +
        "\r\nPSDCOUNT\r\n" +
        infousers.psdcount +
        "\r\nPSDTMA\r\n" +
        infousers.psdtma +
        "\r\nMNGGROUP\r\n-1\r\nINCALLCOUNT\r\n" +
        infousers.incallcount +
        "\r\nINANSCOUNT\r\n" +
        infousers.inanscount +
        "\r\nINTMANS\r\n" +
        infousers.intmans +
        "\r\nINSLA\r\n100\r\nOUTCALLCOUNT\r\n" +
        infousers.outcallcount +
        "\r\nOUTANSCOUNT\r\n" +
        infousers.outanscount +
        "\r\nOUTTMANS\r\n" +
        infousers.outtmans +
        "\r\nCOUNTFPAUSE\r\n" +
        parseInt(infousers.psdfbreak) +
        "\r\nOUTSLA\r\n100" +
        "\r\nDESCFUTUREPAUSE\r\n" +
        descPauseFuture +
        "\r\nINITIALLOGIN\r\n0\r\nTMLOGIN\r\n" +
        parseInt(duracaoLoginFinal) +
        "\r\nJSON\r\n" +
        jsonChannelPhoneCall +
        "\r\nCDRID\r\n" +
        proximoatd.idatendimento +
        "\r\nFUTUREPAUSE\r\n" +
        strPauseFuture +
        "\r\nSRVIN\r\n" +
        proximoatd.nomesubservico +
        "\r\nMEDIAID\r\n" +
        proximoatd.idmidia +
        "\r\n\r\n",
    );
  } else if (isFromClick && statusChanged.isChanged) {
    socket.send(
      "REQ\r\n" +
        infousers.id +
        "\r\nUSERNAME\r\n" +
        infousers.username +
        "\r\nDISPLAYNAME\r\n" +
        infousers.displayname +
        "\r\nEXTEN\r\n" +
        infousers.ramal +
        "\r\nREASON\r\n" +
        proximoatd.telefone +
        `\r\nSTATUS\r\n${statusChanged.newStatus}\r\nSTATUSID\r\n-1\r\nHOUR\r\n` +
        datatime +
        "-" +
        convertido +
        "\r\nDESCRIPTION\r\n" +
        proximoatd.nomesubservico +
        "\r\nEMAIL\r\n \r\nGROUP\r\n" +
        infousers.idgroup +
        "\r\nDTL\r\n" +
        datatime +
        "\r\nGROUPNAME\r\n" +
        infousers.grupo +
        "\r\nPSDCOUNT\r\n" +
        infousers.psdcount +
        "\r\nPSDTMA\r\n" +
        infousers.psdtma +
        "\r\nMNGGROUP\r\n-1\r\nINCALLCOUNT\r\n" +
        infousers.incallcount +
        "\r\nINANSCOUNT\r\n" +
        infousers.inanscount +
        "\r\nINTMANS\r\n" +
        infousers.intmans +
        "\r\nINSLA\r\n100\r\nOUTCALLCOUNT\r\n" +
        infousers.outcallcount +
        "\r\nOUTANSCOUNT\r\n" +
        infousers.outanscount +
        "\r\nOUTTMANS\r\n" +
        infousers.outtmans +
        "\r\nCOUNTFPAUSE\r\n" +
        parseInt(infousers.psdfbreak) +
        "\r\nOUTSLA\r\n100" +
        "\r\nDESCFUTUREPAUSE\r\n" +
        descPauseFuture +
        "\r\nINITIALLOGIN\r\n0\r\nTMLOGIN\r\n" +
        parseInt(duracaoLoginFinal) +
        "\r\nJSON\r\n" +
        jsonChannelPhoneCall +
        "\r\nCDRID\r\n" +
        proximoatd.idatendimento +
        "\r\nFUTUREPAUSE\r\n" +
        strPauseFuture +
        "\r\nSRVIN\r\n" +
        proximoatd.nomesubservico +
        "\r\nMEDIAID\r\n" +
        proximoatd.idmidia +
        "\r\n\r\n",
    );
  }
  console.log("INGENIUM_IMSDN_PAUSEFUTURE_AQUI : ", strPauseFuture);
  statusAgentIMSDN = "AT";
  if (parseInt(strPauseFuture) === 1) {
    stAgIMSDN = "RV";
  } else {
    stAgIMSDN = "AT";
  }
  console.log("INGENIUM_ENVIOSTATUS :", new Date().toLocaleString(), stAgIMSDN);
  requestStatusAgent =
    "REQ\r\n" +
    infousers.id +
    "\r\nUSERNAME\r\n" +
    infousers.username +
    "\r\nDISPLAYNAME\r\n" +
    infousers.displayname +
    "\r\nEXTEN\r\n" +
    infousers.ramal +
    "\r\nREASON\r\n" +
    proximoatd.telefone +
    "\r\nSTATUS\r\nAT\r\nSTATUSID\r\n-1\r\nHOUR\r\n" +
    datatime +
    "-" +
    convertido +
    "\r\nDESCRIPTION\r\n" +
    proximoatd.nomesubservico +
    "\r\nEMAIL\r\n \r\nGROUP\r\n" +
    infousers.idgroup +
    "\r\nDTL\r\n" +
    datatime +
    "\r\nGROUPNAME\r\n" +
    infousers.grupo +
    "\r\nPSDCOUNT\r\n" +
    infousers.psdcount +
    "\r\nPSDTMA\r\n" +
    infousers.psdtma +
    "\r\nMNGGROUP\r\n-1\r\nINCALLCOUNT\r\n" +
    infousers.incallcount +
    "\r\nINANSCOUNT\r\n" +
    infousers.inanscount +
    "\r\nINTMANS\r\n" +
    infousers.intmans +
    "\r\nINSLA\r\n100\r\nOUTCALLCOUNT\r\n" +
    infousers.outcallcount +
    "\r\nOUTANSCOUNT\r\n" +
    infousers.outanscount +
    "\r\nOUTTMANS\r\n" +
    infousers.outtmans +
    "\r\nCOUNTFPAUSE\r\n" +
    parseInt(infousers.psdfbreak) +
    "\r\nOUTSLA\r\n100" +
    "\r\nDESCFUTUREPAUSE\r\n" +
    descPauseFuture +
    "\r\nINITIALLOGIN\r\n0\r\nTMLOGIN\r\n" +
    parseInt(duracaoLoginFinal) +
    "\r\nJSON\r\n" +
    jsonChannelPhoneCall +
    "\r\nCDRID\r\n" +
    proximoatd.idatendimento +
    "\r\nFUTUREPAUSE\r\n" +
    strPauseFuture +
    "\r\nSRVIN\r\n" +
    proximoatd.nomesubservico +
    "\r\nMEDIAID\r\n" +
    proximoatd.idmidia +
    "\r\n\r\n";
  clearInterval(statusIntervalAgent);
  envioStatusAgente(5481, infousers.sipid);
}

function NextAnswerAfterBlock(
  proximoatd,
  mensagem,
  contactid,
  infousers,
  dispatch,
  ipcurrent, //future,
  atdsimult,
) {
  var valorDiferenca = parseInt(Math.abs(Math.round(ipcurrent.difftime)));

  if (proximoatd.line === "0") {
    if (proximoatd.acw !== true) {
      webphone_api.setline(parseInt(proximoatd.line));
      if (proximoatd.statusatd === 3) {
        webphone_api.mute(true, 2);
      } else if (proximoatd.statusatd === 2) {
        if (!webphone_api.isonhold()) webphone_api.hold(true);
      } else {
        webphone_api.mute(false, 0);
        if (webphone_api.isonhold()) webphone_api.hold(false);
      }
    }
  }

  var dataatual = Moment().format("YYYY/MM/DD HH:mm:ss");

  if (parseInt(ipcurrent.difftime) < 0) {
    dataatual = Moment()
      .subtract(valorDiferenca, "seconds")
      .format("YYYY/MM/DD HH:mm:ss");
  } else {
    dataatual = Moment()
      .add(valorDiferenca, "seconds")
      .format("YYYY/MM/DD HH:mm:ss");
  }

  var datatimeatd = Moment(
    proximoatd.datatimeatd,
    "DD/MM/YYYY HH:mm:ss",
  ).format("YYYY/MM/DD HH:mm:ss");
  var time = Moment(dataatual).diff(datatimeatd, "seconds");

  dispatch(
    addAtendimento(
      proximoatd.idatendimento,
      proximoatd.cliente,
      proximoatd.telefone,
      proximoatd.servico,
      proximoatd.datatimeatd,
      proximoatd.criticidade,
      proximoatd.menubot,
      proximoatd.subservico,
      proximoatd.serviceatd,
      proximoatd.recuperation,
      time,
      proximoatd.direction,
      proximoatd.idmidia,
      proximoatd.timecomplete,
      proximoatd.statusagent,
      proximoatd.line,
      proximoatd.queueid,
      proximoatd.serverid,
      proximoatd.qtdmessage,
      proximoatd.pathfile,
      proximoatd.mcdu,
      proximoatd.nomesubservico,
      proximoatd.infoinitcall,
      proximoatd.nomecliente,
      proximoatd.protocolo,
      proximoatd.idsubservico,
      proximoatd.acw,
      proximoatd.isDialNc2,
      proximoatd.arrayChannels,
      proximoatd.caseId,
      proximoatd.statusatd,
      proximoatd.score_class,
      proximoatd.score_value,
      proximoatd.nps_call,
      proximoatd.isTabulation,
    ),
  );
  InteracoesContactNumberPeer(proximoatd.telefone, infousers.idgroup);
}

function ProximoAtdSimult(
  proximoatd,
  mensagem,
  contactid,
  infousers,
  dispatch,
  ipcurrent, //future,
  atdsimult,
) {
  // suspeita de está zerando o time em equipes, no request
  // let datatime = Moment().format('DD/MM/YYYY HH:mm:ss');
  let convertTime = Moment(
    proximoatd.recuperationtime,
    "DD/MM/YYYY HH:mm:ss",
  ).format("DD/MM/YYYY HH:mm:ss");
  let datatime = convertTime;

  var valorDiferenca = parseInt(Math.abs(Math.round(ipcurrent.difftime)));
  let strPauseFuture = infousers.blockfuture ? 1 : 0;
  let descPauseFuture = infousers.blockfuture ? descfuturepause : " ";

  // if(parseInt(ipcurrent.difftime)<0){
  // 	datatime = Moment(datatime).subtract(valorDiferenca,'seconds').format('DD/MM/YYYY HH:mm');
  // }else{
  // 	datatime = Moment(datatime).add(valorDiferenca,'seconds').format('DD/MM/YYYY HH:mm');
  // }

  // if(proximoatd.direction === '2' || proximoatd.direction === 1){
  if (proximoatd.direction === "2") {
    dispatch(
      createStatusAgent(
        "Atendimento",
        "S.(" + proximoatd.telefone + ")",
        Moment().format("DD/MM/YYYY HH:mm:ss"),
      ),
    );
  } else {
    dispatch(
      createStatusAgent(
        "Atendimento",
        "E.(" + proximoatd.telefone + ")",
        Moment().format("DD/MM/YYYY HH:mm:ss"),
      ),
    );
  }

  if (proximoatd.line === "0") {
    if (proximoatd.acw === true) {
      dispatch(
        createStatusAgent(
          "Aftercallwork",
          proximoatd.telefone,
          Moment().format("DD/MM/YYYY HH:mm:ss"),
        ),
      );
      dispatch(
        tratarAfterCallWork(
          infousers.tmoutacw,
          parseInt(proximoatd.serviceatd),
          false,
        ),
      );
    } else {
      dispatch(
        createStatusAgent(
          "Atendimento",
          "E.(" + proximoatd.telefone + ")",
          Moment().format("DD/MM/YYYY HH:mm:ss"),
        ),
      );
    }
  } else {
    webphone_api.setline(parseInt(proximoatd.line));
    if (proximoatd.statusatd === 3) {
      webphone_api.mute(true, 2);
    } else if (proximoatd.statusatd === 2) {
      if (!webphone_api.isonhold()) webphone_api.hold(true);
    } else {
      webphone_api.mute(false, 0);
      if (webphone_api.isonhold()) webphone_api.hold(false);
    }

    setTimeout(() => {
      if (proximoatd.acw === true) {
        dispatch(
          createStatusAgent(
            "Aftercallwork",
            proximoatd.telefone,
            Moment().format("DD/MM/YYYY HH:mm:ss"),
          ),
        );
        dispatch(
          tratarAfterCallWork(
            infousers.tmoutacw,
            parseInt(proximoatd.serviceatd),
            false,
          ),
        );
      } else {
        dispatch(
          createStatusAgent(
            "Ligação",
            "E.(" + proximoatd.telefone + ")",
            Moment().format("DD/MM/YYYY HH:mm:ss"),
          ),
        );
      }
    }, 250);
  }

  if (infousers.blockfuture === false) {
    if (infousers.tmoutacw !== 0) {
      axios.get(
        `${connection_platform.type_connect}://${pathname}:${port}/conn/updatestatusvozacw?idatendimento=${contactid.serviceatd}`,
      );
    }

    // InsertPausaRV(infousers.sipid, infousers.id, dispatch);
    dispatch(InsertPausaRVV2(infousers.sipid, infousers.id));
  }
  let arrayAtdJson = [];

  if (atdsimult) {
    atdsimult.map((atd) => {
      //if (atd.telefone !== contactid.telefone) {
      if (atd.idatendimento !== contactid.idatendimento) {
        arrayAtdJson.push({
          idmidia: atd.idmidia,
          telefone: atd.telefone,
        });
      }
    });
  }
  let jsonChannelPhoneCall = mountCallsStatus(arrayAtdJson);

  let data_hora_atual = Moment().format("YYYY/MM/DD HH:mm:ss");
  let duracaoLoginAtual = Moment(data_hora_atual).diff(
    infousers.datalogin,
    "seconds",
  );
  let duracaoLoginFinal =
    parseInt(duracaoLoginAtual) + parseInt(infousers.tmlogin);

  if (
    proximoatd.idatendimento !== null &&
    proximoatd.idatendimento !== undefined &&
    parseInt(proximoatd.idmidia) !== 1 &&
    parseInt(proximoatd.idmidia) !== 16
  ) {
    dispatch(clearQtdMsg(proximoatd.idatendimento));
    if (proximoatd.serverid !== "" && proximoatd.serverid) {
      let jsonAtdAtual =
        "WSIMSGLOGREAD\r\n" +
        infousers.id +
        "\r\nCALLID\r\nXXXXXXXXXXXXXXXXXXX\r\nTOUSER\r\n" +
        proximoatd.serverid +
        "\r\nTOCLIENT\r\n" +
        proximoatd.idatendimento +
        "\r\nMSGID\r\n-1\r\nRESULT\r\n" +
        `{'CDRID':${proximoatd.idatendimento}}` +
        "\r\n\r\n";
      socket.send(jsonAtdAtual);
    }
  }

  socket.send(
    "REQ\r\n" +
      infousers.id +
      "\r\nUSERNAME\r\n" +
      infousers.username +
      "\r\nDISPLAYNAME\r\n" +
      infousers.displayname +
      "\r\nEXTEN\r\n" +
      infousers.ramal +
      "\r\nREASON\r\n" +
      proximoatd.telefone +
      "\r\nSTATUS\r\nAT\r\nSTATUSID\r\n-1\r\nHOUR\r\n" +
      datatime +
      "-00:00:00\r\nDESCRIPTION\r\n" +
      proximoatd.telefone +
      "\r\nEMAIL\r\n \r\nGROUP\r\n" +
      infousers.idgroup +
      "\r\nDTL\r\n" +
      datatime +
      "\r\nGROUPNAME\r\n" +
      infousers.grupo +
      "\r\nPSDCOUNT\r\n0\r\nPSDTMA\r\n" +
      infousers.psdtma +
      "\r\nPSDTMA\r\n" +
      parseInt(infousers.psdtma) +
      "\r\nMNGGROUP\r\n-1\r\nINCALLCOUNT\r\n" +
      infousers.incallcount +
      "\r\nINANSCOUNT\r\n" +
      infousers.inanscount +
      "\r\nINTMANS\r\n" +
      infousers.intmans +
      "\r\nINSLA\r\n100\r\nOUTCALLCOUNT\r\n" +
      infousers.outcallcount +
      "\r\nOUTANSCOUNT\r\n" +
      infousers.outanscount +
      "\r\nOUTTMANS\r\n" +
      infousers.outtmans +
      "\r\nCOUNTFPAUSE\r\n" +
      parseInt(infousers.psdfbreak) +
      "\r\nOUTSLA\r\n100" +
      "\r\nDESCFUTUREPAUSE\r\n" +
      descPauseFuture +
      "\r\nINITIALLOGIN\r\n0\r\nTMLOGIN\r\n" +
      duracaoLoginFinal +
      "\r\nJSON\r\n" +
      jsonChannelPhoneCall +
      "\r\nMEDIAID\r\n" +
      proximoatd.idmidia +
      "\r\nCDRID\r\n" +
      proximoatd.idatendimento +
      "\r\nFUTUREPAUSE\r\n" +
      strPauseFuture +
      "\r\nSRVIN\r\n" +
      contactid.subservico +
      "\r\n\r\n",
  );
  statusAgentIMSDN = "AT";
  console.log("INGENIUM_IMSDN_PAUSEFUTURE : ", strPauseFuture);
  if (strPauseFuture === 1) {
    stAgIMSDN = "RV";
  } else {
    stAgIMSDN = "AT";
  }
  console.log("INGENIUM_ENVIOSTATUS :", new Date().toLocaleString(), stAgIMSDN);
  requestStatusAgent =
    "REQ\r\n" +
    infousers.id +
    "\r\nUSERNAME\r\n" +
    infousers.username +
    "\r\nDISPLAYNAME\r\n" +
    infousers.displayname +
    "\r\nEXTEN\r\n" +
    infousers.ramal +
    "\r\nREASON\r\n" +
    proximoatd.telefone +
    "\r\nSTATUS\r\nAT\r\nSTATUSID\r\n-1\r\nHOUR\r\n" +
    datatime +
    "-00:00:00\r\nDESCRIPTION\r\n" +
    proximoatd.telefone +
    "\r\nEMAIL\r\n \r\nGROUP\r\n" +
    infousers.idgroup +
    "\r\nDTL\r\n" +
    datatime +
    "\r\nGROUPNAME\r\n" +
    infousers.grupo +
    "\r\nPSDCOUNT\r\n0\r\nPSDTMA\r\n" +
    infousers.psdtma +
    "\r\nPSDTMA\r\n" +
    parseInt(infousers.psdtma) +
    "\r\nMNGGROUP\r\n-1\r\nINCALLCOUNT\r\n" +
    infousers.incallcount +
    "\r\nINANSCOUNT\r\n" +
    infousers.inanscount +
    "\r\nINTMANS\r\n" +
    infousers.intmans +
    "\r\nINSLA\r\n100\r\nOUTCALLCOUNT\r\n" +
    infousers.outcallcount +
    "\r\nOUTANSCOUNT\r\n" +
    infousers.outanscount +
    "\r\nOUTTMANS\r\n" +
    infousers.outtmans +
    "\r\nCOUNTFPAUSE\r\n" +
    parseInt(infousers.psdfbreak) +
    "\r\nOUTSLA\r\n100" +
    "\r\nDESCFUTUREPAUSE\r\n" +
    descPauseFuture +
    "\r\nINITIALLOGIN\r\n0\r\nTMLOGIN\r\n" +
    duracaoLoginFinal +
    "\r\nJSON\r\n" +
    jsonChannelPhoneCall +
    "\r\nMEDIAID\r\n" +
    proximoatd.idmidia +
    "\r\nCDRID\r\n" +
    proximoatd.idatendimento +
    "\r\nFUTUREPAUSE\r\n" +
    strPauseFuture +
    "\r\nSRVIN\r\n" +
    contactid.subservico +
    "\r\n\r\n";
  clearInterval(statusIntervalAgent);
  envioStatusAgente(5798, infousers.sipid);

  var dataatual = Moment().format("YYYY/MM/DD HH:mm:ss");

  if (parseInt(ipcurrent.difftime) < 0) {
    dataatual = Moment()
      .subtract(valorDiferenca, "seconds")
      .format("YYYY/MM/DD HH:mm:ss");
  } else {
    dataatual = Moment()
      .add(valorDiferenca, "seconds")
      .format("YYYY/MM/DD HH:mm:ss");
  }

  var datatimeatd = Moment(
    proximoatd.datatimeatd,
    "DD/MM/YYYY HH:mm:ss",
  ).format("YYYY/MM/DD HH:mm:ss");
  var time = Moment(dataatual).diff(datatimeatd, "seconds");

  dispatch(
    addAtendimento(
      proximoatd.idatendimento,
      proximoatd.cliente,
      proximoatd.telefone,
      proximoatd.servico,
      proximoatd.datatimeatd,
      proximoatd.criticidade,
      proximoatd.menubot,
      proximoatd.subservico,
      proximoatd.serviceatd,
      proximoatd.recuperation,
      time,
      proximoatd.direction,
      proximoatd.idmidia,
      proximoatd.timecomplete,
      proximoatd.statusagent,
      proximoatd.line,
      proximoatd.queueid,
      proximoatd.serverid,
      proximoatd.qtdmessage,
      proximoatd.pathfile,
      proximoatd.mcdu,
      proximoatd.nomesubservico,
      proximoatd.infoinitcall,
      proximoatd.nomecliente,
      proximoatd.protocolo,
      proximoatd.idsubservico,
      proximoatd.acw,
      proximoatd.isDialNc2,
      proximoatd.arrayChannels,
      proximoatd.caseId,
      proximoatd.statusatd,
      proximoatd.score_class,
      proximoatd.score_value,
      proximoatd.nps_call,
      proximoatd.isTabulation,
      proximoatd.enterpriseAdditionalInfos,
      proximoatd.contactAdditionalInfos,
      proximoatd.lastCdrClicked,
      proximoatd.responsavelPor,
      proximoatd.contactId,
    ),
  );
  InteracoesContactNumberPeer(proximoatd.telefone, infousers.idgroup);
  dispatch(UpdateRgBlockReturn(infousers));
}

function ByeClient(
  getState,
  contactid,
  infousers,
  dispatch,
  reason,
  atdsimult,
  status,
  payload,
  atendimento,
) {
  let arraycallhistory = callhistory[contactid.idatendimento];
  var now = Moment().format("YYYY/MM/DD HH:mm:ss");
  const { informationusers, ipcurrent, connectionsapi } = getState();

  var valorDiferenca = parseInt(Math.abs(Math.round(ipcurrent.difftime)));

  if (parseInt(ipcurrent.difftime) < 0) {
    now = Moment()
      .subtract(valorDiferenca, "seconds")
      .format("YYYY/MM/DD HH:mm:ss");
  } else {
    now = Moment().add(valorDiferenca, "seconds").format("YYYY/MM/DD HH:mm:ss");
  }

  let dataformatada = Moment(
    atendimento.datatimeatd,
    "DD/MM/YYYY HH:mm:ss",
  ).format("YYYY-MM-DD HH:mm:ss");

  if (arraycallhistory) {
    if (reason === "quarentine") {
      UpdateByeAttendantQuarentine(atendimento.serviceatd);
    } else {
      UpdateByeAttendant(atendimento.serviceatd);
    }
    let received = GetInsertCallHistory(
      atendimento.idatendimento,
      informationusers.id,
    );
    received.then(function (result) {
      axios.get(
        `${
          connection_platform.type_connect
        }://${pathname}:${port}/conn/updatecallhistory?id=${result}&duration=${[
          1,
        ]}`,
      );
    });

    if (contactid.length != 0) {
      if (
        contactid.respatendente == false &&
        contactid.respclient == false &&
        contactid.direction == "2"
      ) {
        if (
          (reason != "transferencia" &&
            reason != "URA" &&
            reason !== "quarentine") ||
          reason === undefined
        ) {
          if (parseInt(infousers.tmoutacw) > 0 && contactid.acw !== true) {
            socket.send(
              "WSIBYE\r\n" +
                infousers.id +
                "\r\nTOUSER\r\n" +
                contactid.serverid +
                "\r\nTOCLIENT\r\n" +
                contactid.idatendimento +
                "\r\n\r\n",
            );
          } else if (parseInt(infousers.tmoutacw) === 0) {
            socket.send(
              "WSIBYE\r\n" +
                infousers.id +
                "\r\nTOUSER\r\n" +
                contactid.serverid +
                "\r\nTOCLIENT\r\n" +
                contactid.idatendimento +
                "\r\n\r\n",
            );
          }
        }
      } else {
        if (
          (reason != "transferencia" &&
            reason != "URA" &&
            reason !== "quarentine") ||
          reason === undefined
        ) {
          //socket.send("WSIBYE\r\n"+infousers.id+"\r\nTOUSER\r\n"+contactid.serverid+"\r\nTOCLIENT\r\n"+contactid.idatendimento+"\r\nMSG\r\nAtendimento Encerrado\r\n\r\n");

          if (parseInt(infousers.tmoutacw) > 0 && contactid.acw !== true) {
            socket.send(
              "WSIBYE\r\n" +
                infousers.id +
                "\r\nTOUSER\r\n" +
                contactid.serverid +
                "\r\nTOCLIENT\r\n" +
                contactid.idatendimento +
                "\r\n\r\n",
            );
          } else if (parseInt(infousers.tmoutacw) === 0) {
            socket.send(
              "WSIBYE\r\n" +
                infousers.id +
                "\r\nTOUSER\r\n" +
                contactid.serverid +
                "\r\nTOCLIENT\r\n" +
                contactid.idatendimento +
                "\r\n\r\n",
            );
          }
        }
      }
    }
  }
  dispatch(GetAnotations([]));
  dispatch(GetMarkstar([]));
  dispatch(GetHistory([]));
  dispatch(
    InterationNotifier("Interação Encerrada com " + contactid.cliente, "call"),
  );
  delete callhistory[contactid.idatendimento];
  if (contactid.idmidia !== 1 && contactid.idmidia !== 16) {
    if (contactid.acw === true || infousers.tmoutacw === 0) {
      dispatch(removeConversation(contactid.idatendimento));
      dispatch(RemoveAtd(contactid.idatendimento));
    }
  }

  if (parseInt(contactid.idmidia) === 1 || parseInt(contactid.idmidia) === 16) {
    if (atdsimult.length < 2) {
      if (contactid.acw === true) {
        dispatch(removeAtdUnique());
        dispatch(RemoveAtd(atendimento.idatendimento));
        dispatch(
          createStatusAgent(
            "Encerrou",
            contactid.cliente,
            Moment().format("DD/MM/YYYY HH:mm:ss"),
          ),
        );
        //  descomentar abaixo no nosso ambiente, teste no nc2 - gabriel barreto
        // dispatch(handleConfirmEnableNc2Redux([],false))
        if (
          connection_platform.nc2_integration === true &&
          informationusers.tmoutacw != 0 &&
          connection_platform.nc2_users.indexOf(informationusers.ramal) !== -1
        ) {
          if (informationusers.nc2schedule && atendimento.isDialNc2 === true) {
            nc2Service.nc2EncerraContato(
              informationusers.ramal,
              "0",
              informationusers.paramsnc2.especifica,
              informationusers.paramsnc2.resultado,
              informationusers.paramsnc2.proximoligacao,
              informationusers.paramsnc2.telefone,
            );
            dispatch(handleConfirmEnableNc2Redux([], false));
            dispatch(nc2ScheduleNumbersUser([]));
            dispatch(nc2ScheduleReasonsUser([]));
          } else if (atendimento.isDialNc2 === true) {
            nc2Service.nc2EncerraContato(
              informationusers.ramal,
              "0",
              0,
              1001,
              null,
              null,
            );
            dispatch(nc2ScheduleNumbersUser([]));
            dispatch(nc2ScheduleReasonsUser([]));
          }

          if (atendimento.isDialNc2 === true)
            nc2Service.nc2AtualizaProspect(informationusers.ramal);
        }
      } else {
        if (
          informationusers.tmoutacw !== 0 &&
          ((atdsimult[0].nomesubservico !== "CAMPANHA" &&
            atdsimult[0].nomesubservico) ||
            (status.status !== "Chamando" && status.status !== "Discando"))
        ) {
          console.log("INGENIUM_VOICE_ACW_9");
          dispatch(
            createStatusAgent(
              "Aftercallwork",
              contactid.telefone,
              Moment().format("DD/MM/YYYY HH:mm:ss"),
            ),
          );
          dispatch(EditAcwContact(contactid.idatendimento));
          if (informationusers.classificationcount > 0) {
            dispatch(
              EditIsTabulatorToClassification(contactid.idatendimento, false),
            );
          }
          if (
            informationusers.nc2schedule !== true &&
            connection_platform.nc2_integration === true &&
            connection_platform.nc2_users.indexOf(informationusers.ramal) !==
              -1 &&
            atdsimult[0].isDialNc2 === true
          ) {
            nc2Service.nc2ObterResultados(dispatch);
            nc2Service.nc2ObterTelefones(dispatch);
            MicroModal.show("modal__encerrar-atendimento");
          }
        } else {
          if (atdsimult.length >= 2) {
            dispatch(RemoveAtd(atendimento.idatendimento));
          } else {
            if (atendimento.acw === true || informationusers.tmoutacw === 0) {
              dispatch(removeAtdUnique());
              dispatch(RemoveAtd(atendimento.idatendimento));
              dispatch(
                createStatusAgent(
                  "Encerrou",
                  contactid.cliente,
                  Moment().format("DD/MM/YYYY HH:mm:ss"),
                ),
              );
            }
          }
          dispatch(handleConfirmEnableNc2Redux([], false));
        }
      }
    } else if (
      contactid.acw === true &&
      (atdsimult.length === 2 || atdsimult.length > 2)
    ) {
      if (contactid.isDialNc2 === true) {
        nc2Service.nc2EncerraContato(
          informationusers.ramal,
          "0",
          informationusers.paramsnc2.especifica,
          informationusers.paramsnc2.resultado,
          informationusers.paramsnc2.proximoligacao,
          informationusers.paramsnc2.telefone,
        );
        dispatch(nc2ScheduleNumbersUser([]));
        dispatch(nc2ScheduleReasonsUser([]));
        dispatch(handleConfirmEnableNc2Redux([], false));
        nc2Service.nc2AtualizaProspect(informationusers.ramal);
      }
      dispatch(RemoveAtd(contactid.idatendimento));
    } else if (informationusers.tmoutacw === 0) {
      dispatch(RemoveAtd(contactid.idatendimento));
    }
  }

  LoginNc2Dial(informationusers, dispatch);

  if (informationusers.tmoutacw !== 0 && contactid.acw === true) {
    console.log("INGENIUM_VOICE_ACW_10");
    sendingIngDeskCloseAnswer(dispatch, payload, contactid, connectionsapi);
  } else if (informationusers.tmoutacw === 0) {
    sendingIngDeskCloseAnswer(dispatch, payload, contactid, connectionsapi);
  }
}

export const SendByeAnswerHidden = (atendimento, infousers) => {
  ByeAnswerHidden(atendimento, infousers);
};

function ByeAnswerHidden(atendimento, infousers) {
  UpdateByeAttendant(atendimento.serviceatd);

  let received = GetInsertCallHistory(atendimento.idatendimento, infousers.id);
  received.then(function (result) {
    axios.get(
      `${
        connection_platform.type_connect
      }://${pathname}:${port}/conn/updatecallhistory?id=${result}&duration=${[
        1,
      ]}`,
    );
  });

  socket.send(
    "WSIBYE\r\n" +
      infousers.id +
      "\r\nTOUSER\r\n" +
      atendimento.serverid +
      "\r\nTOCLIENT\r\n" +
      atendimento.idatendimento +
      "\r\n\r\n",
  );
}

function sendingIngDeskCloseAnswer(
  dispatch,
  payload,
  contactid,
  connectionsapi,
) {
  // futuramente mandar no termino da interação no ingdesk
  if (localStorage.getItem("url_iframe") !== "") {
    if (payload) {
      let channel = "";

      if (parseInt(contactid.idmidia) === 1) channel = "Voz";
      else if (parseInt(contactid.idmidia) === 5) channel = "Whatsapp";
      else if (parseInt(contactid.idmidia) === 8) channel = "Telegram";

      if (payload.isSendLog === true) {
        let jsonIngDesk = {
          origin: "ingweb",
          id: "logInteraction",
          payload: {
            caseId: payload.caseId,
            typeId: parseInt(contactid.idmidia) === 1 ? 1 : 2,
            typeName: parseInt(contactid.idmidia) === 1 ? "voz" : "chat",
            clientId: payload.clientId,
            channelId: contactid.idmidia,
            channelName: channel,
            interactionId: contactid.serviceatd,
            externalProtocol: contactid.protocolo,
            log: {},
          },
        };
        connectionsapi.iframe_ref.current.contentWindow.postMessage(
          jsonIngDesk,
          localStorage.getItem("url_iframe"),
        );
      }
      connectionsapi.iframe_ref.current.contentWindow.postMessage(
        {
          origin: "ingweb",
          id: "interactionEnded",
          payload: contactid.telefone,
        },
        localStorage.getItem("url_iframe"),
      );
    }

    if (localStorage.getItem("url_iframe") !== "") {
      dispatch(removeInteractionIngDesk());
    }
  }
}

export const dbfileSize = (size) => {
  if (size != undefined) {
    let decimals = 2;
    if (size == 0) return "0 Bytes";
    var k = 1024,
      dm = decimals <= 0 ? 0 : decimals || 2,
      sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"],
      i = Math.floor(Math.log(size) / Math.log(k));
    return parseFloat((size / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  }
};

export const UpdateContactInteraction = (
  idusuario,
  scriptid,
  cdr,
  idcontact,
  name,
) => {
  socket.send(
    "UPDATECONTACT\r\n" +
      idusuario +
      "\r\nTOUSER\r\n" +
      scriptid +
      "\r\nJSON\r\n" +
      '{"CDRID": ' +
      cdr +
      ', "IDCONTACT": ' +
      idcontact +
      ', "NAME": ' +
      `"${name}"` +
      "}" +
      // { CDRID: cdr, IDCONTACT: idcontact, NAME: name } +
      "\r\n\r\n",
  );
};

export function getMessagesRecursiveInBantchReverseMode(
  cdrOfPreviousMessages,
  cdrOfNextMessages,
  informationusers,
  dispatch,
) {
  const isJson = (item) => {
    item = typeof item != "string" ? JSON.stringify(item) : item;

    try {
      item = JSON.parse(item);
    } catch (e) {
      return false;
    }

    if (typeof item === "object" && item != null) {
      return true;
    }

    return false;
  };
  let dia = Moment().format("DD");
  let mes = Moment().format("MM");
  let ano = Moment().format("YYYY");
  let datatimeChat = Moment().format("YYYY/MM/DD HH:mm:ss");
  mes = meses.indexOf(mes);
  dia = dia + " de " + meses[mes - 1];
  axios
    .get(
      `${connection_platform.type_connect}://${pathname}:${port}/conn/carregamento-new?cdr=${cdrOfNextMessages}&idgroup=${informationusers.idgroup}&supervisor=${informationusers.supervisor}`,
    )
    .then((response) => {
      let resposta = response.data;

      qtdeMsgCDR = 0;
      const messagesToAdd = [];
      const addMessage = (
        messageid,
        message,
        author,
        datatime,
        contactid,
        typemsg,
        statusmsg,
        favorite,
        dia,
        username,
        monuser,
        destiny,
        typemon,
        replyid,
        options,
        title,
        anoenvio,
        dataenvio,
      ) => {
        messagesToAdd.push({
          messageid,
          message,
          author,
          datatime,
          contactid,
          typemsg,
          statusmsg,
          favorite,
          dia,
          username,
          monuser,
          destiny,
          typemon,
          replyid,
          options,
          title,
          anoenvio,
          dataenvio,
        });
      };
      resposta.forEach(function (obj, index) {
        if (obj.mimetypeid === 56) {
          obj.messagem = formatMimeType56(obj, "");
          obj.mimetypeid = 1;
        }
        dia = obj.diaenvio;
        mes = obj.mesenvio;
        mes = meses.indexOf(mes);
        dia = dia + " de " + meses[mes - 1];
        if (ano < obj.anoenvio || ano > obj.anoenvio)
          dia = dia + " de " + obj.anoenvio;

        let statusmsg = "enviado";
        if (
          obj.dateerror !== null &&
          connection_platform.isStatusOfErrorInSendMessage
        )
          statusmsg = "error";
        else if (obj.dateread !== null) statusmsg = "visto";
        else if (
          obj.datedelivered !== null ||
          !connection_platform.isStatusOfErrorInSendMessage
        )
          statusmsg = "entregue";

        if (obj.datereading === null && obj.datereading !== undefined) {
          qtdeMsgCDR++;
          setTimeout(function () {
            dispatch(editQtdMsg(cdrOfPreviousMessages));
          }, 500);
        }

        if (connection_platform.attendance_screen_new) {
          if (!!obj && !!obj.messagem && typeof obj.messagem === "string") {
            obj.messagem = obj.messagem.replace(
              /\\U([0-9a-fA-F]{8})/g,
              (match, hex) => {
                return String.fromCodePoint(parseInt(hex, 16));
              },
            );
            if (
              !isJson(obj.messagem) &&
              obj.messagem.trimStart().startsWith("{")
            ) {
              const sanitized = obj.messagem
                .replace(/\r\n/g, "\\n")
                .replace(/\r/g, "\\r")
                .replace(/\n/g, "\\n");
              if (isJson(sanitized)) obj.messagem = sanitized;
            }
          }

          if (isJson(obj.messagem) === true) {
            let json = JSON.parse(obj.messagem);
            let options = json.options;
            let buttons = json.buttons;
            let items = json.items;

            if (json.menuid) {
              let i = 1;
              var opcoes = [];
              for (i in options) {
                opcoes.push(i + " - " + options[i][1]);
              }

              addMessage(
                obj.id,
                h2p(json.msg) + "§" + h2p(opcoes.join("  §  ")),
                "Me",
                obj.horaenvio,
                cdrOfPreviousMessages,
                "2",
                statusmsg,
                obj.favorite,
                dia,
                obj.username,
                "",
                obj.destiny,
                obj.mon_type_id,
                obj.replyid,
                "",
                obj.title,
                obj.anoenvio,
                obj.data_hora_envio,
              );
            } else if (json.botid) {
              let opcoes = "";
              let filepath = null;
              let msg = prepararParaJson(json.msg);
              msg = msg.replace(/\r\n/gi, "§");
              // if (parseInt(json.mimetype) === 50) {
              //   msg = `*Seja bem-vindo(a)!*§§${msg}`;
              // } else {
              if (json.header) {
                msg = `*${json.header}*§${msg}${
                  parseInt(json.mimetype) === 50 ? "§" : ""
                }`;
              }

              if (items) {
                opcoes = JSON.stringify(items).replace(/"/gi, "'");
              } else if (buttons) {
                opcoes = JSON.stringify(buttons).replace(/"/gi, "'");
              } else if (parseInt(json.mimetype) === 50) {
                opcoes = JSON.stringify([
                  {
                    text: json.footer,
                    flowCta: json.flow_cta,
                  },
                ]).replace(/"/gi, "'");
              }

              if (json.link) {
                filepath = json.FILEPATH || json.link;
              }

              addMessage(
                obj.id,
                msg + "~¿" + filepath,
                "Me",
                obj.horaenvio,
                cdrOfPreviousMessages,
                "2",
                statusmsg,
                obj.favorite,
                dia,
                obj.username,
                "",
                obj.destiny,
                obj.mon_type_id,
                obj.replyid,
                obj.mimetypeid + "§" + opcoes + "§" + json.botid,
                obj.title,
                obj.anoenvio,
                obj.data_hora_envio,
              );
            } else if (json.LONGITUDE || json.longitude) {
              let longitude = "";
              let latitude = "";
              let name = "";
              let address = "";

              if (json.LONGITUDE) {
                longitude = json.LONGITUDE;
                latitude = json.LATITUDE;
                name = json.NAME;
                address = json.ADDRESS;
              } else {
                longitude = json.longitude;
                latitude = json.latitude;
                name = json.name;
                address = json.address;
              }
              // var msg = json.msg;
              // msg = msg.replace(/\r\n/gi, '§');

              addMessage(
                obj.id,
                address + "~¿" + name + "~¿" + longitude + "~¿" + latitude,
                obj.agente ? "Me" : "username",
                obj.horaenvio,
                cdrOfPreviousMessages,
                "4",
                statusmsg,
                obj.favorite,
                dia,
                obj.username,
                "",
                obj.destiny,
                obj.mon_type_id,
                obj.replyid,
                "",
                obj.title,
                obj.anoenvio,
                obj.data_hora_envio,
              );
            } else if (json.URL) {
              let opcoes = "";
              let filepath = null;
              if (json.FILEPATH) {
                filepath = json.FILEPATH;
              }
              if (json.HSM_BUTTONS) {
                const buttons = json.HSM_BUTTONS;
                const buttonsFormated = [];
                for (const btn of buttons) {
                  const objBtn = {
                    payload: btn.payload.index,
                    text: btn.payload.value,
                  };

                  buttonsFormated.push(objBtn);
                }
                opcoes = JSON.stringify(buttonsFormated).replace(/"/gi, "'");
              }
              // var msg = json.msg;
              // msg = msg.replace(/\r\n/gi, '§');

              addMessage(
                obj.id,
                json.URL + "~¿" + filepath,
                "Me",
                obj.horaenvio,
                cdrOfPreviousMessages,
                "2",
                statusmsg,
                obj.favorite,
                dia,
                obj.username,
                "",
                obj.destiny,
                obj.mon_type_id,
                obj.replyid,
                obj.mimetypeid + "§" + opcoes,
                obj.title,
                obj.anoenvio,
                obj.data_hora_envio,
              );
            } else if (parseInt(json.MIMETYPE) === 30) {
              let msgFormatted = json.MSG;
              msgFormatted = msgFormatted.replace(/<+/g, "*");
              msgFormatted = msgFormatted.replace(/>+/g, "*");

              addMessage(
                obj.id,
                h2p(msgFormatted),
                "Me",
                obj.horaenvio,
                cdrOfPreviousMessages,
                "2",
                statusmsg,
                obj.favorite,
                dia,
                obj.username,
                "",
                obj.destiny,
                obj.mon_type_id,
                obj.replyid,
                "hsm§",
                obj.title,
                obj.anoenvio,
                obj.data_hora_envio,
              );
            } else if (obj.typename === "contact") {
              const msgArray = Array.isArray(json) ? json : [json];

              msgArray.forEach((msg, index) => {
                addMessage(
                  index === 0 ? obj.id : obj.id + `v_${index}`,
                  JSON.stringify(msg).replace(/"/gi, "'"),
                  obj.agente ? "Me" : obj.username,
                  obj.horaenvio,
                  cdrOfPreviousMessages,
                  "11",
                  statusmsg,
                  obj.favorite,
                  dia,
                  obj.username,
                  "",
                  obj.destiny,
                  obj.mon_type_id,
                  obj.replyid,
                  "",
                  obj.title,
                  obj.anoenvio,
                  obj.data_hora_envio,
                );
              });
            } else if (parseInt(obj.mimetypeid) === 50) {
              // let msg = prepararParaJson(json.msg);
              let opcoes = "";
              let filepath = null;
              let newMsg = Object.entries(json).map(([key, value]) => {
                if (key !== "flow_token") {
                  return `*${key}*§_${value}_§`;
                }
              });

              let msg = `${newMsg.join("")}`;

              if (items) {
                opcoes = JSON.stringify(items).replace(/"/gi, "'");
              } else if (buttons) {
                opcoes = JSON.stringify(buttons).replace(/"/gi, "'");
              }

              if (json.link) {
                filepath = json.FILEPATH || json.link;
              }

              addMessage(
                obj.id,
                msg + "~¿" + filepath,
                obj.agente ? "Me" : obj.username,
                obj.horaenvio,
                cdrOfPreviousMessages,
                "2",
                statusmsg,
                obj.favorite,
                dia,
                obj.username,
                "",
                obj.destiny,
                obj.mon_type_id,
                obj.replyid,
                obj.mimetypeid + "§" + opcoes + "§" + json.botid,
                obj.title,
                obj.anoenvio,
                obj.data_hora_envio,
              );
            } else {
              addMessage(
                obj.id,
                h2p(json.msg),
                obj.agente ? "Me" : obj.username,
                obj.horaenvio,
                cdrOfPreviousMessages,
                "0",
                statusmsg,
                obj.favorite,
                dia,
                obj.username,
                "",
                obj.destiny,
                obj.mon_type_id,
                obj.replyid,
                "",
                obj.title,
                obj.anoenvio,
                obj.data_hora_envio,
              );
            }
          } else {
            obj.messagem = obj.messagem.replace(/"/gm, '\\"');
            if (obj.agente === false) {
              if (obj.mimetypeid < 3) {
                var msg = obj.messagem;
                msg = msg.replace(/\\\\n/gi, "\r\n");
                msg = msg.replace(/"/gi, "'");
                msg = msg.replace(/"/gm, '\\"');

                addMessage(
                  obj.id,
                  msg,
                  obj.username,
                  obj.horaenvio,
                  cdrOfPreviousMessages,
                  "0",
                  statusmsg,
                  obj.favorite,
                  dia,
                  obj.username,
                  "",
                  obj.destiny,
                  obj.mon_type_id,
                  obj.replyid,
                  "",
                  obj.title,
                  obj.anoenvio,
                  obj.data_hora_envio,
                );
              } else if (obj.mimetypeid === 45) {
                let recipients = [];
                let msgIdMail = null;
                axios
                  .get(
                    `${connection_platform.type_connect}://${pathname}:${port}/conn/list-infomail-byid?id=${obj.id}`,
                  )
                  .then((response) => {
                    if (response.data !== "") {
                      let retorno = response.data[0].email.split("Â¿");
                      retorno.map((todo) => {
                        let stringSplit = todo.split("Â§");
                        let type = 0;
                        if (stringSplit[1] === "4") {
                          type = 0;
                        } else if (stringSplit[1] === "2") {
                          type = 2;
                        } else if (stringSplit[1] === "1") {
                          type = 1;
                        } else if (stringSplit[1] === "3") {
                          type = 3;
                        }
                        console.log("2342#%:235", response.data[0]);
                        msgIdMail = response.data[0].externalcode;
                        console.log("2342#%:235", msgIdMail);
                        recipients.push({
                          label: stringSplit[0],
                          type: type,
                        });
                      });
                      dispatch(
                        AddMessageMail(
                          obj.client,
                          recipients,
                          obj.messagem,
                          [],
                          obj.data_hora_envio,
                          cdrOfPreviousMessages,
                          obj.id,
                          obj.favorite,
                          obj.id,
                          obj.caption,
                          msgIdMail,
                          obj.agente,
                        ),
                      );
                    }
                  });
                console.log("2342#%:235", msgIdMail);
                axios
                  .get(
                    `${connection_platform.type_connect}://${pathname}:${port}/conn/getattachmentemail?id=${obj.id}`,
                  )
                  .then((response) => {
                    dispatch(AddAttachmentsMail(obj.id, response.data));
                  });
                // dispatch(
                //   EditInfoCli(
                //     novadata[5],
                //     obj.caption,
                //     `Assunto: ${obj.caption}`,
                //     obj.caption
                //   )
                // );
                if (index === 0) {
                  setTimeout(() => {
                    dispatch(
                      EditSubjectMail(cdrOfPreviousMessages, obj.caption),
                    );
                  }, 1000);
                }
              } else {
                let tamanhoimagem = dbfileSize(obj.filesize);

                addMessage(
                  obj.id,
                  obj.thumbnail +
                    "~¿" +
                    obj.caption +
                    "~¿" +
                    obj.messagem +
                    "~¿" +
                    tamanhoimagem,
                  obj.username,
                  obj.horaenvio,
                  cdrOfPreviousMessages,
                  "1",
                  statusmsg,
                  obj.favorite,
                  dia,
                  obj.username,
                  "",
                  obj.destiny,
                  obj.mon_type_id,
                  obj.replyid,
                  "",
                  obj.title,
                  obj.anoenvio,
                  obj.data_hora_envio,
                );
              }
            } else {
              if (obj.mimetypeid < 3) {
                let message_fd = obj.messagem;
                message_fd = message_fd.replace(/\n|\r\n/gi, "¿");

                addMessage(
                  obj.id,
                  message_fd,
                  "Me",
                  obj.horaenvio,
                  cdrOfPreviousMessages,
                  "0",
                  statusmsg,
                  obj.favorite,
                  dia,
                  obj.username,
                  "",
                  obj.destiny,
                  obj.mon_type_id,
                  obj.replyid,
                  "",
                  obj.title,
                  obj.anoenvio,
                  obj.data_hora_envio,
                );
              } else if (obj.mimetypeid === 45) {
                let recipients = [];
                let msgIdMail = null;
                axios
                  .get(
                    `${connection_platform.type_connect}://${pathname}:${port}/conn/list-infomail-byid?id=${obj.id}`,
                  )
                  .then((response) => {
                    if (response.data !== "") {
                      let retorno = response.data[0].email.split("Â¿");
                      retorno.map((todo) => {
                        let stringSplit = todo.split("Â§");
                        let type = 0;
                        if (stringSplit[1] === "4") {
                          type = 0;
                        } else if (stringSplit[1] === "2") {
                          type = 2;
                        } else if (stringSplit[1] === "1") {
                          type = 1;
                        } else if (stringSplit[1] === "3") {
                          type = 3;
                        }
                        msgIdMail = response.data[0].externalcode;
                        recipients.push({
                          label: stringSplit[0],
                          type: type,
                        });
                      });
                      dispatch(
                        AddMessageMail(
                          obj.client,
                          recipients,
                          obj.messagem,
                          [],
                          obj.data_hora_envio,
                          cdrOfPreviousMessages,
                          obj.id,
                          obj.favorite,
                          obj.id,
                          obj.caption,
                          msgIdMail,
                          obj.agente,
                        ),
                      );
                    }
                  });
                console.log("2342#%:235");
                axios
                  .get(
                    `${connection_platform.type_connect}://${pathname}:${port}/conn/getattachmentemail?id=${obj.id}`,
                  )
                  .then((response) => {
                    dispatch(AddAttachmentsMail(obj.id, response.data));
                  });
                // dispatch(
                //   EditInfoCli(
                //     novadata[5],
                //     obj.caption,
                //     `Assunto: ${obj.caption}`,
                //     obj.caption
                //   )
                // );
                if (index === 0) {
                  setTimeout(() => {
                    dispatch(
                      EditSubjectMail(cdrOfPreviousMessages, obj.caption),
                    );
                  }, 1000);
                }
              } else {
                let tamanhoimagem = dbfileSize(obj.filesize);

                addMessage(
                  obj.id,
                  obj.thumbnail +
                    "~¿" +
                    obj.caption +
                    "~¿" +
                    obj.messagem +
                    "~¿" +
                    tamanhoimagem,
                  "Me",
                  obj.horaenvio,
                  cdrOfPreviousMessages,
                  "1",
                  statusmsg,
                  obj.favorite,
                  dia,
                  obj.username,
                  "",
                  obj.destiny,
                  obj.mon_type_id,
                  obj.replyid,
                  "",
                  obj.title,
                  obj.anoenvio,
                  obj.data_hora_envio,
                );
              }
            }
          }
        }

        if (!connection_platform.attendance_screen_new) {
          if (isJson(obj.messagem) === true) {
            let json = JSON.parse(obj.messagem);
            let options = json.options;

            if (json.menuid) {
              let i = 1;
              var opcoes = [];
              for (i in options) {
                opcoes.push(i + " - " + options[i][1]);
              }

              addMessage(
                obj.id,
                h2p(json.msg) + "§" + h2p(opcoes.join("  §  ")),
                "Me",
                obj.horaenvio,
                cdrOfPreviousMessages,
                "2",
                statusmsg,
                obj.favorite,
                dia,
                obj.username,
                "",
                obj.destiny,
                "",
                obj.replyid,
                "",
                obj.title,
                obj.anoenvio,
                obj.data_hora_envio,
              );
            } else if (json.botid) {
              var msg = json.msg;
              msg = msg.replace(/\r\n/gi, "§");

              addMessage(
                obj.id,
                msg,
                "Me",
                obj.horaenvio,
                cdrOfPreviousMessages,
                "2",
                statusmsg,
                obj.favorite,
                dia,
                obj.username,
                "",
                obj.destiny,
                "",
                obj.replyid,
                "",
                obj.title,
                obj.anoenvio,
                obj.data_hora_envio,
              );
            } else if (json.LONGITUDE || json.longitude) {
              let longitude = "";
              let latitude = "";
              let name = "";
              let address = "";

              if (json.LONGITUDE) {
                longitude = json.LONGITUDE;
                latitude = json.LATITUDE;
                name = json.NAME;
                address = json.ADDRESS;
              } else {
                longitude = json.longitude;
                latitude = json.latitude;
                name = json.name;
                address = json.address;
              }
              // var msg = json.msg;
              // msg = msg.replace(/\r\n/gi, '§');

              addMessage(
                obj.id,
                address + "~¿" + name + "~¿" + longitude + "~¿" + latitude,
                obj.agente ? "Me" : "username",
                obj.horaenvio,
                cdrOfPreviousMessages,
                "4",
                statusmsg,
                obj.favorite,
                dia,
                obj.username,
                "",
                obj.destiny,
                "",
                obj.replyid,
                "",
                obj.title,
                obj.anoenvio,
                obj.data_hora_envio,
              );
            } else if (parseInt(json.MIMETYPE) === 30) {
              let msgFormatted = json.MSG;
              msgFormatted = msgFormatted.replace(/<+/g, "*");
              msgFormatted = msgFormatted.replace(/>+/g, "*");

              addMessage(
                obj.id,
                h2p(msgFormatted),
                "Me",
                obj.horaenvio,
                cdrOfPreviousMessages,
                "0",
                statusmsg,
                obj.favorite,
                dia,
                obj.username,
                "",
                obj.destiny,
                "",
                obj.replyid,
                "",
                obj.title,
                obj.anoenvio,
                obj.data_hora_envio,
              );
            } else if (json.URL) {
              // var msg = json.msg;
              // msg = msg.replace(/\r\n/gi, '§');

              addMessage(
                obj.id,
                h2p(json.URL),
                "Me",
                obj.horaenvio,
                cdrOfPreviousMessages,
                "0",
                statusmsg,
                obj.favorite,
                dia,
                obj.username,
                "",
                obj.destiny,
                "",
                obj.replyid,
                "",
                obj.title,
                obj.anoenvio,
                obj.data_hora_envio,
              );
            } else {
              addMessage(
                obj.id,
                h2p(json.msg),
                "Me",
                obj.horaenvio,
                cdrOfPreviousMessages,
                "0",
                statusmsg,
                obj.favorite,
                dia,
                obj.username,
                "",
                obj.destiny,
                "",
                obj.replyid,
                "",
                obj.title,
                obj.anoenvio,
                obj.data_hora_envio,
              );
            }
          } else {
            obj.messagem = obj.messagem.replace(/"/gm, '\\"');
            if (obj.agente === false) {
              if (obj.mimetypeid < 3) {
                var msg = obj.messagem;
                msg = msg.replace(/\\\\n/gi, "\r\n");
                msg = msg.replace(/"/gm, '\\"');

                addMessage(
                  obj.id,
                  msg,
                  obj.username,
                  obj.horaenvio,
                  cdrOfPreviousMessages,
                  "0",
                  statusmsg,
                  obj.favorite,
                  dia,
                  obj.username,
                  "",
                  obj.destiny,
                  "",
                  obj.replyid,
                  "",
                  obj.title,
                  obj.anoenvio,
                  obj.data_hora_envio,
                );
              } else {
                let tamanhoimagem = dbfileSize(obj.filesize);

                addMessage(
                  obj.id,
                  obj.thumbnail +
                    "~¿" +
                    obj.caption +
                    "~¿" +
                    obj.messagem +
                    "~¿" +
                    tamanhoimagem,
                  obj.username,
                  obj.horaenvio,
                  cdrOfPreviousMessages,
                  "1",
                  statusmsg,
                  obj.favorite,
                  dia,
                  obj.username,
                  "",
                  obj.destiny,
                  "",
                  obj.replyid,
                  "",
                  obj.title,
                  obj.anoenvio,
                  obj.data_hora_envio,
                );
              }
            } else {
              if (obj.mimetypeid < 3) {
                let message_fd = obj.messagem;
                message_fd = message_fd.replace(/\n|\r\n/gi, "¿");

                addMessage(
                  obj.id,
                  message_fd,
                  "Me",
                  obj.horaenvio,
                  cdrOfPreviousMessages,
                  "0",
                  statusmsg,
                  obj.favorite,
                  dia,
                  "username",
                  "",
                  obj.destiny,
                  "",
                  obj.replyid,
                  "",
                  obj.title,
                  obj.anoenvio,
                );
              } else {
                let tamanhoimagem = dbfileSize(obj.filesize);

                addMessage(
                  obj.id,
                  obj.thumbnail +
                    "~¿" +
                    obj.caption +
                    "~¿" +
                    obj.messagem +
                    "~¿" +
                    tamanhoimagem,
                  "Me",
                  obj.horaenvio,
                  cdrOfPreviousMessages,
                  "1",
                  statusmsg,
                  obj.favorite,
                  dia,
                  "username",
                  "",
                  obj.destiny,
                  "",
                  obj.replyid,
                  "",
                  obj.title,
                  obj.anoenvio,
                  obj.data_hora_envio,
                );
              }
            }
          }
        }
      });

      if (messagesToAdd.length !== 0) {
        dispatch(
          AddMessagesInBatchReverseMode(cdrOfPreviousMessages, messagesToAdd),
        );
      }

      dispatch(typingadd(cdrOfPreviousMessages, 0));

      dispatch(editTotalQtdMsgMonitoring(cdrOfPreviousMessages, qtdeMsgCDR));
      // const isFromStandby =
      //   novadata.length >= 42 &&
      //   Boolean(novadata[41]) &&
      //   isJson(novadata[41]) &&
      //   Boolean(JSON.parse(novadata[41]).STANDBY) &&
      //   Boolean(JSON.parse(novadata[41]).STANDBY.ID);

      // let scoreClass = "";
      // let scoreValue = "";
      // if (novadata.length >= 42 && isJson(novadata[41])) {
      //   const parsedJson = JSON.parse(novadata[41]);
      //   if (Boolean(parsedJson.LASTSCORE)) {
      //     scoreClass = parsedJson.LASTSCORE.CLASS;
      //     scoreValue = parsedJson.LASTSCORE.SCORE;
      //   }
      // }
      // dispatch(
      //   clientusermonitorsin(
      //     novadata[5],
      //     cliente,
      //     telefonefilt[1],
      //     telefonefilt[1],
      //     novadata[27],
      //     criticidade,
      //     novadata[19],
      //     novadata[11],
      //     novadata[27],
      //     novadata[25],
      //     novadata[37],
      //     novadata[15],
      //     novadata[13],
      //     timecomplete,
      //     statusagent,
      //     "0",
      //     "0",
      //     novadata[23],
      //     novadata[1],
      //     novadata[39],
      //     isFromStandby,
      //     qtdeMsgCDR,
      //     scoreClass,
      //     scoreValue
      //   )
      // );
    })
    .catch((error) => {})
    .finally(() => {
      dispatch(
        ChangeLastCdrClicked(cdrOfPreviousMessages, {
          cdr: cdrOfNextMessages,
          isLoading: false,
          isError: false,
        }),
      );
    });
}

function obterDadosAdicionaisParaExibirEmDetalhes(
  telefone,
  cdr,
  scripttrunk,
  direction,
) {
  return async (dispatch, getState) => {
    let apiChannelId = null;

    if (cdr) {
      try {
        const responseApiChannel = await axios.get(
          `${connection_platform.type_connect}://${pathname}:${port}/conn/getapichannelbycdr?cdrid=${cdr}`,
        );

        apiChannelId =
          responseApiChannel &&
          responseApiChannel.data &&
          responseApiChannel.data.api_channel_id
            ? responseApiChannel.data.api_channel_id
            : null;
      } catch (e) {
        console.log("Erro ao buscar api_channel_id", e);
      }
    }
    let actualUrl2 = `${connection_platform.type_connect}://${pathname}:${port}/conn/getcontactstonumberv2?number=${telefone}&api_channel_id=${apiChannelId}`;
    axios.get(actualUrl2).then((response) => {
      const hasResponse = Boolean(response) && response.status === 200;
      const hasData =
        hasResponse &&
        Boolean(response.data) &&
        typeof response.data === "object";
      const hasCdr = Boolean(cdr) || cdr === 0;
      if (hasData && hasCdr) {
        const arrayWithEnterpriseAdditionalInformation = [];
        const arrayWithContactAdditionalInformation = [];
        const hasEnterprise =
          Boolean(response) &&
          Boolean(response.data) &&
          typeof response.data === "object" &&
          "empresa" in response.data &&
          Boolean(response.data.empresa);
        if (hasEnterprise) {
          arrayWithEnterpriseAdditionalInformation.push(
            `Empresa na Agenda: ${response.data.empresa}`,
          );
        }
        const hasCnpj =
          Boolean(response.data) &&
          "cnpj_empresa" in response.data &&
          Boolean(response.data.cnpj_empresa);
        if (hasCnpj) {
          arrayWithEnterpriseAdditionalInformation.push(
            `CNPJ: ${response.data.cnpj_empresa}`,
          );
        }
        const hasExternCode =
          Boolean(response.data) &&
          "externcode_empresa" in response.data &&
          Boolean(response.data.externcode_empresa);
        if (hasExternCode) {
          arrayWithEnterpriseAdditionalInformation.push(
            `Código Externo: ${response.data.externcode_empresa}`,
          );
        }
        const hasContactExternCode =
          Boolean(response.data) &&
          "externcode" in response.data &&
          Boolean(response.data.externcode);
        if (hasContactExternCode) {
          arrayWithContactAdditionalInformation.push(
            `Código Externo: ${response.data.externcode}`,
          );
        }
        const hasDirection = Boolean(direction) && Boolean(parseInt(direction));
        if (hasDirection) {
          if (parseInt(direction) === 1) {
            arrayWithContactAdditionalInformation.push(
              `Tipo de chamada: Receptivo`,
            );
          }
          if (parseInt(direction) === 2) {
            arrayWithContactAdditionalInformation.push(
              `Tipo de chamada: Ativo`,
            );
          }
        }

        const hasCargo =
          Boolean(response.data) &&
          "description_position" in response.data &&
          Boolean(response.data.description_position);
        if (hasCargo) {
          arrayWithContactAdditionalInformation.push(
            `Cargo: ${response.data.description_position}`,
          );
        }

        const hasRelacaoDoContato =
          Boolean(response.data) &&
          "description_relation" in response.data &&
          Boolean(response.data.description_relation);
        if (hasRelacaoDoContato) {
          arrayWithContactAdditionalInformation.push(
            `Relação do contato: ${response.data.description_relation}`,
          );
        }

        const hasMidias =
          Boolean(response.data) &&
          "telefones" in response.data &&
          Array.isArray(response.data.telefones) &&
          response.data.telefones.length > 0;
        if (hasMidias) {
          let msgAlertWhatsVoz = "";
          let typeResponseWhastVoz = 3;
          let arrayFilterWhatsVoz = response.data.telefones.filter(
            (telefone) => telefone.midiaid === 16,
          );

          console.log("jejejej", arrayFilterWhatsVoz);
          if (arrayFilterWhatsVoz.length !== 0) {
            console.log("jejejej", arrayFilterWhatsVoz);
            if (arrayFilterWhatsVoz[0].api_channel_id) {
              console.log("jejejej", arrayFilterWhatsVoz);
              if (arrayFilterWhatsVoz[0].type === 1) {
                console.log("jejejej", arrayFilterWhatsVoz);
                msgAlertWhatsVoz =
                  "Chamada via Whastapp Voz permitida permanentemente";
                typeResponseWhastVoz = 1;
              } else if (arrayFilterWhatsVoz[0].type === 2) {
                console.log("jejejej", arrayFilterWhatsVoz);
                msgAlertWhatsVoz = `Chamada via Whatsapp Voz permitida até ${Moment(arrayFilterWhatsVoz[0].date_limit, "DD/MM/YYYY HH:mm:ss").format("DD/MM/YYYY [às] HH:mm:ss")}`;
                typeResponseWhastVoz = 2;
              } else {
                console.log("jejejej", arrayFilterWhatsVoz);
                msgAlertWhatsVoz =
                  "Chamada via WhatsApp Voz bloqueada. Envie o modelo de mensagem orientando o cliente a liberar a chamada.";
                typeResponseWhastVoz = 3;
              }
            } else {
              console.log("jejejej", arrayFilterWhatsVoz);
              typeResponseWhastVoz = 3;
              msgAlertWhatsVoz =
                "Chamada via WhatsApp Voz bloqueada. Envie o modelo de mensagem orientando o cliente a liberar a chamada.";
            }
          }

          arrayWithContactAdditionalInformation.push(
            `(contentWithJson)Canais: ${JSON.stringify(response.data.telefones.filter((item) => item.midiaid !== 11).map((item) => ({ id: item.id, label: item.number, midiaId: item.midiaid, isActive: typeResponseWhastVoz, descriptionActive: item.midiaid === 16 ? msgAlertWhatsVoz : "" })))}`,
          );
        }

        dispatch(
          addEnterpriseAdditionalInfos(
            cdr,
            arrayWithEnterpriseAdditionalInformation,
          ),
        );

        const hasCdr = Boolean(cdr) || cdr === 0;
        if (hasCdr) {
          axios
            .get(
              `${connection_platform.type_connect}://${pathname}:${port}/conn/trunkByCDR?cdrid=${cdr}`,
            )
            .then((response2) => {
              const hasData =
                Boolean(response2) &&
                Boolean(response2.data) &&
                response2.data.success &&
                Boolean(response2.data.data) &&
                typeof response2.data.data === "object" &&
                "tech" in response2.data.data &&
                (Boolean(response2.data.data.tech) ||
                  response2.data.data.tech === 0);

              if (hasData) {
                arrayWithContactAdditionalInformation.push(
                  `Tel Origem: ${response2.data.data.tech}`,
                );
              }
            })
            .catch((error) => {
              console.error("Erro ao buscar trunkByCDR:", error);
            })
            .finally(() => {
              dispatch(
                addContactAdditionalInfos(
                  cdr,
                  arrayWithContactAdditionalInformation,
                ),
              );
            });
          // insere responsavel por no menu lateral
          const hasResponsavelPor =
            Boolean(response.data) &&
            "empresas_responsavel" in response.data &&
            Array.isArray(response.data.empresas_responsavel);
          if (hasResponsavelPor) {
            dispatch(
              changeResponsavelPor(
                parseInt(cdr),
                response.data.empresas_responsavel,
                response.data.id,
              ),
            );
          }
        } else {
          dispatch(
            addContactAdditionalInfos(
              cdr,
              arrayWithContactAdditionalInformation,
            ),
          );
        }

        // dispatch(
        //   addContactAdditionalInfos(cdr, arrayWithContactAdditionalInformation)
        // );
      }
    });
  };
}

function obterCanaisParaExibirEmDetalhes(telefone, cdr) {
  return async (dispatch, getState) => {
    let apiChannelId = null;

    if (cdr) {
      try {
        const responseApiChannel = await axios.get(
          `${connection_platform.type_connect}://${pathname}:${port}/conn/getapichannelbycdr?cdrid=${cdr}`,
        );

        apiChannelId =
          responseApiChannel &&
          responseApiChannel.data &&
          responseApiChannel.data.api_channel_id
            ? responseApiChannel.data.api_channel_id
            : null;
      } catch (e) {
        console.log("Erro ao buscar api_channel_id", e);
      }
    }
    let actualUrl2 = `${connection_platform.type_connect}://${pathname}:${port}/conn/getcontactstonumberv2?number=${telefone}&api_channel_id=${apiChannelId}`;
    axios.get(actualUrl2).then((response) => {
      const hasResponse = Boolean(response) && response.status === 200;
      const hasData =
        hasResponse &&
        Boolean(response.data) &&
        typeof response.data === "object";
      // console.log("obterCanaisParaExibirEmDetalhes 4", hasCdr)
      const hasCdr = Boolean(cdr) || cdr === 0;
      if (hasData && hasCdr) {
        // console.log("obterCanaisParaExibirEmDetalhes 5", hasCdr)
        const hasMidias =
          Boolean(response.data) &&
          "telefones" in response.data &&
          Array.isArray(response.data.telefones) &&
          response.data.telefones.length > 0;
        // console.log("obterCanaisParaExibirEmDetalhes 5.1", hasMidias)
        if (hasMidias) {
          // console.log("obterCanaisParaExibirEmDetalhes 5.2", hasMidias)
          let msgAlertWhatsVoz = "";
          let typeResponseWhastVoz = 3;
          let arrayFilterWhatsVoz = response.data.telefones.filter(
            (telefone) => telefone.midiaid === 16,
          );

          if (arrayFilterWhatsVoz.length !== 0) {
            if (arrayFilterWhatsVoz[0].api_channel_id) {
              if (arrayFilterWhatsVoz[0].type === 1) {
                msgAlertWhatsVoz =
                  "Chamada via Whastapp Voz permitida permanentemente";
                typeResponseWhastVoz = 1;
              } else if (arrayFilterWhatsVoz[0].type === 2) {
                msgAlertWhatsVoz = `Chamada via Whatsapp Voz permitida até ${Moment(arrayFilterWhatsVoz[0].date_limit, "DD/MM/YYYY HH:mm:ss").format("DD/MM/YYYY [às] HH:mm:ss")}`;
                typeResponseWhastVoz = 2;
              } else {
                msgAlertWhatsVoz =
                  "Chamada via WhatsApp Voz bloqueada. Envie o modelo de mensagem orientando o cliente a liberar a chamada.";
                typeResponseWhastVoz = 3;
              }
            } else {
              typeResponseWhastVoz = 3;
              msgAlertWhatsVoz =
                "Chamada via WhatsApp Voz bloqueada. Envie o modelo de mensagem orientando o cliente a liberar a chamada.";
            }
          }

          let arrayWithContactAdditionalInformation = `(contentWithJson)Canais: ${JSON.stringify(response.data.telefones.filter((item) => item.midiaid !== 11).map((item) => ({ id: item.id, label: item.number, midiaId: item.midiaid, isActive: typeResponseWhastVoz, descriptionActive: item.midiaid === 16 ? msgAlertWhatsVoz : "" })))}`;
          console.log("jejejeje 6", arrayWithContactAdditionalInformation);
          dispatch(
            editChannelsDetailsAtd(cdr, arrayWithContactAdditionalInformation),
          );
        }
      }
    });
  };
}

const setupSocket = (
  getState,
  dispatch,
  userid,
  displayname,
  idgroup,
  ramal,
  grupo,
  username,
  sipid,
) => {
  const { informationusers } = getState();

  port = localStorage.getItem("port");
  pathname = localStorage.getItem("pathname");

  var eventTimer = null;
  var lastStatus = "";
  var evtReceivedTick = 0;
  var duracaoderingini = 0;
  var contduracaodocall = 0;
  var numrandom = "";
  var servicecode = "";
  var anomesdia = "";
  var horagravacao = "";

  function GetTickCount() {
    // returns the current time in milliseconds
    var currDate = new Date();
    return currDate.getTime();
  }

  function editarchatInterno(
    contato,
    chatativo,
    infouser,
    infodisplay,
    atendimento,
    chatsimult,
    atdsimult,
  ) {
    if (infouser.supervisor == true) {
      let checkTela = false;
      let telaDestino = "Equipes";

      switch (infodisplay.infodisplay) {
        case "Gestor":
          checkTela = true;
          break;
        case "Historic":
          checkTela = true;
          break;
      }
      if (atendimento.length === 0 && infodisplay.infodisplay == "Clientes") {
        dispatch(ShowInfoDisplay(telaDestino));
      } else if (checkTela == true) {
        dispatch(ShowInfoDisplay(telaDestino));
      }
    } else {
      if (atendimento.length === 0 && infodisplay.infodisplay == "Clientes") {
        dispatch(ShowInfoDisplay("Atendentes"));
      } else if (infodisplay.infodisplay == "Historic") {
        dispatch(ShowInfoDisplay("Atendentes"));
      }
    }
    let datatime = Moment().format("YYYY/MM/DD HH:mm:ss");

    if (chatativo === true) {
      dispatch(
        editChat(contato.value, true, true, datatime, webphone_api.getline()),
      );
      dispatch(
        editChatInternal(contato.value, true, true, webphone_api.getline()),
      );
    } else {
      let qtdeatdvoz = atdsimult.filter(
        (atd) => parseInt(atd.idmidia) === 1 && parseInt(atd.direction) === 1,
      );

      dispatch(
        addChatSimult(
          contato.value,
          contato.label,
          true,
          true,
          contato.ramal,
          datatime,
          parseInt(qtdeatdvoz.length) + 1,
        ),
      );
      dispatch(
        addChat(
          contato.value,
          contato.label,
          true,
          true,
          contato.ramal,
          datatime,
        ),
      );
    }
  }

  function AceitarChamada(closeToast, contato, chatativo) {
    CallButtonAccept();
    closeToast();
  }

  function RejeitarChamada(closeToast) {
    CallButtonReject();
    closeToast();
  }

  function muteChamada() {
    CallButtonMute();
  }

  const CustomToastCallExt = ({
    closeToast,
    mcdu,
    telefone,
    nomeousub,
    nomesubservico,
  }) => {
    let nomenumero =
      nomeousub !== null &&
      nomeousub !== undefined &&
      nomeousub !== "IMS9300" &&
      nomeousub !== "  "
        ? nomeousub
        : telefone;
    return (
      <div className="calling-popup">
        <div className="calling-popup__close">
          <div
            className="calling-popup__close-button"
            onClick={() => closeToast()}
          >
            <IconClose />
          </div>
        </div>
        <div className="calling-popup__infos">
          <UserPhoto size="extra-large" />
          <div className="calling-popup__infos-container">
            <span className="calling-popup__infos-item">{telefone}</span>
            <span className="calling-popup__infos-item">
              {mcdu} - {nomesubservico}
            </span>
            <span className="calling-popup__infos-calling">Chamando...</span>
          </div>
        </div>
        <div className="calling-popup__actions">
          <div
            className="calling-popup__actions-buttons recuse"
            id="reject"
            onClick={() => {
              RejeitarChamada(closeToast);
            }}
          >
            <IconRecuseCall />
          </div>
          <div
            className="calling-popup__actions-buttons mute"
            id="mute"
            onClick={() => {
              muteChamada();
            }}
          >
            <IconMute />
          </div>
          <div
            className="calling-popup__actions-buttons answer"
            id="accept"
            onClick={() => {
              AceitarChamada(closeToast);
            }}
          >
            <IconAnswerCall />
          </div>
        </div>
      </div>
      // <div className="calling">
      //   <div className="calling__text">
      //     <div className="calling__text__label">Chamador:</div>.
      //     <div className="calling__text__value">{telefone}</div>
      //   </div>
      //   <div className="calling__text">
      //     <div className="calling__text__label">Número:</div>
      //     <div className="calling__text__value">
      //       {mcdu} - {nomesubservico}
      //     </div>
      //   </div>
      //   <div className="calling__content">
      //     <button
      //       className="calling__content__button calling__content__button--answer"
      //       id="accept"
      //       onClick={() => {
      //         AceitarChamada(closeToast);
      //       }}
      //     >
      //       <i className="material-icons">call</i>
      //     </button>
      //     <button
      //       className="calling__content__button calling__content__button--mute"
      //       id="mute"
      //       onClick={() => {
      //         muteChamada();
      //       }}
      //     >
      //       <i className="material-icons">volume_off</i>
      //     </button>
      //     <button
      //       className="calling__content__button calling__content__button--deny"
      //       id="reject"
      //       onClick={() => {
      //         RejeitarChamada(closeToast);
      //       }}
      //     >
      //       <i className="material-icons">call_end</i>
      //     </button>
      //   </div>
      // </div>
    );
  };

  const CustomToastCallTransfer = ({
    closeToast,
    contato,
    chatativo,
    nomecliente,
    mcdu,
  }) => {
    return (
      <div className="calling-popup">
        <div className="calling-popup__close">
          <div
            className="calling-popup__close-button"
            onClick={() => closeToast()}
          >
            <IconClose />
          </div>
        </div>
        <div className="calling-popup__infos">
          <UserPhoto
            size="extra-large"
            link={contato.userImg ? contato.userImg : false}
          />
          <div className="calling-popup__infos-container">
            <span className="calling-popup__infos-item">{mcdu}</span>
            <span className="calling-popup__infos-item">{nomecliente}</span>
            <span className="calling-popup__infos-calling">Chamando...</span>
          </div>
        </div>
        <div className="calling-popup__actions">
          <div
            className="calling-popup__actions-buttons recuse"
            id="reject"
            onClick={() => {
              RejeitarChamada(closeToast);
            }}
          >
            <IconRecuseCall />
          </div>
          <div
            className="calling-popup__actions-buttons mute"
            id="mute"
            onClick={() => {
              muteChamada();
            }}
          >
            <IconMute />
          </div>
          <div
            className="calling-popup__actions-buttons answer"
            id="accept"
            onClick={() => {
              AceitarChamada(closeToast, contato, chatativo);
            }}
          >
            <IconAnswerCall />
          </div>
        </div>
      </div>
      // <div className="calling">
      //   <div className="calling__text">
      //     <div className="calling__text__label">Chamador:</div>.
      //     <div className="calling__text__value">{nomecliente}</div>
      //   </div>
      //   <div className="calling__text">
      //     <div className="calling__text__label">Número:</div>
      //     <div className="calling__text__value">{mcdu}</div>
      //   </div>
      //   <div className="calling__content">
      //     <button
      //       className="calling__content__button calling__content__button--answer"
      //       id="accept"
      //       onClick={() => {
      //         AceitarChamada(closeToast, contato, chatativo);
      //       }}
      //     >
      //       <i className="material-icons">call</i>
      //     </button>
      //     <button
      //       className="calling__content__button calling__content__button--mute"
      //       id="mute"
      //       onClick={() => {
      //         muteChamada();
      //       }}
      //     >
      //       <i className="material-icons">volume_off</i>
      //     </button>
      //     <button
      //       className="calling__content__button calling__content__button--deny"
      //       id="reject"
      //       onClick={() => {
      //         RejeitarChamada(closeToast);
      //       }}
      //     >
      //       <i className="material-icons">call_end</i>
      //     </button>
      //   </div>
      // </div>
    );
  };

  const CustomToastCall = ({ closeToast, contato, chatativo }) => {
    return (
      <div className="calling-popup">
        <div className="calling-popup__close">
          <div
            className="calling-popup__close-button"
            onClick={() => closeToast()}
          >
            <IconClose />
          </div>
        </div>
        <div className="calling-popup__infos">
          <UserPhoto
            size="extra-large"
            link={contato.userImg ? contato.userImg : false}
          />
          <div className="calling-popup__infos-container">
            <span className="calling-popup__infos-item">
              {contato.ramal} - {contato.label}
            </span>
            <span className="calling-popup__infos-calling">Chamando...</span>
          </div>
        </div>
        <div className="calling-popup__actions">
          <div
            className="calling-popup__actions-buttons recuse"
            id="reject"
            onClick={() => {
              RejeitarChamada(closeToast);
            }}
          >
            <IconRecuseCall />
          </div>
          <div
            className="calling-popup__actions-buttons mute"
            id="mute"
            onClick={() => {
              muteChamada();
            }}
          >
            <IconMute />
          </div>
          <div
            className="calling-popup__actions-buttons answer"
            id="accept"
            onClick={() => {
              AceitarChamada(closeToast, contato, chatativo);
            }}
          >
            <IconAnswerCall />
          </div>
        </div>
      </div>
      // <div className="calling">
      //   <div className="calling__text">
      //     <div className="calling__text__label">Chamador:</div>.
      //     <div className="calling__text__value">{contato.label}</div>
      //   </div>
      //   <div className="calling__text">
      //     <div className="calling__text__label">Número:</div>
      //     <div className="calling__text__value">{contato.ramal}</div>
      //   </div>
      //   <div className="calling__content">
      //     <button
      //       className="calling__content__button calling__content__button--answer"
      //       id="accept"
      //       onClick={() => {
      //         AceitarChamada(closeToast, contato, chatativo);
      //       }}
      //     >
      //       <i className="material-icons">call</i>
      //     </button>
      //     <button
      //       className="calling__content__button calling__content__button--mute"
      //       id="mute"
      //       onClick={() => {
      //         muteChamada();
      //       }}
      //     >
      //       <i className="material-icons">volume_off</i>
      //     </button>
      //     <button
      //       className="calling__content__button calling__content__button--deny"
      //       id="reject"
      //       onClick={() => {
      //         RejeitarChamada(closeToast);
      //       }}
      //     >
      //       <i className="material-icons">call_end</i>
      //     </button>
      //   </div>
      // </div>
    );
  };

  // webphone_api.setvolume(0, 50);
  // webphone_api.setvolume(1, 50);
  // webphone_api.setvolume(2, 50);

  // if (connection_platform.type_connect === "https") {
  //   navigator.mediaDevices
  //     .enumerateDevices()
  //     .then(function (devices) {
  //       devices.forEach(function (device) {
  //         if (
  //           device.kind === "audioinput" &&
  //           device.deviceId !== "default" &&
  //           device.deviceId !== "communications"
  //         ) {
  //           dispatch(listDevice(0, device.label.substring(0, 31)));
  //         } else if (
  //           device.kind === "audiooutput" &&
  //           device.deviceId !== "default" &&
  //           device.deviceId !== "communications"
  //         ) {
  //           dispatch(listDevice(1, device.label.substring(0, 31)));
  //           dispatch(listDevice(2, device.label.substring(0, 31)));
  //         }
  //         if (
  //           device.kind === "audioinput" &&
  //           device.deviceId === "default" &&
  //           device.deviceId !== "communications"
  //         ) {
  //           //let devicepadrao0 = device.label.replace('Padrão - ','' );

  //           let devicepadrao0 = device.label.split("-");
  //           dispatch(listDeviceDefault(0, devicepadrao0[1].substring(0, 31)));
  //           dispatch(getDeviceMicrofone(devicepadrao0[1].substring(0, 15)));
  //           webphone_api.setdevice(0, devicepadrao0[1].substring(0, 15), 2);
  //         } else if (
  //           device.kind === "audiooutput" &&
  //           device.deviceId === "default" &&
  //           device.deviceId !== "communications"
  //         ) {
  //           //let devicepadrao1 = device.label.replace('Padrão - ','' );

  //           let devicepadrao1 = device.label.split("-");
  //           dispatch(listDeviceDefault(1, devicepadrao1[1].substring(0, 31)));
  //           dispatch(listDeviceDefault(2, devicepadrao1[1].substring(0, 31)));
  //           dispatch(getDeviceAudio(devicepadrao1[1].substring(0, 15)));
  //           dispatch(getDeviceRing(devicepadrao1[1].substring(0, 15)));
  //           webphone_api.setdevice(1, devicepadrao1[1].substring(0, 15), 2);
  //           webphone_api.setdevice(2, devicepadrao1[1].substring(0, 15), 2);
  //         }
  //       });
  //     })
  //     .catch(function (err) {
  //       console.log(err.name + ": " + err.message);
  //     });
  // } else {
  //   webphone_api.getaudiodevicelist(0, (disgrav) => {
  //     var listaDispGrav = disgrav.split(/\n/);

  //     for (var i = 0; i <= listaDispGrav.length; i++) {
  //       if (
  //         listaDispGrav[i] !== undefined &&
  //         listaDispGrav[i] !== "undefined"
  //       ) {
  //         let descDispositivo1 = listaDispGrav[i];
  //         descDispositivo1 = descDispositivo1.replace(
  //           "APIREQUEST:UNKNONREQAPIRESULT:",
  //           "",
  //         );
  //         dispatch(listDevice(0, descDispositivo1));
  //         webphone_api.setvolume(0, 50);
  //       }
  //     }
  //   });

  //   webphone_api.getdevice(0, function (e) {
  //     dispatch(listDeviceDefault(1, e));
  //   });

  //   webphone_api.getaudiodevicelist(1, (disprep) => {
  //     var listaDispRep = disprep.split(/\n/);
  //     for (var i = 0; i <= listaDispRep.length; i++) {
  //       if (listaDispRep[i] !== undefined && listaDispRep[i] !== "undefined") {
  //         let descDispositivo2 = listaDispRep[i];
  //         descDispositivo2 = descDispositivo2.replace(
  //           "APIREQUEST:UNKNONREQAPIRESULT:",
  //           "",
  //         );
  //         dispatch(listDevice(1, descDispositivo2));
  //         webphone_api.setvolume(1, 50);
  //       }
  //     }
  //   });

  //   webphone_api.getdevice(1, function (e) {
  //     dispatch(listDeviceDefault(1, e));
  //   });

  //   webphone_api.getaudiodevicelist(2, (disptoq) => {
  //     var listaDispToq = disptoq.split(/\n/);
  //     for (var i = 0; i <= listaDispToq.length; i++) {
  //       if (
  //         listaDispToq[i] !== undefined &&
  //         listaDispToq[i] !== "undefined" &&
  //         listaDispToq[i] !== "All"
  //       ) {
  //         let descDispositivo3 = listaDispToq[i];
  //         descDispositivo3 = descDispositivo3.replace(
  //           "APIREQUEST:UNKNONREQAPIRESULT:",
  //           "",
  //         );
  //         dispatch(listDevice(2, descDispositivo3));
  //         webphone_api.setvolume(2, 50);
  //       }
  //     }
  //   });

  //   webphone_api.getdevice(2, function (e) {
  //     dispatch(listDeviceDefault(2, e));
  //   });
  // }

  // webphone_api.onRegStateChange((callback) => {
  //    console.log ("INGENIUM_STATUSCALL_callback:",callback)
  // });

  // Para o parâmetro dev, passe 0 para a lista de nomes de dispositivos de gravação,
  //  1 para dispositivos de reprodução ou toque,
  //  ou 3 para dispositivos de câmera de vídeo.
  // webphone_api.getdevicelist(0, function(devices) {
  //     console.log("Microfones disponiveis:");
  //     console.log(devices);
  // });

  // webphone_api.getdevicelist(1, function(devices) {
  //     console.log("Saidas de audio disponiveis:");
  //     console.log(devices);
  // });

  // webphone_api.getdevice(0, function(currentDevice) {
  //     console.log("Microfone atual:", currentDevice);
  // });

  // webphone_api.getdevice(1, function(currentDevice) {
  //     console.log("Saida de audio atual:", currentDevice);
  // });

  function isCameraDevice(nome) {
    if (!nome || typeof nome !== "string") return false;

    const n = nome.toLowerCase();

    return n.includes("camera") || n.includes("webcam") || n.includes("video");
  }

  // function carregarDevicesMizutech() {
  //   if (connection_platform.type_connect !== "https") return;

  //   function normalizarLista(retorno) {
  //     if (!retorno || typeof retorno !== "string") return [];

  //     return retorno
  //       .split(/\r\n|\n|\r/)
  //       .map(function (item) {
  //         return item.trim();
  //       })
  //       .filter(function (item) {
  //         return item !== "";
  //       });
  //   }

  // function adicionarLista(dev, lista) {
  //   lista.forEach(function (nomeDevice) {

  //     // 🔥 BLOQUEIO DE CAMERA
  //     if (isCameraDevice(nomeDevice)) return;

  //     if (dev === 0) {
  //       dispatch(listDevice(0, nomeDevice));
  //     } else if (dev === 1) {
  //       dispatch(listDevice(1, nomeDevice));
  //       dispatch(listDevice(2, nomeDevice));
  //     }
  //   });
  // }

  // function aplicarDeviceAtual(dev, nomeAtual) {
  //   if (!nomeAtual || typeof nomeAtual !== "string") return;

  //   var nomeTratado = nomeAtual.trim();
  //   if (!nomeTratado) return;

  //   // 🔥 BLOQUEIO DE CAMERA NO DEFAULT
  //   if (isCameraDevice(nomeTratado)) {
  //     console.log("Ignorando camera como device atual:", nomeTratado);
  //     return;
  //   }

  //   if (dev === 0) {
  //     dispatch(listDeviceDefault(0, nomeTratado));
  //     dispatch(getDeviceMicrofone(nomeTratado));
  //   } else if (dev === 1) {
  //     dispatch(listDeviceDefault(1, nomeTratado));
  //     dispatch(getDeviceAudio(nomeTratado));
  //   } else if (dev === 2) {
  //     dispatch(listDeviceDefault(2, nomeTratado));
  //     dispatch(getDeviceRing(nomeTratado));
  //   }
  // }

  //   try {
  //     webphone_api.getdevicelist(0, function (listaMicrofones) {
  //       var microfones = normalizarLista(listaMicrofones);
  //       adicionarLista(0, microfones);

  //       webphone_api.getdevice(0, function (microfoneAtual) {
  //         aplicarDeviceAtual(0, microfoneAtual);
  //       });
  //     });

  //     webphone_api.getdevicelist(1, function (listaSaidas) {
  //       var saidas = normalizarLista(listaSaidas);
  //       adicionarLista(1, saidas);

  //       webphone_api.getdevice(1, function (audioAtual) {
  //         aplicarDeviceAtual(1, audioAtual);
  //       });

  //       webphone_api.getdevice(2, function (ringAtual) {
  //         aplicarDeviceAtual(2, ringAtual);
  //       });
  //     });
  //   } catch (err) {
  //     console.log("Erro ao carregar devices Mizutech:", err);
  //   }
  // }

  // function carregarDevicesMizutech() {
  //   if (connection_platform.type_connect !== "https") return;

  //   // Função auxiliar para remover prefixos do Windows e deixar apenas o nome do hardware
  //   function limparNomeHardware(nome) {
  //     if (!nome) return "";
  //     return nome
  //       .replace(/^(Padrão|Comunicações|Default|Communications)\s*-\s*/i, "")
  //       .trim();
  //   }

  //   function normalizarLista(retorno) {
  //     if (!retorno || typeof retorno !== "string") return [];

  //     var linhas = retorno.split(/\r\n|\n|\r/);
  //     var listaUnica = [];
  //     var nomesJaProcessados = []; // Array para controle de duplicatas

  //     linhas.forEach(function (linha) {
  //       var nomeOriginal = linha.trim();
  //       if (nomeOriginal === "") return;

  //       // 🔥 BLOQUEIO DE CAMERA
  //       if (typeof isCameraDevice === "function" && isCameraDevice(nomeOriginal)) return;

  //       var nomeLimpo = limparNomeHardware(nomeOriginal);

  //       // Só adiciona se o nome limpo ainda não estiver na nossa lista de controle
  //       if (nomesJaProcessados.indexOf(nomeLimpo) === -1) {
  //         nomesJaProcessados.push(nomeLimpo);
  //         listaUnica.push(nomeOriginal); // Mantemos o nome original para o comando de 'setdevice' funcionar
  //       }
  //     });

  //     return listaUnica;
  //   }

  //   function adicionarLista(dev, lista) {
  //     lista.forEach(function (nomeDevice) {
  //       // Como a normalizarLista já filtrou as câmeras e duplicatas, aqui só despachamos
  //       if (dev === 0) {
  //         dispatch(listDevice(0, nomeDevice));
  //       } else if (dev === 1) {
  //         dispatch(listDevice(1, nomeDevice));
  //         dispatch(listDevice(2, nomeDevice));
  //       }
  //     });
  //   }

  //   function aplicarDeviceAtual(dev, nomeAtual) {
  //     if (!nomeAtual || typeof nomeAtual !== "string") return;
  //     var nomeTratado = nomeAtual.trim();
  //     if (!nomeTratado) return;

  //     if (typeof isCameraDevice === "function" && isCameraDevice(nomeTratado)) return;

  //     if (dev === 0) {
  //       dispatch(listDeviceDefault(0, nomeTratado));
  //       dispatch(getDeviceMicrofone(nomeTratado));
  //     } else if (dev === 1) {
  //       dispatch(listDeviceDefault(1, nomeTratado));
  //       dispatch(getDeviceAudio(nomeTratado));
  //     } else if (dev === 2) {
  //       dispatch(listDeviceDefault(2, nomeTratado));
  //       dispatch(getDeviceRing(nomeTratado));
  //     }
  //   }

  //   try {
  //     webphone_api.getdevicelist(0, function (listaMicrofones) {
  //       var microfones = normalizarLista(listaMicrofones);
  //       adicionarLista(0, microfones);

  //       webphone_api.getdevice(0, function (microfoneAtual) {
  //         aplicarDeviceAtual(0, microfoneAtual);
  //       });
  //     });

  //     webphone_api.getdevicelist(1, function (listaSaidas) {
  //       var saidas = normalizarLista(listaSaidas);
  //       adicionarLista(1, saidas);

  //       webphone_api.getdevice(1, function (audioAtual) {
  //         aplicarDeviceAtual(1, audioAtual);
  //       });

  //       webphone_api.getdevice(2, function (ringAtual) {
  //         aplicarDeviceAtual(2, ringAtual);
  //       });
  //     });
  //   } catch (err) {
  //     console.error("Erro ao carregar devices Mizutech:", err);
  //   }
  // }

  // Substituída em 24/03/2026

  // function carregarDevicesMizutech() {
  //   if (connection_platform.type_connect !== "https") return;

  //   // Função auxiliar para remover prefixos do Windows e deixar apenas o nome do hardware
  //   function limparNomeHardware(nome) {
  //     if (!nome) return "";
  //     return nome
  //       .replace(/^(Padrão|Comunicações|Default|Communications)\s*-\s*/i, "")
  //       .trim();
  //   }

  //   function normalizarLista(retorno) {
  //     if (!retorno || typeof retorno !== "string") return [];

  //     var linhas = retorno.split(/\r\n|\n|\r/);
  //     var listaUnica = [];
  //     var nomesJaProcessados = []; // Array para controle de duplicatas

  //     linhas.forEach(function (linha) {
  //       var nomeOriginal = linha.trim();
  //       if (nomeOriginal === "") return;

  //       // 🔥 BLOQUEIO DE CAMERA
  //       if (typeof isCameraDevice === "function" && isCameraDevice(nomeOriginal)) return;

  //       var nomeLimpo = limparNomeHardware(nomeOriginal);

  //       // Só adiciona se o nome limpo ainda não estiver na nossa lista de controle
  //       if (nomesJaProcessados.indexOf(nomeLimpo) === -1) {
  //         nomesJaProcessados.push(nomeLimpo);
  //         listaUnica.push(nomeOriginal); // Mantemos o nome original para o comando de 'setdevice' funcionar
  //       }
  //     });

  //     return listaUnica;
  //   }

  //   function adicionarLista(dev, lista) {
  //     lista.forEach(function (nomeDevice) {
  //       // Como a normalizarLista já filtrou as câmeras e duplicatas, aqui só despachamos
  //       if (dev === 0) {
  //         dispatch(listDevice(0, nomeDevice));
  //       } else if (dev === 1) {
  //         dispatch(listDevice(1, nomeDevice));
  //         dispatch(listDevice(2, nomeDevice));
  //       }
  //     });
  //   }

  //   function aplicarDeviceAtual(dev, nomeAtual) {
  //     if (!nomeAtual || typeof nomeAtual !== "string") return;
  //     var nomeTratado = nomeAtual.trim();
  //     if (!nomeTratado) return;

  //     if (typeof isCameraDevice === "function" && isCameraDevice(nomeTratado)) return;

  //     if (dev === 0) {
  //       dispatch(listDeviceDefault(0, nomeTratado));
  //       dispatch(getDeviceMicrofone(nomeTratado));
  //     } else if (dev === 1) {
  //       dispatch(listDeviceDefault(1, nomeTratado));
  //       dispatch(getDeviceAudio(nomeTratado));
  //     } else if (dev === 2) {
  //       dispatch(listDeviceDefault(2, nomeTratado));
  //       dispatch(getDeviceRing(nomeTratado));
  //     }
  //   }

  //   try {
  //     webphone_api.getdevicelist(0, function (listaMicrofones) {
  //       var microfones = normalizarLista(listaMicrofones);
  //       adicionarLista(0, microfones);

  //       webphone_api.getdevice(0, function (microfoneAtual) {
  //         aplicarDeviceAtual(0, microfoneAtual);
  //       });
  //     });

  //     webphone_api.getdevicelist(1, function (listaSaidas) {
  //       var saidas = normalizarLista(listaSaidas);
  //       adicionarLista(1, saidas);

  //       webphone_api.getdevice(1, function (audioAtual) {
  //         aplicarDeviceAtual(1, audioAtual);
  //       });

  //       webphone_api.getdevice(2, function (ringAtual) {
  //         aplicarDeviceAtual(2, ringAtual);
  //       });
  //     });
  //   } catch (err) {
  //     console.error("Erro ao carregar devices Mizutech:", err);
  //   }
  // }

  function carregarDevicesMizutech() {
    if (connection_platform.type_connect !== "https") return;

    // Função auxiliar para remover prefixos do Windows e deixar apenas o nome do hardware
    function limparNomeHardware(nome) {
      if (!nome) return "";
      return nome
        .replace(/^(Padrão|Comunicações|Default|Communications)\s*-\s*/i, "")
        .trim();
    }

    function normalizarLista(retorno) {
      if (!retorno || typeof retorno !== "string") return [];

      var linhas = retorno.split(/\r\n|\n|\r/);
      var listaUnica = [];
      var nomesJaProcessados = []; // Array para controle de duplicatas

      linhas.forEach(function (linha) {
        var nomeOriginal = linha.trim();
        if (nomeOriginal === "") return;

        // 🔥 BLOQUEIO DE CAMERA
        if (
          typeof isCameraDevice === "function" &&
          isCameraDevice(nomeOriginal)
        )
          return;

        var nomeLimpo = limparNomeHardware(nomeOriginal);

        // Só adiciona se o nome limpo ainda não estiver na nossa lista de controle
        if (nomesJaProcessados.indexOf(nomeLimpo) === -1) {
          nomesJaProcessados.push(nomeLimpo);
          listaUnica.push(nomeOriginal); // Mantemos o nome original para o comando de 'setdevice' funcionar
        }
      });

      return listaUnica;
    }

    function adicionarLista(dev, lista) {
      lista.forEach(function (nomeDevice) {
        // Como a normalizarLista já filtrou as câmeras e duplicatas, aqui só despachamos
        if (dev === 0) {
          dispatch(listDevice(0, nomeDevice));
        } else if (dev === 1) {
          dispatch(listDevice(1, nomeDevice));
          dispatch(listDevice(2, nomeDevice));
        }
      });
    }

    function aplicarDeviceAtual(dev, nomeAtual) {
      if (!nomeAtual || typeof nomeAtual !== "string") return;
      var nomeTratado = nomeAtual.trim();
      if (!nomeTratado) return;

      if (typeof isCameraDevice === "function" && isCameraDevice(nomeTratado))
        return;

      if (dev === 0) {
        dispatch(listDeviceDefault(0, nomeTratado));
        dispatch(getDeviceMicrofone(nomeTratado));
      } else if (dev === 1) {
        dispatch(listDeviceDefault(1, nomeTratado));
        dispatch(getDeviceAudio(nomeTratado));
      } else if (dev === 2) {
        dispatch(listDeviceDefault(2, nomeTratado));
        dispatch(getDeviceRing(nomeTratado));
      }
    }

    function restaurarDeviceSalvo(dev, lista) {
      var chave =
        dev === 0
          ? "device_microfone"
          : dev === 1
            ? "device_audio"
            : "device_ring";
      var salvo = localStorage.getItem(chave);
      if (!salvo) return false;
      var encontrado = lista.find(function (nome) {
        return nome === salvo;
      });
      if (!encontrado) return false;
      webphone_api.setdevice(dev, salvo, 2);
      aplicarDeviceAtual(dev, salvo);
      return true;
    }

    try {
      webphone_api.getdevicelist(0, function (listaMicrofones) {
        var microfones = normalizarLista(listaMicrofones);
        adicionarLista(0, microfones);

        if (!restaurarDeviceSalvo(0, microfones)) {
          webphone_api.getdevice(0, function (microfoneAtual) {
            aplicarDeviceAtual(0, microfoneAtual);
          });
        }
      });

      webphone_api.getdevicelist(1, function (listaSaidas) {
        var saidas = normalizarLista(listaSaidas);
        adicionarLista(1, saidas);

        if (!restaurarDeviceSalvo(1, saidas)) {
          webphone_api.getdevice(1, function (audioAtual) {
            aplicarDeviceAtual(1, audioAtual);
          });
        }

        if (!restaurarDeviceSalvo(2, saidas)) {
          webphone_api.getdevice(2, function (ringAtual) {
            aplicarDeviceAtual(2, ringAtual);
          });
        }
      });
    } catch (err) {
      console.error("Erro ao carregar devices Mizutech:", err);
    }
  }

  let evtAux = "";
  // webphone_api.onEvents((evt) => {
  webphone_api.onEvent((typeevt, evt) => {
    console.log("INGENIUM_STATUSCALL_1_1:", evt);
    console.log(
      "INGENIUM_STATUSCALL_voiceServiceActive:",
      connection_platform.voiceServiceActive,
    );

    if (evt === evtAux) {
      return true;
    }
    evtAux = evt;

    if (evt) {
      evt = evt.toString();
      if (evt.indexOf("[") > 0) {
        evt = evt.substring(0, evt.indexOf("["));
      }
    }

    const {
      atendimento,
      informationusers,
      connectionsapi,
      interactioningdesk,
      atdsimult,
      messages,
      status,
      ipcurrent,
      chatsimult,
      chatinternal,
      gravacaovoz,
      agents,
      infodisplay,
      listcallqueue,
      serviceurl,
      capturafila,
      devices,
    } = getState();

    if (
      Array.isArray(atdsimult) &&
      atdsimult.filter((atd) => parseInt(atd.idmidia) === 1).length === 0 &&
      connection_platform.voiceServiceActive
    ) {
      voiceService.clearIdsAtendimentoToRejectIdsList();
    }

    let datatime = Moment().format("YYYY/MM/DD HH:mm:ss");
    let datatimeatd = Moment().format("DD/MM/YYYY HH:mm:ss");
    var datetimeBR = Moment().format("DD/MM/YYYY HH:mm:ss");
    let timecomplete = Moment().format("YYYY/MM/DD HH:mm:ss");
    var consultaInterna = "";
    var checkConsulta = false;
    var checkDisconnect = false;

    //NUCA RETIRAR O CONSOLE ABAIXO: RISCO DE DEMISSÃO
    // console.log("INGENIUM_STATUSCALL_1_2:", evt);

    if (
      (evt === "STATUS,-1,Registered." ||
        evt === "EVENT, USER, API_IsRegistered: true") &&
      checkLoginInitial === true
    ) {
      // if (evt === "STATUS,-1,Registered."  && checkLoginInitial === true) {
      console.log("INGENIUM_STATUSCALL_REGISTERED:", evt);

      carregarDevicesMizutech();

      if (!isMobileDevice()) {
        spawnNotification({
          opt: {
            body: "IngWeb",
            icon: LOGOINGWEB,
          },
          title: "Registrado no servidor SIP",
        });
      }

      checkLoginInitial = false;
      if (parseInt(status.idreason) < 0) {
        setTimeout(() => {
          console.log("UPDATEREGISTEREDLOGIN_EVENT", new Date().toISOString(), {
            userId: informationusers.id,
          });
          axios
            .get(
              `${connection_platform.type_connect}://${pathname}:${port}/conn/updateregisteredlogin?id=${informationusers.id}`,
            )
            .then((response) => {
              // sucesso
            })
            .catch((error) => {
              console.log(
                "ERRO AO INSERIR O STATUS LV updateregisteredlogin: ",
                error,
              );

              // tenta novamente após 2 segundos
              setTimeout(() => {
                axios.get(
                  `${connection_platform.type_connect}://${pathname}:${port}/conn/updateregisteredlogin?id=${informationusers.id}`,
                );
              }, 2000);
            });
        }, 3000); // delay de 3 segundos antes da primeira chamada
      }

      dispatch(EnableCall(true, true));
      if (
        connection_platform.nc2_integration &&
        checkNc2 === false &&
        connection_platform.nc2_users.indexOf(informationusers.ramal) !== -1
      ) {
        if (status.status === "Livre") {
          dispatch(setLoginNc2(true));
          nc2Service.nc2Login(informationusers.ramal);
          nc2Service.nc2MonitoraService(informationusers.ramal, dispatch);
          checkNc2 = true;
        }
      }
      //if (parseInt(status.idreason) < 0) {
      sendRegister(informationusers, status, dispatch);
      //}

      //}, 3000);

      //if(evt=='STATUS,-1,Registered.' && parseInt(status.idreason) < 0){
    }
    //2026-03-26 -> adicionado para ver se so entra aqui se for STATUS
    if (typeof evt === "string" && evt.startsWith("STATUS")) {
      if (parseInt(status.idreason) < 0) {
        if (checkStatus == false) {
          dispatch(changeBlockStatus());
          axios.get(
            `${connection_platform.type_connect}://${pathname}:${port}/conn/updateloadinglogin?id=${informationusers.id}`,
          );
          checkStatus = true;
        }
      }

      let valorDiferenca = parseInt(Math.abs(Math.round(ipcurrent.difftime)));
      if (parseInt(ipcurrent.difftime) < 0) {
        datatime = Moment()
          .subtract(valorDiferenca, "seconds")
          .format("YYYY/MM/DD HH:mm:ss");
        datetimeBR = Moment()
          .subtract(valorDiferenca, "seconds")
          .format("DD/MM/YYYY HH:mm:ss");
        timecomplete = Moment()
          .subtract(valorDiferenca, "seconds")
          .format("YYYY/MM/DD HH:mm:ss");
      } else {
        datatime = Moment()
          .add(valorDiferenca, "seconds")
          .format("YYYY/MM/DD HH:mm:ss");
        datetimeBR = Moment()
          .add(valorDiferenca, "seconds")
          .format("DD/MM/YYYY HH:mm:ss");
        timecomplete = Moment()
          .add(valorDiferenca, "seconds")
          .format("YYYY/MM/DD HH:mm:ss");
      }

      let [type, number, statusCall, infsip, dest, direction, infoserv] =
        evt.split(",");

      //let [type, number, statusCall, infsip, dest, direction] =  evt.split(",");
      //let infoserv = "";

      infoserv = infsip;

      if (connection_platform.voiceServiceActive) {
        const idatendimentoRecuperado = voiceService.getIdatendimentoByEvt(
          dest,
          direction,
          infoserv,
        );

        if (
          idatendimentoRecuperado &&
          voiceService.isThisIdAtendimentoToBeReject(idatendimentoRecuperado)
        ) {
          const isToRemoveCall =
            statusCall == "CallSetup" &&
            infsip.search("sigilo") == -1 &&
            infsip.search("itw") == -1 &&
            infsip.search("itv") == -1 &&
            checkConsulta === false;
          if (isToRemoveCall) {
            webphone_api.hangup(parseInt(informationusers.skill) + 1);
          }
          return;
        }
      }

      // console.log("INGENIUM_STATUSCALL_1_3:", evt);

      if (parseInt(number) >= 0 && parseInt(infsip) !== 55) {
        consultaInterna = infsip.split("-");

        let mediaId = "1";
        let nameChannel = "Voz";

        let qtdeatdvoz = atdsimult.filter((atd) => parseInt(atd.idmidia) === 1);

        let qtdeatdvozD = atdsimult.filter(
          (atd) => parseInt(atd.idmidia) !== 1,
        );

        if (parseInt(qtdeatdvoz.length) === 0) {
          if (statusCall === "Ringing") {
            InsertPausaQAT(
              informationusers.sipid,
              informationusers.id,
              dispatch,
            );
          }
        }

        if (
          parseInt(qtdeatdvozD.length) !== 0 &&
          !informationusers.blockfuture
        ) {
          if (statusCall === "CallDisconnect") {
            // InsertPausaRV(
            //   informationusers.sipid,
            //   informationusers.id,
            //   dispatch,
            // );
            dispatch(
              InsertPausaRVV2(informationusers.sipid, informationusers.id),
            );
          }
        }

        if (parseInt(direction) === 1) {
          if (
            (consultaInterna[0] !== "" || consultaInterna[0] !== undefined) &&
            infsip.search("-") === -1
          ) {
            checkConsulta = true;
          } else if (
            consultaInterna[0] !== "" &&
            consultaInterna[0] !== undefined &&
            infsip.search("-") === -1
          ) {
            checkConsulta = true;
          }
        } else if (parseInt(direction) === 2) {
          if (
            (consultaInterna[0] === "" || consultaInterna[0] === undefined) &&
            infsip.search("-") !== -1
          ) {
            //if(((consultaInterna[0]==="" || consultaInterna[0]===undefined))){
            checkConsulta = true;
          } else if (
            consultaInterna[0] !== "" &&
            consultaInterna[0] !== undefined &&
            infsip.search("-") === -1
          ) {
            checkConsulta = true;
          }
        }

        if (statusCall == "Registered") {
          if (parseInt(status.idreason) < 0) {
            setTimeout(() => {
              console.log(
                "UPDATEREGISTEREDLOGIN_EVENT",
                new Date().toISOString(),
                { userId: informationusers.id },
              );
              axios
                .get(
                  `${connection_platform.type_connect}://${pathname}:${port}/conn/updateregisteredlogin?id=${informationusers.id}`,
                )
                .then((response) => {
                  // sucesso
                })
                .catch((error) => {
                  console.log(
                    "ERRO AO INSERIR O STATUS LV updateregisteredlogin: ",
                    error,
                  );

                  // tenta novamente após 2 segundos
                  setTimeout(() => {
                    axios.get(
                      `${connection_platform.type_connect}://${pathname}:${port}/conn/updateregisteredlogin?id=${informationusers.id}`,
                    );
                  }, 2000);
                });
            }, 3000); // delay de 3 segundos antes da primeira chamada
          }

          dispatch(EnableCall(true, true));
          if (
            connection_platform.nc2_integration &&
            checkNc2 === false &&
            connection_platform.nc2_users.indexOf(informationusers.ramal) !== -1
          ) {
            if (status.status === "Livre") {
              dispatch(setLoginNc2(true));
              nc2Service.nc2Login(informationusers.ramal);
              nc2Service.nc2MonitoraService(informationusers.ramal, dispatch);
              checkNc2 = true;
            }
          }

          sendRegister(informationusers, status, dispatch);
        }

        if (direction == "1") {
          direction = 2;
        } else {
          direction = 1;
        }

        if (
          infsip.search("cfbt") === -1 &&
          infsip.search("cfct") === -1 &&
          infsip.search("sigilo") === -1 &&
          infsip.search("itw") === -1 &&
          infsip.search("itv") === -1 &&
          infsip !== undefined &&
          dest.search("sigilo") === -1 &&
          dest.search("itw") === -1 &&
          dest.search("itv") === -1
        ) {
          if (
            statusCall === "Ringing" &&
            infsip.search("-") !== -1 &&
            checkConsulta === true
          ) {
            ChangeCallHold(atdsimult, 0);
            let ramal = infsip.split("-")[1];
            let displayname = "";
            let iduser = "";
            let checkChatSimullt = false;
            let agentSelect = "";
            let agentline = "";

            agents.map((agent) => {
              if (parseInt(ramal) == parseInt(agent.ramal)) {
                displayname = agent.label;
                iduser = agent.value;
                agentSelect = agent;
              }
            });

            chatsimult.map((chat) => {
              if (parseInt(iduser) == parseInt(chat.iduserout)) {
                checkChatSimullt = true;
                agentline = chat.line;
              }
            });

            if (agentline === "") {
              agentline = webphone_api.getline();
            }

            dispatch(editChat(agentSelect, true, true, datatime, agentline));
            dispatch(editChatInternal(agentSelect, true, true, agentline));

            ramaldisconnect[webphone_api.getline()] = agentSelect.ramal;

            editarchatInterno(
              agentSelect,
              checkChatSimullt,
              informationusers,
              infodisplay,
              atendimento,
              chatsimult,
              atdsimult,
            );
            dispatch(
              createStatusAgent(
                "Atendimento",
                "CONSULTA",
                Moment().format("DD/MM/YYYY HH:mm:ss"),
              ),
            );

            let position = toast.POSITION.BOTTOM_RIGHT;

            if (localStorage.getItem("position-popup")) {
              const getPosition = JSON.parse(
                localStorage.getItem("position-popup"),
              );
              switch (getPosition.position) {
                case "top-left":
                  position = toast.POSITION.TOP_LEFT;
                  break;
                case "top-right":
                  position = toast.POSITION.TOP_RIGHT;
                  break;
                case "top-center":
                  position = toast.POSITION.TOP_CENTER;
                  break;
                case "bottom-left":
                  position = toast.POSITION.BOTTOM_LEFT;
                  break;
                case "bottom-center":
                  position = toast.POSITION.BOTTOM_CENTER;
                  break;
                case "bottom-right":
                  position = toast.POSITION.BOTTOM_RIGHT;
                  break;
                default:
                  position = toast.POSITION.BOTTOM_RIGHT;
                  break;
              }
            }

            toast(
              <CustomToastCall
                contato={agentSelect}
                chatativo={checkChatSimullt}
                containerId={iduser}
              />,
              {
                autoClose: false,
                // position: toast.POSITION.BOTTOM_RIGHT,
                position: position,
                draggable: false,
                closeOnClick: false,
                toastId: agentSelect.ramal,
                closeButton: false,
                containerId: agentSelect.ramal,
              },
            );
          }

          //CONSULTA VINDA DE UM MÓDULO EXTERNO

          if (
            statusCall === "Speaking" &&
            checkConsulta === true &&
            infsip.search("-") === -1
          ) {
            dispatch(addChatSimultAtd(infsip, true));
          }

          if (
            statusCall === "Ringing" &&
            checkConsulta === true &&
            infsip.search("-") === -1
          ) {
            dispatch(addChatSimultAtd(infsip, true));
            ChangeCallHold(atdsimult, 1);
            let ramal = infsip;
            let displayname = "";
            let iduser = "";
            let checkChatSimullt = false;
            let agentSelect = "";
            let agentline = "";

            agents.map((agent) => {
              if (parseInt(ramal) === parseInt(agent.ramal)) {
                displayname = agent.label;
                iduser = agent.value;
                agentSelect = agent;
              }
            });

            // chatsimult.map((chat) => {
            //   if (parseInt(iduser) == parseInt(chat.iduserout)) {
            //     checkChatSimullt = true;
            //     agentline = chat.line;
            //   }
            // });

            let chatSimultNew = getState().chatsimult;

            let valorLineInternal = chatSimultNew.filter(
              (chat) => chat.voz === true,
            );

            if (valorLineInternal && valorLineInternal.length !== 0) {
              dispatch(
                editChat(
                  agentSelect,
                  true,
                  true,
                  datatime,
                  valorLineInternal[0].line,
                ),
              );
              dispatch(
                editChatInternal(
                  agentSelect,
                  true,
                  true,
                  valorLineInternal[0].line,
                ),
              );
              ramaldisconnect[valorLineInternal[0].line] = agentSelect.ramal;
            }

            editarchatInterno(
              agentSelect,
              checkChatSimullt,
              informationusers,
              infodisplay,
              atendimento,
              chatsimult,
              atdsimult,
            );
            dispatch(
              createStatusAgent(
                "Atendimento",
                "CONSULTA",
                Moment().format("DD/MM/YYYY HH:mm:ss"),
              ),
            );
            if (
              parseInt(informationusers.ramal) !== parseInt(infsip) &&
              parseInt(direction) === 1
            ) {
              let position = toast.POSITION.BOTTOM_RIGHT;
              if (localStorage.getItem("position-popup")) {
                const getPosition = JSON.parse(
                  localStorage.getItem("position-popup"),
                );
                switch (getPosition.position) {
                  case "top-left":
                    position = toast.POSITION.TOP_LEFT;
                    break;
                  case "top-right":
                    position = toast.POSITION.TOP_RIGHT;
                    break;
                  case "top-center":
                    position = toast.POSITION.TOP_CENTER;
                    break;
                  case "bottom-left":
                    position = toast.POSITION.BOTTOM_LEFT;
                    break;
                  case "bottom-center":
                    position = toast.POSITION.BOTTOM_CENTER;
                    break;
                  case "bottom-right":
                    position = toast.POSITION.BOTTOM_RIGHT;
                    break;
                  default:
                    position = toast.POSITION.BOTTOM_RIGHT;
                    break;
                }
              }

              toast(
                <CustomToastCall
                  contato={agentSelect}
                  chatativo={checkChatSimullt}
                  containerId={iduser}
                />,
                {
                  autoClose: false,
                  // position: toast.POSITION.BOTTOM_RIGHT,
                  position: position,
                  draggable: false,
                  closeOnClick: false,
                  toastId: agentSelect.ramal,
                  closeButton: false,
                  containerId: agentSelect.ramal,
                },
              );
            }
          }

          if (statusCall == "CallConnect" && checkConsulta === true) {
            //if(statusCall == "CallConnect" && infsip.search("-") !=-1 && checkConsulta === true){
            let datatime = Moment().format("YYYY/MM/DD HH:mm:ss");
            let datatimeatd = Moment().format("DD/MM/YYYY HH:mm:ss");

            let valorLineInternal = chatsimult.filter(
              (chat) => chat.voz === true,
            );

            if (valorLineInternal && valorLineInternal.length !== 0) {
              ramaldisconnect[webphone_api.getline()] = chatinternal.ramal;
              dispatch(
                editChat(
                  chatinternal.iduserout,
                  true,
                  true,
                  datatime,
                  valorLineInternal[0].line,
                ),
              );
            }

            let arrayAtdJson = [];
            let existNumberAndChannel = false;
            atdsimult.map((atd) => {
              if (
                parseInt(atd.idmidia) === 1 &&
                parseInt(atd.telefone) === parseInt(telefonesplit)
              )
                existNumberAndChannel = true;

              arrayAtdJson.push({
                idmidia: atd.idmidia,
                telefone: atd.telefone,
              });
            });
            let post = Moment().format("DD/MM/YYYY HH:mm:ss");
            let jsonChannelPhoneCall = mountCallsStatus(arrayAtdJson);

            let data_hora_atual = Moment().format("YYYY/MM/DD HH:mm:ss");
            let duracaoLoginAtual = Moment(data_hora_atual).diff(
              informationusers.datalogin,
              "seconds",
            );
            let duracaoLoginFinal =
              parseInt(duracaoLoginAtual) + parseInt(informationusers.tmlogin);

            let strPauseFuture = informationusers.blockfuture ? 1 : 0;
            let descPauseFuture = informationusers.blockfuture
              ? descfuturepause
              : " ";

            socket.send(
              "REQ\r\n" +
                informationusers.id +
                "\r\nUSERNAME\r\n" +
                informationusers.username +
                "\r\nDISPLAYNAME\r\n" +
                informationusers.displayname +
                "\r\nEXTEN\r\n" +
                informationusers.ramal +
                "\r\nREASON\r\n" +
                chatinternal.ramal +
                "\r\nSTATUS\r\nQAT\r\nSTATUSID\r\n-1\r\nHOUR\r\n" +
                post +
                "-00:00:00\r\nDESCRIPTION\r\nConsulta com " +
                chatinternal.agent +
                "\r\nEMAIL\r\n \r\nGROUP\r\n" +
                informationusers.idgroup +
                "\r\nDTL\r\n" +
                post +
                "\r\nGROUPNAME\r\n" +
                informationusers.grupo +
                "\r\nPSDCOUNT\r\n" +
                parseInt(informationusers.psdcount) +
                "\r\nPSDTMA\r\n" +
                parseInt(informationusers.psdtma) +
                "\r\nMNGGROUP\r\n-1\r\nINCALLCOUNT\r\n" +
                parseInt(informationusers.incallcount) +
                "\r\nINANSCOUNT\r\n" +
                parseInt(informationusers.inanscount) +
                "\r\nINTMANS\r\n" +
                parseInt(informationusers.intmans) +
                "\r\nINSLA\r\n100\r\nOUTCALLCOUNT\r\n" +
                parseInt(informationusers.outcallcount) +
                "\r\nOUTANSCOUNT\r\n" +
                parseInt(informationusers.outanscount) +
                "\r\nOUTTMANS\r\n" +
                parseInt(informationusers.outtmans) +
                "\r\nOUTSLA\r\n100\r\nJSON\r\n" +
                jsonChannelPhoneCall +
                "\r\nTMLOGIN\r\n" +
                parseInt(duracaoLoginFinal) +
                "\r\nCOUNTFPAUSE\r\n" +
                parseInt(informationusers.psdfbreak) +
                "\r\nFUTUREPAUSE\r\n" +
                strPauseFuture +
                "\r\nDESCFUTUREPAUSE\r\n" +
                descPauseFuture +
                "\r\nINITIALLOGIN\r\n0\r\n\r\n",
            );
            statusAgentIMSDN = "QAT";
            stAgIMSDN = "QAT";
            console.log(
              "INGENIUM_ENVIOSTATUS :",
              new Date().toLocaleString(),
              stAgIMSDN,
            );
            requestStatusAgent =
              "REQ\r\n" +
              informationusers.id +
              "\r\nUSERNAME\r\n" +
              informationusers.username +
              "\r\nDISPLAYNAME\r\n" +
              informationusers.displayname +
              "\r\nEXTEN\r\n" +
              informationusers.ramal +
              "\r\nREASON\r\n" +
              chatinternal.ramal +
              "\r\nSTATUS\r\nQAT\r\nSTATUSID\r\n-1\r\nHOUR\r\n" +
              post +
              "-00:00:00\r\nDESCRIPTION\r\nConsulta com " +
              chatinternal.agent +
              "\r\nEMAIL\r\n \r\nGROUP\r\n" +
              informationusers.idgroup +
              "\r\nDTL\r\n" +
              post +
              "\r\nGROUPNAME\r\n" +
              informationusers.grupo +
              "\r\nPSDCOUNT\r\n" +
              parseInt(informationusers.psdcount) +
              "\r\nPSDTMA\r\n" +
              parseInt(informationusers.psdtma) +
              "\r\nMNGGROUP\r\n-1\r\nINCALLCOUNT\r\n" +
              parseInt(informationusers.incallcount) +
              "\r\nINANSCOUNT\r\n" +
              parseInt(informationusers.inanscount) +
              "\r\nINTMANS\r\n" +
              parseInt(informationusers.intmans) +
              "\r\nINSLA\r\n100\r\nOUTCALLCOUNT\r\n" +
              parseInt(informationusers.outcallcount) +
              "\r\nOUTANSCOUNT\r\n" +
              parseInt(informationusers.outanscount) +
              "\r\nOUTTMANS\r\n" +
              parseInt(informationusers.outtmans) +
              "\r\nOUTSLA\r\n100\r\nJSON\r\n" +
              jsonChannelPhoneCall +
              "\r\nTMLOGIN\r\n" +
              parseInt(duracaoLoginFinal) +
              "\r\nCOUNTFPAUSE\r\n" +
              parseInt(informationusers.psdfbreak) +
              "\r\nFUTUREPAUSE\r\n" +
              strPauseFuture +
              "\r\nDESCFUTUREPAUSE\r\n" +
              descPauseFuture +
              "\r\nINITIALLOGIN\r\n0\r\n\r\n";
            clearInterval(statusIntervalAgent);
            envioStatusAgente(7247, informationusers.sipid);
          }

          if (statusCall == "CallDisconnect" && checkConsulta === true) {
            webphone_api.setline(parseInt(atendimento.line));

            setTimeout(() => {
              if (webphone_api.isonhold()) {
                webphone_api.hold(false);
              }
              webphone_api.mute(false, 0);
            }, 1000);

            let datatime = Moment().format("YYYY/MM/DD HH:mm:ss");
            let datatimeatd = Moment().format("DD/MM/YYYY HH:mm:ss");
            let post = Moment().format("DD/MM/YYYY HH:mm:ss");
            toast.dismiss(ramaldisconnect[number]);

            // aqui vou olhar pela linha e nao pelo usuario
            dispatch(editChatInternalLine(number, datatime));
            dispatch(endCallLine(number, datatime));
            dispatch(editChatLine(number, datatime));

            if (parseInt(chatinternal.line) > 0) {
              dispatch(
                editChat(chatinternal.iduserout, false, false, datatime, 0),
              );
            }

            //dispatch(endCall(chatinternal.iduserout));
            //dispatch(editChat(chatinternal.iduserout,false,false,datatime,0));
            //dispatch(ShowInfoDisplay('atend1ance'));
            let statusAnterior = "LV";

            if (atdsimult.length === 0) {
              dispatch(
                createStatusAgent(
                  "Encerrou",
                  "" + ramaldisconnect[number] + "",
                  Moment().format("DD/MM/YYYY HH:mm:ss"),
                ),
              );
            }

            if (status.afterStatus === "Pausado") {
              statusAnterior = "BQ";
            } else if (atdsimult.length > 0) {
              statusAnterior = "AT";
            }

            let data_hora_atual = Moment().format("YYYY/MM/DD HH:mm:ss");
            let duracaoLoginAtual = Moment(data_hora_atual).diff(
              informationusers.datalogin,
              "seconds",
            );
            let duracaoLoginFinal =
              parseInt(duracaoLoginAtual) + parseInt(informationusers.tmlogin);

            let valorDescription =
              atendimento.servico !== "" && atendimento.servico !== undefined
                ? atendimento.servico
                : "";
            let valorReason =
              atendimento.telefone !== "" && atendimento.telefone !== undefined
                ? atendimento.telefone
                : "";
            let strPauseFuture = informationusers.blockfuture ? 1 : 0;
            let descPauseFuture = informationusers.blockfuture
              ? descfuturepause
              : " ";
            socket.send(
              "REQ\r\n" +
                informationusers.id +
                "\r\nUSERNAME\r\n" +
                informationusers.username +
                "\r\nDISPLAYNAME\r\n" +
                informationusers.displayname +
                "\r\nEXTEN\r\n" +
                informationusers.ramal +
                "\r\nREASON\r\n" +
                valorReason +
                "\r\nSTATUS\r\n" +
                statusAnterior +
                "\r\nSTATUSID\r\n-1\r\nHOUR\r\n" +
                post +
                "-00:00:00\r\nDESCRIPTION\r\n" +
                valorDescription +
                "\r\nEMAIL\r\n \r\nGROUP\r\n" +
                informationusers.idgroup +
                "\r\nDTL\r\n" +
                post +
                "\r\nGROUPNAME\r\n" +
                informationusers.grupo +
                "\r\nPSDCOUNT\r\n" +
                parseInt(informationusers.psdcount) +
                "\r\nPSDTMA\r\n" +
                parseInt(informationusers.psdtma) +
                "\r\nMNGGROUP\r\n-1\r\nINCALLCOUNT\r\n" +
                parseInt(informationusers.incallcount) +
                "\r\nINANSCOUNT\r\n" +
                parseInt(informationusers.inanscount) +
                "\r\nINTMANS\r\n" +
                parseInt(informationusers.intmans) +
                "\r\nINSLA\r\n100\r\nOUTCALLCOUNT\r\n" +
                parseInt(informationusers.outcallcount) +
                "\r\nOUTANSCOUNT\r\n" +
                parseInt(informationusers.outanscount) +
                "\r\nOUTTMANS\r\n" +
                parseInt(informationusers.outtmans) +
                "\r\nOUTSLA\r\n100\r\nTMLOGIN\r\n" +
                parseInt(duracaoLoginFinal) +
                "\r\nCOUNTFPAUSE\r\n" +
                parseInt(informationusers.psdfbreak) +
                "\r\nFUTUREPAUSE\r\n" +
                strPauseFuture +
                "\r\nDESCFUTUREPAUSE\r\n" +
                descPauseFuture +
                "\r\nINITIALLOGIN\r\n0\r\n\r\n",
            );
            statusAgentIMSDN = statusAnterior;
            stAgIMSDN = statusAnterior;
            console.log(
              "INGENIUM_ENVIOSTATUS :",
              new Date().toLocaleString(),
              stAgIMSDN,
            );
            requestStatusAgent =
              "REQ\r\n" +
              informationusers.id +
              "\r\nUSERNAME\r\n" +
              informationusers.username +
              "\r\nDISPLAYNAME\r\n" +
              informationusers.displayname +
              "\r\nEXTEN\r\n" +
              informationusers.ramal +
              "\r\nREASON\r\n \r\nSTATUS\r\n" +
              statusAnterior +
              "\r\nSTATUSID\r\n-1\r\nHOUR\r\n" +
              post +
              "-00:00:00\r\nDESCRIPTION\r\n \r\nEMAIL\r\n \r\nGROUP\r\n" +
              informationusers.idgroup +
              "\r\nDTL\r\n" +
              post +
              "\r\nGROUPNAME\r\n" +
              informationusers.grupo +
              "\r\nPSDCOUNT\r\n" +
              parseInt(informationusers.psdcount) +
              "\r\nPSDTMA\r\n" +
              parseInt(informationusers.psdtma) +
              "\r\nMNGGROUP\r\n-1\r\nINCALLCOUNT\r\n" +
              parseInt(informationusers.incallcount) +
              "\r\nINANSCOUNT\r\n" +
              parseInt(informationusers.inanscount) +
              "\r\nINTMANS\r\n" +
              parseInt(informationusers.intmans) +
              "\r\nINSLA\r\n100\r\nOUTCALLCOUNT\r\n" +
              parseInt(informationusers.outcallcount) +
              "\r\nOUTANSCOUNT\r\n" +
              parseInt(informationusers.outanscount) +
              "\r\nOUTTMANS\r\n" +
              parseInt(informationusers.outtmans) +
              "\r\nOUTSLA\r\n100\r\nTMLOGIN\r\n" +
              parseInt(duracaoLoginFinal) +
              "\r\nCOUNTFPAUSE\r\n" +
              parseInt(informationusers.psdfbreak) +
              "\r\nFUTUREPAUSE\r\n" +
              strPauseFuture +
              "\r\nDESCFUTUREPAUSE\r\n" +
              descPauseFuture +
              "\r\nINITIALLOGIN\r\n0\r\n\r\n";
            clearInterval(statusIntervalAgent);
            envioStatusAgente(7479, informationusers.sipid);
          } else if (
            statusCall == "CallDisconnect" &&
            infsip.search("-") == -1 &&
            checkConsulta === false
          ) {
            if (webphone_api.isonhold()) webphone_api.hold(false);

            dispatch(editChatInternal(chatinternal.iduserout, false, false, 0));
            dispatch(endCall(chatinternal.iduserout));
            dispatch(
              editChat(chatinternal.iduserout, false, false, datatime, 0),
            );
          }
        }

        if (
          dest.split("/")[0] != "sigilo" &&
          dest.split("/")[0] != "itv" &&
          dest.split("/")[0] != "itw"
        ) {
          if (direction == 2) {
            var infoserv2 = infoserv.split("-");

            if (infoserv2.length > 10) {
              var [
                idatendimento,
                sip,
                telefone,
                versiona,
                versionb,
                versionc,
                idattdesc,
              ] = infoserv.split("-");
              var [telefonesplit, equip] = telefone.split("+");
            } else {
              var [
                telefone,
                sip,
                idatendimento,
                versiona,
                versionb,
                versionc,
                idattdesc,
              ] = infoserv.split("-");
              var [telefonesplit, equip] = telefone.split("!");
            }
          } else {
            if (infoserv.search("=") != -1) {
              var strContato = infoserv.split("-");
              var strNomeContato = "";
              for (var i = 4; i < strContato.length; i++) {
                strNomeContato += strContato[i];
              }
              var [idatendimento, idservico, quemtransferiu, infocomp] =
                infoserv.split("-");

              //INGENIUM_AUDITORIA
              if (parseInt(idservico) === 1 || parseInt(idservico) === 5) {
                var [
                  nomesubservicostr,
                  ims,
                  telefone,
                  permitirmute,
                  consultargestor,
                  consultartransferencia,
                  montarconferencia,
                  direcaose,
                  transferenciacega,
                  colocarconferencia,
                  compartilhartela,
                  consultaragente,
                  variavel5,
                  variavel6,
                  variavel7,
                  variavel8,
                  variavel9,
                  idsubservico,
                  q14,
                  consultanome,
                ] = infocomp.split("=");
                var [nomesubservico, variavel1, variavel2, variavel3] =
                  nomesubservicostr.split("+");
                var [telefonesplit, quemtransferiu] = telefone.split("+");
                var [nomeousub, iddb, onumber] = strNomeContato.split("�");
              } else if (parseInt(idservico) === 4) {
                var [
                  nomesubservicostr,
                  ims,
                  telefone,
                  permitirmute,
                  consultargestor,
                  consultartransferencia,
                  montarconferencia,
                  direcaose,
                  transferenciacega,
                  colocarconferencia,
                  compartilhartela,
                  consultaragente,
                  variavel5,
                  variavel6,
                  variavel7,
                  variavel8,
                  variavel9,
                  variavel10,
                  q14,
                  consultanome,
                ] = infocomp.split("=");
                //var [nomesubservico,variavel1,variavel2,variavel3] = nomesubservicostr.split("+");
                var [quemtransferiu, telefonesplit] = telefone.split("+");
                //var [nomeousub,nomesubservico,idsubservico] = null;
              }
            } else {
              //infoserv = '95487-4-3700+71982718640-s-1-1-1-1-1-1-1-2-0-1-1-1-0-13-2-';
              var strContato = infoserv.split("-");

              //CAMPANHA
              //95487-4-3700+71982718640-s-1-1-1-1-1-1-1-2-0-1-1-1-0-13-2-;

              //RECEPTIVO
              //95489-1-71996390675+4672-RafaelTeste+1++0-1-1-1-1-1-1-1-1-1-1-0-1-156-

              if (parseInt(strContato[11]) === 1) {
                var strNomeContato = "";
                for (var i = 18; i < strContato.length; i++) {
                  strNomeContato += strContato[i];
                }
                var [
                  idatendimento,
                  idservico,
                  telefone,
                  infosub,
                  permissaoparargravacao,
                  permissaoparagravar,
                  colocarholder,
                  permitirmute,
                  consultargestor,
                  consultartransferencia,
                  montarconferencia,
                  direcaose,
                  transferenciacega,
                  colocarconferencia,
                  compartilhartela,
                  consultaragente,
                  idsubservico,
                  q14,
                  consultanome,
                ] = infoserv.split("-");
                var [telefonesplit, mcdu] = telefone.split("+");
                var [nomesubservico, cargaautomatica, datatachada, statustela] =
                  infosub.split("+");

                //227132-1-71996390675+3710-Rafael_3710+1++0-1-1-1-1-1-1-1-1-1-1-0-1-365-

                var [nomeousub, iddb, onumber] = strNomeContato.split("�");
              } else if (parseInt(strContato[11]) === 2) {
                var [idatendimento, idservico, telefone, infosub] =
                  infoserv.split("-");
                var [mcdu, telefonesplit] = telefone.split("+");
                var nomesubservico = "CAMPANHA";
                //var [nomeousub, iddb, onumber] = "";
              }
            }
          }

          if (
            telefonesplit.length == 14 &&
            telefonesplit.substr(0, 2) != "00"
          ) {
            telefonesplit = telefonesplit.substr(3, telefonesplit.length);
          } else if (
            telefonesplit.length == 13 &&
            telefonesplit.substr(0, 2) != "00"
          ) {
            telefonesplit = telefonesplit.substr(3, telefonesplit.length);
          }
        }

        if (infsip.search("sigilo") != -1) {
          //webphone_api.mute(true, 2);
          webphone_api.setparameter("volumein", 100);
        }

        if (infsip.search("cfbt") !== -1 && statusCall === "Ringing") {
          console.log("INGENIUM_TRANSFERENCIA_CEGA : ", informationusers);

          if (informationusers.atdauto) {
            AceitarChamada();
          } else {
            //INGENIUM_AUDITORIA
            if (parseInt(idservico) === 1 || parseInt(idservico) === 5) {
              dispatch(
                createStatusAgent(
                  "Atendimento",
                  "E.(" + quemtransferiu + ")",
                  Moment().format("DD/MM/YYYY HH:mm:ss"),
                ),
              );
            } else {
              dispatch(
                createStatusAgent(
                  "Atendimento",
                  "S.(" + quemtransferiu + ")",
                  Moment().format("DD/MM/YYYY HH:mm:ss"),
                ),
              );
            }
            let ramal = quemtransferiu;
            let displayname = "";
            let iduser = "";
            let checkChatSimullt = false;
            let agentSelect = "";
            agents.map((agent) => {
              if (parseInt(ramal) == parseInt(agent.ramal)) {
                displayname = agent.label;
                iduser = agent.value;
                agentSelect = agent;
              }
            });

            chatsimult.map((chat) => {
              if (parseInt(iduser) === parseInt(chat.iduserout)) {
                checkChatSimullt = true;
              }
            });

            let nomenumero = "";
            let mcducalling = "";
            if (parseInt(idservico) === 4) {
              nomenumero = telefonesplit;
              mcducalling = quemtransferiu;
              //INGENIUM_AUDITORIA
            } else if (parseInt(idservico) === 1 || parseInt(idservico) === 5) {
              nomenumero =
                (nomeousub !== null || nomeousub !== undefined) &&
                nomeousub.trim() !== "IMS9300"
                  ? nomeousub
                  : telefonesplit;
              mcducalling = quemtransferiu + " - " + nomesubservico;
            }

            // InsertPausaRV(sipid, userid, dispatch);
            dispatch(InsertPausaRVV2(sipid, userid));

            let position = toast.POSITION.BOTTOM_RIGHT;

            if (localStorage.getItem("position-popup")) {
              const getPosition = JSON.parse(
                localStorage.getItem("position-popup"),
              );
              switch (getPosition.position) {
                case "top-left":
                  position = toast.POSITION.TOP_LEFT;
                  break;
                case "top-right":
                  position = toast.POSITION.TOP_RIGHT;
                  break;
                case "top-center":
                  position = toast.POSITION.TOP_CENTER;
                  break;
                case "bottom-left":
                  position = toast.POSITION.BOTTOM_LEFT;
                  break;
                case "bottom-center":
                  position = toast.POSITION.BOTTOM_CENTER;
                  break;
                case "bottom-right":
                  position = toast.POSITION.BOTTOM_RIGHT;
                  break;
                default:
                  position = toast.POSITION.BOTTOM_RIGHT;
                  break;
              }
            }

            toast(
              <CustomToastCallTransfer
                contato={nomenumero}
                chatativo={checkChatSimullt}
                containerId={iduser}
                nomecliente={nomenumero}
                mcdu={mcducalling}
              />,
              {
                autoClose: false,
                position: position,
                draggable: false,
                closeOnClick: false,
                //toastId: ramal,
                toastId: idatendimento,
                closeButton: false,
                //ContainerId:ramal
                containerId: idatendimento,
              },
            );
          }
        }
        if (infsip.search("cfct") !== -1 && statusCall === "Ringing") {
          //INGENIUM_AUDITORIA
          console.log("INGENIUM_TRANSFERENCIA_CEGA : ", informationusers);
          if (parseInt(idservico) === 1 || parseInt(idservico) === 5) {
            dispatch(
              createStatusAgent(
                "Atendimento",
                "E.(" + quemtransferiu + ")",
                Moment().format("DD/MM/YYYY HH:mm:ss"),
              ),
            );
          } else {
            dispatch(
              createStatusAgent(
                "Atendimento",
                "S.(" + quemtransferiu + ")",
                Moment().format("DD/MM/YYYY HH:mm:ss"),
              ),
            );
          }
          webphone_api.accept();
        }

        //  console.log ("INGENIUM_STATUSCALL_4:",statusCall,infsip,checkConsulta)

        if (
          statusCall == "CallSetup" &&
          infsip.search("sigilo") == -1 &&
          infsip.search("itw") == -1 &&
          infsip.search("itv") == -1 &&
          checkConsulta === false
        ) {
          console.log("INGENIUM_QTATDVOZ : ", direction);
          let atdsimult = getState().atdsimult;
          console.log(
            "INGENIUM_QTATDVOZ:",
            atdsimult !== undefined ? JSON.stringify(atdsimult) : "undefined",
          );
          let qtdeatdvoz = [];
          if (connection_platform.voiceServiceActive) {
            qtdeatdvoz = atdsimult.filter(
              (atd) =>
                (parseInt(atd.idmidia) === 1 || parseInt(atd.idmidia) === 16) &&
                !atd.acw &&
                parseInt(atd.idatendimento) !== parseInt(idatendimento),
            );
          } else {
            qtdeatdvoz = atdsimult.filter(
              (atd) =>
                (parseInt(atd.idmidia) === 1 || parseInt(atd.idmidia) === 16) &&
                !atd.acw,
            );
          }

          console.log("INGENIUM_QTATDVOZ : ", qtdeatdvoz.length);
          if (
            parseInt(qtdeatdvoz.length) >= parseInt(informationusers.skill) &&
            parseInt(direction) !== 2
          ) {
            webphone_api.hangup(parseInt(informationusers.skill + 1));
            checkSkill = false;
            if (connection_platform.voiceServiceActive) {
              voiceService.addIdAtendimentoToRejectIdsList(idatendimento);
              return;
            }

            //RejeitarChamada()
          } else {
            checkSkill = true;
          }
          ChangeCallHold(atdsimult, 2);

          let direcao = "Saida";
          if (direction !== 2) {
            direcao = "Entrada";
            arrayinfoTo[idatendimento] = infoserv;
          }
          //if(checkConsulta === true){
          //let ramdonatendimento = Math.floor((Math.random() * 9999) + 1000);
          ChangeCallHold(atdsimult, 3);

          //}else{
          if (idsubservico === undefined) {
            idsubservico = "";
          }
          let numberIms = null;

          let queueid = "";

          listcallqueue.map((queue) => {
            if (parseInt(queue.cdrnew) === parseInt(idatendimento)) {
              queueid = queue.queueid;
            }
          });

          let infoinitcall = arrayinfoTo[idatendimento];

          let nps_call = false;

          if (localStorage.getItem("NUMBERNPS") === telefonesplit) {
            nps_call = true;
            localStorage.setItem("NUMBERNPS", "");
          }

          let idServiceWait = 0;

          webphone_api.getsipheader("X-IngInfo", (callback) => {
            let objIngInfo = JSON.parse(callback);
            console.log(
              "INGENIUM_STATUSCALL_insertserviceattendant_INICIO_0",
              objIngInfo,
            );
            idServiceWait = objIngInfo.srv_wait_id;
            mediaId = parseInt(objIngInfo.media_id) === 16 ? "16" : "1";
            nameChannel =
              parseInt(objIngInfo.media_id) === 16 ? "WhatsAppVoz" : "Voz";
          });

          if (isWhatsVoz && direcao === "Saida") {
            mediaId = "16";
            nameChannel = "WhatsApp Voz";
          }

          if (
            atendimento.length !== 0 &&
            atendimento.idatendimento === idatendimento
          ) {
            dispatch(EditAcwContactDisabled(idatendimento));
          } else {
            let tipoChamada = nomesubservico ? "Entrada" : "Saída";
            console.log(
              "INGENIUM_STATUSCALL_insertserviceattendant_INICIO_01",
              atendimento,
            );
            dispatch(
              addAtendimento(
                idatendimento,
                telefonesplit,
                telefonesplit,
                "Saída",
                datatimeatd,
                "Não informar",
                "",
                "",
                0,
                "0",
                datetimeBR,
                direction,
                mediaId,
                timecomplete,
                status.status,
                number,
                queueid,
                "",
                "",
                "",
                mcdu,
                nomesubservico,
                infoinitcall,
                nomeousub,
                "",
                idsubservico,
                false,
                nomesubservico === "CAMPANHA" ? true : false,
                "",
                "",
                "",
                "",
                "",
                nps_call,
              ),
            );
            dispatch(
              addAtdSimult(
                idatendimento,
                telefonesplit,
                telefonesplit,
                "Saída",
                datatimeatd,
                "Não informar",
                "",
                "",
                0,
                "0",
                datetimeBR,
                direction,
                mediaId,
                timecomplete,
                status.status,
                number,
                queueid,
                "",
                "",
                "",
                "",
                mcdu,
                nomesubservico,
                infoinitcall,
                nomeousub,
                "",
                idsubservico,
                false,
                nomesubservico === "CAMPANHA" ? true : false,
                "",
                "",
                "",
                "",
                "",
                nps_call,
              ),
            );
          }
          InteracoesContactNumberPeer(telefonesplit, informationusers.idgroup);
          dispatch(UpdateRgBlockReturn(informationusers));

          setTimeout(() => {
            //corrigir aqui
            console.log("INGENIUM-AJUSTE-22-08-2025 pt-1", { connectionsapi });
            const hasContentWindow =
              Boolean(connectionsapi) &&
              Boolean(connectionsapi.iframe_ref) &&
              Boolean(connectionsapi.iframe_ref.current) &&
              Boolean(connectionsapi.iframe_ref.current.contentWindow);
            if (hasContentWindow) {
              connectionsapi.iframe_ref.current.contentWindow.postMessage(
                {
                  origin: "ingweb",
                  id: "getContactIdInteraction",
                  telefone: telefonesplit,
                },
                localStorage.getItem("url_iframe"),
              );
            }
          }, [3000]);

          dispatch(
            addInteractionIngDesk({
              clientId: null,
              clientName: telefonesplit,
              channelId: parseInt(mediaId),
              channelName: nameChannel,
              destination: telefonesplit,
              protocol: null,
            }),
          );

          if (interactioningdesk.length !== 0) {
            let numprotocolo = "";

            if (
              parseInt(telefonesplit) ===
              parseInt(interactioningdesk.payload.destination)
            ) {
              let channel = nameChannel;

              let jsonIngDesk = {
                origin: "ingweb",
                id: "currentInteraction",
                payload: {
                  clientId: interactioningdesk.payload.clientId,
                  clientName: interactioningdesk.payload.clientName,
                  channelId: parseInt(mediaId),
                  channelName: channel,
                  destination: interactioningdesk.payload.destination,
                  protocol: numprotocolo,
                }, /// testar voz se mandab
              };
              setTimeout(() => {
                connectionsapi.iframe_ref.current.contentWindow.postMessage(
                  jsonIngDesk,
                  localStorage.getItem("url_iframe"),
                );
              }, 300);
            }
          }

          console.log(
            "INGENIUM_STATUSCALL_insertserviceattendant_ANTES_DO_IF_0",
            idatendimento,
          );

          console.log(
            "INGENIUM_STATUSCALL_insertserviceattendant_ANTES_DO_IF_1",
            atendimento,
          );

          if (idatendimento !== undefined) {
            console.log("INGENIUM_CHECK_ATD_ACW");

            console.log("INGENIUM_SERVICEOUT : ", informationusers);

            if (direction === 2) idsubservico = informationusers.serviceout;
            console.log(
              "INGENIUM_STATUSCALL_insertserviceattendant_INICIO_0",
              idatendimento,
            );
            console.log(
              "INGENIUM_STATUSCALL_insertserviceattendant_INICIO_1",
              informationusers.id,
            );
            console.log(
              "INGENIUM_STATUSCALL_insertserviceattendant_INICIO_2",
              telefonesplit,
            );
            console.log(
              "INGENIUM_STATUSCALL_insertserviceattendant_INICIO_3",
              direcao,
            );
            console.log(
              "INGENIUM_STATUSCALL_insertserviceattendant_INICIO_4",
              idsubservico,
            );
            console.log(
              "INGENIUM_STATUSCALL_insertserviceattendant_INICIO_5",
              idServiceWait,
            );

            const attemptInsertServiceAttendant = (
              retriesLeft,
              retryDelay,
              idatendimento,
              informationusers,
              telefonesplit,
              direcao,
              idsubservico,
              idServiceWait,
            ) => {
              const insertServiceAttendantUrl = `${
                connection_platform.type_connect
              }://${pathname}:${port}/conn/insertserviceattendant?idcdr=${idatendimento}&iduser=${
                informationusers.id
              }&telefone=${telefonesplit}&descricao=${direcao}&serviceinid=${idsubservico}&srvwaitid=${
                idServiceWait > 0 ? idServiceWait : null
              }`;
              axios
                .get(insertServiceAttendantUrl)
                .then((response) => {
                  console.log(
                    "INGENIUM_STATUSCALL_insertserviceattendant_SUCESSO_0",
                    response,
                  );
                  let retornoatt = response.data.id;
                  console.log(
                    "INGENIUM_STATUSCALL_insertserviceattendant_SUCESSO_1",
                    retornoatt,
                  );
                  dispatch(changeServiceAtd(idatendimento, retornoatt));
                  atendimentoOnCdr[idatendimento] = response.data.id;
                  dateOnCdr[idatendimento] = Moment().format(
                    "YYYY/MM/DD HH:mm:ss",
                  );

                  let infoinitcall = arrayinfoTo[idatendimento];
                  let numberIms = null;
                  if (direction !== 2) {
                    numberIms = infsip;
                  }

                  dispatch(getDataTachadowebrtc(idatendimento));
                  dispatch(
                    getPesquisaSatisfacao(
                      parseInt(telefonesplit),
                      idatendimento,
                    ),
                  );

                  if (
                    infsip.search("cfbt") === -1 ||
                    infsip.search("cfct") === -1
                  ) {
                    if (direction === 2) {
                      dispatch(
                        createStatusAgent(
                          "Discando",
                          "S.(" + telefonesplit + ")",
                          Moment().format("DD/MM/YYYY HH:mm:ss"),
                        ),
                      );
                    } else {
                      dispatch(
                        createStatusAgent(
                          "Discando",
                          "E.(" + telefonesplit + ")",
                          Moment().format("DD/MM/YYYY HH:mm:ss"),
                        ),
                      );
                    }
                  }
                  if (direction !== 2) {
                    direcao = "Entrada";
                    let datatimeAns = Moment().format("DD/MM/YYYY HH:mm:ss");

                    if (parseInt(ipcurrent.difftime) < 0) {
                      datatimeAns = Moment()
                        .subtract(valorDiferenca, "seconds")
                        .format("DD/MM/YYYY HH:mm:ss");
                    } else {
                      datatimeAns = Moment()
                        .add(valorDiferenca, "seconds")
                        .format("DD/MM/YYYY HH:mm:ss");
                    }
                    dispatch(
                      incrementInfoUsers(
                        informationusers.email,
                        informationusers.password,
                        informationusers.id,
                        informationusers.displayname,
                        informationusers.grupo,
                        informationusers.ramal,
                        informationusers.idgroup,
                        informationusers.username,
                        informationusers.idsupervisao,
                        informationusers.sipid,
                        informationusers.acessofila,
                        informationusers.semdefinicao,
                        informationusers.supervisor,
                        parseInt(informationusers.inanscount) + 1,
                        parseInt(informationusers.incallcount) + 1,
                        informationusers.intmans,
                        informationusers.outanscount,
                        informationusers.outcallcount,
                        informationusers.outtmans,
                        informationusers.psdcount,
                        informationusers.psdtma,
                        informationusers.tmlogin,
                        informationusers.atdauto,
                        informationusers.idin,
                        informationusers.idout,
                      ),
                    );
                  }
                })
                .catch((err) => {
                  console.error(
                    "INGENIUM_insertserviceattendant_ERROR",
                    err,
                    "retriesLeft:",
                    retriesLeft,
                  );
                  if (retriesLeft > 0) {
                    setTimeout(
                      () =>
                        attemptInsertServiceAttendant(
                          retriesLeft - 1,
                          retryDelay,
                          idatendimento,
                          informationusers,
                          telefonesplit,
                          direcao,
                          idsubservico,
                          idServiceWait,
                        ),
                      retryDelay,
                    );
                  } else {
                    console.error(
                      "INGENIUM_insertserviceattendant_FAILED_ALL_RETRIES",
                      idatendimento,
                    );
                  }
                });
            };

            attemptInsertServiceAttendant(
              40,
              500,
              idatendimento,
              informationusers,
              telefonesplit,
              direcao,
              idsubservico,
              idServiceWait,
            );

            let actualUrl2 = `${connection_platform.type_connect}://${pathname}:${port}/conn/getcontactstonumber?number=${telefonesplit}`;
            actualUrl2 = `${connection_platform.type_connect}://${pathname}:${port}/conn/getcontactstonumberv2?number=${telefonesplit}`;
            axios.get(actualUrl2).then((response) => {
              if (response.data.length !== 0) {
                if (response.data !== null) {
                  let arraymenubot = "";

                  if (response.data.displayname !== null) {
                    if (
                      parseInt(response.data.displayname) !==
                      parseInt(telefonesplit)
                    ) {
                      let infoname =
                        "Nome Social: " + response.data.displayname;
                      arraymenubot = arraymenubot + infoname + "~¿";
                    }
                  }

                  if (response.data.email !== "") {
                    if (response.data.email !== null) {
                      let infoname = "Email: " + response.data.email;
                      arraymenubot = arraymenubot + infoname + "~¿";
                    }
                  }

                  if (response.data.empresa !== null) {
                    let infoname = "Empresa: " + response.data.empresa;
                    arraymenubot = arraymenubot + infoname + "~¿";
                  }
                  if (response.data.externcode !== null) {
                    let infocodext =
                      "Código externo: " + response.data.externcode;
                    arraymenubot = arraymenubot + infocodext + "~¿";
                  }
                  if (response.data.externcode_empresa !== null) {
                    let infoname =
                      "Código externo empresa: " +
                      response.data.externcode_empresa;
                    arraymenubot = arraymenubot + infoname + "~¿";
                  }
                  if (response.data.cnpj_empresa !== null) {
                    let infoname = "CNPJ: " + response.data.cnpj_empresa;
                    arraymenubot = arraymenubot + infoname + "~¿";
                  }
                  if (
                    Boolean(direction) &&
                    Boolean(parseInt(direction)) &&
                    parseInt(direction) === 2
                  ) {
                    let callType = "Tipo de chamada: Ativo";
                    arraymenubot = arraymenubot + callType + "~¿";
                  }
                  if (
                    Boolean(direction) &&
                    Boolean(parseInt(direction)) &&
                    parseInt(direction) === 1
                  ) {
                    let callType = "Tipo de chamada: Receptivo";
                    arraymenubot = arraymenubot + callType + "~¿";
                  }
                  //lógica aqui

                  const dispatchEditInfo = () => {
                    setTimeout(function () {
                      dispatch(
                        EditInfoCli(
                          idatendimento,
                          response.data.displayname,
                          arraymenubot,
                        ),
                      );
                    }, 1000);
                  };

                  try {
                    const hasCdr =
                      Boolean(idatendimento) || idatendimento === 0;
                    if (hasCdr) {
                      axios
                        .get(
                          `${connection_platform.type_connect}://${pathname}:${port}/conn/trunkByCDR?cdrid=${idatendimento}`,
                        )
                        .then((response2) => {
                          const hasData =
                            Boolean(response2) &&
                            Boolean(response2.data) &&
                            response2.data.success &&
                            Boolean(response2.data.data) &&
                            typeof response2.data.data === "object" &&
                            "tech" in response2.data.data &&
                            (Boolean(response2.data.data.tech) ||
                              response2.data.data.tech === 0);

                          if (hasData) {
                            arraymenubot =
                              arraymenubot +
                              `Tel Origem: ${response2.data.data.tech}` +
                              "~¿";
                          }
                        })
                        .catch((error) => {
                          console.error(
                            "Erro ao buscar trunkByCDR voz:",
                            error,
                          );
                        })
                        .finally(() => {
                          dispatchEditInfo();
                        });
                    } else {
                      dispatchEditInfo();
                    }
                    //obterDadosAdicionaisParaExibirEmDetalhes
                  } catch (error) {
                    console.log(
                      "erro verificação do número por meio do thrunkId: ",
                      error,
                    );
                    dispatchEditInfo();
                  }

                  // setTimeout(function () {
                  //   dispatch(
                  //     EditInfoCli(
                  //       idatendimento,
                  //       response.data.displayname,
                  //       arraymenubot
                  //     )
                  //   );
                  // }, 1000);
                  if (
                    response.data.externcode != null &&
                    connection_platform.nc2_integration === false &&
                    connection_platform.nc2_users.indexOf(
                      informationusers.ramal,
                    ) !== -1
                  ) {
                    serviceurl.map((url) => {
                      if (parseInt(url.iddirection) === parseInt(direction)) {
                        setTimeout(function () {
                          let checkexterncode =
                            url.param.indexOf(`{EXTERNCODE}`);
                          if (checkexterncode > 0) {
                            let urlalterada = url.param.replace(
                              "{EXTERNCODE}",
                              `${response.data.externcode}`,
                            );
                            window.open(`${urlalterada}`, "_blank");
                          }
                        }, 5000);
                      }
                    });
                  }
                }
              }
            });
            let actualUrl = `${connection_platform.type_connect}://${pathname}:${port}/conn/getmidiasnumber?number=${telefonesplit}`;
            actualUrl = `${connection_platform.type_connect}://${pathname}:${port}/conn/getmidiasnumberv2?number=${telefonesplit}`;
             setTimeout(function () {
              axios.get(actualUrl).then((response) => {
                if (response.data !== "") {
                    dispatch(
                      changeNumberDisponiblesChannel(
                        idatendimento,
                        response.data,
                      ),
                    );
                }
              });
             }, 5000);
          } else {
            console.error(
              "INGENIUM_STATUSCALL_insertserviceattendant_INGENIUM_SEM_IDATENDIMENTO",
            );

            enviarLogErroInsert({
              idatendimento: idatendimento,
              iduser: informationusers.id,
              telefone: telefonesplit,
              descricao: direcao,
              serviceinid: idsubservico,
              evt: evt,
              erro: "idatendimento undefined - nao entrou no fluxo",
            });
          }
        } else if (
          statusCall == "Ringing" &&
          dest.split("/")[0] != undefined &&
          (dest.split("/")[0] == "sigilo" ||
            dest.split("/")[0] == "itw" ||
            dest.split("/")[0] == "itv")
        ) {
          webphone_api.accept();

          if (dest.split("/")[0] == "itv") {
            ramalMonitoring = ramal;
          }
        } else if (
          statusCall == "CallConnect" &&
          dest.split("/")[0] != undefined &&
          dest.split("/")[0] == "itv"
        ) {
          let ramal = infsip.split("-")[1];

          if (
            parseInt(atendimento.idmidia) === 1 &&
            dest.split("/")[0] === "itv"
          ) {
            webphone_api.setline(parseInt(atendimento.line));
            webphone_api.hold(false);
            webphone_api.conference();
          }
        } else if (
          statusCall == "Ringing" &&
          infsip.search("sigilo") == -1 &&
          infsip.search("itv") == -1 &&
          infsip.search("itw") == -1 &&
          checkConsulta === false &&
          infsip.search("cfbt") === -1 &&
          infsip.search("cfct") === -1 &&
          checkSkill === true
        ) {
          if (connection_platform.play_callin !== "" && checkPlayIn) {
            var snd = new Audio(connection_platform.play_callin);
            snd.play();
            checkPlayIn = false;
          }

          duracaoderingini = Moment().format("YYYY/MM/DD HH:mm:ss");
          valorDiferenca = parseInt(Math.abs(Math.round(ipcurrent.difftime)));

          if (parseInt(ipcurrent.difftime) < 0) {
            duracaoderingini = Moment()
              .subtract(valorDiferenca, "seconds")
              .format("YYYY/MM/DD HH:mm:ss");
            datetimeBR = Moment()
              .subtract(valorDiferenca, "seconds")
              .format("DD/MM/YYYY HH:mm:ss");
          } else {
            duracaoderingini = Moment()
              .add(valorDiferenca, "seconds")
              .format("YYYY/MM/DD HH:mm:ss");
            datetimeBR = Moment()
              .add(valorDiferenca, "seconds")
              .format("DD/MM/YYYY HH:mm:ss");
          }

          if (idatendimento != undefined) {
            dispatch(editAtendimentoVoz(idatendimento, datetimeBR));
            dispatch(editmultiplesatdVoz(idatendimento, datetimeBR));
          }
          if (checkConsulta === false) {
            if (direction == 2) {
              dispatch(
                createStatusAgent(
                  "Chamando",
                  "S.(" + telefonesplit + ")",
                  Moment().format("DD/MM/YYYY HH:mm:ss"),
                ),
              );
            } else {
              dispatch(
                createStatusAgent(
                  "Chamando",
                  "E.(" + telefonesplit + ")",
                  Moment().format("DD/MM/YYYY HH:mm:ss"),
                ),
              );
            }
            if (informationusers.blockfuture === false) {
              InsertPausaRVATD(sipid, userid, dispatch);
            }
          }
          let arrayAtdJson = [];
          let existNumberAndChannel = false;
          atdsimult.map((atd) => {
            if (
              (parseInt(atd.idmidia) === 1 || parseInt(atd.idmidia) === 16) &&
              parseInt(atd.telefone) === parseInt(telefonesplit)
            )
              existNumberAndChannel = true;

            arrayAtdJson.push({
              idmidia: atd.idmidia,
              telefone: atd.telefone,
            });
          });
          if (!existNumberAndChannel) {
            arrayAtdJson.push({
              idmidia: isWhatsVoz && direction === 2 ? 16 : 1,
              telefone: telefonesplit,
            });
          }
          let jsonChannelPhoneCall = mountCallsStatus(arrayAtdJson);

          let data_hora_atual = Moment().format("YYYY/MM/DD HH:mm:ss");
          let duracaoLoginAtual = Moment(data_hora_atual).diff(
            informationusers.datalogin,
            "seconds",
          );
          let duracaoLoginFinal =
            parseInt(duracaoLoginAtual) + parseInt(informationusers.tmlogin);

          let datatimeStatus = Moment().format("DD/MM/YYYY HH:mm:ss");
          let valorDiferencaStatus = parseInt(
            Math.abs(Math.round(ipcurrent.difftime)),
          );
          let strPauseFuture = informationusers.blockfuture ? 1 : 0;
          let descPauseFuture = informationusers.blockfuture
            ? descfuturepause
            : " ";

          if (parseInt(ipcurrent.difftime) < 0) {
            datatimeStatus = Moment()
              .subtract(valorDiferencaStatus, "seconds")
              .format("DD/MM/YYYY HH:mm:ss");
          } else {
            datatimeStatus = Moment()
              .add(valorDiferencaStatus, "seconds")
              .format("DD/MM/YYYY HH:mm:ss");
          }

          socket.send(
            "REQ\r\n" +
              informationusers.id +
              "\r\nUSERNAME\r\n" +
              informationusers.username +
              "\r\nDISPLAYNAME\r\n" +
              informationusers.displayname +
              "\r\nEXTEN\r\n" +
              informationusers.ramal +
              "\r\nREASON\r\n" +
              telefonesplit +
              "\r\nSTATUS\r\nCHND\r\nSTATUSID\r\n-1\r\nHOUR\r\n" +
              datatimeStatus +
              "-00:00:00\r\nDESCRIPTION\r\n" +
              telefonesplit +
              "\r\nEMAIL\r\n \r\nGROUP\r\n" +
              informationusers.idgroup +
              "\r\nDTL\r\n" +
              datatimeStatus +
              "\r\nGROUPNAME\r\n" +
              informationusers.grupo +
              "\r\nPSDCOUNT\r\n" +
              informationusers.psdcount +
              "\r\nPSDTMA\r\n" +
              parseInt(informationusers.psdtma) +
              "\r\nMNGGROUP\r\n-1\r\nINCALLCOUNT\r\n" +
              (parseInt(informationusers.incallcount) + 1) +
              "\r\nINANSCOUNT\r\n" +
              (parseInt(informationusers.inanscount) + 1) +
              "\r\nINTMANS\r\n" +
              informationusers.intmans +
              "\r\nINSLA\r\n100\r\nOUTCALLCOUNT\r\n" +
              parseInt(informationusers.outcallcount) +
              "\r\nOUTANSCOUNT\r\n" +
              parseInt(informationusers.outanscount) +
              "\r\nOUTTMANS\r\n" +
              informationusers.outtmans +
              "\r\nCOUNTFPAUSE\r\n" +
              parseInt(informationusers.psdfbreak) +
              "\r\nOUTSLA\r\n100\r\nDESCFUTUREPAUSE\r\n" +
              descPauseFuture +
              "\r\nINITIALLOGIN\r\n0\r\nTMLOGIN\r\n" +
              duracaoLoginFinal +
              "\r\nJSON\r\n" +
              jsonChannelPhoneCall +
              "\r\nCDRID\r\n" +
              idatendimento +
              "\r\nMEDIAID\r\n" +
              parseInt(arrayAtdJson[0].idmidia) +
              "\r\nFUTUREPAUSE\r\n" +
              strPauseFuture +
              "\r\nSRVIN\r\n \r\nDIRECTIONCHND\r\n" +
              direction +
              "\r\n\r\n",
          );
          statusAgentIMSDN = "CHND";
          if (strPauseFuture === 1) {
            stAgIMSDN = "RV";
          } else {
            stAgIMSDN = "CHND";
          }
          console.log(
            "INGENIUM_ENVIOSTATUS :",
            new Date().toLocaleString(),
            stAgIMSDN,
          );
          requestStatusAgent =
            "REQ\r\n" +
            informationusers.id +
            "\r\nUSERNAME\r\n" +
            informationusers.username +
            "\r\nDISPLAYNAME\r\n" +
            informationusers.displayname +
            "\r\nEXTEN\r\n" +
            informationusers.ramal +
            "\r\nREASON\r\n" +
            telefonesplit +
            "\r\nSTATUS\r\nCHND\r\nSTATUSID\r\n-1\r\nHOUR\r\n" +
            datatimeStatus +
            "-00:00:00\r\nDESCRIPTION\r\n" +
            telefonesplit +
            "\r\nEMAIL\r\n \r\nGROUP\r\n" +
            informationusers.idgroup +
            "\r\nDTL\r\n" +
            datatimeStatus +
            "\r\nGROUPNAME\r\n" +
            informationusers.grupo +
            "\r\nPSDCOUNT\r\n" +
            informationusers.psdcount +
            "\r\nPSDTMA\r\n" +
            parseInt(informationusers.psdtma) +
            "\r\nMNGGROUP\r\n-1\r\nINCALLCOUNT\r\n" +
            (parseInt(informationusers.incallcount) + 1) +
            "\r\nINANSCOUNT\r\n" +
            (parseInt(informationusers.inanscount) + 1) +
            "\r\nINTMANS\r\n" +
            informationusers.intmans +
            "\r\nINSLA\r\n100\r\nOUTCALLCOUNT\r\n" +
            parseInt(informationusers.outcallcount) +
            "\r\nOUTANSCOUNT\r\n" +
            parseInt(informationusers.outanscount) +
            "\r\nOUTTMANS\r\n" +
            informationusers.outtmans +
            "\r\nCOUNTFPAUSE\r\n" +
            parseInt(informationusers.psdfbreak) +
            "\r\nOUTSLA\r\n100\r\nDESCFUTUREPAUSE\r\n" +
            descPauseFuture +
            "\r\nINITIALLOGIN\r\n0\r\nTMLOGIN\r\n" +
            duracaoLoginFinal +
            "\r\nJSON\r\n" +
            jsonChannelPhoneCall +
            "\r\nCDRID\r\n" +
            idatendimento +
            "\r\nMEDIAID\r\n" +
            parseInt(arrayAtdJson[0].idmidia) +
            "\r\nFUTUREPAUSE\r\n" +
            strPauseFuture +
            "\r\nSRVIN\r\n \r\nDIRECTIONCHND\r\n" +
            direction +
            "\r\n\r\n";
          clearInterval(statusIntervalAgent);
          envioStatusAgente(8448, informationusers.sipid);

          if (
            parseInt(direction) === 1 &&
            informationusers.atdauto === false &&
            checkCapturaFila[idatendimento] !== true
          ) {
            if (!isMobileDevice()) {
              spawnNotification({
                opt: {
                  body: "IngWeb",
                  icon: LOGOINGWEB,
                },
                title:
                  "Chamada de entrada : " +
                  telefonesplit +
                  "\nServiço : " +
                  nomesubservico,
              });
            }

            let position = toast.POSITION.BOTTOM_RIGHT;

            if (localStorage.getItem("position-popup")) {
              const getPosition = JSON.parse(
                localStorage.getItem("position-popup"),
              );
              switch (getPosition.position) {
                case "top-left":
                  position = toast.POSITION.TOP_LEFT;
                  break;
                case "top-right":
                  position = toast.POSITION.TOP_RIGHT;
                  break;
                case "top-center":
                  position = toast.POSITION.TOP_CENTER;
                  break;
                case "bottom-left":
                  position = toast.POSITION.BOTTOM_LEFT;
                  break;
                case "bottom-center":
                  position = toast.POSITION.BOTTOM_CENTER;
                  break;
                case "bottom-right":
                  position = toast.POSITION.BOTTOM_RIGHT;
                  break;
                default:
                  position = toast.POSITION.BOTTOM_RIGHT;
                  break;
              }
            }

            toast(
              <CustomToastCallExt
                mcdu={mcdu}
                telefone={telefonesplit}
                nomeousub={nomeousub}
                nomesubservico={nomesubservico}
              />,
              {
                autoClose: false,
                position: position,
                draggable: false,
                closeOnClick: false,
                toastId: idatendimento,
                closeButton: false,
                containerId: idatendimento,
              },
            );
          } else if (
            parseInt(direction) === 1 &&
            informationusers.atdauto === true
          ) {
            AceitarChamada();
          } else if (
            parseInt(direction) === 1 &&
            checkCapturaFila[idatendimento] === true
          ) {
            AceitarChamada();
          }
          // }
        } else if (
          statusCall == "CallConnect" &&
          infsip.search("sigilo") == -1 &&
          checkConsulta === false &&
          dest.split("/")[0] != "sigilo" &&
          infsip.search("itw") == -1 &&
          dest.split("/")[0] != "itw" &&
          infsip.search("itv") == -1 &&
          dest.split("/")[0] != "itv" &&
          checkConsulta === false
        ) {
          axios.get(
            `${connection_platform.type_connect}://${pathname}:${port}/conn/updatebyeattendantvozanswer?idatendimento=${atendimento.serviceatd}&status=${atendimento.statusagent}`,
          );
          const isToPauseInFuture = verifyIfIsAfterStatusPause(
            getState().atdsimult,
            getState().isFuturePauseActive,
            reconnectionHandler.isReconnecting,
          );

          dispatch(
            UpdatePauseFutureRV(
              informationusers,
              "RV",
              atendimento,
              status.afterReason,
              status.afterIdReason,
              // status.afterIsReasonLogout,
              isToPauseInFuture,
            ),
          );

          let strCaseId = "";

          if (informationusers.nameauth === "IngDesk") {
            axios
              .get(
                `${connection_platform.type_connect}://${pathname}:${port}/conn/getcaseidingdesk?cdrid=${idatendimento}`,
              )
              .then((response) => {
                if (response.data.length > 0) {
                  setTimeout(function () {
                    strCaseId = response.data[0].caseid;
                    dispatch(
                      changeAtdIngDeskSuccess(telefonesplit, "", "", strCaseId),
                    );
                    dispatch(
                      isSaveInteractionIngDesk({
                        caseId: strCaseId,
                        isSendLog: true,
                      }),
                    );
                    dispatch(
                      changeAtdIngDesk(telefonesplit, "", "", strCaseId),
                    );

                    dispatch(ShowVisibleNextAtd("ocultar", true));
                  }, 1500);
                }
              });
          }

          anomesdia = Moment().format("YYYYMMDD");
          horagravacao = Moment().format("HH");
          checkPlayIn = true;

          let serverport = "";
          let serverlogin = "";
          let serverpasswd = "";
          let serveraddress = "";
          numrandom = Math.floor(Math.random() * 10000);

          randomAtd[idatendimento] = numrandom;

          gravacaovoz.map((grav) => {
            if (parseInt(grav.iddirection) === parseInt(direction)) {
              servicecode = grav.servicecode;
              serveraddress = grav.serveraddress;
              serverport = grav.serverport;
              serverlogin = grav.serverlogin;
              serverpasswd = grav.serverpasswd;
            }
          });

          var now = Moment().format("YYYY/MM/DD HH:mm:ss");

          valorDiferenca = parseInt(Math.abs(Math.round(ipcurrent.difftime)));

          if (parseInt(ipcurrent.difftime) < 0) {
            now = Moment()
              .subtract(valorDiferenca, "seconds")
              .format("YYYY/MM/DD HH:mm:ss");
            datetimeBR = Moment()
              .subtract(valorDiferenca, "seconds")
              .format("DD/MM/YYYY HH:mm:ss");
          } else {
            now = Moment()
              .add(valorDiferenca, "seconds")
              .format("YYYY/MM/DD HH:mm:ss");
            datetimeBR = Moment()
              .add(valorDiferenca, "seconds")
              .format("DD/MM/YYYY HH:mm:ss");
          }

          if (parseInt(duracaoderingini) > 0) {
            contduracaodocall = Moment(now).diff(
              duracaoderingini,
              "seconds",
              true,
            );
          } else {
            contduracaodocall = 0;
          }

          let queueid = "";
          let checkqueue = false;

          listcallqueue.map((queue) => {
            if (parseInt(queue.cdrnew) === parseInt(idatendimento)) {
              queueid = queue.queueid;
              checkqueue = true;
            }
          });
          if (checkqueue == true) {
            dispatch(deleteListCallQueue(queueid));
            axios.get(
              `${connection_platform.type_connect}://${pathname}:${port}/conn/clearqueue?cdr=${idatendimento}&queueid=${queueid}&novocdr=${idatendimento}&usuario=${informationusers.id}&opcao=t&media=1`,
            );
            socket.send(
              "CALLQUEUE\r\n" +
                informationusers.id +
                "\r\nQUEUEID\r\n" +
                queueid +
                "\r\nCDRID\r\n" +
                idatendimento +
                "\r\nTP\r\nRM\r\nCBACKCOUNT\r\n0\r\nTMCBACK\r\n0\r\nCQUEUE\r\n0\r\nUSERNAME\r\n" +
                informationusers.username +
                "\r\nCDRIDNEW\r\n" +
                queueid +
                "\r\n\r\n",
            );
          }
          dispatch(editAtendimentoVoz(idatendimento, datetimeBR));
          dispatch(editmultiplesatdVoz(idatendimento, datetimeBR));
          let arrayAtdJson = [];
          let existNumberAndChannel = false;
          let idMidiaBlock = isWhatsVoz && direction === 2 ? 16 : 1;

          for (const atd of atdsimult) {
            if (
              (parseInt(atd.idmidia) === 1 || parseInt(atd.idmidia) === 16) &&
              parseInt(atd.telefone) === parseInt(telefonesplit)
            ) {
              existNumberAndChannel = true;
              idMidiaBlock = atd.idmidia;
            }

            arrayAtdJson.push({
              idmidia: atd.idmidia,
              telefone: atd.telefone,
            });
          }
          if (!existNumberAndChannel) {
            arrayAtdJson.push({
              idmidia: idMidiaBlock,
              telefone: telefonesplit,
            });
          }
          let jsonChannelPhoneCall = mountCallsStatus(arrayAtdJson);

          let data_hora_atual = Moment().format("YYYY/MM/DD HH:mm:ss");
          let duracaoLoginAtual = Moment(data_hora_atual).diff(
            informationusers.datalogin,
            "seconds",
          );
          let duracaoLoginFinal =
            parseInt(duracaoLoginAtual) + parseInt(informationusers.tmlogin);

          let datatimeStatus = Moment().format("DD/MM/YYYY HH:mm:ss");
          let valorDiferencaStatus = parseInt(
            Math.abs(Math.round(ipcurrent.difftime)),
          );
          let strPauseFuture = informationusers.blockfuture ? 1 : 0;
          let descPauseFuture = informationusers.blockfuture
            ? descfuturepause
            : " ";

          if (parseInt(ipcurrent.difftime) < 0) {
            datatimeStatus = Moment()
              .subtract(valorDiferencaStatus, "seconds")
              .format("DD/MM/YYYY HH:mm:ss");
          } else {
            datatimeStatus = Moment()
              .add(valorDiferencaStatus, "seconds")
              .format("DD/MM/YYYY HH:mm:ss");
          }
          socket.send(
            "REQ\r\n" +
              informationusers.id +
              "\r\nUSERNAME\r\n" +
              informationusers.username +
              "\r\nDISPLAYNAME\r\n" +
              informationusers.displayname +
              "\r\nEXTEN\r\n" +
              informationusers.ramal +
              "\r\nREASON\r\n" +
              telefonesplit +
              "\r\nSTATUS\r\nAT\r\nSTATUSID\r\n-1\r\nHOUR\r\n" +
              datatimeStatus +
              "-00:00:00\r\nDESCRIPTION\r\n" +
              telefonesplit +
              "\r\nEMAIL\r\n \r\nGROUP\r\n" +
              informationusers.idgroup +
              "\r\nDTL\r\n" +
              datatimeStatus +
              "\r\nGROUPNAME\r\n" +
              informationusers.grupo +
              "\r\nPSDCOUNT\r\n" +
              informationusers.psdcount +
              "\r\nPSDTMA\r\n" +
              parseInt(informationusers.psdtma) +
              "\r\nMNGGROUP\r\n-1\r\nINCALLCOUNT\r\n" +
              parseInt(informationusers.incallcount) +
              "\r\nINANSCOUNT\r\n" +
              parseInt(informationusers.inanscount) +
              "\r\nINTMANS\r\n" +
              informationusers.intmans +
              "\r\nINSLA\r\n100\r\nOUTCALLCOUNT\r\n" +
              parseInt(informationusers.outcallcount) +
              "\r\nOUTANSCOUNT\r\n" +
              parseInt(informationusers.outanscount) +
              "\r\nOUTTMANS\r\n" +
              informationusers.outtmans +
              "\r\nCOUNTFPAUSE\r\n" +
              parseInt(informationusers.psdfbreak) +
              "\r\nOUTSLA\r\n100\r\nDESCFUTUREPAUSE\r\n" +
              descPauseFuture +
              "\r\nINITIALLOGIN\r\n0\r\nTMLOGIN\r\n" +
              duracaoLoginFinal +
              "\r\nJSON\r\n" +
              jsonChannelPhoneCall +
              "\r\nCDRID\r\n" +
              idatendimento +
              "\r\nFUTUREPAUSE\r\n" +
              strPauseFuture +
              "\r\nSRVIN\r\n" +
              nomesubservico +
              "\r\nMEDIAID\r\n" +
              idMidiaBlock +
              "\r\n\r\n",
          );
          statusAgentIMSDN = "AT";
          if (strPauseFuture === 1) {
            stAgIMSDN = "RV";
          } else {
            stAgIMSDN = "AT";
          }
          console.log(
            "INGENIUM_ENVIOSTATUS :",
            new Date().toLocaleString(),
            stAgIMSDN,
          );
          requestStatusAgent =
            "REQ\r\n" +
            informationusers.id +
            "\r\nUSERNAME\r\n" +
            informationusers.username +
            "\r\nDISPLAYNAME\r\n" +
            informationusers.displayname +
            "\r\nEXTEN\r\n" +
            informationusers.ramal +
            "\r\nREASON\r\n" +
            telefonesplit +
            "\r\nSTATUS\r\nAT\r\nSTATUSID\r\n-1\r\nHOUR\r\n" +
            datatimeStatus +
            "-00:00:00\r\nDESCRIPTION\r\n" +
            telefonesplit +
            "\r\nEMAIL\r\n \r\nGROUP\r\n" +
            informationusers.idgroup +
            "\r\nDTL\r\n" +
            datatimeStatus +
            "\r\nGROUPNAME\r\n" +
            informationusers.grupo +
            "\r\nPSDCOUNT\r\n" +
            informationusers.psdcount +
            "\r\nPSDTMA\r\n" +
            parseInt(informationusers.psdtma) +
            "\r\nMNGGROUP\r\n-1\r\nINCALLCOUNT\r\n" +
            parseInt(informationusers.incallcount) +
            "\r\nINANSCOUNT\r\n" +
            parseInt(informationusers.inanscount) +
            "\r\nINTMANS\r\n" +
            informationusers.intmans +
            "\r\nINSLA\r\n100\r\nOUTCALLCOUNT\r\n" +
            parseInt(informationusers.outcallcount) +
            "\r\nOUTANSCOUNT\r\n" +
            parseInt(informationusers.outanscount) +
            "\r\nOUTTMANS\r\n" +
            informationusers.outtmans +
            "\r\nCOUNTFPAUSE\r\n" +
            parseInt(informationusers.psdfbreak) +
            "\r\nOUTSLA\r\n100\r\nDESCFUTUREPAUSE\r\n" +
            descPauseFuture +
            "\r\nINITIALLOGIN\r\n0\r\nTMLOGIN\r\n" +
            duracaoLoginFinal +
            "\r\nJSON\r\n" +
            jsonChannelPhoneCall +
            "\r\nCDRID\r\n" +
            idatendimento +
            "\r\nFUTUREPAUSE\r\n" +
            strPauseFuture +
            "\r\nSRVIN\r\n" +
            nomesubservico +
            "\r\nMEDIAID\r\n" +
            idMidiaBlock +
            "\r\n\r\n";
          clearInterval(statusIntervalAgent);
          envioStatusAgente(8845, informationusers.sipid);
          if (direction == 2) {
            setTimeout(() => {
              dispatch(
                createStatusAgent(
                  "Ligação",
                  "S.(" + telefonesplit + ")",
                  Moment().format("DD/MM/YYYY HH:mm:ss"),
                ),
              );
            }, 250);
          } else {
            setTimeout(() => {
              dispatch(
                createStatusAgent(
                  "Ligação",
                  "E.(" + telefonesplit + ")",
                  Moment().format("DD/MM/YYYY HH:mm:ss"),
                ),
              );
            }, 250);
          }
        } else if (
          statusCall == "Speaking" &&
          infsip.search("sigilo") == -1 &&
          checkConsulta === false &&
          dest.split("/")[0] != "sigilo" &&
          infsip.search("itw") == -1 &&
          dest.split("/")[0] != "itw" &&
          infsip.search("itv") == -1 &&
          dest.split("/")[0] != "itv" &&
          checkConsulta === false
        ) {
          let atendimentoSimult = getState().atdsimult;
          let qtdeatdvoz = atendimentoSimult.filter(
            (atd) => parseInt(atd.idmidia) === 1,
          );

          if (parseInt(qtdeatdvoz.length) <= 1) {
            let valorLineInternal = chatsimult.filter(
              (chat) => chat.voz === true,
            );
            if (valorLineInternal && valorLineInternal.length !== 0) {
              setTimeout(function () {
                webphone_api.setline(parseInt(valorLineInternal[0].line));
                if (!webphone_api.isonhold()) webphone_api.hold(true);
              }, 1500);
            }
          }
        } else if (statusCall == "Call") {
          ChangeAtdnow(informationusers, atendimento, atdsimult, ipcurrent);
          if (direction == 2) {
            dispatch(
              createStatusAgent(
                "Discando",
                "S.(" + telefonesplit + ")",
                Moment().format("DD/MM/YYYY HH:mm:ss"),
              ),
            );
          } else {
            dispatch(
              createStatusAgent(
                "Discando",
                "E.(" + telefonesplit + ")",
                Moment().format("DD/MM/YYYY HH:mm:ss"),
              ),
            );
          }
        } else if (
          (statusCall === "CallDisconnect" || statusCall === "Deletable") &&
          checkConsulta === false &&
          dest.split("/")[0] != "sigilo" &&
          dest.split("/")[0] != "itw" &&
          dest.split("/")[0] != "itv" &&
          infsip.search("sigilo") == -1 &&
          infsip.search("itw") == -1 &&
          infsip.search("itv") == -1 &&
          infsip != undefined &&
          infoserv.search("-") != -1
        ) {
          toast.dismiss();
          console.log("INGENIUM_VOICE_REMOVEATD_0");

          if (atendimento.respatendente === true) {
            console.log(
              "INGENIUM_VOICE_REMOVEATD_1",
              atendimento.idatendimento,
            );
            console.log("INGENIUM_VOICE_REMOVEATD_1_1", idatendimento);

            dispatch(removeConversation(atendimento.idatendimento));
            dispatch(RemoveAtd(atendimento.idatendimento));
            webphone_api.setline(parseInt(atendimento.line));

            let comando =
              infsip +
              "=" +
              atendimento.idatendimento +
              "=4=+0++0=cfct=" +
              informationusers.ramal +
              "+" +
              atendimento.telefone +
              "=" +
              informationusers.displayname +
              "=" +
              atendimentoOnCdr[idatendimento] +
              "=1=1=1=1=1=1=1=2=1=1=0=1=0=" +
              atendimento.idsubservico +
              "=2=";
            webphone_api.transfer(comando);
          }
          dispatch(capturaFila(false));
          var now = Moment().format("YYYY/MM/DD HH:mm:ss");
          let valorDiferenca = parseInt(
            Math.abs(Math.round(ipcurrent.difftime)),
          );

          if (parseInt(ipcurrent.difftime) < 0) {
            now = Moment()
              .subtract(valorDiferenca, "seconds")
              .format("YYYY/MM/DD HH:mm:ss");
          } else {
            now = Moment()
              .add(valorDiferenca, "seconds")
              .format("YYYY/MM/DD HH:mm:ss");
          }

          var duracaodocall = Moment(now).diff(
            atendimento.timecomplete,
            "seconds",
            true,
          );
          let dataformatada = Moment(
            atendimento.datatimeatd,
            "YYYY/MM/DD HH:mm:ss",
          ).format("YYYY-MM-DD HH:mm:ss");
          let chamador = telefonesplit;
          let chamado = informationusers.ramal;

          let duracaoformatada = Moment(
            atendimento.datatimeatd,
            "YYYY/MM/DD HH:mm:ss",
          ).format("YYYY-MM-DD HH:mm:ss");

          let namefile =
            "\\\\\\\\192.168.178.2\\\\rec\\\\0000" +
            servicecode +
            "\\" +
            anomesdia +
            "\\" +
            horagravacao +
            "\\" +
            informationusers.ramal +
            "_" +
            idatendimento +
            "_" +
            randomAtd[idatendimento] +
            ".wav";

          if (direction == "2") {
            chamador = informationusers.ramal;
            chamado = telefonesplit;
          }

          if (contduracaodocall == 0) {
            var now = Moment().format("YYYY/MM/DD HH:mm:ss");

            valorDiferenca = parseInt(Math.abs(Math.round(ipcurrent.difftime)));

            if (parseInt(ipcurrent.difftime) < 0) {
              now = Moment()
                .subtract(valorDiferenca, "seconds")
                .format("YYYY/MM/DD HH:mm:ss");
            } else {
              now = Moment()
                .add(valorDiferenca, "seconds")
                .format("YYYY/MM/DD HH:mm:ss");
            }
            if (parseInt(duracaoderingini) > 0) {
              contduracaodocall = Moment(now).diff(
                duracaoderingini,
                "seconds",
                true,
              );
            } else {
              contduracaodocall = 0;
            }
          }

          var now = Moment().format("YYYY/MM/DD HH:mm:ss");

          valorDiferenca = parseInt(Math.abs(Math.round(ipcurrent.difftime)));

          if (parseInt(ipcurrent.difftime) < 0) {
            now = Moment()
              .subtract(valorDiferenca, "seconds")
              .format("YYYY/MM/DD HH:mm:ss");
          } else {
            now = Moment()
              .add(valorDiferenca, "seconds")
              .format("YYYY/MM/DD HH:mm:ss");
          }

          duracaodocall = Moment(now).diff(
            atendimento.timecomplete,
            "seconds",
            true,
          );

          dispatch(
            EditIndicatorsUser(
              parseInt(atendimento.direction) === 2
                ? duracaodocall + parseInt(informationusers.outtmans)
                : parseInt(informationusers.outtmans),
              parseInt(atendimento.direction) === 1
                ? duracaodocall + parseInt(informationusers.intmans)
                : parseInt(informationusers.intmans),
            ),
          );
          if (idatendimento != 0) {
            if (
              parseInt(atendimento.idmidia) !== 1 &&
              parseInt(atendimento.idmidia) !== 16 &&
              atendimento.idmidia
            ) {
              socket.send(
                "WSIBYE\r\n" +
                  informationusers.id +
                  "\r\nTOUSER\r\n" +
                  atendimento.serverid +
                  "\r\nTOCLIENT\r\n" +
                  idatendimento +
                  "\r\n\r\n",
              );
            }
            dispatch(
              InterationNotifier(
                "Interação Encerrada com " + telefonesplit,
                "call",
              ),
            );
            dispatch(GetAnotations([]));
            dispatch(GetMarkstar([]));
            dispatch(GetHistory([]));

            // o atendimento em curso correto não entra aqui
            let atdcurso = atdsimult.filter(
              (atd) => atd.idatendimento === idatendimento,
            );

            if (atdcurso.length !== 0) {
              atdcurso = atdcurso[0];
            }

            if (atdsimult.length > 1) {
              dispatch(removeConversation(idatendimento));

              let qtdeatdvoz = atdsimult.filter(
                (atd) =>
                  (parseInt(atd.idmidia) === 1 ||
                    parseInt(atd.idmidia) === 16) &&
                  atd.idatendimento !== idatendimento,
              );

              if (parseInt(qtdeatdvoz.length) === 0) {
                let valorLineInternal = chatsimult.filter(
                  (chat) => chat.voz === true,
                );
                if (valorLineInternal && valorLineInternal.length !== 0) {
                  webphone_api.setline(parseInt(valorLineInternal[0].line));
                  if (webphone_api.isonhold()) webphone_api.hold(false);
                }
              } else {
                webphone_api.setline(parseInt(qtdeatdvoz[0].line));
                if (webphone_api.isonhold()) webphone_api.hold(false);
              }
              //INGTRANSFER_1111111: 1 71996390675+0370 undefined
              if (
                informationusers.tmoutacw === 0 ||
                (informationusers.tmoutacw !== 0 && atdcurso.acw === true)
              ) {
                console.log("INGENIUM_VOICE_ACW_1", atdcurso);
                const isToIgnoreRemoveAtd =
                  getState().atdsimult.length > 1 &&
                  informationusers.tmoutacw !== 0 &&
                  atdcurso.acw === true;
                if (!isToIgnoreRemoveAtd) {
                  console.log("INGENIUM_VOICE_REMOVEATD_2", idatendimento);
                  dispatch(RemoveAtd(idatendimento));
                }
              } else if (
                informationusers.tmoutacw !== 0 &&
                atdcurso.acw === false
              ) {
                console.log("INGENIUM_VOICE_ACW_2", atdcurso);
                if (
                  parseInt(atendimento.idatendimento) !==
                  parseInt(idatendimento)
                ) {
                  console.log("INGENIUM_VOICE_ACW_2_1", idatendimento);
                  console.log(
                    "INGENIUM_VOICE_ACW_2_2",
                    atendimento.idatendimento,
                  );
                  dispatch(EditAcwContact(idatendimento));
                  if (informationusers.classificationcount > 0) {
                    dispatch(
                      EditIsTabulatorToClassification(idatendimento, false),
                    );
                  }
                  dispatch(
                    tratarAfterCallWorkCDR(
                      informationusers.tmoutacw,
                      parseInt(idatendimento),
                      false,
                    ),
                  );
                } else {
                  dispatch(
                    createStatusAgent(
                      "Aftercallwork",
                      atdcurso.telefone,
                      Moment().format("DD/MM/YYYY HH:mm:ss"),
                    ),
                  );
                  dispatch(EditAcwContact(idatendimento));
                  if (informationusers.classificationcount > 0) {
                    dispatch(
                      EditIsTabulatorToClassification(idatendimento, false),
                    );
                  }
                  dispatch(
                    tratarAfterCallWork(
                      informationusers.tmoutacw,
                      parseInt(atdcurso.serviceatd),
                      false,
                    ),
                  );
                }
              } else if (informationusers.tmoutacw !== 0 && !atdcurso.acw) {
                console.log("INGENIUM_VOICE_ACW_3", atdcurso);
                dispatch(
                  createStatusAgent(
                    "Aftercallwork",
                    atdcurso.telefone,
                    Moment().format("DD/MM/YYYY HH:mm:ss"),
                  ),
                );
                dispatch(EditAcwContact(atendimento.idatendimento));
                if (informationusers.classificationcount > 0) {
                  console.log(
                    "INGENIUM_VOICE_ACW_3_1",
                    informationusers.classificationcount,
                  );
                  console.log(
                    "INGENIUM_VOICE_ACW_3_2",
                    atendimento.idatendimento,
                  );
                  dispatch(
                    EditIsTabulatorToClassification(
                      atendimento.idatendimento,
                      false,
                    ),
                  );
                }
                dispatch(
                  tratarAfterCallWork(
                    informationusers.tmoutacw,
                    parseInt(atendimento.serviceatd),
                    false,
                  ),
                );
              }

              if (informationusers.tmoutacw === 0) {
                let i = 0;
                if (atdsimult[0].idatendimento == idatendimento) i = 1;
                if (!informationusers.blockscreen) {
                  const isCurrentAtt =
                    parseInt(idatendimento) ===
                    parseInt(atendimento.idatendimento);
                  if (isCurrentAtt) {
                    const storageAtdActually =
                      localStorage.getItem("current-service");
                    if (
                      storageAtdActually &&
                      parseInt(atendimento.idatendimento) !==
                        parseInt(storageAtdActually)
                    ) {
                      const indice = atdsimult.findIndex(
                        (item) =>
                          parseInt(item.idatendimento) ===
                          parseInt(storageAtdActually),
                      );
                      if (indice !== -1) {
                        i = indice;
                        localStorage.removeItem("current-service");
                      }
                    }
                    ProximoAtdSimult(
                      atdsimult[i],
                      messages,
                      atendimento,
                      informationusers,
                      dispatch,
                      ipcurrent,
                      atdsimult,
                    );
                  }
                  console.log("23j4j235jj235");
                } else {
                  NextAnswerAfterBlock(
                    atdsimult[i],
                    messages,
                    atendimento,
                    informationusers,
                    dispatch,
                    ipcurrent,
                    atdsimult,
                  );
                }
              } else if (
                informationusers.tmoutacw !== 0 &&
                atdsimult[0].idatendimento === true
              ) {
                console.log("INGENIUM_VOICE_ACW_4");
                let i = 0;
                if (atdsimult[0].idatendimento == idatendimento) i = 1;
                if (!informationusers.blockscreen) {
                  console.log("INGENIUM_VOICE_ACW_4_1", idatendimento);
                  console.log(
                    "INGENIUM_VOICE_ACW_4_2",
                    atendimento.idatendimento,
                  );
                  const isCurrentAtt =
                    parseInt(idatendimento) ===
                    parseInt(atendimento.idatendimento);
                  if (isCurrentAtt) {
                    console.log("INGENIUM_VOICE_ACW_4_3", atdsimult[i]);
                    ProximoAtdSimult(
                      atdsimult[i],
                      messages,
                      atendimento,
                      informationusers,
                      dispatch,
                      ipcurrent,
                      atdsimult,
                    );
                  }
                  console.log("23j4j235jj235");
                } else {
                  console.log("INGENIUM_VOICE_ACW_4_4");
                  NextAnswerAfterBlock(
                    atdsimult[i],
                    messages,
                    atendimento,
                    informationusers,
                    dispatch,
                    ipcurrent,
                    atdsimult,
                  );
                }
              }
            } else if (atdsimult.length > 1 && atendimento.line != "0") {
              if (atendimento.direction == "2") {
                setTimeout(() => {
                  dispatch(
                    createStatusAgent(
                      "Ligação",
                      "S.(" + atendimento.telefone + ")",
                      Moment().format("DD/MM/YYYY HH:mm:ss"),
                    ),
                  );
                }, 250);
              } else {
                setTimeout(() => {
                  dispatch(
                    createStatusAgent(
                      "Ligação",
                      "E.(" + atendimento.telefone + ")",
                      Moment().format("DD/MM/YYYY HH:mm:ss"),
                    ),
                  );
                }, 250);
              }
            } else if (atdsimult.length <= 1) {
              // chatsimult.map((chat) => {
              //   if (parseInt(iduser) === parseInt(chat.iduserout)) {
              //     checkChatSimullt = true;
              //   }
              // });
              let valorLineInternal = chatsimult.filter(
                (chat) => chat.voz === true,
              );

              if (valorLineInternal.length !== 0) {
                webphone_api.setline(parseInt(valorLineInternal[0].line));
                if (webphone_api.isonhold()) webphone_api.hold(false);
              }
            } else if (atendimento.line == "0") {
              dispatch(
                createStatusAgent(
                  "Atendimento",
                  "E.(" + atendimento.telefone + ")",
                  Moment().format("DD/MM/YYYY HH:mm:ss"),
                ),
              );
            }
            webphone_api.onCdr(
              function (
                caller,
                called,
                connecttime,
                duration,
                direction,
                peerdisplayname,
                reason,
                line,
              ) {
                if (checkDisconnect === false) {
                  //if(reason!=="Not Found"){
                  checkDisconnect = true;
                  let consultaInternaCdr = "";
                  let checkConsultaCdr = false;
                  consultaInternaCdr = caller.split("-");
                  if (
                    (consultaInternaCdr[0] === "" ||
                      consultaInternaCdr[0] === undefined) &&
                    caller.search("-") !== -1
                  ) {
                    checkConsultaCdr = true;
                  }

                  let contduracaodoring = parseInt(connecttime / 1000);
                  durationans =
                    durationans == 0 ? informationusers.intmans : durationans;
                  durationoutans =
                    durationoutans == 0
                      ? informationusers.outtmans
                      : durationoutans;
                  let duracaoformatada = dateOnCdr[idatendimento];

                  let datatimeAns = Moment().format("DD/MM/YYYY HH:mm:ss");
                  let valorDiferenca = parseInt(
                    Math.abs(Math.round(ipcurrent.difftime)),
                  );

                  if (parseInt(ipcurrent.difftime) < 0) {
                    datatimeAns = Moment()
                      .subtract(valorDiferenca, "seconds")
                      .format("DD/MM/YYYY HH:mm:ss");
                  } else {
                    datatimeAns = Moment()
                      .add(valorDiferenca, "seconds")
                      .format("DD/MM/YYYY HH:mm:ss");
                  }
                  consultaInternaCdr = caller.split("-");

                  //    if(((consultaInternaCdr[0]==="" || consultaInternaCdr[0]===undefined)&& caller.search("-") !=-1 )){
                  // 	   checkConsultaCdr = true;
                  //    }

                  if (parseInt(direction) === 1) {
                    if (
                      (consultaInternaCdr[0] !== "" ||
                        consultaInternaCdr[0] !== undefined) &&
                      peerdisplayname.search("-") === -1
                    ) {
                      checkConsultaCdr = true;
                    }
                  } else if (parseInt(direction) === 2) {
                    if (
                      (consultaInternaCdr[0] === "" ||
                        consultaInternaCdr[0] === undefined) &&
                      peerdisplayname.search("-") !== -1
                    ) {
                      checkConsultaCdr = true;
                    }
                  }

                  let duracaoligacao = parseInt(duration) / 1000;
                  contduracaodoring =
                    contduracaodoring < 0 ? 0 : contduracaodoring;

                  let direcaoIngenium = parseInt(direction) === 1 ? 2 : 1;

                  contduracaodoring =
                    parseInt(direction) === 1 ? 0 : contduracaodoring;

                  if (checkConsultaCdr === false) {
                    let valorIdAtendimento =
                      atendimentoOnCdr[idatendimento] !== undefined &&
                      parseInt(atendimentoOnCdr[idatendimento]) > 0
                        ? atendimentoOnCdr[idatendimento]
                        : atendimentoOnCdr[atendimento.idatendimento];

                    console.log("INGENIUM_ATDACW_1 : ", idatendimento);
                    console.log(
                      "INGENIUM_ATDACW_2 : ",
                      atendimento ? atendimento.idatendimento : "undefined",
                    );

                    console.log("INGENIUM_ATDACW_3 : ", valorIdAtendimento);

                    let valorHistoricoCdr =
                      idatendimento !== undefined && parseInt(idatendimento) > 0
                        ? idatendimento
                        : atendimento.idatendimento;

                    if (
                      parseInt(duracaoligacao) >= 0 &&
                      reason !== "Call Rejected" &&
                      reason !== "Request Cancelled"
                    ) {
                      if (parseInt(informationusers.tmoutacw) !== 0) {
                        //AQUI INSERIR O TEMPO DO ACW
                        // dispatch(InsertACW(valorIdAtendimento));

                        axios.get(
                          `${
                            connection_platform.type_connect
                          }://${pathname}:${port}/conn/updatebyeattendantvozacwv2?idatendimento=${valorIdAtendimento}&duracao=${parseInt(
                            duracaoligacao,
                          )}&ringing=${parseInt(contduracaodoring)}`,
                        );

                        setTimeout(
                          () => {
                            //AQUI FINALIZAR O TEMPO DO ACW (DATEEND)
                            // dispatch(UpdateACW(valorIdAtendimento,62));
                            axios.get(
                              `${connection_platform.type_connect}://${pathname}:${port}/conn/updatestatusvozacw?idatendimento=${valorIdAtendimento}`,
                            );
                          },
                          parseInt(informationusers.tmoutacw) * 1000,
                        );
                      } else {
                        axios.get(
                          `${
                            connection_platform.type_connect
                          }://${pathname}:${port}/conn/updatebyeattendantvozv2?idatendimento=${valorIdAtendimento}&duracao=${parseInt(
                            duracaoligacao,
                          )}&ringing=${parseInt(contduracaodoring)}`,
                        );
                      }
                    } else if (
                      reason === "Call Rejected" ||
                      reason === "Request Cancelled"
                    ) {
                      if (parseInt(informationusers.tmoutacw) !== 0) {
                        //AQUI INSERIR O ACW
                        // dispatch(InsertACW(valorIdAtendimento));

                        const timeoutID = setTimeout(
                          () => {
                            //AQUI FINALIZAR O TEMPO DO ACW (DATEEND)
                            //  dispatch(UpdateACW(valorIdAtendimento,62));
                            axios.get(
                              `${
                                connection_platform.type_connect
                              }://${pathname}:${port}/conn/updatebyeattendantvozrejected?idatendimento=${valorIdAtendimento}&ringing=${parseInt(
                                contduracaodoring,
                              )}`,
                            );

                            axios.get(
                              `${connection_platform.type_connect}://${pathname}:${port}/conn/updatestatusvozacw?idatendimento=${valorIdAtendimento}`,
                            );
                          },
                          parseInt(informationusers.tmoutacw) * 1000,
                        );
                      } else {
                        axios.get(
                          `${
                            connection_platform.type_connect
                          }://${pathname}:${port}/conn/updatebyeattendantvozrejected?idatendimento=${valorIdAtendimento}&ringing=${parseInt(
                            contduracaodoring,
                          )}`,
                        );
                      }
                    }
                    axios.get(
                      `${connection_platform.type_connect}://${pathname}:${port}/conn/insertcallhistory2?cdr=${valorHistoricoCdr}&userid=${informationusers.id}&date=${duracaoformatada}&caller=${chamador}&called=${chamado}&directin=${direcaoIngenium}&answer=TRUE&userin=&utransf=&tempatend=${duracaoligacao}&userout=&directionout=null&motivo=6&idgroup=&status=${atendimento.statusagent}&ring=${contduracaodoring}&read=false&mediaid=${atendimento.idmidia}`,
                    );

                    axios
                      .get(
                        `${connection_platform.type_connect}://${pathname}:${port}/conn/updatedatestatusvoz?sipid=${informationusers.sipid}`,
                      )
                      .then((response) => {})
                      .catch((error) => {
                        console.log(
                          "ERRO AO INSERIR O DATESTATUS updatedatestatusvoz: ",
                          error,
                        );
                        setTimeout(() => {
                          axios.get(
                            `${connection_platform.type_connect}://${pathname}:${port}/conn/updatedatestatusvoz?sipid=${informationusers.sipid}`,
                          );
                        }, 2000);
                      });

                    let namefile =
                      "\\\\\\\\192.168.178.2\\\\rec\\\\0000" +
                      servicecode +
                      "\\" +
                      anomesdia +
                      "\\" +
                      horagravacao +
                      "\\" +
                      informationusers.ramal +
                      "_" +
                      idatendimento +
                      "_" +
                      randomAtd[idatendimento] +
                      ".wav";

                    if (
                      atdsimult.length < 2 &&
                      (parseInt(atendimento.idmidia) === 1 ||
                        parseInt(atendimento.idmidia) === 16) &&
                      reason.trim() !== "Hangup"
                    ) {
                      if (
                        informationusers.tmoutacw !== 0 &&
                        (atendimento.nomesubservico !== "CAMPANHA" ||
                          (status.status !== "Chamando" &&
                            status.status !== "Discando"))
                      ) {
                        console.log("INGENIUM_VOICE_ACW_5");
                        dispatch(
                          createStatusAgent(
                            "Aftercallwork",
                            atendimento.telefone,
                            Moment().format("DD/MM/YYYY HH:mm:ss"),
                          ),
                        );
                        dispatch(EditAcwContact(atendimento.idatendimento));
                        if (informationusers.classificationcount > 0) {
                          dispatch(
                            EditIsTabulatorToClassification(
                              atendimento.idatendimento,
                              false,
                            ),
                          );
                        }
                        dispatch(
                          tratarAfterCallWork(
                            informationusers.tmoutacw,
                            parseInt(atendimento.serviceatd),
                            false,
                          ),
                        );
                      } else if (
                        reason.trim() !== "Hangup 1" &&
                        reason.trim() !== "User hangup" &&
                        reason.trim() !== "cancel received"
                      ) {
                        setTimeout(() => {
                          const isToRemoveCurrentAtd =
                            parseInt(idatendimento) &&
                            atendimento &&
                            atendimento.idatendimento &&
                            parseInt(idatendimento) ===
                              parseInt(atendimento.idatendimento);

                          console.log(
                            "INGENIUM_VOICE_ACW_6",
                            isToRemoveCurrentAtd,
                          );
                          console.log("INGENIUM_VOICE_ACW_6_1", idatendimento);
                          console.log(
                            "INGENIUM_VOICE_ACW_6_2",
                            idatendimento
                              ? idatendimento
                              : atendimento.idatendimento,
                          );

                          if (isToRemoveCurrentAtd) {
                            dispatch(removeAtdUnique());
                          }
                          console.log(
                            "INGENIUM_VOICE_REMOVEATD_3",
                            idatendimento,
                          );
                          console.log(
                            "INGENIUM_VOICE_REMOVEATD_3_1",
                            idatendimento
                              ? idatendimento
                              : atendimento.idatendimento,
                          );

                          dispatch(
                            RemoveAtd(
                              idatendimento
                                ? idatendimento
                                : atendimento.idatendimento,
                            ),
                          );
                          if (!informationusers.blockscreen) {
                            dispatch(
                              createStatusAgent(
                                "Encerrou",
                                idatendimento
                                  ? idatendimento
                                  : atendimento.idatendimento,
                                Moment().format("DD/MM/YYYY HH:mm:ss"),
                              ),
                            );
                          }
                        }, 550);
                      } else if (reason.trim() === "User hangup") {
                        setTimeout(() => {
                          const isToRemoveCurrentAtd =
                            parseInt(idatendimento) &&
                            atendimento &&
                            atendimento.idatendimento &&
                            parseInt(idatendimento) ===
                              parseInt(atendimento.idatendimento);
                          console.log(
                            "INGENIUM_VOICE_ACW_7",
                            isToRemoveCurrentAtd,
                          );
                          console.log("INGENIUM_VOICE_ACW_7_1", idatendimento);
                          console.log(
                            "INGENIUM_VOICE_ACW_7_2",
                            idatendimento
                              ? idatendimento
                              : atendimento.idatendimento,
                          );
                          if (isToRemoveCurrentAtd) {
                            dispatch(removeAtdUnique());
                          }
                          console.log(
                            "INGENIUM_VOICE_REMOVEATD_4",
                            idatendimento,
                          );
                          console.log(
                            "INGENIUM_VOICE_REMOVEATD_4_1",
                            idatendimento
                              ? idatendimento
                              : atendimento.idatendimento,
                          );
                          dispatch(
                            RemoveAtd(
                              idatendimento
                                ? idatendimento
                                : atendimento.idatendimento,
                            ),
                          );
                          if (!informationusers.blockscreen) {
                            dispatch(
                              createStatusAgent(
                                "Encerrou",
                                idatendimento
                                  ? idatendimento
                                  : atendimento.idatendimento,
                                Moment().format("DD/MM/YYYY HH:mm:ss"),
                              ),
                            );
                          }
                        }, 550);
                      } else if (reason.trim() === "cancel received") {
                        setTimeout(() => {
                          console.log("INGENIUM_VOICE_ACW_8");
                          console.log("INGENIUM_VOICE_ACW_8_1", idatendimento);
                          console.log(
                            "INGENIUM_VOICE_ACW_8_2",
                            atendimento.idatendimento,
                          );
                          dispatch(removeAtdUnique()); // parece ser nesse
                          console.log(
                            "INGENIUM_VOICE_REMOVEATD_5",
                            idatendimento,
                          );
                          console.log(
                            "INGENIUM_VOICE_REMOVEATD_5_1",
                            atendimento.idatendimento,
                          );

                          dispatch(RemoveAtd(atendimento.idatendimento));
                          if (!informationusers.blockscreen) {
                            dispatch(
                              createStatusAgent(
                                "Encerrou",
                                atendimento.cliente,
                                Moment().format("DD/MM/YYYY HH:mm:ss"),
                              ),
                            );
                          }
                        }, 550);
                      }
                    }
                  }

                  // }
                }
              },
            );
          }
          //}, 500);
        }

        // always display the last relevant status
        evtReceivedTick = GetTickCount();
        if (evt.indexOf("STATUS") >= 0) {
          lastStatus = evt;
        }
        if (eventTimer === null) {
          // We receive EVENT and STATUS type messages here. We display EVENT messages only for a few seconds and after which we put back the last STATUS message (so always the relevant status is displayed)
          eventTimer = setInterval(function () {
            if (
              GetTickCount() - evtReceivedTick > 3000 &&
              lastStatus.length > 0
            ) {
              evtReceivedTick = GetTickCount();
              if (lastStatus.indexOf("Registered") > 0) {
                lastStatus = lastStatus.substring(
                  0,
                  lastStatus.indexOf("Registered") + 10,
                );
              }
              // document.getElementById('events').innerHTML = lastStatus;
              let [type, number, status] = lastStatus.split(",");
            }
          }, 300);
        }
        //ProcessEvents(evt);
      } else if (parseInt(infsip) === 55) {
        if (statusCall === "CallConnect") {
          anomesdia = Moment().format("YYYYMMDD");
          horagravacao = Moment().format("HH");

          let serverport = "";
          let serverlogin = "";
          let serverpasswd = "";
          let serveraddress = "";
          numrandom = Math.floor(Math.random() * 10000);

          gravacaovoz.map((grav) => {
            if (parseInt(grav.iddirection) === parseInt(direction)) {
              servicecode = grav.servicecode;
              serveraddress = grav.serveraddress;
              serverport = grav.serverport;
              serverlogin = grav.serverlogin;
              serverpasswd = grav.serverpasswd;
            }
          });

          //webphone_api.voicerecord(true, 'ftp://'+serverlogin+':'+serverpasswd+'@'+serveraddress+':'+serverport+'/0000'+servicecode+'/'+anomesdia+'/'+horagravacao+'/'+informationusers.ramal+'_'+idatendimento+'_'+randomAtd[idatendimento]);
          var now = Moment().format("YYYY/MM/DD HH:mm:ss");

          valorDiferenca = parseInt(Math.abs(Math.round(ipcurrent.difftime)));

          if (parseInt(ipcurrent.difftime) < 0) {
            now = Moment()
              .subtract(valorDiferenca, "seconds")
              .format("YYYY/MM/DD HH:mm:ss");
            datetimeBR = Moment()
              .subtract(valorDiferenca, "seconds")
              .format("DD/MM/YYYY HH:mm:ss");
          } else {
            now = Moment()
              .add(valorDiferenca, "seconds")
              .format("YYYY/MM/DD HH:mm:ss");
            datetimeBR = Moment()
              .add(valorDiferenca, "seconds")
              .format("DD/MM/YYYY HH:mm:ss");
          }

          if (parseInt(duracaoderingini) > 0) {
            contduracaodocall = Moment(now).diff(
              duracaoderingini,
              "seconds",
              true,
            );
          } else {
            contduracaodocall = 0;
          }

          let queueid = "";
          let checkqueue = false;

          listcallqueue.map((queue) => {
            if (
              parseInt(queue.cdrnew) === parseInt(atendimento.idatendimento)
            ) {
              queueid = queue.queueid;
              checkqueue = true;
            }
          });
          if (checkqueue === true) {
            dispatch(deleteListCallQueue(queueid));
            axios.get(
              `${connection_platform.type_connect}://${pathname}:${port}/conn/clearqueue?cdr=${atendimento.idatendimento}&queueid=${queueid}&novocdr=${atendimento.idatendimento}&usuario=${informationusers.id}&opcao=t&media=1`,
            );
            socket.send(
              "CALLQUEUE\r\n" +
                informationusers.id +
                "\r\nQUEUEID\r\n" +
                queueid +
                "\r\nCDRID\r\n" +
                atendimento.idatendimento +
                "\r\nTP\r\nRM\r\nCBACKCOUNT\r\n0\r\nTMCBACK\r\n0\r\nCQUEUE\r\n0\r\nUSERNAME\r\n" +
                informationusers.username +
                "\r\nCDRIDNEW\r\n" +
                queueid +
                "\r\n\r\n",
            );
          }

          dispatch(editAtendimentoVoz(atendimento.idatendimento, datetimeBR));
          dispatch(editmultiplesatdVoz(atendimento.idatendimento, datetimeBR));

          if (direction == 2) {
            setTimeout(() => {
              dispatch(
                createStatusAgent(
                  "Ligação",
                  "S.(" + atendimento.telefone + ")",
                  Moment().format("DD/MM/YYYY HH:mm:ss"),
                ),
              );
            }, 250);
          } else {
            setTimeout(() => {
              dispatch(
                createStatusAgent(
                  "Ligação",
                  "E.(" + atendimento.telefone + ")",
                  Moment().format("DD/MM/YYYY HH:mm:ss"),
                ),
              );
            }, 250);
          }
        } else if (statusCall == "Call") {
          if (direction == 2) {
            dispatch(
              createStatusAgent(
                "Discando",
                "S.(" + atendimento.telefone + ")",
                Moment().format("DD/MM/YYYY HH:mm:ss"),
              ),
            );
          } else {
            dispatch(
              createStatusAgent(
                "Discando",
                "E.(" + atendimento.telefone + ")",
                Moment().format("DD/MM/YYYY HH:mm:ss"),
              ),
            );
          }
        }

        if (statusCall === "CallDisconnect") {
          let dataformatada = Moment(
            atendimento.datatimeatd,
            "YYYY/MM/DD HH:mm:ss",
          ).format("YYYY-MM-DD HH:mm:ss");
          let chamador = atendimento.telefone;
          let chamado = informationusers.ramal;
          let namefile =
            "\\\\\\\\192.168.178.2\\\\rec\\\\0000" +
            servicecode +
            "\\" +
            anomesdia +
            "\\" +
            horagravacao +
            "\\" +
            informationusers.ramal +
            "_" +
            atendimento.idatendimento +
            "_" +
            randomAtd[idatendimento] +
            ".wav";

          webphone_api.onCdr(
            function (
              caller,
              called,
              connecttime,
              duration,
              direction,
              peerdisplayname,
              reason,
              line,
            ) {
              if (reason.trim() !== "Forbidden") {
                let consultaInternaCdr = "";
                let checkConsultaCdr = false;
                let contduracaodoring = parseInt(connecttime / 1000);
                durationans =
                  durationans == 0 ? informationusers.intmans : durationans;
                durationoutans =
                  durationoutans == 0
                    ? informationusers.outtmans
                    : durationoutans;
                let duracaoformatada = dateOnCdr[idatendimento];
                let datatimeAns55 = Moment().format("DD/MM/YYYY HH:mm:ss");
                let valorDiferenca55 = parseInt(
                  Math.abs(Math.round(ipcurrent.difftime)),
                );

                if (parseInt(ipcurrent.difftime) < 0) {
                  datatimeAns55 = Moment()
                    .subtract(valorDiferenca55, "seconds")
                    .format("DD/MM/YYYY HH:mm:ss");
                } else {
                  datatimeAns55 = Moment()
                    .add(valorDiferenca55, "seconds")
                    .format("DD/MM/YYYY HH:mm:ss");
                }
                consultaInternaCdr = caller.split("-");

                //    if(((consultaInternaCdr[0]==="" || consultaInternaCdr[0]===undefined)&& caller.search("-") !=-1 )){
                // 	   checkConsultaCdr = true;
                //    }

                if (parseInt(direction) === 1) {
                  if (
                    (consultaInternaCdr[0] !== "" ||
                      consultaInternaCdr[0] !== undefined) &&
                    peerdisplayname.search("-") === -1
                  ) {
                    checkConsultaCdr = true;
                  }
                } else if (parseInt(direction) === 2) {
                  if (
                    (consultaInternaCdr[0] === "" ||
                      consultaInternaCdr[0] === undefined) &&
                    peerdisplayname.search("-") !== -1
                  ) {
                    checkConsultaCdr = true;
                  }
                }

                let duracaoligacao = parseInt(duration) / 1000;
                contduracaodoring =
                  contduracaodoring < 0 ? 0 : contduracaodoring;

                contduracaodoring =
                  parseInt(direction) === 1 ? 0 : contduracaodoring;

                if (checkConsultaCdr === false) {
                  let direcaoIngenium = parseInt(direction) === 1 ? 2 : 1;

                  let valorIdAtendimento =
                    atendimentoOnCdr[idatendimento] !== undefined &&
                    parseInt(atendimentoOnCdr[idatendimento]) > 0
                      ? atendimentoOnCdr[idatendimento]
                      : atendimentoOnCdr[atendimento.idatendimento];

                  let valorHistoricoCdr =
                    idatendimento !== undefined && parseInt(idatendimento) > 0
                      ? idatendimento
                      : atendimento.idatendimento;

                  if (parseInt(duracaoligacao) > 0) {
                    axios.get(
                      `${
                        connection_platform.type_connect
                      }://${pathname}:${port}/conn/updatebyeattendantvozv2?idatendimento=${valorIdAtendimento}&duracao=${parseInt(
                        duracaoligacao,
                      )}&ringing=${parseInt(contduracaodoring)}`,
                    );
                  }

                  axios.get(
                    `${
                      connection_platform.type_connect
                    }://${pathname}:${port}/conn/insertcallhistory2?cdr=${valorHistoricoCdr}&userid=${
                      informationusers.id
                    }&date=${duracaoformatada}&caller=${chamador}&called=${chamado}&directin=${direcaoIngenium}&answer=TRUE&userin=&utransf=&tempatend=${parseInt(
                      duracaoligacao,
                    )}&userout=&directionout=null&motivo=6&idgroup=&status=${
                      atendimento.statusagent
                    }&ring=${contduracaodoring}&read=false&mediaid=${atendimento.idmidia}`,
                  );

                  if (atdsimult.length < 2) {
                    dispatch(removeAtdUnique());
                    dispatch(
                      createStatusAgent(
                        "Encerrou",
                        atendimento.cliente,
                        Moment().format("DD/MM/YYYY HH:mm:ss"),
                      ),
                    );
                  }
                  dispatch(removeConversation(atendimento.idatendimento));
                  console.log("INGENIUM_VOICE_REMOVEATD_6", idatendimento);
                  console.log(
                    "INGENIUM_VOICE_REMOVEATD_6_1",
                    atendimento.idatendimento,
                  );

                  dispatch(RemoveAtd(atendimento.idatendimento));
                  let jsonChannelPhoneCall = mountCallsStatus(atdsimult);
                  let strPauseFuture = informationusers.blockfuture ? 1 : 0;
                  let descPauseFuture = informationusers.blockfuture
                    ? descfuturepause
                    : " ";

                  let data_hora_atual = Moment().format("YYYY/MM/DD HH:mm:ss");
                  let duracaoLoginAtual = Moment(data_hora_atual).diff(
                    informationusers.datalogin,
                    "seconds",
                  );
                  let duracaoLoginFinal =
                    parseInt(duracaoLoginAtual) +
                    parseInt(informationusers.tmlogin);
                  socket.send(
                    "REQ\r\n" +
                      informationusers.id +
                      "\r\nUSERNAME\r\n" +
                      informationusers.username +
                      "\r\nDISPLAYNAME\r\n" +
                      informationusers.displayname +
                      "\r\nEXTEN\r\n" +
                      informationusers.ramal +
                      "\r\nREASON\r\n" +
                      chamador +
                      "\r\nSTATUS\r\nAT\r\nSTATUSID\r\n-1\r\nHOUR\r\n" +
                      datatimeAns55 +
                      "-00:00:00\r\nDESCRIPTION\r\n" +
                      chamador +
                      "\r\nEMAIL\r\n \r\nGROUP\r\n" +
                      informationusers.idgroup +
                      "\r\nDTL\r\n" +
                      datatime +
                      "\r\nGROUPNAME\r\n" +
                      informationusers.grupo +
                      "\r\nPSDCOUNT\r\n" +
                      informationusers.psdcount +
                      "\r\nPSDTMA\r\n" +
                      parseInt(informationusers.psdtma) +
                      "\r\nMNGGROUP\r\n-1\r\nINCALLCOUNT\r\n" +
                      parseInt(informationusers.incallcount) +
                      "\r\nINANSCOUNT\r\n" +
                      parseInt(informationusers.inanscount) +
                      "\r\nINTMANS\r\n" +
                      durationans +
                      "\r\nINSLA\r\n100\r\nOUTCALLCOUNT\r\n" +
                      parseInt(informationusers.outcallcount) +
                      "\r\nOUTANSCOUNT\r\n" +
                      parseInt(informationusers.outanscount) +
                      "\r\nOUTTMANS\r\n" +
                      durationoutans +
                      "\r\nCOUNTFPAUSE\r\n" +
                      parseInt(informationusers.psdfbreak) +
                      "\r\nOUTSLA\r\n100\r\nDESCFUTUREPAUSE\r\n" +
                      descPauseFuture +
                      "\r\nINITIALLOGIN\r\n0\r\nTMLOGIN\r\n" +
                      duracaoLoginFinal +
                      "\r\nJSON\r\n" +
                      jsonChannelPhoneCall +
                      "\r\nCDRID\r\n" +
                      atendimento.idatendimento +
                      "\r\nFUTUREPAUSE\r\n" +
                      strPauseFuture +
                      "\r\nSRVIN\r\n \r\nMEDIAID\r\n1\r\n\r\n",
                  );
                  statusAgentIMSDN = "AT";
                  stAgIMSDN = "AT";
                  console.log(
                    "INGENIUM_ENVIOSTATUS :",
                    new Date().toLocaleString(),
                    stAgIMSDN,
                  );
                  requestStatusAgent =
                    "REQ\r\n" +
                    informationusers.id +
                    "\r\nUSERNAME\r\n" +
                    informationusers.username +
                    "\r\nDISPLAYNAME\r\n" +
                    informationusers.displayname +
                    "\r\nEXTEN\r\n" +
                    informationusers.ramal +
                    "\r\nREASON\r\n" +
                    chamador +
                    "\r\nSTATUS\r\nAT\r\nSTATUSID\r\n-1\r\nHOUR\r\n" +
                    datatimeAns55 +
                    "-00:00:00\r\nDESCRIPTION\r\n" +
                    chamador +
                    "\r\nEMAIL\r\n \r\nGROUP\r\n" +
                    informationusers.idgroup +
                    "\r\nDTL\r\n" +
                    datatime +
                    "\r\nGROUPNAME\r\n" +
                    informationusers.grupo +
                    "\r\nPSDCOUNT\r\n" +
                    informationusers.psdcount +
                    "\r\nPSDTMA\r\n" +
                    parseInt(informationusers.psdtma) +
                    "\r\nMNGGROUP\r\n-1\r\nINCALLCOUNT\r\n" +
                    parseInt(informationusers.incallcount) +
                    "\r\nINANSCOUNT\r\n" +
                    parseInt(informationusers.inanscount) +
                    "\r\nINTMANS\r\n" +
                    durationans +
                    "\r\nINSLA\r\n100\r\nOUTCALLCOUNT\r\n" +
                    parseInt(informationusers.outcallcount) +
                    "\r\nOUTANSCOUNT\r\n" +
                    parseInt(informationusers.outanscount) +
                    "\r\nOUTTMANS\r\n" +
                    durationoutans +
                    "\r\nCOUNTFPAUSE\r\n" +
                    parseInt(informationusers.psdfbreak) +
                    "\r\nOUTSLA\r\n100\r\nDESCFUTUREPAUSE\r\n" +
                    descPauseFuture +
                    "\r\nINITIALLOGIN\r\n0\r\nTMLOGIN\r\n" +
                    duracaoLoginFinal +
                    "\r\nJSON\r\n" +
                    jsonChannelPhoneCall +
                    "\r\nCDRID\r\n" +
                    atendimento.idatendimento +
                    "\r\nFUTUREPAUSE\r\n" +
                    strPauseFuture +
                    "\r\nSRVIN\r\n \r\nMEDIAID\r\n1\r\n\r\n";
                  clearInterval(statusIntervalAgent);
                  envioStatusAgente(9963, informationusers.sipid);
                }
              } else if (reason.trim() === "Forbidden") {
                MicroModal.show("modal__capture-fail");
              }
            },
          );
        }

        if (statusCall == "No call in progress") {
          if (atdsimult.length < 2) {
            dispatch(removeAtdUnique());
            dispatch(
              createStatusAgent(
                "Encerrou",
                atendimento.cliente,
                Moment().format("DD/MM/YYYY HH:mm:ss"),
              ),
            );
          }
          dispatch(removeConversation(atendimento.idatendimento));
          console.log("INGENIUM_VOICE_REMOVEATD_7", atendimento.idatendimento);
          console.log("INGENIUM_VOICE_REMOVEATD_7_1", idatendimento);

          dispatch(RemoveAtd(atendimento.idatendimento));
        }
      }
    }
  });

  function makeidp(length) {
    var text = "";
    var possible =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz04234234789";
    for (var i = 0; i < length; i++) {
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    }
    return text;
  }

  function isJson(item) {
    item = typeof item != "string" ? JSON.stringify(item) : item;

    try {
      item = JSON.parse(item);
    } catch (e) {
      return false;
    }

    if (typeof item === "object" && item != null) {
      return true;
    }

    return false;
  }

  function processData(jsonData) {
    if (jsonData.info) {
      concatenatedInfo = concatenatedInfo.concat(jsonData.info);
    }
    return jsonData.complete;
  }

  socket.onopen = (event) => {};

  socket.onmessage = (event) => {
    const {
      informationusers,
      atdsimult,
      chatsimult,
      status,
      atendimento,
      messages,
      listcallqueue,
      queuepermission,
      displaynextatd,
      currentscreen,
      ipcurrent,
      clientusermonitors,
      groups,
      connectionsapi,
      interactioningdesk,
      reasonsblock,
      callpark,
      groupsrow,
      filtersmanager,
      infodisplay,
    } = getState();
    let time = Moment().format("HH:mm");
    time = time;
    let datatime = Moment().format("DD/MM/YYYY HH:mm:ss");
    let criticidade = "Insucesso: Desistência!";
    let datareceived = "Received: " + event.data;

    // console.log(`INGENIUM_MENSAGENS_WEBSOCKET: ${event.data.length} bytes`);

    let novadata = datareceived.split("\r\n");
    switch (novadata[0]) {
      case "Received: USRMSGLOG":
        let dia = Moment().format("DD");
        let mes = Moment().format("MM");
        let ano = Moment().format("YYYY");
        let datatimeChat = Moment().format("YYYY/MM/DD HH:mm:ss");
        mes = meses.indexOf(mes);
        dia = dia + " de " + meses[mes - 1];
        let erro = 0;

        let verifierTransfer = novadata[11].indexOf("TRANSFERCLP");
        if (verifierTransfer === 0) {
          let texto = novadata[11];
          texto = texto.split(":");

          atdsimult.map((simult) => {
            if (simult.idatendimento == texto[1])
              socket.send(
                "CHATTRANSFER\r\n" +
                  informationusers.id +
                  "\r\nCONTACTID\r\n" +
                  texto[1] +
                  "\r\nTO\r\n" +
                  simult.serverid +
                  "\r\nTOAGENT\r\n" +
                  novadata[1] +
                  "\r\n\r\n",
              );
          });
        } else {
          if (chatsimult.length != 0) {
            chatsimult.map((chat) => {
              if (parseInt(chat.iduserout) === parseInt(novadata[1])) {
                erro = 1;
              } else if (erro != 1) {
                erro = 0;
              }
            });
            if (erro === 1) {
              dispatch(
                addMessage(
                  makeidp(32),
                  novadata[11],
                  novadata[1],
                  time,
                  novadata[1],
                  "0",
                  "cliente",
                  false,
                  dia,
                ),
              );
              dispatch(typingedit(parseInt(novadata[1]), 0));
            } else {
              dispatch(
                addChatSimult(
                  parseInt(novadata[1]),
                  novadata[7],
                  "computer",
                  0,
                  0,
                  datatimeChat,
                ),
              );
              dispatch(
                addMessage(
                  makeidp(32),
                  novadata[11],
                  novadata[1],
                  time,
                  novadata[1],
                  "0",
                  "cliente",
                  false,
                  dia,
                ),
              );
              dispatch(typingadd(parseInt(novadata[1]), 0));
              dispatch(typingedit(parseInt(novadata[1]), 0));
            }
          } else {
            dispatch(
              addChatSimult(
                parseInt(novadata[1]),
                novadata[7],
                "computer",
                0,
                0,
                datatimeChat,
              ),
            );
            dispatch(
              addChat(
                parseInt(novadata[1]),
                novadata[7],
                false,
                0,
                0,
                datatimeChat,
              ),
            );
            dispatch(
              addMessage(
                makeidp(32),
                novadata[11],
                novadata[1],
                time,
                novadata[1],
                "0",
                "cliente",
                false,
                dia,
              ),
            );
            dispatch(typingadd(parseInt(novadata[1]), 0));
            dispatch(typingedit(parseInt(novadata[1]), 0));
          }
          let data = Moment();
          const [author, grupo] = novadata[7].split("(");

          if (
            currentscreen.screen != "Equipes" &&
            currentscreen.screen != "Clientes" &&
            currentscreen.screen != "Atendentes" &&
            currentscreen.screen != "Monitorias"
          ) {
            dispatch(
              InsertRegisterNotifier(
                ": " + novadata[11],
                "mensagemchat",
                data,
                novadata[7],
                novadata[15],
                "1",
                novadata[13],
                novadata[1],
              ),
            );
          }
          if (currentscreen.screen === "Clientes" && atdsimult.length === 0) {
            dispatch(
              InsertRegisterNotifier(
                ": " + novadata[11],
                "mensagemchat",
                data,
                novadata[7],
                novadata[15],
                "1",
                novadata[13],
                novadata[1],
              ),
            );
          }

          dispatch(
            InterationNotifier(
              author + ": " + novadata[11],
              "chat",
              novadata[13],
              "",
              novadata[1],
            ),
          );

          if (ipcurrent.audio) {
            var snd = new Audio(
              connection_platform.type_connect +
                "://" +
                ipcurrent.ip +
                ":" +
                connection_platform.port_apache_view_extern +
                "/ingweb/frontend/build/sound/ring_msg.mp3",
            );
            snd.play();
          }
        }
        socket.send(
          "USRMSGLOGREAD\r\n" +
            informationusers.id +
            "\r\nTOUSER\r\n" +
            novadata[1] +
            "\r\nCALLID\r\n" +
            novadata[5] +
            "\r\nUSERNAME\r\n" +
            informationusers.username +
            "\r\nMSGID\r\n" +
            novadata[13] +
            "\r\nWRNG\r\n0\r\n",
        );
        // Automatic garbage collection will handle novadata
        // event.data is immutable; no need to manually set it to null
        break;
      case "Received: LOGINRESPONSE":
        if (connection_platform.waitToSendReq.isToActive) {
          setTimeout(() => {
            reqServiceSingleton.sendReq();
          }, connection_platform.waitToSendReq.timeToWait);
        }

        if (reconnectionHandler.isReconnecting) {
          reconnectionHandler.setCorrectStatus(getState, dispatch);
          reconnectionHandler.reconnectionFinished();
        }

        setTimeout(() => {
          checkAnswerInitial = getState().atdsimult.length;
          let atendimentoAtual = getState().atendimento;

          if (
            atendimentoAtual.idatendimento !== null &&
            atendimentoAtual.idatendimento !== undefined &&
            parseInt(atendimentoAtual.serverid) === parseInt(novadata[1]) &&
            parseInt(atendimentoAtual.idmidia) !== 1
          ) {
            dispatch(clearQtdMsg(atendimentoAtual.idatendimento));
            if (atendimentoAtual.serverid !== "" && atendimentoAtual.serverid) {
              let jsonAtdAtual =
                "WSIMSGLOGREAD\r\n" +
                informationusers.id +
                "\r\nCALLID\r\nXXXXXXXXXXXXXXXXXXX\r\nTOUSER\r\n" +
                atendimentoAtual.serverid +
                "\r\nTOCLIENT\r\n" +
                atendimentoAtual.idatendimento +
                "\r\nMSGID\r\n-1\r\nRESULT\r\n" +
                `{'CDRID':${atendimentoAtual.idatendimento}}` +
                "\r\n\r\n";
              socket.send(jsonAtdAtual);
            }
          }

          checkLoginSendIdle(
            informationusers.user_midias,
            checkAnswerInitial,
            informationusers,
          );
          dispatch(UpdateChamadasRecuperadas(getState()));
          dispatch(UpdateUserLoginResponse(true));
          const {
            atdsimult: atdsimultToProcess,
            atendimento: atendimentoToProcess,
            messages: messagesToProcess,
            informationusers: informationusersToProcess,
            ipcurrent: ipcurrentToProcess,
          } = getState();

          const hasAtdsimultAndDontHaveAtd =
            Array.isArray(atdsimultToProcess) &&
            atdsimultToProcess.length > 0 &&
            !noReadHandler.isLoaded &&
            !Boolean(atendimentoToProcess.length) &&
            novadata &&
            novadata.length >= 6 &&
            parseInt(novadata[5]) === 1;
          if (hasAtdsimultAndDontHaveAtd) {
            noReadHandler.setIsLoaded();
            noReadHandler.removeOldNoReadInfoInStorage(atdsimultToProcess);
            pinHandler.removeOldNoReadInfoInStorage(atdsimultToProcess);
            ProximoAtdSimult(
              atdsimultToProcess[atdsimultToProcess.length - 1],
              messagesToProcess,
              atendimentoToProcess,
              informationusersToProcess,
              dispatch,
              ipcurrentToProcess,
              atdsimultToProcess,
            );
          }

          // tela de reconexão some
          // const isToRemoveReconnectModal =
          //   getState().isReconnectModalActive === true;
          // if (isToRemoveReconnectModal) {
          //   dispatch(setIsReconnectModalActive(false));
          // }
        }, 3000);

        // BUSCAR OS CLIENTES(CDRS) QUE FICARAM NO ACW SIMILAR AO CARREGAMENTO-NEW
        // criar uma funcao p isso
        // dentro da funcao criada faço o push
        // Automatic garbage collection will handle novadata
        // event.data is immutable; no need to manually set it to null
        break;

      case "Received: USERSSTATUS":
        //for (let data of novadata) {

        let jsonUSERSSTATUS = JSON.parse(novadata[2]);

        if (processData(jsonUSERSSTATUS)) {
          checkUserStatusEnd = true;
          // break;
        }
        //}

        if (checkUserStatusEnd) {
          if (isJson(concatenatedInfo) === true) {
            // let json = JSON.parse(concatenatedInfo);
            let json = concatenatedInfo;
            let jsonFim = "[";
            for (var k in json) {
              let checkUsuario = -1;

              try {
                checkUsuario = groups.groups.findIndex(
                  (groups, index, array) =>
                    parseInt(groups.id) === parseInt(json[k].GROUP),
                );
              } catch (error) {
                console.log(
                  "INGENIUM-AJUSTE-22-08-2025 pt-3 (entrou na exceção)",
                  {
                    groups,
                    novadata,
                    error,
                  },
                );
                checkUsuario = -1;
              }
              // let checkUsuario = groups.groups.findIndex(
              //   (groups, index, array) =>
              //     parseInt(groups.id) === parseInt(json[k].GROUP)
              // );

              if (parseInt(checkUsuario) >= 0 && json[k].STATUS !== undefined) {
                if (
                  json[k].GROUP !== undefined &&
                  json[k].GROUP !== " " &&
                  json[k].GROUP !== ""
                ) {
                  jsonFim += "{";

                  let result = groups.groups.find(
                    (item) => item.id === parseInt(json[k].GROUP),
                  );

                  jsonFim += '"desc_grupo":"' + result.name + '",';
                  jsonFim += '"id_grupo":' + parseInt(json[k].GROUP) + ",";
                  jsonFim += '"iduser":' + parseInt(json[k].USERID) + ",";
                  jsonFim += `"label":"${
                    json[k].DISPLAYNAME ? json[k].DISPLAYNAME : json[k].USERNAME
                  }",`;
                  jsonFim += '"ramal":"' + json[k].EXTEN + '",';
                  jsonFim += '"username":"' + json[k].USERNAME + '",';
                  jsonFim += '"value":' + parseInt(json[k].USERID) + ",";
                  jsonFim += '"razao_bloqueio":"' + json[k].REASON + '",';
                  jsonFim += '"duration":"' + json[k].HOUR + '",';
                  jsonFim += '"cdremcurso": null,';
                  jsonFim += '"direcao": null,';
                  jsonFim += '"gdaagent":0,';
                  jsonFim += `"inanscount":"${
                    json[k].INANSCOUNT ? json[k].INANSCOUNT : 0
                  }",`;
                  jsonFim += `"incallcount":"${
                    json[k].INCALLCOUNT ? json[k].INCALLCOUNT : 0
                  }",`;
                  jsonFim += `"insla":"${json[k].INSLA ? json[k].INSLA : 0}",`;
                  jsonFim += `"intmans":"${
                    json[k].INTMANS ? json[k].INTMANS : 0
                  }",`;
                  jsonFim += `"mediaid":"${
                    json[k].MEDIAID ? json[k].MEDIAID : null
                  }",`;
                  jsonFim += `"outanscount":"${
                    json[k].OUTANSCOUNT ? json[k].OUTANSCOUNT : 0
                  }",`;
                  jsonFim += `"outcallcount":"${
                    json[k].OUTCALLCOUNT ? json[k].OUTCALLCOUNT : 0
                  }",`;
                  jsonFim += `"outsla":"${
                    json[k].OUTSLA ? json[k].OUTSLA : 0
                  }",`;
                  jsonFim += `"outtmans":"${
                    json[k].OUTTMANS ? json[k].OUTTMANS : 0
                  }",`;
                  jsonFim += `"psdcount":"${
                    json[k].PSDCOUNT ? json[k].PSDCOUNT : 0
                  }",`;

                  jsonFim += `"psdtma":"${
                    json[k].PSDTMA ? json[k].PSDTMA : 0
                  }",`;

                  jsonFim += `"speaknum":"${
                    json[k].REASON ? json[k].REASON : ""
                  }",`;

                  jsonFim += `"description":"${
                    json[k].REASON ? json[k].REASON : ""
                  }",`;

                  jsonFim += '"time": 0,';
                  jsonFim += '"tmentrada": 0,';
                  jsonFim += `"tmlogin":"${
                    json[k].TMLOGIN ? json[k].TMLOGIN : 0
                  }",`;

                  jsonFim += '"tmpausa":0,';
                  jsonFim += '"tmsaida": 0,';
                  jsonFim += '"usedmodule": "' + json[k].MOD + '",';
                  jsonFim += `"futurepause":"${
                    json[k].FUTUREPAUSE ? json[k].FUTUREPAUSE : 0
                  }",`;
                  jsonFim += `"countfpause":"${
                    json[k].COUNTFPAUSE ? json[k].COUNTFPAUSE : 0
                  }",`;
                  jsonFim += `"tmfuturepause":"${
                    json[k].TMFUTUREPAUSE ? json[k].TMFUTUREPAUSE : 0
                  }",`;
                  jsonFim += `"descfuturepause":"${
                    json[k].DESCFUTUREPAUSE ? json[k].DESCFUTUREPAUSE : null
                  }",`;

                  jsonFim += '"visible": true,';
                  jsonFim += `"jsoncall":"${
                    json[k].STATUS === "LV" ? "" : json[k].JSON
                  }",`;

                  if (json[k].SATISFACTION)
                    jsonFim +=
                      '"satisfaction": "nps:' +
                      json[k].SATISFACTION.nps +
                      "&&csat:" +
                      json[k].SATISFACTION.csat +
                      '",';
                  else jsonFim += '"satisfaction":null,';

                  if (
                    json[k].STATUS === undefined ||
                    json[k].STATUS === "" ||
                    json[k].STATUS === " "
                  ) {
                    jsonFim += '"status_sip":"' + null + '",';
                    jsonFim += '"status":"' + null + '",';
                  } else {
                    jsonFim += '"status_sip":"' + json[k].STATUS + '",';
                    jsonFim += '"status":"' + json[k].STATUS + '",';
                  }
                  if (
                    json[k].DTL === undefined ||
                    json[k].DTL === "" ||
                    json[k].DTL === " "
                  ) {
                    jsonFim += '"dtl":"0"';
                  } else {
                    jsonFim += '"dtl":"' + json[k].DTL + '"';
                  }

                  jsonFim += "},";
                }
              }
            }

            jsonFim += "]";
            jsonFim = jsonFim.replace(",]", "]");
            try {
              dispatch(refreshUsersAgentsJsonV2(JSON.parse(jsonFim)));
            } catch (error) {
              console.log("refreshUsersAgentsJsonV2 ERROR", error);
            }
          }

          concatenatedInfo = [];
          checkUserStatusEnd = false;
        }
        // Automatic garbage collection will handle novadata
        // event.data is immutable; no need to manually set it to null
        break;
      case "Received: GRPMSGLOG":
        dia = Moment().format("DD");
        mes = Moment().format("MM");
        ano = Moment().format("YYYY");
        mes = meses.indexOf(mes);
        dia = dia + " de " + meses[mes - 1];
        let datatime = Moment().format("HH:mm");
        let data = Moment();
        const [authorgroup, group] = novadata[7].split("(");
        dispatch(
          InterationNotifier(
            authorgroup + ": " + novadata[11],
            "chatgrupo",
            novadata[13],
            currentscreen.screen,
            novadata[13],
          ),
        );
        if (currentscreen.screen != "ChatGrupo") {
          dispatch(
            InsertRegisterNotifier(
              novadata[11],
              "mensagemgrupo",
              data,
              novadata[7],
              novadata[15],
              "1",
              "",
              novadata[13],
            ),
          );
        }
        dispatch(
          addMessage(
            makeidp(32),
            novadata[11],
            novadata[1],
            datatime,
            -333,
            "0",
            "visto",
            false,
            novadata[7] + " em " + dia,
          ),
        );
        socket.send(
          "USRMSGLOGREAD\r\n" +
            informationusers.id +
            "\r\nTOUSER\r\n" +
            novadata[1] +
            "\r\nCALLID\r\n" +
            novadata[5] +
            "\r\nMSGID\r\n" +
            novadata[13] +
            "\r\n\r\n",
        );
        // Automatic garbage collection will handle novadata
        // event.data is immutable; no need to manually set it to null
        break;
      case "Received: GRPMSGLOGACK":
      //dispatch(MsgIdReturn(novadata[5],novadata[7], novadata[3]))
      case "Received: WSIMSGLOGREMOVE":
        let jsonmsgid = JSON.parse(novadata[7]);
        dispatch(DeleteMsgId(jsonmsgid.MSGID, novadata[5]));
        // Automatic garbage collection will handle novadata
        // event.data is immutable; no need to manually set it to null
        break;
      case "Received: USRTYPING":
        dispatch(typingedit(parseInt(novadata[1]), novadata[5]));
        // Automatic garbage collection will handle novadata
        // event.data is immutable; no need to manually set it to null
        break;
      case "Received: USRMSGLOGACK":
        dispatch(
          MsgIdReturn(
            novadata[5],
            novadata[7],
            novadata[3],
            "entregue",
            "entregue",
          ),
        );
        // Automatic garbage collection will handle novadata
        // event.data is immutable; no need to manually set it to null
        break;
      case "Received: USRMSGLOGREAD":
        dispatch(MsgIdReturn2(novadata[5], novadata[1], "visto", "visto"));
        // Automatic garbage collection will handle novadata
        // event.data is immutable; no need to manually set it to null
        break;
      case "Received: SUPERINFO":
        dispatch(EditSuperInfo(parseInt(novadata[1])));
        // Automatic garbage collection will handle novadata
        // event.data is immutable; no need to manually set it to null
        break;
      case "Received: INFO":
        let CDRID = novadata.indexOf("CDRID");
        let PSDCOUNT = novadata.indexOf("PSDCOUNT");
        let PSDTMA = novadata.indexOf("PSDTMA");
        let INCALLCOUNT = novadata.indexOf("INCALLCOUNT");
        let INANSCOUNT = novadata.indexOf("INANSCOUNT");
        let INTMANS = novadata.indexOf("INTMANS");
        let INSLA = novadata.indexOf("INSLA");
        let HOUR = novadata.indexOf("HOUR");
        let OUTCALLCOUNT = novadata.indexOf("OUTCALLCOUNT");
        let OUTANSCOUNT = novadata.indexOf("OUTANSCOUNT");
        let OUTTMANS = novadata.indexOf("OUTTMANS");
        let OUTSLA = novadata.indexOf("OUTSLA");
        let TMLOGIN = novadata.indexOf("TMLOGIN");
        let MEDIAID = novadata.indexOf("MEDIAID");
        let REASONAT = novadata.indexOf("REASON");
        let TELEFONEACW = novadata.indexOf("TELEFONE");
        let RTSATISFACTION = novadata.indexOf("RTSATISFACTION");
        let SATISFACTION = novadata.indexOf("SATISFACTION");

        let DESCGRUPO = novadata.indexOf("GROUPNAME");
        let IDGRUPO = novadata.indexOf("GROUP");
        let USERNAME = novadata.indexOf("USERNAME");
        let LABEL = "";
        if (novadata.indexOf("DISPLAYNAME") >= 0)
          LABEL = novadata.indexOf("DISPLAYNAME");
        else LABEL = novadata.indexOf("USERNAME");
        let RAMAL = novadata.indexOf("EXTEN");
        let MODULE = novadata.indexOf("MOD");
        let STATUS = novadata.indexOf("STATUS");
        let DTL = novadata.indexOf("DTL");
        let SRVIN = novadata.indexOf("SRVIN");
        let PAUSA = novadata.indexOf("REASON");
        let DESCRIPTION = novadata.indexOf("DESCRIPTION");
        let PSFUTURE = novadata.indexOf("FUTUREPAUSE");
        let DESCPSFUTURE = novadata.indexOf("DESCFUTUREPAUSE");
        let TMFUTUREPAUSE = novadata.indexOf("TMFUTUREPAUSE");
        let COUNTFPAUSE = novadata.indexOf("COUNTFPAUSE");
        let DIRECTIONCHND = novadata.indexOf("DIRECTIONCHND");

        //corrigir aqui
        //console.log("INGENIUM-AJUSTE-22-08-2025 pt-2", { groups });
        let checkUsuario = -1;
        try {
          checkUsuario = groups.groups.findIndex(
            (groups, index, array) =>
              parseInt(groups.id) === parseInt(novadata[IDGRUPO + 1]),
          );
        } catch (error) {
          console.log("INGENIUM-AJUSTE-22-08-2025 pt-3 (entrou na exceção)", {
            groups,
            novadata,
            error,
          });
          checkUsuario = -1;
        }

        let reasonatt = novadata[21];

        if (parseInt(novadata[MEDIAID + 1]) === 1) {
          //reasonatt = novadata[SRVIN+1] === ' ' ? 'Saída: '+novadata[21]:'Entrada: '+novadata[21];
          reasonatt =
            novadata[SRVIN + 1] === " "
              ? "Saída: " + novadata[DESCRIPTION + 1]
              : "Entrada: " + novadata[DESCRIPTION + 1];
        }

        let jsonSatisfaction = novadata[SATISFACTION + 1];
        let tempSat = null;

        if (jsonSatisfaction && jsonSatisfaction !== "Received: INFO") {
          tempSat = novadata[SATISFACTION + 1];
          tempSat = JSON.parse(tempSat);
          tempSat = `nps:${tempSat.nps}&&csat:${tempSat.csat}`;
        }
        if (parseInt(checkUsuario) >= 0) {
          if (novadata[STATUS + 1] == "LV") {
            let iduser = parseInt(novadata[1]);
            dispatch(
              refreshUsersAgents(
                iduser,
                "LV",
                "LV",
                "",
                "",
                "",
                0,
                novadata[PSDCOUNT + 1],
                novadata[PSDTMA + 1],
                novadata[INCALLCOUNT + 1],
                novadata[INANSCOUNT + 1],
                novadata[INTMANS + 1],
                novadata[INSLA + 1],
                novadata[OUTCALLCOUNT + 1],
                novadata[OUTANSCOUNT + 1],
                novadata[OUTTMANS + 1],
                novadata[OUTSLA + 1],
                novadata[TMLOGIN + 1],
                novadata[HOUR + 1],
                novadata[MEDIAID + 1],
                novadata[DESCGRUPO + 1],
                parseInt(novadata[IDGRUPO + 1]),
                novadata[USERNAME + 1],
                novadata[LABEL + 1],
                novadata[RAMAL + 1],
                novadata[MODULE + 1],
                0,
                novadata[DTL + 1],
                true,
                "",
                tempSat,
                novadata[PSFUTURE + 1],
                novadata[DESCPSFUTURE + 1],
                novadata[TMFUTUREPAUSE + 1],
                novadata[COUNTFPAUSE + 1],
              ),
            );
          } else if (novadata[STATUS + 1] == "BQ") {
            let iduser = parseInt(novadata[1]);
            dispatch(
              refreshUsersAgents(
                iduser,
                "BQ",
                "BQ",
                novadata[PAUSA + 1],
                "",
                "",
                0,
                novadata[PSDCOUNT + 1],
                novadata[PSDTMA + 1],
                novadata[INCALLCOUNT + 1],
                novadata[INANSCOUNT + 1],
                novadata[INTMANS + 1],
                novadata[INSLA + 1],
                novadata[OUTCALLCOUNT + 1],
                novadata[OUTANSCOUNT + 1],
                novadata[OUTTMANS + 1],
                novadata[OUTSLA + 1],
                novadata[TMLOGIN + 1],
                novadata[HOUR + 1],
                novadata[MEDIAID + 1],
                novadata[DESCGRUPO + 1],
                parseInt(novadata[IDGRUPO + 1]),
                novadata[USERNAME + 1],
                novadata[LABEL + 1],
                novadata[RAMAL + 1],
                novadata[MODULE + 1],
                0,
                novadata[DTL + 1],
                true,
                "",
                tempSat,
                novadata[PSFUTURE + 1],
                novadata[DESCPSFUTURE + 1],
                novadata[TMFUTUREPAUSE + 1],
                novadata[COUNTFPAUSE + 1],
              ),
            );
          } else if (novadata[STATUS + 1] == "RV") {
            let iduser = parseInt(novadata[1]);
            dispatch(
              refreshUsersAgents(
                iduser,
                "LV",
                "RV",
                novadata[21],
                novadata[23],
                novadata[21],
                0,
                novadata[PSDCOUNT + 1],
                novadata[PSDTMA + 1],
                novadata[INCALLCOUNT + 1],
                novadata[INANSCOUNT + 1],
                novadata[INTMANS + 1],
                novadata[INSLA + 1],
                novadata[OUTCALLCOUNT + 1],
                novadata[OUTANSCOUNT + 1],
                novadata[OUTTMANS + 1],
                novadata[OUTSLA + 1],
                novadata[TMLOGIN + 1],
                novadata[HOUR + 1],
                novadata[MEDIAID + 1],
                novadata[DESCGRUPO + 1],
                parseInt(novadata[IDGRUPO + 1]),
                novadata[USERNAME + 1],
                novadata[LABEL + 1],
                novadata[RAMAL + 1],
                novadata[MODULE + 1],
                0,
                novadata[DTL + 1],
                true,
                "",
                tempSat,
                novadata[PSFUTURE + 1],
                novadata[DESCPSFUTURE + 1],
                novadata[TMFUTUREPAUSE + 1],
                novadata[COUNTFPAUSE + 1],
              ),
            );
          } else if (novadata[STATUS + 1] == "AT") {
            let iduser = parseInt(novadata[1]);
            let JSONCALL = novadata.indexOf("JSON");
            let stringCalls = "";
            try {
              stringCalls = novadata[JSONCALL + 1];
            } catch (error) {
              stringCalls = "";
            }
            dispatch(
              refreshUsersAgents(
                iduser,
                "LV",
                "AT",
                reasonatt,
                novadata[REASONAT + 1],
                novadata[DESCRIPTION + 1],
                0,
                novadata[PSDCOUNT + 1],
                novadata[PSDTMA + 1],
                novadata[INCALLCOUNT + 1],
                novadata[INANSCOUNT + 1],
                novadata[INTMANS + 1],
                novadata[INSLA + 1],
                novadata[OUTCALLCOUNT + 1],
                novadata[OUTANSCOUNT + 1],
                novadata[OUTTMANS + 1],
                novadata[OUTSLA + 1],
                novadata[TMLOGIN + 1],
                novadata[HOUR + 1],
                novadata[MEDIAID + 1],
                novadata[DESCGRUPO + 1],
                parseInt(novadata[IDGRUPO + 1]),
                novadata[USERNAME + 1],
                novadata[LABEL + 1],
                novadata[RAMAL + 1],
                novadata[MODULE + 1],
                novadata[CDRID + 1],
                novadata[DTL + 1],
                true,
                stringCalls,
                tempSat,
                novadata[PSFUTURE + 1],
                novadata[DESCPSFUTURE + 1],
                novadata[TMFUTUREPAUSE + 1],
                novadata[COUNTFPAUSE + 1],
                novadata[DIRECTIONCHND + 1],
              ),
            );
            dispatch(
              EditCursoUserMonitoringSimult(iduser, novadata[CDRID + 1]),
            );
            dispatch(EditCursoUserMonitoring(iduser, novadata[CDRID + 1]));
          } else if (novadata[STATUS + 1] == "QAT") {
            let iduser = parseInt(novadata[1]);
            let JSONCALL = novadata.indexOf("JSON");
            let stringCalls = "";
            try {
              stringCalls = novadata[JSONCALL + 1];
            } catch (error) {
              stringCalls = "";
            }
            dispatch(
              refreshUsersAgents(
                iduser,
                "QAT",
                "AT",
                reasonatt,
                novadata[REASONAT + 1],
                novadata[DESCRIPTION + 1],
                0,
                novadata[PSDCOUNT + 1],
                novadata[PSDTMA + 1],
                novadata[INCALLCOUNT + 1],
                novadata[INANSCOUNT + 1],
                novadata[INTMANS + 1],
                novadata[INSLA + 1],
                novadata[OUTCALLCOUNT + 1],
                novadata[OUTANSCOUNT + 1],
                novadata[OUTTMANS + 1],
                novadata[OUTSLA + 1],
                novadata[TMLOGIN + 1],
                novadata[HOUR + 1],
                novadata[MEDIAID + 1],
                novadata[DESCGRUPO + 1],
                parseInt(novadata[IDGRUPO + 1]),
                novadata[USERNAME + 1],
                novadata[LABEL + 1],
                novadata[RAMAL + 1],
                novadata[MODULE + 1],
                novadata[CDRID + 1],
                novadata[DTL + 1],
                true,
                stringCalls,
                tempSat,
                novadata[PSFUTURE + 1],
                novadata[DESCPSFUTURE + 1],
                novadata[TMFUTUREPAUSE + 1],
                novadata[COUNTFPAUSE + 1],
              ),
            );
            dispatch(
              EditCursoUserMonitoringSimult(iduser, novadata[CDRID + 1]),
            );
            dispatch(EditCursoUserMonitoring(iduser, novadata[CDRID + 1]));
          } else if (novadata[STATUS + 1] == "BQSUPER") {
            let iduser = parseInt(novadata[1]);
            dispatch(
              refreshUsersAgents(
                iduser,
                "BQSUPER",
                "BQSUPER",
                novadata[23],
                "",
                "",
                0,
                novadata[PSDCOUNT + 1],
                novadata[PSDTMA + 1],
                novadata[INCALLCOUNT + 1],
                novadata[INANSCOUNT + 1],
                novadata[INTMANS + 1],
                novadata[INSLA + 1],
                novadata[OUTCALLCOUNT + 1],
                novadata[OUTANSCOUNT + 1],
                novadata[OUTTMANS + 1],
                novadata[OUTSLA + 1],
                novadata[TMLOGIN + 1],
                novadata[HOUR + 1],
                novadata[MEDIAID + 1],
                novadata[DESCGRUPO + 1],
                parseInt(novadata[IDGRUPO + 1]),
                novadata[USERNAME + 1],
                novadata[LABEL + 1],
                novadata[RAMAL + 1],
                novadata[MODULE + 1],
                0,
                novadata[DTL + 1],
                true,
                "",
                tempSat,
                novadata[PSFUTURE + 1],
                novadata[DESCPSFUTURE + 1],
                novadata[TMFUTUREPAUSE + 1],
                novadata[COUNTFPAUSE + 1],
              ),
            );
          } else if (novadata[STATUS + 1] == "ACW") {
            let iduser = parseInt(novadata[1]);
            let JSONCALL = novadata.indexOf("JSON");
            let stringCalls = "";
            try {
              stringCalls = novadata[JSONCALL + 1];
            } catch (error) {
              stringCalls = "";
            }
            dispatch(
              refreshUsersAgents(
                iduser,
                "ACW",
                "ACW",
                novadata[TELEFONEACW + 1],
                "",
                "",
                0,
                novadata[PSDCOUNT + 1],
                novadata[PSDTMA + 1],
                novadata[INCALLCOUNT + 1],
                novadata[INANSCOUNT + 1],
                novadata[INTMANS + 1],
                novadata[INSLA + 1],
                novadata[OUTCALLCOUNT + 1],
                novadata[OUTANSCOUNT + 1],
                novadata[OUTTMANS + 1],
                novadata[OUTSLA + 1],
                novadata[TMLOGIN + 1],
                novadata[HOUR + 1],
                novadata[MEDIAID + 1],
                novadata[DESCGRUPO + 1],
                parseInt(novadata[IDGRUPO + 1]),
                novadata[USERNAME + 1],
                novadata[LABEL + 1],
                novadata[RAMAL + 1],
                novadata[MODULE + 1],
                0,
                novadata[DTL + 1],
                true,
                stringCalls,
                tempSat,
                novadata[PSFUTURE + 1],
                novadata[DESCPSFUTURE + 1],
                novadata[TMFUTUREPAUSE + 1],
                novadata[COUNTFPAUSE + 1],
              ),
            );
          } else if (novadata[STATUS + 1] == "CHND") {
            let iduser = parseInt(novadata[1]);

            let JSONCALL = novadata.indexOf("JSON");
            let stringCalls = "";
            try {
              stringCalls = novadata[JSONCALL + 1];
            } catch (error) {
              stringCalls = "";
            }

            console.log("INGENIUM-AJUSTE-20-05-2026", {
              direcao: novadata[DIRECTIONCHND + 1],
              status: novadata[STATUS + 1],
              mediaid: novadata[MEDIAID + 1],
              username: novadata[USERNAME + 1],
            });

            dispatch(
              refreshUsersAgents(
                iduser,
                "CHND",
                "CHND",
                novadata[DESCRIPTION + 1],
                novadata[23],
                novadata[DESCRIPTION + 1],
                0,
                novadata[PSDCOUNT + 1],
                novadata[PSDTMA + 1],
                novadata[INCALLCOUNT + 1],
                novadata[INANSCOUNT + 1],
                novadata[INTMANS + 1],
                novadata[INSLA + 1],
                novadata[OUTCALLCOUNT + 1],
                novadata[OUTANSCOUNT + 1],
                novadata[OUTTMANS + 1],
                novadata[OUTSLA + 1],
                novadata[TMLOGIN + 1],
                novadata[HOUR + 1],
                novadata[MEDIAID + 1],
                novadata[DESCGRUPO + 1],
                parseInt(novadata[IDGRUPO + 1]),
                novadata[USERNAME + 1],
                novadata[LABEL + 1],
                novadata[RAMAL + 1],
                novadata[MODULE + 1],
                novadata[CDRID + 1],
                novadata[DTL + 1],
                true,
                stringCalls,
                tempSat,
                novadata[PSFUTURE + 1],
                novadata[DESCPSFUTURE + 1],
                novadata[TMFUTUREPAUSE + 1],
                novadata[COUNTFPAUSE + 1],
                novadata[DIRECTIONCHND + 1],
              ),
            );
            dispatch(
              EditCursoUserMonitoringSimult(iduser, novadata[CDRID + 1]),
            );
            dispatch(EditCursoUserMonitoring(iduser, novadata[CDRID + 1]));
          } else if (novadata[STATUS + 1] === " ") {
            let iduser = parseInt(novadata[1]);

            let JSONCALL = novadata.indexOf("JSON");
            let stringCalls = "";
            try {
              stringCalls = novadata[JSONCALL + 1];
            } catch (error) {
              stringCalls = "";
            }

            dispatch(
              refreshUsersAgents(
                iduser,
                null,
                null,
                novadata[21],
                novadata[23],
                novadata[21],
                0,
                novadata[PSDCOUNT + 1],
                novadata[PSDTMA + 1],
                novadata[INCALLCOUNT + 1],
                novadata[INANSCOUNT + 1],
                novadata[INTMANS + 1],
                novadata[INSLA + 1],
                novadata[OUTCALLCOUNT + 1],
                novadata[OUTANSCOUNT + 1],
                novadata[OUTTMANS + 1],
                novadata[OUTSLA + 1],
                novadata[TMLOGIN + 1],
                novadata[HOUR + 1],
                novadata[MEDIAID + 1],
                novadata[DESCGRUPO + 1],
                parseInt(novadata[IDGRUPO + 1]),
                novadata[USERNAME + 1],
                novadata[LABEL + 1],
                novadata[RAMAL + 1],
                novadata[MODULE + 1],
                0,
                0,
                true,
                stringCalls,
                tempSat,
                novadata[PSFUTURE + 1],
                novadata[DESCPSFUTURE + 1],
                novadata[TMFUTUREPAUSE + 1],
                novadata[COUNTFPAUSE + 1],
              ),
            );
          }
        }
        // Automatic garbage collection will handle novadata
        // event.data is immutable; no need to manually set it to null
        break;
      case "Received: ANSWEBCHAT":
        var telefone = novadata[17].split("~¿");
        var cliente = novadata[19].split("~¿");
        let timecomplete = timecomplete;
        var servico = "";
        // var servico = novadata[21].split(":");

        if (novadata[21].includes(":")) {
          servico = novadata[21].split(":")[1];
        } else {
          servico = novadata[21];
        }
        var cliente = cliente[0].split(": ");
        var telefonefilt = telefone[0].split(": ");
        var MenuBot = [];
        let cpark = false;
        let mtnow = "newatd";
        let numprotocolo = "";
        let passjson = "";
        let deliveryType = "";
        let score_class2 = "";
        let score_value2 = "";
        let srv_wait_id = "";
        let nps_call = false;

        //{ "delivery_type": 0, "LASTSCORE" : { "SCORE" :5, "CLASS": "otimo" }}

        console.log("INGENIUM_ACK_CDRID : ", cdrId);
        console.log("INGENIUM_ACK_ATDCURSO : ", atdsimult);
        // const checkAtdExist = atdsimult.some(simult =>
        //   parseInt(simult.idatendimento) === parseInt(novadata[5])
        // );

        const checkAtdExist = atdsimult.some(
          (simult) =>
            parseInt(simult.idatendimento) === parseInt(novadata[5]) &&
            !(simult.direction === ""),
        );

        const checkAtdExistV2 = () => {
          let exists = false;
          const { atdsimult } = getState();
          const hasAtdsimult = Array.isArray(atdsimult);
          if (hasAtdsimult) {
            exists = atdsimult.some(
              (simult) =>
                parseInt(simult.idatendimento) === parseInt(novadata[5]) &&
                !(simult.direction === ""),
            );
          }
          return exists;
        };

        console.log("INGENIUM_ACK_CHECKATDEXIST :", checkAtdExist);
        if (!checkAtdExist) {
          const hasJsonInformation = !!novadata && novadata.length >= 38;
          if (hasJsonInformation && isJson(novadata[37])) {
            const parsedJson = JSON.parse(novadata[37]);
            const hasStandByInANSWEBCHAT = !!parsedJson && !!parsedJson.STANDBY;
            const standbyId = hasStandByInANSWEBCHAT
              ? parsedJson.STANDBY.ID
              : "";
            const dateTimeOfInsertionInQuarentine = hasStandByInANSWEBCHAT
              ? parsedJson.STANDBY.DATETIME
              : novadata[33];
            const cdrId = novadata[5];
            const idAtendimento = novadata[27];
            let contactName = novadata[19].split("~¿");

            ///////AQUIII///////

            const nomeNaAgenda = contactName.find((contact) => {
              return contact.includes("Nome na Agenda:");
            });
            contactName = !!nomeNaAgenda
              ? nomeNaAgenda.replace("Nome na Agenda: ", "")
              : novadata[19]
                  .split("~¿")[0]
                  .replace("Nome na Agenda: ", "")
                  .replace("Nome: ", "");
            const hasLastScore = !!parsedJson && !!parsedJson.LASTSCORE;
            const scoreValue = hasLastScore ? parsedJson.LASTSCORE.SCORE : "";
            const scoreClass = hasLastScore ? parsedJson.LASTSCORE.CLASS : "";
            const dateTime = novadata[33];
            const phoneNumber = novadata[17]
              .split("~¿")[0]
              .replace("TELEFONE: ", "");
            const midiaId = parseInt(novadata[13]);
            const isFromQuarentineQueueInANSWEBCHAT =
              !!standbyId && standbyId !== 0;

            if (isFromQuarentineQueueInANSWEBCHAT) {
              const infosAboutContact = {
                idatendimento: novadata[5],
                cliente,
                telefone: telefonefilt[1],
                servico: novadata[21],
                datatimeatd: novadata[23],
                criticidade,
                menubot: novadata[19],
                subservico: novadata[11],
                serviceatd: novadata[27],
                recuperation: novadata[25],
                recuperationtime: dataatual,
                direction: novadata[15],
                idmidia: novadata[13],
                timecomplete: timecomplete,
                statusagent: statusagent,
                line: "0",
                queueid: 0,
                serverid: novadata[1],
                qtdmessage: 0,
                pathfile: novadata[35],
                mcdu: "",
                nomesubservico: servico,
                infoinitcall: "",
                nomecliente: "",
                protocolo: "",
                idsubservico: "",
                acw: "",
                isDialNc2: "",
                arrayChannels: "",
                caseId: "",
                statusatd: "",
                score_class,
                score_value,
                nps_call,
                isTabulation: undefined,
              };
              const contactIdCreated = {
                idatendimento: infosAboutContact.idatendimento,
                cliente: infosAboutContact.cliente,
                telefone: infosAboutContact.telefone,
                servico: infosAboutContact.servico,
                datatimeatd: infosAboutContact.datatimeatd,
                criticidade: infosAboutContact.criticidade,
                menubot: infosAboutContact.menubot,
                subservico: infosAboutContact.subservico,
                serviceatd: infosAboutContact.serviceatd,
                recuperation: infosAboutContact.recuperation,
                recuperationtime: infosAboutContact.recuperationtime,
                respatendente: false,
                respclient: false,
                direction: infosAboutContact.direction,
                idmidia: infosAboutContact.idmidia,
                timecomplete: infosAboutContact.timecomplete,
                statusagent: infosAboutContact.statusagent,
                line: infosAboutContact.line,
                queueid: infosAboutContact.queueid,
                serverid: infosAboutContact.serverid,
                qtdmessage: infosAboutContact.qtdmessage,
                pathfile: infosAboutContact.pathfile,
                mcdu: infosAboutContact.mcdu,
                nomesubservico: infosAboutContact.nomesubservico,
                infoinitcall: infosAboutContact.infoinitcall,
                nomecliente: infosAboutContact.nomecliente,
                protocolo: infosAboutContact.protocolo,
                idsubservico: infosAboutContact.idsubservico,
                acw: infosAboutContact.acw,
                isDialNc2: infosAboutContact.isDialNc2,
                arrayChannels: infosAboutContact.arrayChannels,
                caseId: infosAboutContact.caseId,
                statusatd: infosAboutContact.statusatd,
                score_class: infosAboutContact.score_class,
                score_value: infosAboutContact.score_value,
                nps_call: infosAboutContact.nps_call,
                isTabulation: infosAboutContact.isTabulation,
              };
              //ttkh
              console.log("INGENIUM_SUPERVISOR : ", informationusers);
              axios
                .get(
                  `${
                    connection_platform.type_connect
                  }://${pathname}:${port}/conn/carregamento-new?cdr=${
                    novadata[5]
                  }&idgroup=${getState().informationusers.idgroup}&supervisor=${
                    informationusers.supervisor
                  }`,
                )
                .then((response) => {
                  const respostas = response.data;
                  let qtdUnreadedMessages = 0;
                  respostas.forEach((resposta) => {
                    if (resposta.mimetypeid === 56) {
                      resposta.messagem = formatMimeType56(resposta, "");
                      resposta.mimetypeid = 1;
                    }
                    if (
                      resposta.datereading === null &&
                      resposta.datereading !== undefined
                    ) {
                      qtdUnreadedMessages++;
                    }
                  });
                  dispatch(
                    addListQuarentineCallQueue(
                      standbyId,
                      cdrId,
                      idAtendimento,
                      contactName,
                      scoreValue,
                      scoreClass,
                      dateTimeOfInsertionInQuarentine,
                      phoneNumber,
                      midiaId,
                      contactIdCreated,
                      qtdUnreadedMessages,
                    ),
                  );
                })
                .catch((error) => {
                  throw error;
                });

              return;
            }
          }

          axios.get(
            `${
              connection_platform.type_connect
            }://${pathname}:${port}/conn/updateattendatack?atdid=${parseInt(
              novadata[27],
            )}`,
          );

          if (novadata[37] != "" && novadata[37] != undefined) {
            if (isJson(novadata[37]) === true) {
              passjson = JSON.parse(novadata[37]);
              deliveryType = passjson.delivery_type;

              srv_wait_id = passjson.srv_wait_id;

              if (isJson(passjson.LASTSCORE) === true) {
                score_class2 = passjson.LASTSCORE.CLASS;
                score_value2 = passjson.LASTSCORE.SCORE;
              }
            }
          } else if (novadata[41] != "" && novadata[41] != undefined) {
            if (isJson(novadata[41]) === true) {
              passjson = JSON.parse(novadata[41]);
              deliveryType = passjson.delivery_type;
              score_class2 = passjson.LASTSCORE.CLASS;
              score_value2 = passjson.LASTSCORE.SCORE;
              srv_wait_id = passjson.srv_wait_id;
            }
          }

          if (cliente[0] === "Nome") {
            cliente = cliente[1];
          } else {
            cliente = telefonefilt[1];
          }

          let timecomplete = Moment().format("YYYY/MM/DD HH:mm:ss");

          if (checkAtdCurso(novadata[5]) === false) {
            if (novadata[19]) {
              var MenuBot = novadata[19];
              MenuBot = MenuBot.split("~¿");
              if (MenuBot.length != 0) {
                MenuBot.forEach((obj) => {
                  var value = obj.split(":");
                  if (value[0] === "Nome na Agenda") {
                    cliente = value[1];
                  }
                  if (value[0] === "DisplayName") {
                    cliente = value[1];
                  }
                });
              }
            }

            var chamado = "";
            var chamador = "";
            if (novadata[15] === "2") {
              chamado = telefonefilt[1];
              chamador = ramaluser;
              username = chamado.replace(/\D+/g, "");
            } else {
              chamado = novadata[21];
              chamador = telefone[0];
              username = chamador.replace(/\D+/g, "");
            }

            chamador = chamador.split(":");
            if (chamador.length >= 2) {
              chamador = chamador[1];
            } else {
              chamador = chamador[0].replace(/\D+/g, "");
            }

            let datetimeBR = Moment().format("DD/MM/YYYY HH:mm:ss");
            let valorDiferencaZap = parseInt(
              Math.abs(Math.round(ipcurrent.difftime)),
            );

            if (localStorage.getItem("NUMBERNPS") === telefonefilt[1]) {
              nps_call = true;
              localStorage.setItem("NUMBERNPS", "");
            }

            if (localStorage.getItem("ACTIVEHIDDEN") === telefonefilt[1]) {
              localStorage.setItem("ACTIVEHIDDEN", "");

              let received = dispatch(
                InsertAnswerACK(
                  parseInt(novadata[5]),
                  telefonefilt[1],
                  informationusers.id,
                  parseInt(novadata[11]),
                  "Saida",
                  parseInt(srv_wait_id) > 0 ? parseInt(srv_wait_id) : null,
                ),
              );
              received.then(function (retornoid) {
                dispatch(
                  addAnswerHidden(
                    novadata[5],
                    cliente,
                    telefonefilt[1],
                    novadata[21],
                    novadata[23],
                    criticidade,
                    novadata[19],
                    novadata[11],
                    retornoid,
                    novadata[25],
                    dataatual,
                    novadata[15],
                    novadata[13],
                    timecomplete,
                    statusagent,
                    "0",
                    0,
                    novadata[1],
                    0,
                    novadata[35],
                    "",
                    servico, //23
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    true,
                  ),
                );
              });
              if (
                parseInt(novadata[25]) !== 1 &&
                parseInt(novadata[13]) > 1 &&
                !checkAtdExistV2()
              ) {
                axios.get(
                  `${
                    connection_platform.type_connect
                  }://${pathname}:${port}/conn/insertcallhistory3?cdr=${
                    novadata[5]
                  }&userid=${
                    informationusers.id
                  }&date=${timehistory}&caller=${chamador.trim()}&called=${chamado}&directin=${
                    novadata[15]
                  }&answer=${true}&userin=&utransf=&tempatend=${0}&userout=&directionout=&motivo=6&idgroup=&status=${
                    status.reason
                  }&ring=0&read=false&mediaid=${novadata[13]}`,
                );
              }
              return true;
            }

            if (parseInt(ipcurrent.difftime) < 0) {
              datatime = Moment()
                .subtract(valorDiferencaZap, "seconds")
                .format("YYYY/MM/DD HH:mm:ss");
              datetimeBR = Moment()
                .subtract(valorDiferencaZap, "seconds")
                .format("DD/MM/YYYY HH:mm:ss");
              timecomplete = Moment()
                .subtract(valorDiferencaZap, "seconds")
                .format("YYYY/MM/DD HH:mm:ss");
            } else {
              datatime = Moment()
                .add(valorDiferencaZap, "seconds")
                .format("YYYY/MM/DD HH:mm:ss");
              datetimeBR = Moment()
                .add(valorDiferencaZap, "seconds")
                .format("DD/MM/YYYY HH:mm:ss");
              timecomplete = Moment()
                .add(valorDiferencaZap, "seconds")
                .format("YYYY/MM/DD HH:mm:ss");
            }
            // let direction = `${connection_platform.type_connect}://${pathname}:${port}/conn/carregamento?cdr=${novadata[5]}&idgroup=${informationusers.idgroup}`;
            console.log("INGENIUM_SUPERVISOR : ", informationusers);
            const getCorrectDirection = () => {
              let direction = `${connection_platform.type_connect}://${pathname}:${port}/conn/carregamento-new?cdr=${novadata[5]}&idgroup=${informationusers.idgroup}&supervisor=${informationusers.supervisor}`;
              const isAnEmailMessage =
                Boolean(novadata) &&
                novadata.length >= 14 &&
                (novadata[13] === "3" || novadata[13] === 3);

              if (isAnEmailMessage) {
                direction = `${connection_platform.type_connect}://${pathname}:${port}/conn/carregamento-new-email?cdr=${novadata[5]}&idgroup=${informationusers.idgroup}&supervisor=${informationusers.supervisor}`;
              }

              return direction;
            };
            let direction = getCorrectDirection();
            listcallqueue.map((list) => {
              if (parseInt(novadata[5]) === parseInt(list.cdrnew)) {
                direction = `${connection_platform.type_connect}://${pathname}:${port}/conn/carregarcallback?cdr=${list.queueid}&idgroup=${informationusers.idgroup}`;
              }
            });

            if (
              novadata[15] === 2 &&
              queueidfila != undefined &&
              queueidfila != 0
            )
              direction = `${connection_platform.type_connect}://${pathname}:${port}/conn/carregarcallback?cdr=${queueidfila}&idgroup=${informationusers.idgroup}`;

            var timehistory = novadata[23];
            timehistory = Moment(timehistory, "DD/MM/YYYY HH:mm:ss").format(
              "YYYY-MM-DD HH:mm:ss",
            );

            let isLoadingMessage = true;

            if (novadata[22] === "MONUSER") {
              let findIndex = clientusermonitors.findIndex(
                (client) =>
                  parseInt(client.idatendimento) === parseInt(novadata[5]),
              );
              if (findIndex !== -1) isLoadingMessage = false;
            }

            let findIndex = clientusermonitors.findIndex(
              (client) =>
                parseInt(client.idatendimento) === parseInt(novadata[5]),
            );

            const isToMonitoring = novadata[22] === "MONUSER";
            if (findIndex === -1 && isToMonitoring) {
              const isFromStandby =
                novadata.length >= 42 &&
                Boolean(novadata[41]) &&
                isJson(novadata[41]) &&
                Boolean(JSON.parse(novadata[41]).STANDBY) &&
                Boolean(JSON.parse(novadata[41]).STANDBY.ID);

              let scoreClass = "";
              let scoreValue = "";
              if (novadata.length >= 42 && isJson(novadata[41])) {
                const parsedJson = JSON.parse(novadata[41]);
                if (Boolean(parsedJson.LASTSCORE)) {
                  scoreClass = parsedJson.LASTSCORE.CLASS;
                  scoreValue = parsedJson.LASTSCORE.SCORE;
                }
              }
              let serviceAtdId = "";
              if (Boolean(novadata) && novadata.length >= 32) {
                serviceAtdId = novadata[31];
              }

              dispatch(
                clientusermonitorsin(
                  novadata[5],
                  cliente,
                  telefonefilt[1],
                  telefonefilt[1],
                  novadata[27],
                  criticidade,
                  novadata[19],
                  novadata[11],
                  novadata[27],
                  novadata[25],
                  novadata[37],
                  novadata[15],
                  novadata[13],
                  timecomplete,
                  statusagent,
                  "0",
                  "0",
                  novadata[23],
                  novadata[1],
                  novadata[39],
                  isFromStandby,
                  0,
                  scoreClass,
                  scoreValue,
                  serviceAtdId,
                  servico,
                ),
              );
            }

            if (isLoadingMessage) {
              let timeoutId = null;
              function getMessagesRecursiveInBantch() {
                axios
                  .get(direction)
                  .then((response) => {
                    let resposta = response.data;

                    qtdeMsgCDR = 0;
                    const messagesToAdd = [];
                    const addMessage = (
                      messageid,
                      message,
                      author,
                      datatime,
                      contactid,
                      typemsg,
                      statusmsg,
                      favorite,
                      dia,
                      username,
                      monuser,
                      destiny,
                      typemon,
                      replyid,
                      options,
                      title,
                      anoenvio,
                      dataenvio,
                    ) => {
                      messagesToAdd.push({
                        messageid,
                        message,
                        author,
                        datatime,
                        contactid,
                        typemsg,
                        statusmsg,
                        favorite,
                        dia,
                        username,
                        monuser,
                        destiny,
                        typemon,
                        replyid,
                        options,
                        title,
                        anoenvio,
                        dataenvio,
                      });
                    };
                    resposta.forEach(function (obj, index) {
                      if (obj.mimetypeid === 56) {
                        obj.messagem = formatMimeType56(obj, "");
                        obj.mimetypeid = 1;
                      }
                      dia = obj.diaenvio;
                      mes = obj.mesenvio;
                      mes = meses.indexOf(mes);
                      dia = dia + " de " + meses[mes - 1];
                      if (ano < obj.anoenvio || ano > obj.anoenvio)
                        dia = dia + " de " + obj.anoenvio;

                      let statusmsg = "enviado";
                      if (
                        obj.dateerror !== null &&
                        connection_platform.isStatusOfErrorInSendMessage
                      )
                        statusmsg = "error";
                      else if (obj.dateread !== null) statusmsg = "visto";
                      else if (
                        obj.datedelivered !== null ||
                        !connection_platform.isStatusOfErrorInSendMessage
                      )
                        statusmsg = "entregue";

                      if (
                        obj.datereading === null &&
                        obj.datereading !== undefined
                      ) {
                        qtdeMsgCDR++;
                        setTimeout(function () {
                          dispatch(editQtdMsg(novadata[5]));
                        }, 500);
                      }

                      if (connection_platform.attendance_screen_new) {
                        if (
                          !!obj &&
                          !!obj.messagem &&
                          typeof obj.messagem === "string"
                        ) {
                          obj.messagem = obj.messagem.replace(
                            /\\U([0-9a-fA-F]{8})/g,
                            (match, hex) => {
                              return String.fromCodePoint(parseInt(hex, 16));
                            },
                          );
                          if (
                            !isJson(obj.messagem) &&
                            obj.messagem.trimStart().startsWith("{")
                          ) {
                            const sanitized = obj.messagem
                              .replace(/\r\n/g, "\\n")
                              .replace(/\r/g, "\\r")
                              .replace(/\n/g, "\\n");
                            if (isJson(sanitized)) obj.messagem = sanitized;
                          }
                        }

                        if (isJson(obj.messagem) === true) {
                          let json = JSON.parse(obj.messagem);
                          let options = json.options;
                          let buttons = json.buttons;
                          let items = json.items;
                          if (json.menuid) {
                            let i = 1;
                            var opcoes = [];
                            for (i in options) {
                              opcoes.push(i + " - " + options[i][1]);
                            }

                            addMessage(
                              obj.id,
                              h2p(json.msg) + "§" + h2p(opcoes.join("  §  ")),
                              "Me",
                              obj.horaenvio,
                              novadata[5],
                              "2",
                              statusmsg,
                              obj.favorite,
                              dia,
                              obj.username,
                              "",
                              obj.destiny,
                              obj.mon_type_id,
                              obj.replyid,
                              "",
                              obj.title,
                              obj.anoenvio,
                              obj.data_hora_envio,
                            );
                          } else if (json.botid) {
                            let opcoes = "";
                            let filepath = null;
                            let msg = prepararParaJson(json.msg);
                            msg = msg.replace(/\r\n/gi, "§");
                            // if (parseInt(json.mimetype) === 50) {
                            //   msg = `*Seja bem-vindo(a)!*§§${msg}`;
                            // } else {
                            if (json.header) {
                              msg = `*${json.header}*§${msg}${
                                parseInt(json.mimetype) === 50 ? "§" : ""
                              }`;
                            }

                            if (items) {
                              opcoes = JSON.stringify(items).replace(
                                /"/gi,
                                "'",
                              );
                            } else if (buttons) {
                              opcoes = JSON.stringify(buttons).replace(
                                /"/gi,
                                "'",
                              );
                            } else if (parseInt(json.mimetype) === 50) {
                              opcoes = JSON.stringify([
                                {
                                  text: json.footer,
                                  flowCta: json.flow_cta,
                                },
                              ]).replace(/"/gi, "'");
                            }

                            if (json.link) {
                              filepath = json.FILEPATH || json.link;
                            }

                            addMessage(
                              obj.id,
                              msg + "~¿" + filepath,
                              "Me",
                              obj.horaenvio,
                              novadata[5],
                              "2",
                              statusmsg,
                              obj.favorite,
                              dia,
                              obj.username,
                              "",
                              obj.destiny,
                              obj.mon_type_id,
                              obj.replyid,
                              obj.mimetypeid + "§" + opcoes + "§" + json.botid,
                              obj.title,
                              obj.anoenvio,
                              obj.data_hora_envio,
                            );
                          } else if (json.LONGITUDE || json.longitude) {
                            let longitude = "";
                            let latitude = "";
                            let name = "";
                            let address = "";

                            if (json.LONGITUDE) {
                              longitude = json.LONGITUDE;
                              latitude = json.LATITUDE;
                              name = json.NAME;
                              address = json.ADDRESS;
                            } else {
                              longitude = json.longitude;
                              latitude = json.latitude;
                              name = json.name;
                              address = json.address;
                            }
                            // var msg = json.msg;
                            // msg = msg.replace(/\r\n/gi, '§');

                            addMessage(
                              obj.id,
                              address +
                                "~¿" +
                                name +
                                "~¿" +
                                longitude +
                                "~¿" +
                                latitude,
                              obj.agente ? "Me" : "username",
                              obj.horaenvio,
                              novadata[5],
                              "4",
                              statusmsg,
                              obj.favorite,
                              dia,
                              obj.username,
                              "",
                              obj.destiny,
                              obj.mon_type_id,
                              obj.replyid,
                              "",
                              obj.title,
                              obj.anoenvio,
                              obj.data_hora_envio,
                            );
                          } else if (json.URL) {
                            let opcoes = "";
                            let filepath = null;
                            if (json.FILEPATH) {
                              filepath = json.FILEPATH;
                            }
                            if (json.HSM_BUTTONS) {
                              const buttons = json.HSM_BUTTONS;
                              const buttonsFormated = [];
                              for (const btn of buttons) {
                                const objBtn = {
                                  payload: btn.payload.index,
                                  text: btn.payload.value,
                                };

                                buttonsFormated.push(objBtn);
                              }
                              opcoes = JSON.stringify(buttonsFormated).replace(
                                /"/gi,
                                "'",
                              );
                            }
                            // var msg = json.msg;
                            // msg = msg.replace(/\r\n/gi, '§');

                            addMessage(
                              obj.id,
                              json.URL + "~¿" + filepath,
                              "Me",
                              obj.horaenvio,
                              novadata[5],
                              "2",
                              statusmsg,
                              obj.favorite,
                              dia,
                              obj.username,
                              "",
                              obj.destiny,
                              obj.mon_type_id,
                              obj.replyid,
                              obj.mimetypeid + "§" + opcoes,
                              obj.title,
                              obj.anoenvio,
                              obj.data_hora_envio,
                            );
                          } else if (parseInt(json.MIMETYPE) === 30) {
                            let msgFormatted = json.MSG;
                            msgFormatted = msgFormatted.replace(/<+/g, "*");
                            msgFormatted = msgFormatted.replace(/>+/g, "*");

                            addMessage(
                              obj.id,
                              h2p(msgFormatted),
                              "Me",
                              obj.horaenvio,
                              novadata[5],
                              "2",
                              statusmsg,
                              obj.favorite,
                              dia,
                              obj.username,
                              "",
                              obj.destiny,
                              obj.mon_type_id,
                              obj.replyid,
                              "hsm§",
                              obj.title,
                              obj.anoenvio,
                              obj.data_hora_envio,
                            );
                          } else if (obj.typename === "contact") {
                            const msgArray = Array.isArray(json)
                              ? json
                              : [json];

                            msgArray.forEach((msg, index) => {
                              addMessage(
                                index === 0 ? obj.id : obj.id + `v_${index}`,
                                JSON.stringify(msg).replace(/"/gi, "'"),
                                obj.agente ? "Me" : obj.username,
                                obj.horaenvio,
                                novadata[5],
                                "11",
                                statusmsg,
                                obj.favorite,
                                dia,
                                obj.username,
                                "",
                                obj.destiny,
                                obj.mon_type_id,
                                obj.replyid,
                                "",
                                obj.title,
                                obj.anoenvio,
                                obj.data_hora_envio,
                              );
                            });
                          } else if (parseInt(obj.mimetypeid) === 50) {
                            // let msg = prepararParaJson(json.msg);
                            let opcoes = "";
                            let filepath = null;
                            let newMsg = Object.entries(json).map(
                              ([key, value]) => {
                                if (key !== "flow_token") {
                                  return `*${key}*§_${value}_§`;
                                }
                              },
                            );

                            let msg = `${newMsg.join("")}`;

                            if (items) {
                              opcoes = JSON.stringify(items).replace(
                                /"/gi,
                                "'",
                              );
                            } else if (buttons) {
                              opcoes = JSON.stringify(buttons).replace(
                                /"/gi,
                                "'",
                              );
                            }

                            if (json.link) {
                              filepath = json.FILEPATH || json.link;
                            }

                            addMessage(
                              obj.id,
                              msg + "~¿" + filepath,
                              obj.agente ? "Me" : obj.username,
                              obj.horaenvio,
                              novadata[5],
                              "2",
                              statusmsg,
                              obj.favorite,
                              dia,
                              obj.username,
                              "",
                              obj.destiny,
                              obj.mon_type_id,
                              obj.replyid,
                              obj.mimetypeid + "§" + opcoes + "§" + json.botid,
                              obj.title,
                              obj.anoenvio,
                              obj.data_hora_envio,
                            );
                          } else if (json.RESPONSE) {
                            let msgFormatted = "";

                            if (json.RESPONSE === "2") {
                              msgFormatted = `Ligação de voz permitida até ${Moment(json.DATETIME, "YYYY-MM-DD HH:mm:ss").format("DD/MM/YYYY [às] HH:mm:ss")}`;
                            } else if (json.RESPONSE === "1") {
                              msgFormatted =
                                "Ligação autorizada de forma permanente";
                            } else if (json.RESPONSE === "3") {
                              msgFormatted = "Ligação de voz bloqueada";
                            }

                            addMessage(
                              obj.id,
                              h2p(msgFormatted),
                              obj.username,
                              obj.horaenvio,
                              novadata[5],
                              "0",
                              statusmsg,
                              obj.favorite,
                              dia,
                              obj.username,
                              "",
                              obj.destiny,
                              obj.mon_type_id,
                              obj.replyid,
                              "hsm§",
                              obj.title,
                              obj.anoenvio,
                              obj.data_hora_envio,
                            );
                          } else {
                            addMessage(
                              obj.id,
                              h2p(json.msg),
                              obj.agente ? "Me" : obj.username,
                              obj.horaenvio,
                              novadata[5],
                              "0",
                              statusmsg,
                              obj.favorite,
                              dia,
                              obj.username,
                              "",
                              obj.destiny,
                              obj.mon_type_id,
                              obj.replyid,
                              "",
                              obj.title,
                              obj.anoenvio,
                              obj.data_hora_envio,
                            );
                          }
                        } else {
                          obj.messagem = obj.messagem.replace(/"/gm, '\\"');
                          if (obj.agente === false) {
                            if (obj.mimetypeid < 3) {
                              var msg = obj.messagem;
                              msg = msg.replace(/\\\\n/gi, "\r\n");
                              msg = msg.replace(/"/gi, "'");
                              msg = msg.replace(/"/gm, '\\"');

                              addMessage(
                                obj.id,
                                msg,
                                obj.username,
                                obj.horaenvio,
                                novadata[5],
                                "0",
                                statusmsg,
                                obj.favorite,
                                dia,
                                obj.username,
                                "",
                                obj.destiny,
                                obj.mon_type_id,
                                obj.replyid,
                                "",
                                obj.title,
                                obj.anoenvio,
                                obj.data_hora_envio,
                              );
                            } else if (obj.mimetypeid === 45) {
                              let recipients = [];
                              let msgIdMail = null;
                              axios
                                .get(
                                  `${connection_platform.type_connect}://${pathname}:${port}/conn/list-infomail-byid?id=${obj.id}`,
                                )
                                .then((response) => {
                                  if (response.data !== "") {
                                    let retorno =
                                      response.data[0].email.split("Â¿");
                                    retorno.map((todo) => {
                                      let stringSplit = todo.split("Â§");
                                      let type = 0;
                                      if (stringSplit[1] === "4") {
                                        type = 0;
                                      } else if (stringSplit[1] === "2") {
                                        type = 2;
                                      } else if (stringSplit[1] === "1") {
                                        type = 1;
                                      } else if (stringSplit[1] === "3") {
                                        type = 3;
                                      }
                                      console.log(
                                        "2342#%:235",
                                        response.data[0],
                                      );
                                      msgIdMail = response.data[0].externalcode;
                                      console.log("2342#%:235", msgIdMail);
                                      recipients.push({
                                        label: stringSplit[0],
                                        type: type,
                                      });
                                    });
                                    dispatch(
                                      AddMessageMail(
                                        obj.client,
                                        recipients,
                                        obj.messagem,
                                        [],
                                        obj.data_hora_envio,
                                        novadata[5],
                                        obj.id,
                                        obj.favorite,
                                        obj.id,
                                        obj.caption,
                                        msgIdMail,
                                        obj.agente,
                                      ),
                                    );
                                  }
                                });
                              console.log("2342#%:235", msgIdMail);
                              axios
                                .get(
                                  `${connection_platform.type_connect}://${pathname}:${port}/conn/getattachmentemail?id=${obj.id}`,
                                )
                                .then((response) => {
                                  dispatch(
                                    AddAttachmentsMail(obj.id, response.data),
                                  );
                                });
                              // dispatch(
                              //   EditInfoCli(
                              //     novadata[5],
                              //     obj.caption,
                              //     `Assunto: ${obj.caption}`,
                              //     obj.caption
                              //   )
                              // );
                              if (index === 0) {
                                setTimeout(() => {
                                  dispatch(
                                    EditSubjectMail(novadata[5], obj.caption),
                                  );
                                }, 1000);
                              }
                            } else {
                              let tamanhoimagem = dbfileSize(obj.filesize);

                              addMessage(
                                obj.id,
                                obj.thumbnail +
                                  "~¿" +
                                  obj.caption +
                                  "~¿" +
                                  obj.messagem +
                                  "~¿" +
                                  tamanhoimagem,
                                obj.username,
                                obj.horaenvio,
                                novadata[5],
                                "1",
                                statusmsg,
                                obj.favorite,
                                dia,
                                obj.username,
                                "",
                                obj.destiny,
                                obj.mon_type_id,
                                obj.replyid,
                                "",
                                obj.title,
                                obj.anoenvio,
                                obj.data_hora_envio,
                              );
                            }
                          } else {
                            if (obj.mimetypeid < 3) {
                              let message_fd = obj.messagem;
                              message_fd = message_fd.replace(/\n|\r\n/gi, "¿");

                              addMessage(
                                obj.id,
                                message_fd,
                                "Me",
                                obj.horaenvio,
                                novadata[5],
                                "0",
                                statusmsg,
                                obj.favorite,
                                dia,
                                obj.username,
                                "",
                                obj.destiny,
                                obj.mon_type_id,
                                obj.replyid,
                                "",
                                obj.title,
                                obj.anoenvio,
                                obj.data_hora_envio,
                              );
                            } else if (obj.mimetypeid === 45) {
                              let recipients = [];
                              let msgIdMail = null;
                              axios
                                .get(
                                  `${connection_platform.type_connect}://${pathname}:${port}/conn/list-infomail-byid?id=${obj.id}`,
                                )
                                .then((response) => {
                                  if (response.data !== "") {
                                    let retorno =
                                      response.data[0].email.split("Â¿");
                                    retorno.map((todo) => {
                                      let stringSplit = todo.split("Â§");
                                      let type = 0;
                                      if (stringSplit[1] === "4") {
                                        type = 0;
                                      } else if (stringSplit[1] === "2") {
                                        type = 2;
                                      } else if (stringSplit[1] === "1") {
                                        type = 1;
                                      } else if (stringSplit[1] === "3") {
                                        type = 3;
                                      }
                                      msgIdMail = response.data[0].externalcode;
                                      recipients.push({
                                        label: stringSplit[0],
                                        type: type,
                                      });
                                    });
                                    dispatch(
                                      AddMessageMail(
                                        obj.client,
                                        recipients,
                                        obj.messagem,
                                        [],
                                        obj.data_hora_envio,
                                        novadata[5],
                                        obj.id,
                                        obj.favorite,
                                        obj.id,
                                        obj.caption,
                                        msgIdMail,
                                        obj.agente,
                                      ),
                                    );
                                  }
                                });
                              console.log("2342#%:235");
                              axios
                                .get(
                                  `${connection_platform.type_connect}://${pathname}:${port}/conn/getattachmentemail?id=${obj.id}`,
                                )
                                .then((response) => {
                                  dispatch(
                                    AddAttachmentsMail(obj.id, response.data),
                                  );
                                });
                              // dispatch(
                              //   EditInfoCli(
                              //     novadata[5],
                              //     obj.caption,
                              //     `Assunto: ${obj.caption}`,
                              //     obj.caption
                              //   )
                              // );
                              if (index === 0) {
                                setTimeout(() => {
                                  dispatch(
                                    EditSubjectMail(novadata[5], obj.caption),
                                  );
                                }, 1000);
                              }
                            } else {
                              let tamanhoimagem = dbfileSize(obj.filesize);

                              addMessage(
                                obj.id,
                                obj.thumbnail +
                                  "~¿" +
                                  obj.caption +
                                  "~¿" +
                                  obj.messagem +
                                  "~¿" +
                                  tamanhoimagem,
                                "Me",
                                obj.horaenvio,
                                novadata[5],
                                "1",
                                statusmsg,
                                obj.favorite,
                                dia,
                                obj.username,
                                "",
                                obj.destiny,
                                obj.mon_type_id,
                                obj.replyid,
                                "",
                                obj.title,
                                obj.anoenvio,
                                obj.data_hora_envio,
                              );
                            }
                          }
                        }
                      }

                      if (!connection_platform.attendance_screen_new) {
                        if (isJson(obj.messagem) === true) {
                          let json = JSON.parse(obj.messagem);
                          let options = json.options;

                          if (json.menuid) {
                            let i = 1;
                            var opcoes = [];
                            for (i in options) {
                              opcoes.push(i + " - " + options[i][1]);
                            }

                            addMessage(
                              obj.id,
                              h2p(json.msg) + "§" + h2p(opcoes.join("  §  ")),
                              "Me",
                              obj.horaenvio,
                              novadata[5],
                              "2",
                              statusmsg,
                              obj.favorite,
                              dia,
                              username,
                              "",
                              obj.destiny,
                              "",
                              obj.replyid,
                              "",
                              obj.title,
                              obj.anoenvio,
                              obj.data_hora_envio,
                            );
                          } else if (json.botid) {
                            var msg = json.msg;
                            msg = msg.replace(/\r\n/gi, "§");

                            addMessage(
                              obj.id,
                              msg,
                              "Me",
                              obj.horaenvio,
                              novadata[5],
                              "2",
                              statusmsg,
                              obj.favorite,
                              dia,
                              username,
                              "",
                              obj.destiny,
                              "",
                              obj.replyid,
                              "",
                              obj.title,
                              obj.anoenvio,
                              obj.data_hora_envio,
                            );
                          } else if (json.LONGITUDE || json.longitude) {
                            let longitude = "";
                            let latitude = "";
                            let name = "";
                            let address = "";

                            if (json.LONGITUDE) {
                              longitude = json.LONGITUDE;
                              latitude = json.LATITUDE;
                              name = json.NAME;
                              address = json.ADDRESS;
                            } else {
                              longitude = json.longitude;
                              latitude = json.latitude;
                              name = json.name;
                              address = json.address;
                            }
                            // var msg = json.msg;
                            // msg = msg.replace(/\r\n/gi, '§');

                            addMessage(
                              obj.id,
                              address +
                                "~¿" +
                                name +
                                "~¿" +
                                longitude +
                                "~¿" +
                                latitude,
                              obj.agente ? "Me" : "username",
                              obj.horaenvio,
                              novadata[5],
                              "4",
                              statusmsg,
                              obj.favorite,
                              dia,
                              username,
                              "",
                              obj.destiny,
                              "",
                              obj.replyid,
                              "",
                              obj.title,
                              obj.anoenvio,
                              obj.data_hora_envio,
                            );
                          } else if (parseInt(json.MIMETYPE) === 30) {
                            let msgFormatted = json.MSG;
                            msgFormatted = msgFormatted.replace(/<+/g, "*");
                            msgFormatted = msgFormatted.replace(/>+/g, "*");

                            addMessage(
                              obj.id,
                              h2p(msgFormatted),
                              "Me",
                              obj.horaenvio,
                              novadata[5],
                              "0",
                              statusmsg,
                              obj.favorite,
                              dia,
                              username,
                              "",
                              obj.destiny,
                              "",
                              obj.replyid,
                              "",
                              obj.title,
                              obj.anoenvio,
                              obj.data_hora_envio,
                            );
                          } else if (json.URL) {
                            // var msg = json.msg;
                            // msg = msg.replace(/\r\n/gi, '§');

                            addMessage(
                              obj.id,
                              h2p(json.URL),
                              "Me",
                              obj.horaenvio,
                              novadata[5],
                              "0",
                              statusmsg,
                              obj.favorite,
                              dia,
                              username,
                              "",
                              obj.destiny,
                              "",
                              obj.replyid,
                              "",
                              obj.title,
                              obj.anoenvio,
                              obj.data_hora_envio,
                            );
                          } else {
                            addMessage(
                              obj.id,
                              h2p(json.msg),
                              "Me",
                              obj.horaenvio,
                              novadata[5],
                              "0",
                              statusmsg,
                              obj.favorite,
                              dia,
                              username,
                              "",
                              obj.destiny,
                              "",
                              obj.replyid,
                              "",
                              obj.title,
                              obj.anoenvio,
                              obj.data_hora_envio,
                            );
                          }
                        } else {
                          obj.messagem = obj.messagem.replace(/"/gm, '\\"');
                          if (obj.agente === false) {
                            if (obj.mimetypeid < 3) {
                              var msg = obj.messagem;
                              msg = msg.replace(/\\\\n/gi, "\r\n");
                              msg = msg.replace(/"/gm, '\\"');

                              addMessage(
                                obj.id,
                                msg,
                                obj.username,
                                obj.horaenvio,
                                novadata[5],
                                "0",
                                statusmsg,
                                obj.favorite,
                                dia,
                                username,
                                "",
                                obj.destiny,
                                "",
                                obj.replyid,
                                "",
                                obj.title,
                                obj.anoenvio,
                                obj.data_hora_envio,
                              );
                            } else {
                              let tamanhoimagem = dbfileSize(obj.filesize);

                              addMessage(
                                obj.id,
                                obj.thumbnail +
                                  "~¿" +
                                  obj.caption +
                                  "~¿" +
                                  obj.messagem +
                                  "~¿" +
                                  tamanhoimagem,
                                obj.username,
                                obj.horaenvio,
                                novadata[5],
                                "1",
                                statusmsg,
                                obj.favorite,
                                dia,
                                username,
                                "",
                                obj.destiny,
                                "",
                                obj.replyid,
                                "",
                                obj.title,
                                obj.anoenvio,
                                obj.data_hora_envio,
                              );
                            }
                          } else {
                            if (obj.mimetypeid < 3) {
                              let message_fd = obj.messagem;
                              message_fd = message_fd.replace(/\n|\r\n/gi, "¿");

                              addMessage(
                                obj.id,
                                message_fd,
                                "Me",
                                obj.horaenvio,
                                novadata[5],
                                "0",
                                statusmsg,
                                obj.favorite,
                                dia,
                                "username",
                                "",
                                obj.destiny,
                                "",
                                obj.replyid,
                                "",
                                obj.title,
                                obj.anoenvio,
                              );
                            } else {
                              let tamanhoimagem = dbfileSize(obj.filesize);

                              addMessage(
                                obj.id,
                                obj.thumbnail +
                                  "~¿" +
                                  obj.caption +
                                  "~¿" +
                                  obj.messagem +
                                  "~¿" +
                                  tamanhoimagem,
                                "Me",
                                obj.horaenvio,
                                novadata[5],
                                "1",
                                statusmsg,
                                obj.favorite,
                                dia,
                                "username",
                                "",
                                obj.destiny,
                                "",
                                obj.replyid,
                                "",
                                obj.title,
                                obj.anoenvio,
                                obj.data_hora_envio,
                              );
                            }
                          }
                        }
                      }
                    });

                    if (messagesToAdd.length !== 0) {
                      dispatch(AddMessagesInBatch(novadata[5], messagesToAdd));

                      const tabulatedInfos =
                        tabulationHandler.getInitialTabulatedInfos(resposta);

                      dispatch(
                        tabulationHandler.editTabulatedInfos(
                          parseInt(novadata[5]),
                          tabulatedInfos,
                        ),
                      );
                    } else {
                      dispatch(
                        tabulationHandler.editTabulatedInfos(
                          parseInt(novadata[5]),
                          [],
                        ),
                      );
                    }

                    dispatch(typingadd(novadata[5], 0));

                    dispatch(
                      editTotalQtdMsgMonitoring(novadata[5], qtdeMsgCDR),
                    );
                    // const isFromStandby =
                    //   novadata.length >= 42 &&
                    //   Boolean(novadata[41]) &&
                    //   isJson(novadata[41]) &&
                    //   Boolean(JSON.parse(novadata[41]).STANDBY) &&
                    //   Boolean(JSON.parse(novadata[41]).STANDBY.ID);

                    // let scoreClass = "";
                    // let scoreValue = "";
                    // if (novadata.length >= 42 && isJson(novadata[41])) {
                    //   const parsedJson = JSON.parse(novadata[41]);
                    //   if (Boolean(parsedJson.LASTSCORE)) {
                    //     scoreClass = parsedJson.LASTSCORE.CLASS;
                    //     scoreValue = parsedJson.LASTSCORE.SCORE;
                    //   }
                    // }
                    // dispatch(
                    //   clientusermonitorsin(
                    //     novadata[5],
                    //     cliente,
                    //     telefonefilt[1],
                    //     telefonefilt[1],
                    //     novadata[27],
                    //     criticidade,
                    //     novadata[19],
                    //     novadata[11],
                    //     novadata[27],
                    //     novadata[25],
                    //     novadata[37],
                    //     novadata[15],
                    //     novadata[13],
                    //     timecomplete,
                    //     statusagent,
                    //     "0",
                    //     "0",
                    //     novadata[23],
                    //     novadata[1],
                    //     novadata[39],
                    //     isFromStandby,
                    //     qtdeMsgCDR,
                    //     scoreClass,
                    //     scoreValue
                    //   )
                    // );
                  })
                  .catch((error) => {
                    // timeoutId = setTimeout(getMessagesRecursive, 2000);
                    // throw error;
                    dispatch(
                      tabulationHandler.editTabulatedInfos(
                        parseInt(novadata[5]),
                        [],
                      ),
                    );
                  });
              }
              function getMessagesRecursive() {
                axios
                  .get(direction)
                  .then((response) => {
                    let resposta = response.data;

                    qtdeMsgCDR = 0;
                    resposta.forEach(function (obj, index) {
                      dia = obj.diaenvio;
                      mes = obj.mesenvio;
                      mes = meses.indexOf(mes);
                      dia = dia + " de " + meses[mes - 1];
                      if (ano < obj.anoenvio || ano > obj.anoenvio)
                        dia = dia + " de " + obj.anoenvio;

                      let statusmsg = "enviado";
                      if (
                        obj.dateerror !== null &&
                        connection_platform.isStatusOfErrorInSendMessage
                      )
                        statusmsg = "error";
                      else if (obj.dateread !== null) statusmsg = "visto";
                      else if (
                        obj.datedelivered !== null ||
                        !connection_platform.isStatusOfErrorInSendMessage
                      )
                        statusmsg = "entregue";

                      if (
                        obj.datereading === null &&
                        obj.datereading !== undefined
                      ) {
                        qtdeMsgCDR++;
                        setTimeout(function () {
                          dispatch(editQtdMsg(novadata[5]));
                        }, 500);
                      }

                      if (connection_platform.attendance_screen_new) {
                        if (
                          !!obj &&
                          !!obj.messagem &&
                          typeof obj.messagem === "string"
                        ) {
                          obj.messagem = obj.messagem.replace(
                            /\\U([0-9a-fA-F]{8})/g,
                            (match, hex) => {
                              return String.fromCodePoint(parseInt(hex, 16));
                            },
                          );
                          if (
                            !isJson(obj.messagem) &&
                            obj.messagem.trimStart().startsWith("{")
                          ) {
                            const sanitized = obj.messagem
                              .replace(/\r\n/g, "\\n")
                              .replace(/\r/g, "\\r")
                              .replace(/\n/g, "\\n");
                            if (isJson(sanitized)) obj.messagem = sanitized;
                          }
                        }

                        if (isJson(obj.messagem) === true) {
                          let json = JSON.parse(obj.messagem);
                          let options = json.options;
                          let buttons = json.buttons;
                          let items = json.items;

                          if (json.menuid) {
                            let i = 1;
                            var opcoes = [];
                            for (i in options) {
                              opcoes.push(i + " - " + options[i][1]);
                            }

                            dispatch(
                              addMessage(
                                obj.id,
                                h2p(json.msg) + "§" + h2p(opcoes.join("  §  ")),
                                "Me",
                                obj.horaenvio,
                                novadata[5],
                                "2",
                                statusmsg,
                                obj.favorite,
                                dia,
                                obj.username,
                                "",
                                obj.destiny,
                                obj.mon_type_id,
                                obj.replyid,
                                "",
                                obj.title,
                                obj.anoenvio,
                                obj.data_hora_envio,
                              ),
                            );
                          } else if (json.botid) {
                            let opcoes = "";
                            let filepath = null;
                            let msg = prepararParaJson(json.msg);
                            msg = msg.replace(/\r\n/gi, "§");
                            // if (parseInt(json.mimetype) === 50) {
                            //   msg = `*Seja bem-vindo(a)!*§§${msg}`;
                            // } else {
                            if (json.header) {
                              msg = `*${json.header}*§${msg}${
                                parseInt(json.mimetype) === 50 ? "§" : ""
                              }`;
                            }

                            if (items) {
                              opcoes = JSON.stringify(items).replace(
                                /"/gi,
                                "'",
                              );
                            } else if (buttons) {
                              opcoes = JSON.stringify(buttons).replace(
                                /"/gi,
                                "'",
                              );
                            } else if (parseInt(json.mimetype) === 50) {
                              opcoes = JSON.stringify([
                                {
                                  text: json.footer,
                                  flowCta: json.flow_cta,
                                },
                              ]).replace(/"/gi, "'");
                            }

                            if (json.link) {
                              filepath = json.FILEPATH || json.link;
                            }

                            dispatch(
                              addMessage(
                                obj.id,
                                msg + "~¿" + filepath,
                                "Me",
                                obj.horaenvio,
                                novadata[5],
                                "2",
                                statusmsg,
                                obj.favorite,
                                dia,
                                obj.username,
                                "",
                                obj.destiny,
                                obj.mon_type_id,
                                obj.replyid,
                                obj.mimetypeid +
                                  "§" +
                                  opcoes +
                                  "§" +
                                  json.botid,
                                obj.title,
                                obj.anoenvio,
                                obj.data_hora_envio,
                              ),
                            );
                          } else if (json.LONGITUDE || json.longitude) {
                            let longitude = "";
                            let latitude = "";
                            let name = "";
                            let address = "";

                            if (json.LONGITUDE) {
                              longitude = json.LONGITUDE;
                              latitude = json.LATITUDE;
                              name = json.NAME;
                              address = json.ADDRESS;
                            } else {
                              longitude = json.longitude;
                              latitude = json.latitude;
                              name = json.name;
                              address = json.address;
                            }
                            // var msg = json.msg;
                            // msg = msg.replace(/\r\n/gi, '§');
                            dispatch(
                              addMessage(
                                obj.id,
                                address +
                                  "~¿" +
                                  name +
                                  "~¿" +
                                  longitude +
                                  "~¿" +
                                  latitude,
                                obj.agente ? "Me" : "username",
                                obj.horaenvio,
                                novadata[5],
                                "4",
                                statusmsg,
                                obj.favorite,
                                dia,
                                obj.username,
                                "",
                                obj.destiny,
                                obj.mon_type_id,
                                obj.replyid,
                                "",
                                obj.title,
                                obj.anoenvio,
                                obj.data_hora_envio,
                              ),
                            );
                          } else if (json.URL) {
                            let opcoes = "";
                            let filepath = null;
                            if (json.FILEPATH) {
                              filepath = json.FILEPATH;
                            }
                            if (json.HSM_BUTTONS) {
                              const buttons = json.HSM_BUTTONS;
                              const buttonsFormated = [];
                              for (const btn of buttons) {
                                const objBtn = {
                                  payload: btn.payload.index,
                                  text: btn.payload.value,
                                };

                                buttonsFormated.push(objBtn);
                              }
                              opcoes = JSON.stringify(buttonsFormated).replace(
                                /"/gi,
                                "'",
                              );
                            }
                            // var msg = json.msg;
                            // msg = msg.replace(/\r\n/gi, '§');
                            dispatch(
                              addMessage(
                                obj.id,
                                json.URL + "~¿" + filepath,
                                "Me",
                                obj.horaenvio,
                                novadata[5],
                                "2",
                                statusmsg,
                                obj.favorite,
                                dia,
                                obj.username,
                                "",
                                obj.destiny,
                                obj.mon_type_id,
                                obj.replyid,
                                obj.mimetypeid + "§" + opcoes,
                                obj.title,
                                obj.anoenvio,
                                obj.data_hora_envio,
                              ),
                            );
                          } else if (parseInt(json.MIMETYPE) === 30) {
                            let msgFormatted = json.MSG;
                            msgFormatted = msgFormatted.replace(/<+/g, "*");
                            msgFormatted = msgFormatted.replace(/>+/g, "*");
                            dispatch(
                              addMessage(
                                obj.id,
                                h2p(msgFormatted),
                                "Me",
                                obj.horaenvio,
                                novadata[5],
                                "2",
                                statusmsg,
                                obj.favorite,
                                dia,
                                obj.username,
                                "",
                                obj.destiny,
                                obj.mon_type_id,
                                obj.replyid,
                                "hsm§",
                                obj.title,
                                obj.anoenvio,
                                obj.data_hora_envio,
                              ),
                            );
                          } else if (obj.typename === "contact") {
                            const msgArray = Array.isArray(json)
                              ? json
                              : [json];

                            msgArray.forEach((msg, index) => {
                              addMessage(
                                index === 0 ? obj.id : obj.id + `v_${index}`,
                                JSON.stringify(msg).replace(/"/gi, "'"),
                                obj.agente ? "Me" : obj.username,
                                obj.horaenvio,
                                novadata[5],
                                "11",
                                statusmsg,
                                obj.favorite,
                                dia,
                                obj.username,
                                "",
                                obj.destiny,
                                obj.mon_type_id,
                                obj.replyid,
                                "",
                                obj.title,
                                obj.anoenvio,
                                obj.data_hora_envio,
                              );
                            });
                          } else if (parseInt(obj.mimetypeid) === 50) {
                            // let msg = prepararParaJson(json.msg);
                            let opcoes = "";
                            let filepath = null;
                            let newMsg = Object.entries(json).map(
                              ([key, value]) => {
                                if (key !== "flow_token") {
                                  return `*${key}*§_${value}_§`;
                                }
                              },
                            );

                            let msg = `${newMsg.join("")}`;

                            if (items) {
                              opcoes = JSON.stringify(items).replace(
                                /"/gi,
                                "'",
                              );
                            } else if (buttons) {
                              opcoes = JSON.stringify(buttons).replace(
                                /"/gi,
                                "'",
                              );
                            }

                            if (json.link) {
                              filepath = json.FILEPATH || json.link;
                            }

                            dispatch(
                              addMessage(
                                obj.id,
                                msg + "~¿" + filepath,
                                obj.agente ? "Me" : obj.username,
                                obj.horaenvio,
                                novadata[5],
                                "2",
                                statusmsg,
                                obj.favorite,
                                dia,
                                obj.username,
                                "",
                                obj.destiny,
                                obj.mon_type_id,
                                obj.replyid,
                                obj.mimetypeid +
                                  "§" +
                                  opcoes +
                                  "§" +
                                  json.botid,
                                obj.title,
                                obj.anoenvio,
                                obj.data_hora_envio,
                              ),
                            );
                          } else {
                            dispatch(
                              addMessage(
                                obj.id,
                                h2p(json.msg),
                                obj.agente ? "Me" : obj.username,
                                obj.horaenvio,
                                novadata[5],
                                "0",
                                statusmsg,
                                obj.favorite,
                                dia,
                                obj.username,
                                "",
                                obj.destiny,
                                obj.mon_type_id,
                                obj.replyid,
                                "",
                                obj.title,
                                obj.anoenvio,
                                obj.data_hora_envio,
                              ),
                            );
                          }
                        } else {
                          obj.messagem = obj.messagem.replace(/"/gm, '\\"');
                          if (obj.agente === false) {
                            if (obj.mimetypeid < 3) {
                              var msg = obj.messagem;
                              msg = msg.replace(/\\\\n/gi, "\r\n");
                              msg = msg.replace(/"/gi, "'");
                              msg = msg.replace(/"/gm, '\\"');

                              dispatch(
                                addMessage(
                                  obj.id,
                                  msg,
                                  obj.username,
                                  obj.horaenvio,
                                  novadata[5],
                                  "0",
                                  statusmsg,
                                  obj.favorite,
                                  dia,
                                  obj.username,
                                  "",
                                  obj.destiny,
                                  obj.mon_type_id,
                                  obj.replyid,
                                  "",
                                  obj.title,
                                  obj.anoenvio,
                                  obj.data_hora_envio,
                                ),
                              );
                            } else if (obj.mimetypeid === 45) {
                              let recipients = [];
                              let msgIdMail = null;
                              axios
                                .get(
                                  `${connection_platform.type_connect}://${pathname}:${port}/conn/list-infomail-byid?id=${obj.id}`,
                                )
                                .then((response) => {
                                  if (response.data !== "") {
                                    let retorno =
                                      response.data[0].email.split("Â¿");
                                    retorno.map((todo) => {
                                      let stringSplit = todo.split("Â§");
                                      let type = 0;
                                      if (stringSplit[1] === "4") {
                                        type = 0;
                                      } else if (stringSplit[1] === "2") {
                                        type = 2;
                                      } else if (stringSplit[1] === "1") {
                                        type = 1;
                                      } else if (stringSplit[1] === "3") {
                                        type = 3;
                                      }
                                      console.log(
                                        "2342#%:235",
                                        response.data[0],
                                      );
                                      msgIdMail = response.data[0].externalcode;
                                      console.log("2342#%:235", msgIdMail);
                                      recipients.push({
                                        label: stringSplit[0],
                                        type: type,
                                      });
                                    });
                                    dispatch(
                                      AddMessageMail(
                                        obj.client,
                                        recipients,
                                        obj.messagem,
                                        [],
                                        obj.data_hora_envio,
                                        novadata[5],
                                        obj.id,
                                        obj.favorite,
                                        obj.id,
                                        obj.caption,
                                        msgIdMail,
                                        obj.agente,
                                      ),
                                    );
                                  }
                                });
                              console.log("2342#%:235", msgIdMail);
                              axios
                                .get(
                                  `${connection_platform.type_connect}://${pathname}:${port}/conn/getattachmentemail?id=${obj.id}`,
                                )
                                .then((response) => {
                                  dispatch(
                                    AddAttachmentsMail(obj.id, response.data),
                                  );
                                });
                              // dispatch(
                              //   EditInfoCli(
                              //     novadata[5],
                              //     obj.caption,
                              //     `Assunto: ${obj.caption}`,
                              //     obj.caption
                              //   )
                              // );
                              if (index === 0) {
                                setTimeout(() => {
                                  dispatch(
                                    EditSubjectMail(novadata[5], obj.caption),
                                  );
                                }, 1000);
                              }
                            } else {
                              let tamanhoimagem = dbfileSize(obj.filesize);
                              dispatch(
                                addMessage(
                                  obj.id,
                                  obj.thumbnail +
                                    "~¿" +
                                    obj.caption +
                                    "~¿" +
                                    obj.messagem +
                                    "~¿" +
                                    tamanhoimagem,
                                  obj.username,
                                  obj.horaenvio,
                                  novadata[5],
                                  "1",
                                  statusmsg,
                                  obj.favorite,
                                  dia,
                                  obj.username,
                                  "",
                                  obj.destiny,
                                  obj.mon_type_id,
                                  obj.replyid,
                                  "",
                                  obj.title,
                                  obj.anoenvio,
                                  obj.data_hora_envio,
                                ),
                              );
                            }
                          } else {
                            if (obj.mimetypeid < 3) {
                              let message_fd = obj.messagem;
                              message_fd = message_fd.replace(/\n|\r\n/gi, "¿");
                              dispatch(
                                addMessage(
                                  obj.id,
                                  message_fd,
                                  "Me",
                                  obj.horaenvio,
                                  novadata[5],
                                  "0",
                                  statusmsg,
                                  obj.favorite,
                                  dia,
                                  obj.username,
                                  "",
                                  obj.destiny,
                                  obj.mon_type_id,
                                  obj.replyid,
                                  "",
                                  obj.title,
                                  obj.anoenvio,
                                  obj.data_hora_envio,
                                ),
                              );
                            } else if (obj.mimetypeid === 45) {
                              let recipients = [];
                              let msgIdMail = null;
                              axios
                                .get(
                                  `${connection_platform.type_connect}://${pathname}:${port}/conn/list-infomail-byid?id=${obj.id}`,
                                )
                                .then((response) => {
                                  if (response.data !== "") {
                                    let retorno =
                                      response.data[0].email.split("Â¿");
                                    retorno.map((todo) => {
                                      let stringSplit = todo.split("Â§");
                                      let type = 0;
                                      if (stringSplit[1] === "4") {
                                        type = 0;
                                      } else if (stringSplit[1] === "2") {
                                        type = 2;
                                      } else if (stringSplit[1] === "1") {
                                        type = 1;
                                      } else if (stringSplit[1] === "3") {
                                        type = 3;
                                      }
                                      msgIdMail = response.data[0].externalcode;
                                      recipients.push({
                                        label: stringSplit[0],
                                        type: type,
                                      });
                                    });
                                    dispatch(
                                      AddMessageMail(
                                        obj.client,
                                        recipients,
                                        obj.messagem,
                                        [],
                                        obj.data_hora_envio,
                                        novadata[5],
                                        obj.id,
                                        obj.favorite,
                                        obj.id,
                                        obj.caption,
                                        msgIdMail,
                                        obj.agente,
                                      ),
                                    );
                                  }
                                });
                              console.log("2342#%:235");
                              axios
                                .get(
                                  `${connection_platform.type_connect}://${pathname}:${port}/conn/getattachmentemail?id=${obj.id}`,
                                )
                                .then((response) => {
                                  dispatch(
                                    AddAttachmentsMail(obj.id, response.data),
                                  );
                                });
                              // dispatch(
                              //   EditInfoCli(
                              //     novadata[5],
                              //     obj.caption,
                              //     `Assunto: ${obj.caption}`,
                              //     obj.caption
                              //   )
                              // );
                              if (index === 0) {
                                setTimeout(() => {
                                  dispatch(
                                    EditSubjectMail(novadata[5], obj.caption),
                                  );
                                }, 1000);
                              }
                            } else {
                              let tamanhoimagem = dbfileSize(obj.filesize);

                              dispatch(
                                addMessage(
                                  obj.id,
                                  obj.thumbnail +
                                    "~¿" +
                                    obj.caption +
                                    "~¿" +
                                    obj.messagem +
                                    "~¿" +
                                    tamanhoimagem,
                                  "Me",
                                  obj.horaenvio,
                                  novadata[5],
                                  "1",
                                  statusmsg,
                                  obj.favorite,
                                  dia,
                                  obj.username,
                                  "",
                                  obj.destiny,
                                  obj.mon_type_id,
                                  obj.replyid,
                                  "",
                                  obj.title,
                                  obj.anoenvio,
                                  obj.data_hora_envio,
                                ),
                              );
                            }
                          }
                        }
                      }

                      if (!connection_platform.attendance_screen_new) {
                        if (isJson(obj.messagem) === true) {
                          let json = JSON.parse(obj.messagem);
                          let options = json.options;

                          if (json.menuid) {
                            let i = 1;
                            var opcoes = [];
                            for (i in options) {
                              opcoes.push(i + " - " + options[i][1]);
                            }
                            dispatch(
                              addMessage(
                                obj.id,
                                h2p(json.msg) + "§" + h2p(opcoes.join("  §  ")),
                                "Me",
                                obj.horaenvio,
                                novadata[5],
                                "2",
                                statusmsg,
                                obj.favorite,
                                dia,
                                username,
                                "",
                                obj.destiny,
                                "",
                                obj.replyid,
                                "",
                                obj.title,
                                obj.anoenvio,
                                obj.data_hora_envio,
                              ),
                            );
                          } else if (json.botid) {
                            var msg = json.msg;
                            msg = msg.replace(/\r\n/gi, "§");
                            dispatch(
                              addMessage(
                                obj.id,
                                msg,
                                "Me",
                                obj.horaenvio,
                                novadata[5],
                                "2",
                                statusmsg,
                                obj.favorite,
                                dia,
                                username,
                                "",
                                obj.destiny,
                                "",
                                obj.replyid,
                                "",
                                obj.title,
                                obj.anoenvio,
                                obj.data_hora_envio,
                              ),
                            );
                          } else if (json.LONGITUDE || json.longitude) {
                            let longitude = "";
                            let latitude = "";
                            let name = "";
                            let address = "";

                            if (json.LONGITUDE) {
                              longitude = json.LONGITUDE;
                              latitude = json.LATITUDE;
                              name = json.NAME;
                              address = json.ADDRESS;
                            } else {
                              longitude = json.longitude;
                              latitude = json.latitude;
                              name = json.name;
                              address = json.address;
                            }
                            // var msg = json.msg;
                            // msg = msg.replace(/\r\n/gi, '§');
                            dispatch(
                              addMessage(
                                obj.id,
                                address +
                                  "~¿" +
                                  name +
                                  "~¿" +
                                  longitude +
                                  "~¿" +
                                  latitude,
                                obj.agente ? "Me" : "username",
                                obj.horaenvio,
                                novadata[5],
                                "4",
                                statusmsg,
                                obj.favorite,
                                dia,
                                username,
                                "",
                                obj.destiny,
                                "",
                                obj.replyid,
                                "",
                                obj.title,
                                obj.anoenvio,
                                obj.data_hora_envio,
                              ),
                            );
                          } else if (parseInt(json.MIMETYPE) === 30) {
                            let msgFormatted = json.MSG;
                            msgFormatted = msgFormatted.replace(/<+/g, "*");
                            msgFormatted = msgFormatted.replace(/>+/g, "*");
                            dispatch(
                              addMessage(
                                obj.id,
                                h2p(msgFormatted),
                                "Me",
                                obj.horaenvio,
                                novadata[5],
                                "0",
                                statusmsg,
                                obj.favorite,
                                dia,
                                username,
                                "",
                                obj.destiny,
                                "",
                                obj.replyid,
                                "",
                                obj.title,
                                obj.anoenvio,
                                obj.data_hora_envio,
                              ),
                            );
                          } else if (json.URL) {
                            // var msg = json.msg;
                            // msg = msg.replace(/\r\n/gi, '§');
                            dispatch(
                              addMessage(
                                obj.id,
                                h2p(json.URL),
                                "Me",
                                obj.horaenvio,
                                novadata[5],
                                "0",
                                statusmsg,
                                obj.favorite,
                                dia,
                                username,
                                "",
                                obj.destiny,
                                "",
                                obj.replyid,
                                "",
                                obj.title,
                                obj.anoenvio,
                                obj.data_hora_envio,
                              ),
                            );
                          } else {
                            dispatch(
                              addMessage(
                                obj.id,
                                h2p(json.msg),
                                "Me",
                                obj.horaenvio,
                                novadata[5],
                                "0",
                                statusmsg,
                                obj.favorite,
                                dia,
                                username,
                                "",
                                obj.destiny,
                                "",
                                obj.replyid,
                                "",
                                obj.title,
                                obj.anoenvio,
                                obj.data_hora_envio,
                              ),
                            );
                          }
                        } else {
                          obj.messagem = obj.messagem.replace(/"/gm, '\\"');
                          if (obj.agente === false) {
                            if (obj.mimetypeid < 3) {
                              var msg = obj.messagem;
                              msg = msg.replace(/\\\\n/gi, "\r\n");
                              msg = msg.replace(/"/gm, '\\"');
                              dispatch(
                                addMessage(
                                  obj.id,
                                  msg,
                                  obj.username,
                                  obj.horaenvio,
                                  novadata[5],
                                  "0",
                                  statusmsg,
                                  obj.favorite,
                                  dia,
                                  username,
                                  "",
                                  obj.destiny,
                                  "",
                                  obj.replyid,
                                  "",
                                  obj.title,
                                  obj.anoenvio,
                                  obj.data_hora_envio,
                                ),
                              );
                            } else {
                              let tamanhoimagem = dbfileSize(obj.filesize);
                              dispatch(
                                addMessage(
                                  obj.id,
                                  obj.thumbnail +
                                    "~¿" +
                                    obj.caption +
                                    "~¿" +
                                    obj.messagem +
                                    "~¿" +
                                    tamanhoimagem,
                                  obj.username,
                                  obj.horaenvio,
                                  novadata[5],
                                  "1",
                                  statusmsg,
                                  obj.favorite,
                                  dia,
                                  username,
                                  "",
                                  obj.destiny,
                                  "",
                                  obj.replyid,
                                  "",
                                  obj.title,
                                  obj.anoenvio,
                                  obj.data_hora_envio,
                                ),
                              );
                            }
                          } else {
                            if (obj.mimetypeid < 3) {
                              let message_fd = obj.messagem;
                              message_fd = message_fd.replace(/\n|\r\n/gi, "¿");
                              dispatch(
                                addMessage(
                                  obj.id,
                                  message_fd,
                                  "Me",
                                  obj.horaenvio,
                                  novadata[5],
                                  "0",
                                  statusmsg,
                                  obj.favorite,
                                  dia,
                                  "username",
                                  "",
                                  obj.destiny,
                                  "",
                                  obj.replyid,
                                  "",
                                  obj.title,
                                  obj.anoenvio,
                                ),
                              );
                            } else {
                              let tamanhoimagem = dbfileSize(obj.filesize);

                              dispatch(
                                addMessage(
                                  obj.id,
                                  obj.thumbnail +
                                    "~¿" +
                                    obj.caption +
                                    "~¿" +
                                    obj.messagem +
                                    "~¿" +
                                    tamanhoimagem,
                                  "Me",
                                  obj.horaenvio,
                                  novadata[5],
                                  "1",
                                  statusmsg,
                                  obj.favorite,
                                  dia,
                                  "username",
                                  "",
                                  obj.destiny,
                                  "",
                                  obj.replyid,
                                  "",
                                  obj.title,
                                  obj.anoenvio,
                                  obj.data_hora_envio,
                                ),
                              );
                            }
                          }
                        }
                      }
                    });

                    dispatch(typingadd(novadata[5], 0));

                    dispatch(
                      editTotalQtdMsgMonitoring(novadata[5], qtdeMsgCDR),
                    );
                    // const isFromStandby =
                    //   novadata.length >= 42 &&
                    //   Boolean(novadata[41]) &&
                    //   isJson(novadata[41]) &&
                    //   Boolean(JSON.parse(novadata[41]).STANDBY) &&
                    //   Boolean(JSON.parse(novadata[41]).STANDBY.ID);

                    // let scoreClass = "";
                    // let scoreValue = "";
                    // if (novadata.length >= 42 && isJson(novadata[41])) {
                    //   const parsedJson = JSON.parse(novadata[41]);
                    //   if (Boolean(parsedJson.LASTSCORE)) {
                    //     scoreClass = parsedJson.LASTSCORE.CLASS;
                    //     scoreValue = parsedJson.LASTSCORE.SCORE;
                    //   }
                    // }
                    // dispatch(
                    //   clientusermonitorsin(
                    //     novadata[5],
                    //     cliente,
                    //     telefonefilt[1],
                    //     telefonefilt[1],
                    //     novadata[27],
                    //     criticidade,
                    //     novadata[19],
                    //     novadata[11],
                    //     novadata[27],
                    //     novadata[25],
                    //     novadata[37],
                    //     novadata[15],
                    //     novadata[13],
                    //     timecomplete,
                    //     statusagent,
                    //     "0",
                    //     "0",
                    //     novadata[23],
                    //     novadata[1],
                    //     novadata[39],
                    //     isFromStandby,
                    //     qtdeMsgCDR,
                    //     scoreClass,
                    //     scoreValue
                    //   )
                    // );

                    if (resposta.length !== 0) {
                      const tabulatedInfos =
                        tabulationHandler.getInitialTabulatedInfos(resposta);

                      dispatch(
                        tabulationHandler.editTabulatedInfos(
                          parseInt(novadata[5]),
                          tabulatedInfos,
                        ),
                      );
                    } else {
                      dispatch(
                        tabulationHandler.editTabulatedInfos(
                          parseInt(novadata[5]),
                          [],
                        ),
                      );
                    }
                  })
                  .catch((error) => {
                    dispatch(
                      tabulationHandler.editTabulatedInfos(
                        parseInt(novadata[5]),
                        [],
                      ),
                    );
                    timeoutId = setTimeout(getMessagesRecursive, 2000);
                    throw error;
                  });
              }
              if (
                Boolean(novadata) &&
                novadata.length >= 14 &&
                (novadata[13] === 3 || novadata[13] === "3")
              ) {
                getMessagesRecursive();
              } else {
                getMessagesRecursiveInBantch();
              }
              if (Boolean(timeoutId)) {
                clearTimeout(timeoutId);
              }
            }

            var result = 0;
            //var resultCdr = false

            if (novadata[22] != "MONUSER") {
              // let checkAtd = atdsimult.map(simult => {
              //  if(parseInt(simult.idatendimento) === parseInt(novadata[5]))
              //   resultCdr = true
              // })

              if (
                informationusers.login_nc2 === true &&
                (atdsimult.length === 1 || atdsimult.length === 0)
              ) {
                nc2Service.nc2AlteraStatus(informationusers.ramal, "2");
              }

              if (ipcurrent.audio) {
                var snd = new Audio(
                  connection_platform.type_connect +
                    "://" +
                    ipcurrent.ip +
                    ":" +
                    connection_platform.port_apache_view_extern +
                    "/ingweb/frontend/build/sound/ring_usr.mp3",
                );

                console.log(
                  "INGENIUM_AUDIO : ",
                  connection_platform.type_connect +
                    "://" +
                    ipcurrent.ip +
                    ":" +
                    connection_platform.port_apache_view_extern +
                    "/ingweb/frontend/build/sound/ring_usr.mp3",
                );

                snd.play();
              }

              dia = Moment().format("DD");
              mes = Moment().format("MM");
              mes = meses.indexOf(mes);
              dia = dia + " de " + meses[mes - 1];
              var statusagent = status.reason;
              var estadopos = status.status;
              var dataatual = Moment().format("DD/MM/YYYY HH:mm:ss");
              var strCaseId = "";

              if (estadopos === "ChamandoChat") {
                estadopos = "Livre";
              }
              let actualUrl = `${connection_platform.type_connect}://${pathname}:${port}/conn/getmidiasnumber?number=${telefonefilt[1]}`;
              actualUrl = `${connection_platform.type_connect}://${pathname}:${port}/conn/getmidiasnumberv2?number=${telefonefilt[1]}`;
               setTimeout(function () {
              axios.get(actualUrl).then((response) => {
                  if (response.data !== "") {
                      dispatch(
                        changeNumberDisponiblesChannel(
                          novadata[5],
                          response.data,
                        ),
                      );
                  }
                });
              }, 5000);

              if (informationusers.nameauth === "IngDesk") {
                //CHECAR SE POSSUI INGDESK HABILITADO
                let CONTACTCDR = novadata.indexOf("CONTACTID");
                let IDCONTACTCDR = JSON.parse(novadata[CONTACTCDR + 1]);
                axios
                  .get(
                    `${connection_platform.type_connect}://${pathname}:${port}/conn/getcaseidingdesk?cdrid=${IDCONTACTCDR}`,
                  )
                  .then((response) => {
                    if (response.data.length > 0) {
                      setTimeout(function () {
                        strCaseId = response.data[0].caseid;
                        dispatch(
                          changeAtdIngDeskSuccess(
                            telefonefilt[1],
                            "",
                            "",
                            strCaseId,
                          ),
                        );
                        dispatch(
                          isSaveInteractionIngDesk({
                            caseId: strCaseId,
                            isSendLog: true,
                          }),
                        );
                        dispatch(
                          changeAtdIngDesk(telefonefilt[1], "", "", strCaseId),
                        );

                        //olhar a qtde de atendimentos do momento
                        if (atdsimult.length === 0)
                          dispatch(ShowVisibleNextAtd("ocultar", true));
                      }, 1500);
                    }
                  });
              }

              listcallqueue.map((queue) => {
                if (parseInt(queue.cdridnew) === parseInt(novadata[5])) {
                  cpark = true;
                }
              });

              if (parseInt(cdrparkid) === parseInt(novadata[5])) {
                cpark = true;
              }

              callhistory[novadata[5]] = [
                novadata[5],
                novadata[7],
                novadata[23],
                chamador,
                chamado,
                true,
                "",
                timecomplete,
                "Desconectado por origem",
                "",
                statusagent,
                0,
                "",
                "",
                novadata[15],
                novadata[13],
              ];

              if (
                parseInt(novadata[25]) !== 1 &&
                parseInt(novadata[13]) > 1 &&
                !checkAtdExistV2()
              ) {
                axios.get(
                  `${
                    connection_platform.type_connect
                  }://${pathname}:${port}/conn/insertcallhistory3?cdr=${
                    novadata[5]
                  }&userid=${
                    informationusers.id
                  }&date=${timehistory}&caller=${chamador.trim()}&called=${chamado}&directin=${
                    novadata[15]
                  }&answer=${true}&userin=&utransf=&tempatend=${0}&userout=&directionout=&motivo=6&idgroup=&status=${
                    status.reason
                  }&ring=0&read=false&mediaid=${novadata[13]}`,
                );
              }

              if (
                parseInt(novadata[15]) === 1 &&
                novadata[25] === "0" &&
                !checkAtdExistV2()
              ) {
                let received = dispatch(
                  InsertAnswerACK(
                    parseInt(novadata[5]),
                    telefonefilt[1],
                    userid,
                    parseInt(novadata[11]),
                    "Entrada",
                    parseInt(srv_wait_id) > 0 ? parseInt(srv_wait_id) : null,
                  ),
                );

                received.then(function (result) {
                  if (cpark === true || atendimento.length === 0) {
                    dispatch(
                      addAtendimento(
                        novadata[5],
                        cliente,
                        telefonefilt[1],
                        novadata[21],
                        novadata[23],
                        criticidade,
                        novadata[19],
                        novadata[11],
                        result,
                        novadata[25],
                        dataatual,
                        novadata[15],
                        novadata[13],
                        timecomplete,
                        statusagent,
                        "0",
                        0,
                        novadata[1],
                        0,
                        novadata[35],
                        "",
                        servico, //23
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                        score_class2,
                        score_value2,
                        nps_call,
                      ),
                    );
                    InteracoesContactNumberPeer(
                      telefonefilt[1],
                      informationusers.idgroup,
                    );
                    dispatch(UpdateRgBlockReturn(informationusers));
                    mtnow = "new";
                  }
                  dispatch(
                    addAtdSimult(
                      novadata[5],
                      cliente,
                      telefonefilt[1],
                      novadata[21],
                      novadata[23],
                      criticidade,
                      novadata[19],
                      novadata[11],
                      result,
                      novadata[25],
                      dataatual,
                      novadata[15],
                      novadata[13],
                      timecomplete,
                      statusagent,
                      "0",
                      0,
                      novadata[1],
                      0,
                      novadata[35],
                      mtnow,
                      "",
                      servico, //23
                      "",
                      "",
                      "",
                      "",
                      "",
                      "",
                      "",
                      score_class2,
                      score_value2,
                      nps_call,
                    ),
                  );
                  socket.send(
                    "ANSWEBCHATACK\r\n" +
                      userid +
                      "\r\nCONTACTID\r\n" +
                      novadata[5] +
                      "\r\nTo\r\n" +
                      novadata[1] +
                      "\r\nSRV\r\n1\r\nSRVIN\r\n" +
                      novadata[11] +
                      "\r\nATDID\r\n" +
                      result +
                      "\r\n\r\n",
                  );
                  dispatch(
                    createStatusAgent(
                      "Atendimento",
                      "E.(" + telefonefilt[1] + ")",
                      Moment().format("DD/MM/YYYY HH:mm:ss"),
                    ),
                  );
                });
              } else if (parseInt(novadata[15]) === 1 && novadata[25] === "1") {
                if (cpark === true || atendimento.length === 0) {
                  dispatch(
                    addAtendimento(
                      novadata[5],
                      cliente,
                      telefonefilt[1],
                      novadata[21],
                      novadata[23],
                      criticidade,
                      novadata[19],
                      novadata[11],
                      novadata[27],
                      novadata[25],
                      novadata[33],
                      novadata[15],
                      novadata[13],
                      timecomplete,
                      statusagent,
                      "0",
                      0,
                      novadata[1],
                      0,
                      novadata[35], //20
                      "",
                      servico,
                      "",
                      "",
                      "",
                      "",
                      "",
                      "",
                      "",
                      "",
                      "",
                      score_class2,
                      score_value2,
                      nps_call,
                    ),
                  );
                  InteracoesContactNumberPeer(
                    telefonefilt[1],
                    informationusers.idgroup,
                  );
                  dispatch(UpdateRgBlockReturn(informationusers));
                  mtnow = "new";
                }
                dispatch(
                  addAtdSimult(
                    novadata[5],
                    cliente,
                    telefonefilt[1],
                    novadata[21],
                    novadata[23],
                    criticidade,
                    novadata[19],
                    novadata[11],
                    novadata[27],
                    novadata[25],
                    novadata[33],
                    novadata[15],
                    novadata[13],
                    timecomplete,
                    statusagent,
                    "0",
                    0,
                    novadata[1],
                    0,
                    novadata[35],
                    mtnow, //21
                    "",
                    servico,
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    score_class2,
                    score_value2,
                    nps_call,
                  ),
                );
                socket.send(
                  "ANSWEBCHATACK\r\n" +
                    userid +
                    "\r\nCONTACTID\r\n" +
                    novadata[5] +
                    "\r\nTo\r\n" +
                    novadata[1] +
                    "\r\nSRV\r\n1\r\nSRVIN\r\n" +
                    novadata[11] +
                    "\r\nATDID\r\n" +
                    novadata[27] +
                    "\r\n\r\n",
                );
                dispatch(
                  createStatusAgent(
                    "Atendimento",
                    "E.(" + telefonefilt[1] + ")",
                    Moment().format("DD/MM/YYYY HH:mm:ss"),
                  ),
                );
              } else {
                dispatch(CallParkCapture(true));
                if (novadata[29] != "0") {
                  let receivedtransf = dispatch(
                    InsertAnswerACK(
                      parseInt(novadata[5]),
                      telefonefilt[1],
                      userid,
                      0,
                      "Transferencia",
                      parseInt(srv_wait_id) > 0 ? parseInt(srv_wait_id) : null,
                    ),
                  );
                  receivedtransf.then(function (result) {
                    if (cpark === true || atendimento.length === 0) {
                      dispatch(
                        addAtendimento(
                          novadata[5],
                          cliente,
                          telefonefilt[1],
                          novadata[21],
                          novadata[23],
                          criticidade,
                          novadata[19],
                          novadata[11],
                          result,
                          novadata[25],
                          "0",
                          novadata[15],
                          novadata[13],
                          timecomplete,
                          statusagent,
                          "0",
                          0,
                          novadata[1],
                          0,
                          novadata[35], //20
                          "",
                          servico,
                          "",
                          "",
                          "",
                          "",
                          "",
                          "",
                          "",
                          "",
                          "",
                          score_class2,
                          score_value2,
                          nps_call,
                        ),
                      );
                      InteracoesContactNumberPeer(
                        telefonefilt[1],
                        informationusers.idgroup,
                      );
                      dispatch(UpdateRgBlockReturn(informationusers));
                      mtnow = "new";
                    }
                    dispatch(
                      addAtdSimult(
                        novadata[5],
                        cliente,
                        telefonefilt[1],
                        novadata[21],
                        novadata[23],
                        criticidade,
                        novadata[19],
                        novadata[11],
                        result,
                        novadata[25],
                        "0",
                        novadata[15],
                        novadata[13],
                        timecomplete,
                        statusagent,
                        "0",
                        0,
                        novadata[1],
                        0,
                        novadata[35],
                        mtnow, //21
                        "",
                        servico,
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                        score_class2,
                        score_value2,
                        nps_call,
                      ),
                    );
                    // dispatch(
                    //   addMessage(
                    //     makeidp(32),
                    //     "IMS9300: Seu Cliente está conectado!",
                    //     novadata[3],
                    //     time,
                    //     novadata[5],
                    //     "0",
                    //     "cliente",
                    //     false,
                    //     dia,
                    //     "Me",
                    //     null,
                    //     null,
                    //     "0",
                    //     null,
                    //     null,
                    //     null,
                    //     Moment().format("YYYY"),
                    //     Moment().format("DD/MM/YYYY HH:mm")
                    //   )
                    // );
                    dispatch(
                      createStatusAgent(
                        "Atendimento",
                        "S.(" + telefonefilt[1] + ")",
                        Moment().format("DD/MM/YYYY HH:mm:ss"),
                      ),
                    );
                    socket.send(
                      "ANSWEBCHATACK\r\n" +
                        userid +
                        "\r\nCONTACTID\r\n" +
                        novadata[5] +
                        "\r\nTo\r\n" +
                        novadata[1] +
                        "\r\nSRV\r\n1\r\nSRVIN\r\n" +
                        novadata[11] +
                        "\r\nATDID\r\n" +
                        result +
                        "\r\n\r\n",
                    );
                  });
                } else {
                  if (parseInt(novadata[25]) === 1) {
                    axios
                      .get(
                        `${
                          connection_platform.type_connect
                        }://${pathname}:${port}/conn/getprotocolbyecdr?cdrid=${parseInt(
                          novadata[5],
                        )}`,
                      )
                      .then((response) => {
                        numprotocolo = "";
                        if (response.data.length !== 0) {
                          if (
                            response.data[0].protocolo !== "" &&
                            response.data[0].protocolo !== undefined
                          ) {
                            numprotocolo = response.data[0].protocolo;
                          }
                        }
                        dispatch(
                          addAtendimento(
                            novadata[5],
                            cliente,
                            telefonefilt[1],
                            novadata[21],
                            novadata[23],
                            criticidade,
                            novadata[19],
                            novadata[11],
                            novadata[27],
                            novadata[25],
                            novadata[33],
                            novadata[15],
                            novadata[13],
                            timecomplete,
                            statusagent,
                            "0",
                            0,
                            novadata[1],
                            0,
                            novadata[35],
                            "",
                            servico,
                            "",
                            "",
                            numprotocolo, //25
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            score_class2,
                            score_value2,
                            nps_call,
                          ),
                        );
                        InteracoesContactNumberPeer(
                          telefonefilt[1],
                          informationusers.idgroup,
                        );
                        dispatch(UpdateRgBlockReturn(informationusers));
                        mtnow = "new";
                        dispatch(
                          addAtdSimult(
                            novadata[5],
                            cliente,
                            telefonefilt[1],
                            novadata[21],
                            novadata[23],
                            criticidade,
                            novadata[19],
                            novadata[11],
                            novadata[27],
                            novadata[25],
                            novadata[33],
                            novadata[15],
                            novadata[13],
                            timecomplete,
                            statusagent,
                            "0",
                            0,
                            novadata[1],
                            0,
                            novadata[35],
                            mtnow,
                            "",
                            servico,
                            "",
                            "",
                            numprotocolo, //26
                            "",
                            "",
                            "",
                            "",
                            score_class2,
                            score_value2,
                            nps_call,
                          ),
                        );
                      });

                    console.log(
                      "INGENIUM_ATT_ACK_CHECKATD_RECUPERACAO : ",
                      novadata,
                    );
                    dispatch(
                      createStatusAgent(
                        "Atendimento",
                        "S.(" + telefonefilt[1] + ")",
                        Moment().format("DD/MM/YYYY HH:mm:ss"),
                      ),
                    );
                    socket.send(
                      "ANSWEBCHATACK\r\n" +
                        userid +
                        "\r\nCONTACTID\r\n" +
                        novadata[5] +
                        "\r\nTo\r\n" +
                        novadata[1] +
                        "\r\nSRV\r\n1\r\nSRVIN\r\n" +
                        novadata[11] +
                        "\r\nATDID\r\n" +
                        novadata[27] +
                        "\r\n\r\n",
                    );
                  } else {
                    if (parseInt(deliveryType) === 1 && novadata[15] === "2") {
                      let exist = false;
                      atdsimult.map((atd) => {
                        if (
                          parseInt(novadata[5]) === parseInt(atd.idatendimento)
                        ) {
                          exist = true;
                        }
                      });

                      if (exist === true) {
                        //TESTEAVIVA
                        dispatch(
                          editAtdSimult(
                            parseInt(novadata[5]),
                            cliente,
                            telefonefilt[1],
                            novadata[21],
                            novadata[23],
                            criticidade,
                            novadata[19],
                            novadata[11],
                            novadata[27],
                            novadata[25],
                            novadata[33],
                            novadata[15],
                            novadata[13],
                            timecomplete,
                            statusagent,
                            "0",
                            0,
                            novadata[1],
                            0,
                            novadata[35],
                            score_class2,
                            score_value2,
                            nps_call,
                          ),
                        );
                        dispatch(
                          editAtendimento(
                            parseInt(novadata[5]),
                            cliente,
                            telefonefilt[1],
                            novadata[21],
                            novadata[23],
                            criticidade,
                            novadata[19],
                            novadata[11],
                            novadata[27],
                            novadata[25],
                            novadata[33],
                            novadata[15],
                            novadata[13],
                            timecomplete,
                            statusagent,
                            "0",
                            0,
                            novadata[1],
                            0,
                            novadata[35],
                            score_class2,
                            score_value2,
                            nps_call,
                          ),
                        );
                        console.log(
                          "INGENIUM_ATT_ACK_CHECKATD_PRIMEIRO_ATIVO : ",
                          novadata[27],
                        );

                        dispatch(
                          createStatusAgent(
                            "Atendimento",
                            "S.(" + telefonefilt[1] + ")",
                            Moment().format("DD/MM/YYYY HH:mm:ss"),
                          ),
                        );
                        socket.send(
                          "ANSWEBCHATACK\r\n" +
                            userid +
                            "\r\nCONTACTID\r\n" +
                            novadata[5] +
                            "\r\nTo\r\n" +
                            novadata[1] +
                            "\r\nSRV\r\n1\r\nSRVIN\r\n" +
                            novadata[11] +
                            "\r\nATDID\r\n" +
                            novadata[27] +
                            "\r\n\r\n",
                        );

                        //idatendimento,           cliente,     telefone,         servico,     datatimeatd, criticidade, menubot, subservico, serviceatd, recuperation, recuperationtime, direction, idmidia, timecomplete, statusagent, line, queueid, serverid, qtdmessage, pathfile
                      } else {
                        dispatch(
                          addAtendimento(
                            novadata[5],
                            cliente,
                            telefonefilt[1],
                            telefonefilt[1],
                            novadata[23],
                            criticidade,
                            novadata[19],
                            novadata[11],
                            novadata[27],
                            novadata[25],
                            novadata[33],
                            novadata[15],
                            novadata[13],
                            timecomplete,
                            statusagent,
                            "0",
                            0,
                            novadata[1],
                            0,
                            novadata[35], //20
                            "",
                            servico,
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            score_class2,
                            score_value2,
                            nps_call,
                          ),
                        );
                        InteracoesContactNumberPeer(
                          telefonefilt[1],
                          informationusers.idgroup,
                        );
                        dispatch(UpdateRgBlockReturn(informationusers));
                        mtnow = "new";
                        dispatch(
                          addAtdSimult(
                            novadata[5],
                            cliente,
                            telefonefilt[1],
                            telefonefilt[1],
                            novadata[23],
                            criticidade,
                            novadata[19],
                            novadata[11],
                            novadata[27],
                            novadata[25],
                            novadata[33],
                            novadata[15],
                            novadata[13],
                            timecomplete,
                            statusagent,
                            "0",
                            0,
                            novadata[1],
                            0,
                            novadata[35],
                            mtnow, //21
                            "",
                            servico,
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            score_class2,
                            score_value2,
                            nps_call,
                          ),
                        );
                      }
                    } else if (
                      parseInt(deliveryType) === 2 &&
                      novadata[15] === "2"
                    ) {
                      let exist = false;
                      atdsimult.map((atd) => {
                        if (
                          parseInt(novadata[5]) === parseInt(atd.idatendimento)
                        ) {
                          exist = true;
                        }
                      });

                      setTimeout(() => {
                        let atendimentoAtual = getState().atendimento;

                        if (
                          parseInt(novadata[5]) > 0 &&
                          parseInt(novadata[13]) !== 1
                        ) {
                          dispatch(clearQtdMsg(atendimentoAtual.idatendimento));
                          if (
                            atendimentoAtual.serverid !== "" &&
                            atendimentoAtual.serverid
                          ) {
                            let jsonAtdAtual =
                              "WSIMSGLOGREAD\r\n" +
                              informationusers.id +
                              "\r\nCALLID\r\nXXXXXXXXXXXXXXXXXXX\r\nTOUSER\r\n" +
                              atendimentoAtual.serverid +
                              "\r\nTOCLIENT\r\n" +
                              atendimentoAtual.idatendimento +
                              "\r\nMSGID\r\n-1\r\nRESULT\r\n" +
                              `{'CDRID':${atendimentoAtual.idatendimento}}` +
                              "\r\n\r\n";
                            socket.send(jsonAtdAtual);
                          }
                        }
                      }, 3000);

                      console.log(
                        "INGENIUM_ATT_ACK_CHECKATD_VERIFICANDO : ",
                        novadata[27],
                      );

                      if (exist === true) {
                        dispatch(
                          editAtdSimult(
                            parseInt(novadata[5]),
                            cliente,
                            telefonefilt[1],
                            novadata[21],
                            novadata[23],
                            criticidade,
                            novadata[19],
                            novadata[11],
                            novadata[27],
                            novadata[25],
                            novadata[33],
                            novadata[15],
                            novadata[13],
                            timecomplete,
                            statusagent,
                            "0",
                            0,
                            novadata[1],
                            0,
                            novadata[35],
                            nps_call,
                          ),
                        );
                        dispatch(
                          editAtendimento(
                            parseInt(novadata[5]),
                            cliente,
                            telefonefilt[1],
                            novadata[21],
                            novadata[23],
                            criticidade,
                            novadata[19],
                            novadata[11],
                            novadata[27],
                            novadata[25],
                            novadata[33],
                            novadata[15],
                            novadata[13],
                            timecomplete,
                            statusagent,
                            "0",
                            0,
                            novadata[1],
                            0,
                            novadata[35],
                            nps_call,
                          ),
                        );

                        dispatch(
                          createStatusAgent(
                            "Atendimento",
                            "S.(" + telefonefilt[1] + ")",
                            Moment().format("DD/MM/YYYY HH:mm:ss"),
                          ),
                        );
                        socket.send(
                          "ANSWEBCHATACK\r\n" +
                            userid +
                            "\r\nCONTACTID\r\n" +
                            novadata[5] +
                            "\r\nTo\r\n" +
                            novadata[1] +
                            "\r\nSRV\r\n1\r\nSRVIN\r\n" +
                            novadata[11] +
                            "\r\nATDID\r\n" +
                            novadata[27] +
                            "\r\n\r\n",
                        );

                        //idatendimento,           cliente,     telefone,         servico,     datatimeatd, criticidade, menubot, subservico, serviceatd, recuperation, recuperationtime, direction, idmidia, timecomplete, statusagent, line, queueid, serverid, qtdmessage, pathfile
                      } else {
                        let receivedCapture = dispatch(
                          InsertAnswerACK(
                            parseInt(novadata[5]),
                            telefonefilt[1],
                            userid,
                            0,
                            "Saida",
                            parseInt(srv_wait_id) > 0
                              ? parseInt(srv_wait_id)
                              : null,
                          ),
                        );
                        receivedCapture.then(function (result) {
                          dispatch(
                            addAtendimento(
                              novadata[5],
                              cliente,
                              telefonefilt[1],
                              telefonefilt[1],
                              novadata[23],
                              criticidade,
                              novadata[19],
                              novadata[11],
                              result,
                              novadata[25],
                              novadata[33],
                              novadata[15],
                              novadata[13],
                              timecomplete,
                              statusagent,
                              "0",
                              0,
                              novadata[1],
                              0,
                              novadata[35], //20
                              "",
                              servico,
                              "",
                              "",
                              "",
                              "",
                              "",
                              "",
                              "",
                              "",
                              "",
                              score_class2,
                              score_value2,
                              nps_call,
                            ),
                          );
                          InteracoesContactNumberPeer(
                            telefonefilt[1],
                            informationusers.idgroup,
                          );
                          dispatch(UpdateRgBlockReturn(informationusers));
                          mtnow = "new";
                          dispatch(
                            addAtdSimult(
                              novadata[5],
                              cliente,
                              telefonefilt[1],
                              telefonefilt[1],
                              novadata[23],
                              criticidade,
                              novadata[19],
                              novadata[11],
                              result,
                              novadata[25],
                              novadata[33],
                              novadata[15],
                              novadata[13],
                              timecomplete,
                              statusagent,
                              "0",
                              0,
                              novadata[1],
                              0,
                              novadata[35],
                              mtnow, //21
                              "",
                              servico,
                              "",
                              "",
                              "",
                              "",
                              "",
                              "",
                              "",
                              score_class2,
                              score_value2,
                              nps_call,
                            ),
                          );

                          dispatch(
                            createStatusAgent(
                              "Atendimento",
                              "S.(" + telefonefilt[1] + ")",
                              Moment().format("DD/MM/YYYY HH:mm:ss"),
                            ),
                          );
                          socket.send(
                            "ANSWEBCHATACK\r\n" +
                              userid +
                              "\r\nCONTACTID\r\n" +
                              novadata[5] +
                              "\r\nTo\r\n" +
                              novadata[1] +
                              "\r\nSRV\r\n1\r\nSRVIN\r\n" +
                              novadata[11] +
                              "\r\nATDID\r\n" +
                              result +
                              "\r\n\r\n",
                          );
                        });
                      }
                    } else if (
                      parseInt(deliveryType) === 0 &&
                      novadata[15] === "2"
                    ) {
                      setTimeout(() => {
                        let atendimentoAtual = getState().atendimento;

                        if (
                          atendimentoAtual.idatendimento !== null &&
                          atendimentoAtual.idatendimento !== undefined &&
                          parseInt(atendimentoAtual.serverid) ===
                            parseInt(novadata[1]) &&
                          parseInt(atendimentoAtual.idmidia) !== 1
                        ) {
                          dispatch(clearQtdMsg(atendimentoAtual.idatendimento));
                          if (
                            atendimentoAtual.serverid !== "" &&
                            atendimentoAtual.serverid
                          ) {
                            let jsonAtdAtual =
                              "WSIMSGLOGREAD\r\n" +
                              informationusers.id +
                              "\r\nCALLID\r\nXXXXXXXXXXXXXXXXXXX\r\nTOUSER\r\n" +
                              atendimentoAtual.serverid +
                              "\r\nTOCLIENT\r\n" +
                              atendimentoAtual.idatendimento +
                              "\r\nMSGID\r\n-1\r\nRESULT\r\n" +
                              `{'CDRID':${atendimentoAtual.idatendimento}}` +
                              "\r\n\r\n";
                            socket.send(jsonAtdAtual);
                          }
                        }
                      }, 3000);

                      let exist = false;
                      atdsimult.map((atd) => {
                        if (
                          parseInt(novadata[5]) === parseInt(atd.idatendimento)
                        ) {
                          exist = true;
                        }
                      });

                      let atendimentoAtual2 = getState().atendimento;
                      if (
                        exist === true &&
                        parseInt(atendimentoAtual2.idatendimento) ===
                          parseInt(novadata[5])
                      ) {
                        //AVIVA  2024-01-03
                        // if (exist === true) {
                        dispatch(
                          editAtdSimult(
                            parseInt(novadata[5]),
                            cliente,
                            telefonefilt[1],
                            novadata[21],
                            novadata[23],
                            criticidade,
                            novadata[19],
                            novadata[11],
                            novadata[27],
                            novadata[25],
                            novadata[33],
                            novadata[15],
                            novadata[13],
                            timecomplete,
                            statusagent,
                            "0",
                            0,
                            novadata[1],
                            0,
                            novadata[35],
                            nps_call,
                          ),
                        );
                        dispatch(
                          editAtendimento(
                            parseInt(novadata[5]),
                            cliente,
                            telefonefilt[1],
                            novadata[21],
                            novadata[23],
                            criticidade,
                            novadata[19],
                            novadata[11],
                            novadata[27],
                            novadata[25],
                            novadata[33],
                            novadata[15],
                            novadata[13],
                            timecomplete,
                            statusagent,
                            "0",
                            0,
                            novadata[1],
                            0,
                            novadata[35],
                            nps_call,
                          ),
                        );

                        //idatendimento,           cliente,     telefone,         servico,     datatimeatd, criticidade, menubot, subservico, serviceatd, recuperation, recuperationtime, direction, idmidia, timecomplete, statusagent, line, queueid, serverid, qtdmessage, pathfile
                      } else {
                        let receivedQueue = dispatch(
                          InsertAnswerACK(
                            parseInt(novadata[5]),
                            telefonefilt[1],
                            userid,
                            0,
                            "Saida",
                            parseInt(srv_wait_id) > 0
                              ? parseInt(srv_wait_id)
                              : null,
                          ),
                        );

                        receivedQueue.then(function (result) {
                          //olhar se ja está com atendimento em curso
                          // console.log("raimundo_neto deliveryType", { result });
                          const novoIdAtendimento = result || novadata[27];
                          socket.send(
                            "ANSWEBCHATACK\r\n" +
                              userid +
                              "\r\nCONTACTID\r\n" +
                              novadata[5] +
                              "\r\nTo\r\n" +
                              novadata[1] +
                              "\r\nSRV\r\n1\r\nSRVIN\r\n" +
                              novadata[11] +
                              "\r\nATDID\r\n" +
                              novoIdAtendimento +
                              "\r\n\r\n",
                          );

                          const { atdsimult: currentAtdSimult } = getState();
                          const isNoAtdSimult = currentAtdSimult
                            ? currentAtdSimult.length === 0
                            : atdsimult.length === 0;

                          if (isNoAtdSimult) {
                            dispatch(
                              createStatusAgent(
                                "Atendimento",
                                "S.(" + telefonefilt[1] + ")",
                                Moment().format("DD/MM/YYYY HH:mm:ss"),
                              ),
                            );
                            dispatch(
                              addAtendimento(
                                novadata[5],
                                cliente,
                                telefonefilt[1],
                                novadata[21],
                                novadata[23],
                                criticidade,
                                novadata[19],
                                novadata[11],
                                result,
                                novadata[25],
                                novadata[33],
                                novadata[15],
                                novadata[13],
                                timecomplete,
                                statusagent,
                                "0",
                                0,
                                novadata[1],
                                0,
                                novadata[35], //20
                                "",
                                servico,
                                "",
                                "",
                                "",
                                "",
                                "",
                                "",
                                "",
                                "",
                                "",
                                score_class2,
                                score_value2,
                                nps_call,
                              ),
                            );
                          }
                          InteracoesContactNumberPeer(
                            telefonefilt[1],
                            informationusers.idgroup,
                          );
                          dispatch(UpdateRgBlockReturn(informationusers));
                          mtnow = "new";
                          dispatch(
                            addAtdSimult(
                              novadata[5],
                              cliente,
                              telefonefilt[1],
                              novadata[21],
                              novadata[23],
                              criticidade,
                              novadata[19],
                              novadata[11],
                              result,
                              novadata[25],
                              novadata[33],
                              novadata[15],
                              novadata[13],
                              timecomplete,
                              statusagent,
                              "0",
                              0,
                              novadata[1],
                              0,
                              novadata[35],
                              mtnow, //21
                              "",
                              servico,
                              "",
                              "",
                              "",
                              "",
                              "",
                              "",
                              "",
                              score_class2,
                              score_value2,
                              nps_call,
                            ),
                          );
                        });
                      }
                    }
                  }
                }
              }
              if (currentscreen.screen != "Clientes") {
                dispatch(
                  InterationNotifier(
                    "Interação Iniciada com " + cliente,
                    "call",
                  ),
                );
              }

              if (
                informationusers.blockfuture === false &&
                status.afterStatus !== "Pausado"
              ) {
                InsertPausaRVATD(sipid, userid, dispatch);
              }

              let inanscount = 0;
              let incallcount = 0;
              let outanscount = 0;
              let outcallcount = 0;
              // let datatimeAns = Moment().format('DD/MM/YYYY HH:mm:ss');
              let datatimeAns = novadata[33];
              var valorDiferenca = parseInt(
                Math.abs(Math.round(ipcurrent.difftime)),
              );

              // if(parseInt(ipcurrent.difftime)<0){
              //  datatimeAns = Moment().subtract(valorDiferenca,'seconds').format('DD/MM/YYYY HH:mm:ss');
              // }else{
              //  datatimeAns = Moment().add(valorDiferenca,'seconds').format('DD/MM/YYYY HH:mm:ss');
              // }

              if (parseInt(novadata[25]) != 1) {
                if (parseInt(novadata[15]) == 2) {
                  inanscount = informationusers.inanscount;
                  incallcount = informationusers.incallcount;
                  outanscount = parseInt(informationusers.outanscount) + 1;
                  outcallcount = parseInt(informationusers.outcallcount) + 1;
                } else {
                  inanscount = parseInt(informationusers.inanscount) + 1;
                  incallcount = parseInt(informationusers.incallcount) + 1;
                  outanscount = informationusers.outanscount;
                  outcallcount = informationusers.outcallcount;
                }
              } else {
                inanscount = informationusers.inanscount;
                incallcount = informationusers.incallcount;
                outanscount = informationusers.outanscount;
                outcallcount = informationusers.outcallcount;
              }

              dispatch(GetAnotations([]));
              dispatch(GetMarkstar([]));
              dispatch(GetHistory([]));
              dispatch(GetFileShared([]));
              dispatch(
                incrementInfoUsers(
                  informationusers.email,
                  informationusers.password,
                  informationusers.id,
                  informationusers.displayname,
                  informationusers.grupo,
                  informationusers.ramal,
                  informationusers.idgroup,
                  informationusers.username,
                  informationusers.idsupervisao,
                  informationusers.sipid,
                  informationusers.acessofila,
                  informationusers.semdefinicao,
                  informationusers.supervisor,
                  inanscount,
                  incallcount,
                  informationusers.intmans,
                  outanscount,
                  outcallcount,
                  informationusers.outtmans,
                  informationusers.psdcount,
                  informationusers.psdtma,
                  informationusers.tmlogin,
                  informationusers.atdauto,
                  informationusers.idin,
                  informationusers.idout,
                ),
              );
              setTimeout(() => {
                let arrayAtdJson = [];

                atdsimult.map((atd) => {
                  arrayAtdJson.push({
                    idmidia: atd.idmidia,
                    telefone: atd.telefone,
                  });
                });

                if (
                  !arrayAtdJson.some(
                    (atd) =>
                      atd.telefone === telefonefilt[1] &&
                      parseInt(atd.idmidia) === parseInt(novadata[13]),
                  )
                ) {
                  if (novadata[25] === "1" && parseInt(novadata[15]) === 1) {
                    arrayAtdJson.push({
                      idmidia: novadata[13],
                      telefone: telefonefilt[1],
                    });
                  } else if (
                    novadata[25] === "1" &&
                    parseInt(novadata[15]) === 2
                  ) {
                    arrayAtdJson.push({
                      idmidia: novadata[13],
                      telefone: telefonefilt[1],
                    });
                  } else if (
                    novadata[25] === "0" &&
                    parseInt(novadata[15]) === 1
                  ) {
                    arrayAtdJson.push({
                      idmidia: novadata[13],
                      telefone: telefonefilt[1],
                    });
                  } else if (
                    novadata[25] === "0" &&
                    parseInt(novadata[15]) === 2
                  ) {
                    arrayAtdJson.push({
                      idmidia: novadata[13],
                      telefone: telefonefilt[1],
                    });
                  }
                }

                let jsonChannelPhoneCall = mountCallsStatus(arrayAtdJson);

                if (novadata[25] === "1") {
                  let itemStorage = localStorage.getItem("jsonchannelstatus");
                  localStorage.setItem(
                    "jsonchannelstatus",
                    jsonChannelPhoneCall,
                  );
                  if (itemStorage !== "")
                    jsonChannelPhoneCall = `${jsonChannelPhoneCall}¿${itemStorage}`;
                }
                let strPauseFuture = informationusers.blockfuture ? 1 : 0;
                let descPauseFuture = informationusers.blockfuture
                  ? descfuturepause
                  : " ";

                let data_hora_atual = Moment().format("YYYY/MM/DD HH:mm:ss");
                let duracaoLoginAtual = Moment(data_hora_atual).diff(
                  informationusers.datalogin,
                  "seconds",
                );
                let duracaoLoginFinal =
                  parseInt(duracaoLoginAtual) +
                  parseInt(informationusers.tmlogin);

                if (
                  status.afterStatus === "Pausado" &&
                  status.status !== "Pausado" &&
                  status.status !== "Logout"
                ) {
                  statusAgentIMSDN = "AT";
                  stAgIMSDN = "AT";
                  console.log(
                    "INGENIUM_ENVIOSTATUS :",
                    new Date().toLocaleString(),
                    stAgIMSDN,
                  );
                  requestStatusAgent =
                    "REQ\r\n" +
                    informationusers.id +
                    "\r\nUSERNAME\r\n" +
                    informationusers.username +
                    "\r\nDISPLAYNAME\r\n" +
                    informationusers.displayname +
                    "\r\nEXTEN\r\n" +
                    informationusers.ramal +
                    "\r\nREASON\r\n" +
                    telefonefilt[1] +
                    "\r\nSTATUS\r\nAT\r\nSTATUSID\r\n-1\r\nHOUR\r\n" +
                    datatimeAns +
                    "-00:00:00\r\nDESCRIPTION\r\n" +
                    novadata[21] +
                    "\r\nEMAIL\r\n \r\nGROUP\r\n" +
                    informationusers.idgroup +
                    "\r\nDTL\r\n" +
                    datatimeAns +
                    "\r\nGROUPNAME\r\n" +
                    informationusers.grupo +
                    "\r\nPSDCOUNT\r\n" +
                    informationusers.psdcount +
                    "\r\nPSDTMA\r\n" +
                    parseInt(informationusers.psdtma) +
                    "\r\nMNGGROUP\r\n-1\r\nINCALLCOUNT\r\n" +
                    incallcount +
                    "\r\nINANSCOUNT\r\n" +
                    inanscount +
                    "\r\nINTMANS\r\n" +
                    informationusers.intmans +
                    "\r\nINSLA\r\n100\r\nOUTCALLCOUNT\r\n" +
                    outcallcount +
                    "\r\nOUTANSCOUNT\r\n" +
                    outanscount +
                    "\r\nOUTTMANS\r\n" +
                    informationusers.outtmans +
                    "\r\nCOUNTFPAUSE\r\n" +
                    parseInt(informationusers.psdfbreak) +
                    "\r\nOUTSLA\r\n100\r\nDESCFUTUREPAUSE\r\n" +
                    descPauseFuture +
                    "\r\nINITIALLOGIN\r\n0\r\nTMLOGIN\r\n" +
                    duracaoLoginFinal +
                    "\r\nCDRID\r\n" +
                    novadata[5] +
                    "\r\nSRVIN\r\n" +
                    novadata[11] +
                    "\r\nJSON\r\n" +
                    jsonChannelPhoneCall +
                    "\r\nFUTUREPAUSE\r\n" +
                    strPauseFuture +
                    "\r\nMEDIAID\r\n" +
                    novadata[13] +
                    "\r\n\r\n";
                  const isToPauseInFuture = verifyIfIsAfterStatusPause(
                    getState().atdsimult,
                    getState().isFuturePauseActive,
                    reconnectionHandler.isReconnecting,
                  );

                  dispatch(
                    UpdatePauseFutureRV(
                      informationusers,
                      "RV",
                      atendimento,
                      status.afterReason,
                      status.afterIdReason,
                      // status.afterIsReasonLogout,
                      isToPauseInFuture,
                    ),
                  );

                  dispatch(BlockFuture(true));
                } else {
                  const isToPauseInFuture = verifyIfIsAfterStatusPause(
                    getState().atdsimult,
                    getState().isFuturePauseActive,
                    reconnectionHandler.isReconnecting,
                  );

                  dispatch(
                    UpdatePauseFutureRV(
                      informationusers,
                      "RV",
                      atendimento,
                      status.afterReason,
                      status.afterIdReason,
                      // status.afterIsReasonLogout,
                      isToPauseInFuture,
                    ),
                  );
                  socket.send(
                    "REQ\r\n" +
                      informationusers.id +
                      "\r\nUSERNAME\r\n" +
                      informationusers.username +
                      "\r\nDISPLAYNAME\r\n" +
                      informationusers.displayname +
                      "\r\nEXTEN\r\n" +
                      informationusers.ramal +
                      "\r\nREASON\r\n" +
                      telefonefilt[1] +
                      "\r\nSTATUS\r\nAT\r\nSTATUSID\r\n-1\r\nHOUR\r\n" +
                      datatimeAns +
                      "-00:00:00\r\nDESCRIPTION\r\n" +
                      novadata[21] +
                      "\r\nEMAIL\r\n \r\nGROUP\r\n" +
                      informationusers.idgroup +
                      "\r\nDTL\r\n" +
                      datatimeAns +
                      "\r\nGROUPNAME\r\n" +
                      informationusers.grupo +
                      "\r\nPSDCOUNT\r\n" +
                      informationusers.psdcount +
                      "\r\nPSDTMA\r\n" +
                      parseInt(informationusers.psdtma) +
                      "\r\nMNGGROUP\r\n-1\r\nINCALLCOUNT\r\n" +
                      incallcount +
                      "\r\nINANSCOUNT\r\n" +
                      inanscount +
                      "\r\nINTMANS\r\n" +
                      informationusers.intmans +
                      "\r\nINSLA\r\n100\r\nOUTCALLCOUNT\r\n" +
                      outcallcount +
                      "\r\nOUTANSCOUNT\r\n" +
                      outanscount +
                      "\r\nOUTTMANS\r\n" +
                      informationusers.outtmans +
                      "\r\nCOUNTFPAUSE\r\n" +
                      parseInt(informationusers.psdfbreak) +
                      "\r\nOUTSLA\r\n100\r\nDESCFUTUREPAUSE\r\n" +
                      descPauseFuture +
                      "\r\nINITIALLOGIN\r\n0\r\nTMLOGIN\r\n" +
                      duracaoLoginFinal +
                      "\r\nCDRID\r\n" +
                      novadata[5] +
                      "\r\nSRVIN\r\n" +
                      novadata[11] +
                      "\r\nJSON\r\n" +
                      jsonChannelPhoneCall +
                      "\r\nFUTUREPAUSE\r\n" +
                      strPauseFuture +
                      "\r\nMEDIAID\r\n" +
                      novadata[13] +
                      "\r\n\r\n",
                  );
                  statusAgentIMSDN = "AT";
                  if (strPauseFuture === 1) {
                    stAgIMSDN = "RV";
                  } else {
                    stAgIMSDN = "AT";
                  }
                  console.log(
                    "INGENIUM_ENVIOSTATUS :",
                    new Date().toLocaleString(),
                    stAgIMSDN,
                  );
                  requestStatusAgent =
                    "REQ\r\n" +
                    informationusers.id +
                    "\r\nUSERNAME\r\n" +
                    informationusers.username +
                    "\r\nDISPLAYNAME\r\n" +
                    informationusers.displayname +
                    "\r\nEXTEN\r\n" +
                    informationusers.ramal +
                    "\r\nREASON\r\n" +
                    telefonefilt[1] +
                    "\r\nSTATUS\r\nAT\r\nSTATUSID\r\n-1\r\nHOUR\r\n" +
                    datatimeAns +
                    "-00:00:00\r\nDESCRIPTION\r\n" +
                    novadata[21] +
                    "\r\nEMAIL\r\n \r\nGROUP\r\n" +
                    informationusers.idgroup +
                    "\r\nDTL\r\n" +
                    datatimeAns +
                    "\r\nGROUPNAME\r\n" +
                    informationusers.grupo +
                    "\r\nPSDCOUNT\r\n" +
                    informationusers.psdcount +
                    "\r\nPSDTMA\r\n" +
                    parseInt(informationusers.psdtma) +
                    "\r\nMNGGROUP\r\n-1\r\nINCALLCOUNT\r\n" +
                    incallcount +
                    "\r\nINANSCOUNT\r\n" +
                    inanscount +
                    "\r\nINTMANS\r\n" +
                    informationusers.intmans +
                    "\r\nINSLA\r\n100\r\nOUTCALLCOUNT\r\n" +
                    outcallcount +
                    "\r\nOUTANSCOUNT\r\n" +
                    outanscount +
                    "\r\nOUTTMANS\r\n" +
                    informationusers.outtmans +
                    "\r\nCOUNTFPAUSE\r\n" +
                    parseInt(informationusers.psdfbreak) +
                    "\r\nOUTSLA\r\n100\r\nDESCFUTUREPAUSE\r\n" +
                    descPauseFuture +
                    "\r\nINITIALLOGIN\r\n0\r\nTMLOGIN\r\n" +
                    duracaoLoginFinal +
                    "\r\nCDRID\r\n" +
                    novadata[5] +
                    "\r\nSRVIN\r\n" +
                    novadata[11] +
                    "\r\nJSON\r\n" +
                    jsonChannelPhoneCall +
                    "\r\nFUTUREPAUSE\r\n" +
                    strPauseFuture +
                    "\r\nMEDIAID\r\n" +
                    novadata[13] +
                    "\r\n\r\n";
                }

                //if(informationusers.blockfuture === false)
                clearInterval(statusIntervalAgent);
                envioStatusAgente(12850, informationusers.sipid);
              }, 500);
              if (localStorage.getItem("url_iframe") !== "") {
                let sendIngDesk = false;

                if (
                  atdsimult.length >= 1 &&
                  atendimento.telefone === telefonefilt[1]
                ) {
                  connectionsapi.iframe_ref.current.contentWindow.postMessage(
                    {
                      origin: "ingweb",
                      id: "getContactIdInteraction",
                      telefone: telefonefilt[1],
                    },
                    localStorage.getItem("url_iframe"),
                  );
                } else if (atdsimult.length >= 1 && cpark === true) {
                  connectionsapi.iframe_ref.current.contentWindow.postMessage(
                    {
                      origin: "ingweb",
                      id: "getContactIdInteraction",
                      telefone: telefonefilt[1],
                    },
                    localStorage.getItem("url_iframe"),
                  );
                } else if (atdsimult.length === 0) {
                  connectionsapi.iframe_ref.current.contentWindow.postMessage(
                    {
                      origin: "ingweb",
                      id: "getContactIdInteraction",
                      telefone: telefonefilt[1],
                    },
                    localStorage.getItem("url_iframe"),
                  );
                }

                if (interactioningdesk.length !== 0) {
                  if (
                    parseInt(telefonefilt[1]) ===
                    parseInt(interactioningdesk.payload.destination)
                  ) {
                    let channel = "";

                    if (parseInt(novadata[13]) === 1) channel = "Voz";
                    else if (parseInt(novadata[13]) === 5) channel = "Whatsapp";
                    else if (parseInt(novadata[13]) === 8) channel = "Telegram";
                    else if (parseInt(novadata[13]) === 16)
                      channel = "Whatsapp Voz";

                    let jsonIngDesk = {
                      origin: "ingweb",
                      id: "currentInteraction",
                      payload: {
                        clientId: interactioningdesk.payload.clientId,
                        clientName: interactioningdesk.payload.clientName,
                        channelId: novadata[13],
                        channelName: channel,
                        destination: interactioningdesk.payload.destination,
                        protocol: numprotocolo,
                      },
                    };
                    setTimeout(() => {
                      connectionsapi.iframe_ref.current.contentWindow.postMessage(
                        jsonIngDesk,
                        localStorage.getItem("url_iframe"),
                      );
                    }, 300);
                    sendIngDesk = true;
                  }
                }

                if (!sendIngDesk) {
                  let channel = "";

                  if (parseInt(novadata[13]) === 1) channel = "Voz";
                  else if (parseInt(novadata[13]) === 5) channel = "Whatsapp";
                  else if (parseInt(novadata[13]) === 8) channel = "Telegram";
                  else if (parseInt(novadata[13]) === 16)
                    channel = "Whatsapp Voz";

                  let jsonIngDesk = {
                    origin: "ingweb",
                    id: "currentInteraction",
                    payload: {
                      clientId: null,
                      clientName: cliente,
                      channelId: novadata[13],
                      channelName: channel,
                      destination: telefonefilt[1],
                      protocol: numprotocolo,
                    },
                  };
                  if (
                    atdsimult.length >= 1 &&
                    atendimento.telefone === telefonefilt[1]
                  ) {
                    setTimeout(() => {
                      connectionsapi.iframe_ref.current.contentWindow.postMessage(
                        jsonIngDesk,
                        localStorage.getItem("url_iframe"),
                      );
                    }, 300);
                    dispatch(
                      addInteractionIngDesk({
                        clientId: null,
                        clientName: cliente,
                        channelId: novadata[13],
                        channelName: channel,
                        destination: telefonefilt[1],
                        protocol: numprotocolo,
                      }),
                    );
                  } else if (atdsimult.length >= 1 && cpark === true) {
                    setTimeout(() => {
                      connectionsapi.iframe_ref.current.contentWindow.postMessage(
                        jsonIngDesk,
                        localStorage.getItem("url_iframe"),
                      );
                    }, 300);
                    dispatch(
                      addInteractionIngDesk({
                        clientId: null,
                        clientName: cliente,
                        channelId: novadata[13],
                        channelName: channel,
                        destination: telefonefilt[1],
                        protocol: numprotocolo,
                      }),
                    );
                  } else if (atdsimult.length === 0) {
                    setTimeout(() => {
                      try {
                        connectionsapi.iframe_ref.current.contentWindow.postMessage(
                          jsonIngDesk,
                          localStorage.getItem("url_iframe"),
                        );
                      } catch (error) {
                        console.log("Error no postmessage", error);
                      }
                    }, 300);
                    dispatch(
                      addInteractionIngDesk({
                        clientId: null,
                        clientName: cliente,
                        channelId: novadata[13],
                        channelName: channel,
                        destination: telefonefilt[1],
                        protocol: numprotocolo,
                      }),
                    );
                  }
                }
              }
            } else {
              var dataatual = Moment().format("DD/MM/YYYY HH:mm:ss");
              var telefone = novadata[17].split("~¿");
              var servico = novadata[21].split(":");
              var telefonefilt = telefone[0].split(": ");
              var statusagent = status.reason;
              var chamado = "";
              var chamador = "";
              if (novadata[15] === "2") {
                chamado = telefonefilt[1];
                chamador = ramaluser;
              } else {
                chamado = novadata[21];
                chamador = telefone[0];
              }
              chamador = chamador.replace(/\D+/g, "");
              //let direction = `${connection_platform.type_connect}://${pathname}:${port}/conn/carregamento?cdr=${novadata[5]}`;
              // let findIndex = clientusermonitors.findIndex(
              //   (client) =>
              //     parseInt(client.idatendimento) === parseInt(novadata[5])
              // );
              // if (findIndex === -1) {
              //   axios.get(direction).then((response) => {
              //     let resposta = response.data;

              //     const isFromStandby =
              //       novadata.length >= 42 &&
              //       Boolean(novadata[41]) &&
              //       isJson(novadata[41]) &&
              //       Boolean(JSON.parse(novadata[41]).STANDBY) &&
              //       Boolean(JSON.parse(novadata[41]).STANDBY.ID);

              //     let qtdUnreadedMessages = 0;

              //     resposta.forEach((obj, index) => {
              //       if (
              //         obj.datereading === null &&
              //         obj.datereading !== undefined
              //       ) {
              //         qtdUnreadedMessages++;
              //       }
              //     });

              //     return dispatch(
              //       clientusermonitorsin(
              //         novadata[5],
              //         cliente,
              //         telefonefilt[1],
              //         telefonefilt[1],
              //         novadata[27],
              //         criticidade,
              //         novadata[19],
              //         novadata[11],
              //         novadata[27],
              //         novadata[25],
              //         novadata[37],
              //         novadata[15],
              //         novadata[13],
              //         timecomplete,
              //         statusagent,
              //         "0",
              //         "0",
              //         novadata[23],
              //         novadata[1],
              //         novadata[39],
              //         isFromStandby,
              //         qtdUnreadedMessages
              //       )
              //     );
              //   });
              // }
            }
          }
          // Automatic garbage collection will handle novadata
          // event.data is immutable; no need to manually set it to null
          ///////AQUIII///////
        }
        //inserir lógica para alterar menuBot
        try {
          const telefoneArr = novadata[17].split("~¿");
          const telefoneRaw = telefoneArr[0];
          const telefoneRawArr = telefoneRaw.split(": ");
          const telefone = telefoneRawArr.length >= 2 ? telefoneRawArr[1] : "";
          const cdr =
            Boolean(novadata) && novadata.length >= 6 ? novadata[5] : "";
          const scripttrunk =
            Boolean(novadata) && novadata.length > 0 && novadata[1];
          const direction =
            Boolean(novadata) && novadata.length >= 16 && novadata[15];
          dispatch(
            obterDadosAdicionaisParaExibirEmDetalhes(
              telefone,
              cdr,
              scripttrunk,
              direction,
            ),
          );
        } catch (error) {
          console.log("ANSWEBCHAT ADD INFO ERROR: ", error);
        }
        break;
      case "Received: WSIMSGLOG":
        const hasInfosAboutCdrAndUser = !!novadata && novadata.length >= 8;
        if (hasInfosAboutCdrAndUser) {
          const userIdInWSIMSGLOG = novadata[5];
          const isTheSameUserIdInWSIMSGLOG =
            userIdInWSIMSGLOG === informationusers.id ||
            parseInt(userIdInWSIMSGLOG) === parseInt(informationusers.id);
          if (isTheSameUserIdInWSIMSGLOG) {
            dispatch(addOneMoreUnreadedMessage(novadata[7]));
          }
          const { monitoring: informationUsersToVerifyIfIsMonitoring } =
            getState();
          const isToMonitoring =
            Boolean(informationUsersToVerifyIfIsMonitoring) &&
            Boolean(informationUsersToVerifyIfIsMonitoring.userout) &&
            Boolean(novadata) &&
            novadata.length >= 20 &&
            parseInt(informationUsersToVerifyIfIsMonitoring.userout) ===
              parseInt(novadata[19]);
          const isMsgOfClientInMonitoring =
            Boolean(novadata) &&
            novadata.length >= 12 &&
            typeof novadata[11] === "string" &&
            novadata[11].toLowerCase().includes("saída:");

          if (isToMonitoring && isMsgOfClientInMonitoring) {
            const cdr = novadata[7];
            dispatch(editQtdMsgMonitoring(cdr));
          } else if (isToMonitoring && !isMsgOfClientInMonitoring) {
            const cdr = novadata[7];
            dispatch(clearQtdMsgMonitoring(cdr));
          }
        }
        const arrayAtd = atdsimult.filter(
          (atd) => parseInt(atd.idatendimento) === parseInt(novadata[7]),
        );

        console.log("VEIO AQ7", atdsimult);

        if (novadata[3] !== "12") {
          arrayAtd[0]
            ? dispatch(
                InterationNotifier(
                  "Você recebeu uma nova mensagem de " +
                    arrayAtd[0].cliente +
                    "!",
                  "call",
                ),
              )
            : dispatch(
                InterationNotifier("Você recebeu uma nova mensagem!", "call"),
              );
        }

        if (ipcurrent.audiomessage && novadata[3] !== "12") {
          var snd = new Audio(
            connection_platform.type_connect +
              "://" +
              ipcurrent.ip +
              ":" +
              connection_platform.port_apache_view_extern +
              "/ingweb/frontend/build/sound/audio_message.mp3",
          );
          snd.play();
        }
        if (
          atendimento.idatendimento !== null &&
          atendimento.idatendimento !== undefined &&
          parseInt(atendimento.serverid) === parseInt(novadata[1]) &&
          parseInt(atendimento.idatendimento) === parseInt(novadata[7]) &&
          parseInt(atendimento.idmidia) !== 1 &&
          parseInt(atendimento.idmidia) !== 16 &&
          infodisplay.infodisplay === "Clientes"
        ) {
          dispatch(clearQtdMsg(atendimento.idatendimento));
          let jsonAtdAtual =
            "WSIMSGLOGREAD\r\n" +
            informationusers.id +
            "\r\nCALLID\r\n" +
            novadata[9] +
            "\r\nTOUSER\r\n" +
            atendimento.serverid +
            "\r\nTOCLIENT\r\n" +
            atendimento.idatendimento +
            "\r\nMSGID\r\n" +
            novadata[13] +
            "\r\n\r\n";
          socket.send(jsonAtdAtual);
        }

        dia = Moment().format("DD");
        mes = Moment().format("MM");
        mes = meses.indexOf(mes);
        dia = dia + " de " + meses[mes - 1];
        var anoenvio = Moment().format("YYYY");
        var dataenvio = Moment().format("DD/MM/YYYY HH:mm:ss");
        var caller = novadata[11].replace(/\D+/g, "");
        var username = novadata[11];
        var destiny = "cliente";
        if (novadata[18] === "MONUSER" || novadata[3] === "1000") {
          destiny = "Gestor";
        }

        //ANTIGO IF QUE ENVIAVA MSG NOVA PRO REDUCE
        // if (
        //   parseInt(novadata[7]) != parseInt(atendimento.idatendimento) &&
        //   parseInt(novadata[3]) !== 1000
        // )

        console.log("editQtdMsg 19778", {
          cdr: novadata[7],
          toUser: novadata[3],
        });
        if (
          (parseInt(novadata[7]) !==
            parseInt(getState().atendimento.idatendimento) ||
            getState().infodisplay.infodisplay !== "Clientes") &&
          parseInt(novadata[3]) !== 1000
        ) {
          console.log("editQtdMsg 19788", novadata[7]);
          dispatch(editQtdMsg(novadata[7]));
        }
        if (novadata[3] === "4") {
          let passjson = JSON.parse(novadata[15]);
          let address = passjson.ADDRESS;
          let longitude = passjson.LONGITUDE;
          let name = passjson.NAME;
          let latitude = passjson.LATITUDE;
          let caller = novadata[11];
          caller = caller.replace(/\D+/g, "");

          dispatch(
            addMessage(
              novadata[13],
              address + "~¿" + name + "~¿" + longitude + "~¿" + latitude,
              novadata[3],
              time,
              novadata[7],
              novadata[3],
              "cliente",
              false,
              dia,
              username,
              novadata[19],
              destiny,
              novadata[21] ? novadata[21] : "0",
              novadata[17],
              null,
              null,
              anoenvio,
              dataenvio,
            ),
          );
          dispatch(refreshReturnClient(1, caller));
          //dispatch(editAtendimentoClient(novadata[7])); verificar onde esta a função de editar o respclient
          dispatch(typingedit(novadata[7], 0));
        }
        if (novadata[3] === "1") {
          let passjson = {};
          if (isJson(novadata[15])) {
            passjson = JSON.parse(novadata[15]);
          }
          let url = passjson.URL;
          let filesize = passjson.FILESIZE;
          let caption = passjson.CAPTION;
          let thumbnail = passjson.THUMBNAIL;
          let caller = novadata[11];
          caller = caller.replace(/\D+/g, "");
          let size = dbfileSize(filesize);
          dispatch(
            addMessage(
              novadata[13],
              thumbnail + "~¿" + caption + "~¿" + url + "~¿" + size,
              novadata[3],
              time,
              novadata[7],
              novadata[3],
              "cliente",
              false,
              dia,
              username,
              novadata[19],
              destiny,
              novadata[21] ? novadata[21] : "0",
              novadata[17],
              null,
              null,
              anoenvio,
              dataenvio,
            ),
          );
          dispatch(refreshReturnClient(1, caller));
          //dispatch(editAtendimentoClient(novadata[7])); verificar onde esta a função de editar o respclient
          dispatch(typingedit(novadata[7], 0));
        }
        if (novadata[3] === "0") {
          var msg = novadata[15];
          msg = msg.replace(/\\\\n/gi, "\r\n");
          msg = msg.replace(/\\"/gi, "'");
          msg = msg.replace(/"/gi, "'");
          msg = msg.replace(/"/gm, '\\"');
          dispatch(
            addMessage(
              novadata[13],
              msg,
              novadata[3],
              time,
              novadata[7],
              novadata[3],
              "cliente",
              false,
              dia,
              username,
              novadata[19],
              destiny,
              novadata[21] ? novadata[21] : "0",
              novadata[17],
              null,
              null,
              anoenvio,
              dataenvio,
            ),
          );
          let caller = novadata[11];
          caller = caller.replace(/\D+/g, "");
          dispatch(refreshReturnClient(1, caller));
          //dispatch(editAtendimentoClient(novadata[7])); verificar onde esta a função de editar o respclient
          dispatch(typingedit(novadata[7], 0));
        }

        if (novadata[3] === "1000") {
          var msg = novadata[15];
          msg = msg.replace(/\\\\n/gi, "\r\n");
          msg = msg.replace(/~/gi, "");

          dispatch(
            addMessage(
              novadata[13],
              msg,
              "Me",
              time,
              novadata[7],
              0,
              "cliente",
              false,
              dia,
              username,
              novadata[19],
              destiny,
              novadata[21] ? novadata[21] : "0",
              novadata[17],
              null,
              null,
              anoenvio,
              dataenvio,
            ),
          );
          let caller = novadata[11];
          caller = caller.replace(/\D+/g, "");
          dispatch(refreshReturnClient(1, caller));
          //dispatch(editAtendimentoClient(novadata[7])); verificar onde esta a função de editar o respclient
          dispatch(typingedit(novadata[7], 0));
        }

        if (novadata[3] === "11") {
          var msg = JSON.parse(novadata[15]);
          const msgArray = Array.isArray(msg) ? msg : [msg];
          // msg = msg.replace(/\\\\n/gi, "\r\n");
          // msg = msg.replace(/~/gi, "");
          msgArray.forEach((singleMsg, index) => {
            dispatch(
              addMessage(
                index === 0 ? novadata[13] : novadata[13] + `v_${index}`,
                JSON.stringify(singleMsg).replace(/"/gi, "'"),
                novadata[3],
                time,
                novadata[7],
                novadata[3],
                "cliente",
                false,
                dia,
                username,
                novadata[19],
                destiny,
                novadata[21] ? novadata[21] : "0",
                novadata[17],
                null,
                null,
                anoenvio,
                dataenvio,
              ),
            );
          });
          let caller = novadata[11];
          caller = caller.replace(/\D+/g, "");
          dispatch(refreshReturnClient(1, caller));
          //dispatch(editAtendimentoClient(novadata[7])); verificar onde esta a função de editar o respclient
          dispatch(typingedit(novadata[7], 0));
        }

        if (novadata[3] === "12") {
          let passjson = JSON.parse(novadata[15]);
          let recipients = [
            {
              type: 0,
              label: passjson.EMAILFROM,
            },
          ];
          if (passjson.EMAILTO !== "") {
            recipients.push({
              type: 1,
              label: passjson.EMAILTO,
            });
          }
          if (passjson.EMAILCC !== "") {
            recipients.push({
              type: 2,
              label: passjson.EMAILCC,
            });
          }
          let AttachmentsFiles = [];
          if (passjson.FILES) {
            AttachmentsFiles = passjson.FILES;
            AttachmentsFiles.map((file) => {
              file.label = file.path;
            });
          }
          const timestamp = passjson.TIMESTAMP; // Seu timestamp aqui
          const data_hora_email =
            Moment.unix(timestamp).format("DD/MM/YYYY HH:mm");
          console.log("2342#%:235", novadata);
          dispatch(
            AddMessageMail(
              "",
              recipients,
              passjson.BODY,
              AttachmentsFiles,
              data_hora_email,
              novadata[7],
              novadata[13],
              false,
              novadata[13],
              passjson.SUBJECT,
              null,
              false,
            ),
          );
          let data = Moment();
          dispatch(
            InsertRegisterNotifier(
              `Email recebido de ${passjson.EMAILFROM},&nbsp;<a>Clique para ver</a>`,
              "mensagememail",
              data,
              `Mensagem recebida`,
              passjson.EMAILFROM,
              "1",
              novadata[13],
              novadata[7],
            ),
          );
        }

        if (novadata[3] === "19") {
          let passjson = {};
          let msg = "";
          if (isJson(novadata[15])) {
            passjson = JSON.parse(novadata[15]);

            if (passjson.RESPONSE === "2") {
              msg = `Ligação de voz permitida até ${Moment(passjson.DATETIME, "YYYY-MM-DD HH:mm:ss").format("DD/MM/YYYY [às] HH:mm:ss")}`;
            } else if (passjson.RESPONSE === "1") {
              msg = "Ligação autorizada de forma permanente";
            } else if (passjson.RESPONSE === "3") {
              msg = "Ligação de voz bloqueada";
            }
          }

          msg = msg.replace(/\\\\n/gi, "\r\n");
          msg = msg.replace(/\\"/gi, "'");
          msg = msg.replace(/"/gi, "'");
          msg = msg.replace(/"/gm, '\\"');

          dispatch(
            addMessage(
              novadata[13],
              msg,
              0,
              time,
              novadata[7],
              0,
              "cliente",
              false,
              dia,
              username,
              novadata[19],
              destiny,
              novadata[21] ? novadata[21] : "0",
              novadata[17],
              null,
              null,
              anoenvio,
              dataenvio,
            ),
          );
          let caller = novadata[11];
          caller = caller.replace(/\D+/g, "");
          dispatch(refreshReturnClient(1, caller));
          //dispatch(editAtendimentoClient(novadata[7])); verificar onde esta a função de editar o respclient
          dispatch(typingedit(novadata[7], 0));
          // console.log("obterCanaisParaExibirEmDetalhes 1", novadata[7]);
          // console.log("obterCanaisParaExibirEmDetalhes 1", atdsimult);
          const obterTelefone = atdsimult.filter(
            (simult) =>
              parseInt(simult.idatendimento) === parseInt(novadata[7]),
          );
          // console.log("obterCanaisParaExibirEmDetalhes 2", obterTelefone)
          if (obterTelefone.length !== 0) {
            // console.log("obterCanaisParaExibirEmDetalhes 3", obterTelefone)
            dispatch(
              obterCanaisParaExibirEmDetalhes(
                obterTelefone[0].telefone,
                novadata[7],
              ),
            );
          }
        }
        // Automatic garbage collection will handle novadata
        // event.data is immutable; no need to manually set it to null
        break;
      case "Received: WSIMSGLOGSTATUS":
        let jsoncheckstatus = JSON.parse(novadata[7]);
        //dispatch(MsgIdReturn(jsoncheckstatus.MSGID,jsoncheckstatus.MSGID, novadata[5],'visto'))
        if (
          jsoncheckstatus.STATUS === "failed" &&
          connection_platform.isStatusOfErrorInSendMessage
        ) {
          dispatch(
            MsgIdReturn2(
              parseInt(jsoncheckstatus.MSGID),
              parseInt(novadata[5]),
              "error",
              jsoncheckstatus.TITLE,
            ),
          );
        } else if (!connection_platform.isStatusOfErrorInSendMessage) {
          dispatch(
            MsgIdReturn2(
              parseInt(jsoncheckstatus.MSGID),
              parseInt(novadata[5]),
              "entregue",
              "entregue",
            ),
          );
        } else {
          dispatch(
            MsgIdReturn2(
              parseInt(jsoncheckstatus.MSGID),
              parseInt(novadata[5]),
              "visto",
              jsoncheckstatus.TITLE,
            ),
          );
        }
        // Automatic garbage collection will handle novadata
        // event.data is immutable; no need to manually set it to null
        break;
      case "Received: WSIMSGLOGREAD":
        const hasMonitoringData =
          Boolean(novadata) && novadata.length >= 12 && isJson(novadata[11]);
        const { monitoring: monitoredAgent } = getState();
        const hasMonitoredAgent =
          Boolean(monitoredAgent) && Boolean(monitoredAgent.userout);
        const isFromMonitoredAgent =
          hasMonitoringData &&
          hasMonitoredAgent &&
          parseInt(JSON.parse(novadata[11]).MONUSER) ===
            parseInt(monitoredAgent.userout);
        if (isFromMonitoredAgent) {
          const cdr = novadata[5];
          dispatch(clearQtdMsgMonitoring(cdr));
        }
        if (
          parseInt(novadata[7]) == -1 &&
          connection_platform.isStatusOfErrorInSendMessage
        ) {
          dispatch(
            MsgIdReturn(
              novadata[9],
              novadata[7],
              novadata[5],
              "error",
              "Error",
            ),
          );
        } else if (parseInt(novadata[7]) > 0) {
          dispatch(
            MsgIdReturn(
              novadata[9],
              novadata[7],
              novadata[5],
              "entregue",
              "entregue",
            ),
          );
        } else if (!connection_platform.isStatusOfErrorInSendMessage) {
          dispatch(
            MsgIdReturn(
              novadata[9],
              novadata[7],
              novadata[5],
              "entregue",
              "entregue",
            ),
          );
        }
        // Automatic garbage collection will handle novadata
        // event.data is immutable; no need to manually set it to null
        break;
      case "Received: GROUPCALLPICKUP":
        let DATAINFO = novadata.indexOf("DATAINFO");
        let passjsongrpck = JSON.parse(novadata[DATAINFO + 1]);
        let cdrgrpck = passjsongrpck.cdr;
        let direcgrpck = passjsongrpck.direction;
        let srvgrpck = passjsongrpck.srv;
        let srvingrpck = passjsongrpck.srvin;
        let attadgrpck = passjsongrpck.attad;
        let callergrpck = passjsongrpck.caller;
        let calledgrpck = passjsongrpck.called;
        let srvinnamegrpck = passjsongrpck.srvinname;
        let contactgrpck = passjsongrpck.contact;
        let datatimegrpck = Moment().format("DD/MM/YYYY HH:mm:ss");
        var datetimeBRgrpck = Moment().format("DD/MM/YYYY HH:mm:ss");
        console.log("INGENIUM_CHECK_ATD_ACW");

        console.log("INGENIUM_SERVICEOUT : ", informationusers);
        axios
          .get(
            `${connection_platform.type_connect}://${pathname}:${port}/conn/insertserviceattendant?idcdr=${cdrgrpck}&iduser=${informationusers.id}&telefone=${callergrpck}&descricao=${direcgrpck}&serviceinid=${srvingrpck}`,
          )
          .then((response) => {
            let retornoatt = response.data.id;
            let queueid = "";
            atendimentoOnCdr[cdrgrpck] = response.data.id;

            listcallqueue.map((queue) => {
              if (parseInt(queue.cdrnew) === parseInt(cdrgrpck)) {
                queueid = queue.queueid;
              }
            });
            dispatch(
              addAtendimento(
                cdrgrpck,
                callergrpck,
                callergrpck,
                srvinnamegrpck,
                datatimegrpck,
                "Não informar",
                "",
                "",
                retornoatt,
                "0",
                datetimeBRgrpck,
                direcgrpck,
                "1",
                timecomplete,
                status.status,
                callergrpck,
                queueid,
                "",
                "",
                "",
                calledgrpck,
                srvinnamegrpck,
                direcgrpck !== 2 ? callergrpck : calledgrpck,
                srvinnamegrpck, //24
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                score_class2,
                score_value2,
              ),
            );
            dispatch(
              addAtdSimult(
                cdrgrpck,
                callergrpck,
                callergrpck,
                srvinnamegrpck,
                datatimegrpck,
                "Não informar",
                "",
                "",
                retornoatt,
                "0",
                datetimeBRgrpck,
                direcgrpck,
                "1",
                timecomplete,
                status.status,
                callergrpck,
                queueid,
                "",
                "",
                "",
                "",
                calledgrpck,
                srvinnamegrpck,
                direcgrpck !== 2 ? callergrpck : calledgrpck,
                srvinnamegrpck,
                "",
                "",
                "",
                "",
                "",
                score_class2,
                score_value2,
              ),
            );
            InteracoesContactNumberPeer(callergrpck, informationusers.idgroup);
            dispatch(UpdateRgBlockReturn(informationusers));
            axios
              .get(
                `${connection_platform.type_connect}://${pathname}:${port}/conn/getcontactstonumber?number=${callergrpck}`,
              )
              .then((response) => {
                if (response.data.length !== 0) {
                  if (response.data !== null) {
                    let arraymenubot = "";

                    if (response.data.displayname !== null) {
                      if (
                        parseInt(response.data.displayname) !==
                        parseInt(callergrpck)
                      ) {
                        let infoname =
                          "Nome Social: " + response.data.displayname;
                        arraymenubot = arraymenubot + infoname + "~¿";
                      }
                    }

                    if (response.data.email !== "") {
                      if (response.data.email !== null) {
                        let infoname = "Email: " + response.data.email;
                        arraymenubot = arraymenubot + infoname + "~¿";
                      }
                    }

                    if (response.data.empresa !== null) {
                      let infoname = "Empresa: " + response.data.empresa;
                      arraymenubot = arraymenubot + infoname + "~¿";
                    }
                    setTimeout(function () {
                      dispatch(
                        EditInfoCli(cdrgrpck, response.data.name, arraymenubot),
                      );
                    }, 500);
                  }
                }
              });
          });
        // Automatic garbage collection will handle novadata
        // event.data is immutable; no need to manually set it to null
        break;
      case "Received: RETURNBOTACK":
        let json = JSON.parse(novadata[5]);
        let cdrid = json.CDR;
        var arraycallhistory = callhistory[cdrid];
        var now2 = Moment().format("YYYY/MM/DD HH:mm:ss");
        var valorDiferenca = parseInt(Math.abs(Math.round(ipcurrent.difftime)));

        // listcallqueue.map(list => {
        //  if(parseInt(novadata[3]) === parseInt(list.cdrnew)){
        //    dispatch(deleteListCallQueue(list.queueid));
        //    axios.get(`${connection_platform.type_connect}://${pathname}:${port}/conn/clearqueue?cdr=${list.cdrid}&queueid=${list.queueid}&novocdr=${list.cdrnew}&usuario=${informationusers.id}&opcao=t&media=${list.mediaid}`)
        //    queueidfila = 0;
        //     socket.send("CALLQUEUE\r\n"+informationusers.id+"\r\nQUEUEID\r\n"+list.queueid+"\r\nCDRID\r\n"+list.cdrid+"\r\nTP\r\nRM\r\nCBACKCOUNT\r\n0\r\nTMCBACK\r\n0\r\nCQUEUE\r\n0\r\nUSERNAME\r\n"+informationusers.username+"\r\nCDRIDNEW\r\n"+list.cdridnew+"\r\n\r\n");
        //  }
        // })

        if (parseInt(ipcurrent.difftime) < 0) {
          now2 = Moment()
            .subtract(valorDiferenca, "seconds")
            .format("YYYY/MM/DD HH:mm:ss");
        } else {
          now2 = Moment()
            .add(valorDiferenca, "seconds")
            .format("YYYY/MM/DD HH:mm:ss");
        }

        if (callhistory.length != 0 && arraycallhistory) {
          let duracaodocall = Moment(now2).diff(
            arraycallhistory[7],
            "seconds",
            true,
          );
          let dataformatada = Moment(
            arraycallhistory[2],
            "DD/MM/YYYY HH:mm:ss",
          ).format("YYYY-MM-DD HH:mm:ss");
          dispatch(
            InterationNotifier(
              "Interação Encerrada com " + arraycallhistory[3],
              "call",
            ),
          );
          dispatch(
            addMessage(
              makeidp(32),
              "IMS9300: Atendimento Encerrado",
              cdrid,
              time,
              cdrid,
              "0",
            ),
          );
          dispatch(removeConversation(cdrid));
          dispatch(
            createStatusAgent(
              "Encerrou",
              arraycallhistory[3],
              Moment().format("DD/MM/YYYY HH:mm:ss"),
            ),
          );
          dispatch(GetAnotations([]));
          dispatch(GetMarkstar([]));
          dispatch(GetHistory([]));
          dispatch(typingadd(novadata[7], 0));
        }
        // Automatic garbage collection will handle novadata
        // event.data is immutable; no need to manually set it to null
        break;
      case "Received: WSIBYE":
        // const { atdsimult, atendimento, messages, listcallqueue, queuepermission, displaynextatd } = getState();
        if (
          localStorage.getItem("url_iframe") !== "" &&
          atdsimult.length === 1
        ) {
          if (atdsimult[0].acw === true || informationusers.tmoutacw === 0) {
            dispatch(ShowVisibleNextAtd(true, true));
          }
        }

        if (novadata[12] === "MONUSER") {
          const { agents } = getState();

          let STRMONUSER = novadata.indexOf("MONUSER");
          let IDUSERMON = novadata[STRMONUSER + 1];

          let userOrigin = agents.find(
            (filt) => parseInt(filt.iduser) === parseInt(IDUSERMON),
          );

          if (
            userOrigin &&
            (userOrigin.status === null ||
              userOrigin.status === "" ||
              (typeof userOrigin.status === "string" &&
                userOrigin.status.trim() === "null"))
          ) {
            UpdateByeAttendantCdr(novadata[5]);
          }

          dispatch(ByeClientMonitoring(novadata[5]));
        } else {
          if (novadata && novadata.length >= 6) {
            dispatch(removeItemFromListQuarentineCallQueueWithCdr(novadata[5]));
          }
          if (!informationusers.blockscreen) {
            if (parseInt(informationusers.tmoutacw) > 0) {
              dispatch(
                tratarAfterCallWorkCDR(
                  informationusers.tmoutacw,
                  parseInt(novadata[5]),
                  false,
                ),
              );
              if (novadata[7] === "IMSCHAT") {
                dispatch(InterationNotifier(novadata[13], "50"));
                dispatch(RemoveAtd(novadata[5]));
                dispatch(removeConversation(novadata[5]));

                if (atdsimult.length > 1) {
                  if (atendimento.direction === "2") {
                    dispatch(
                      createStatusAgent(
                        "Atendimento",
                        "S.(" + atendimento.telefone + ")",
                        Moment().format("DD/MM/YYYY HH:mm:ss"),
                      ),
                    );
                  } else {
                    dispatch(
                      createStatusAgent(
                        "Atendimento",
                        "E.(" + atendimento.telefone + ")",
                        Moment().format("DD/MM/YYYY HH:mm:ss"),
                      ),
                    );
                  }
                } else if (atdsimult.length <= 1) {
                  dispatch(removeAtdUnique());
                  dispatch(
                    createStatusAgent(
                      "Encerrou",
                      novadata[5],
                      Moment().format("DD/MM/YYYY HH:mm:ss"),
                    ),
                  );
                }

                if (
                  atdsimult.length > 1 &&
                  atendimento.idatendimento === novadata[5]
                ) {
                  let i = 0;
                  if (atdsimult[0].idatendimento === atendimento.idatendimento)
                    i = 1;
                  ProximoAtdSimult(
                    atdsimult[i],
                    messages,
                    atendimento,
                    informationusers,
                    dispatch,
                    ipcurrent,
                    atdsimult,
                  );
                  console.log("23j4j235jj235");
                } else if (atdsimult.length > 1) {
                  // if(atendimento.direction === '2' || atendimento.direction === 1){
                  if (atendimento.direction === "2") {
                    dispatch(
                      createStatusAgent(
                        "Atendimento",
                        "S.(" + atendimento.telefone + ")",
                        Moment().format("DD/MM/YYYY HH:mm:ss"),
                      ),
                    );
                  } else {
                    dispatch(
                      createStatusAgent(
                        "Atendimento",
                        "E.(" + atendimento.telefone + ")",
                        Moment().format("DD/MM/YYYY HH:mm:ss"),
                      ),
                    );
                  }
                  let i = 0;
                  if (
                    atdsimult[0].idatendimento === atendimento.idatendimento
                  ) {
                    i = 0;
                  } else {
                    if (novadata[5] === atendimento.idatendimento) {
                      i = 1;
                    }
                    // comentado após o problema, onde a primeira chamada era de whatsapp e receptivo
                    //e o cliente dava # sendo que o operador estava com outra chamada
                    // }else{
                    //  i = 0;
                    // }
                  }
                  //ALTERADO POIS ACHAMOS QUE NÃO PRECISA DESTA LINHA QUANDO O CLIENTE DESCONECTA E NÃO É ELE O ATENDIMENTO ATUAL
                  if (
                    parseInt(novadata[5]) !==
                    parseInt(atdsimult[i].idatendimento)
                  ) {
                    const isCurrentAtt =
                      parseInt(novadata[5]) ===
                      parseInt(atendimento.idatendimento);
                    if (isCurrentAtt) {
                      ProximoAtdSimult(
                        atdsimult[i],
                        messages,
                        atendimento,
                        informationusers,
                        dispatch,
                        ipcurrent,
                        atdsimult,
                      );
                    }
                    console.log("23j4j235jj235");
                  }
                }
              } else {
                if (novadata[9] === "46") {
                  const [numero] = novadata[7].split("@");
                  dispatch(
                    InterationNotifier(numero + " => " + novadata[13], "50"),
                  );
                } else if (novadata[9] === "59") {
                  const [numero] = novadata[7].split("@");
                  dispatch(
                    InterationNotifier(numero + " => " + novadata[13], "50"),
                  );
                }

                if (
                  parseInt(novadata[5]) === parseInt(atendimento.idatendimento)
                ) {
                  dispatch(
                    createStatusAgent(
                      "Aftercallwork",
                      novadata[5],
                      Moment().format("DD/MM/YYYY HH:mm:ss"),
                    ),
                  );
                }
                dispatch(EditAcwContact(novadata[5]));
                if (informationusers.classificationcount > 0) {
                  dispatch(EditIsTabulatorToClassification(novadata[5], false));
                }
              }
            } else {
              var arraycallhistory = callhistory[novadata[5]];

              var now = Moment().format("YYYY/MM/DD HH:mm:ss");
              valorDiferenca = parseInt(
                Math.abs(Math.round(ipcurrent.difftime)),
              );

              if (parseInt(ipcurrent.difftime) < 0) {
                now = Moment()
                  .subtract(valorDiferenca, "seconds")
                  .format("YYYY/MM/DD HH:mm:ss");
              } else {
                now = Moment()
                  .add(valorDiferenca, "seconds")
                  .format("YYYY/MM/DD HH:mm:ss");
              }

              if (novadata[7] === "IMSCHAT") {
                dispatch(InterationNotifier(novadata[13], "50"));

                if (novadata[5] !== undefined && parseInt(novadata[5]) > 0) {
                  UpdateByeAttendantCdr(novadata[5]);
                }

                if (localStorage.getItem("url_iframe") !== "") {
                  atdsimult.map((atd) => {
                    if (interactioningdesk.payload) {
                      if (
                        interactioningdesk.payload.destination === atd.telefone
                      ) {
                        let jsonIngDesk = {
                          origin: "ingweb",
                          id: "interactionFailed",
                          payload: {
                            errorId: 1,
                            errorMessage: novadata[13],
                          },
                        };
                        connectionsapi.iframe_ref.current.contentWindow.postMessage(
                          jsonIngDesk,
                          localStorage.getItem("url_iframe"),
                        );
                      }
                    }
                  });
                }
              }

              if (novadata[9] === "46") {
                const [numero] = novadata[7].split("@");
                dispatch(
                  InterationNotifier(numero + " => " + novadata[13], "50"),
                );
              } else if (novadata[9] === "59") {
                const [numero] = novadata[7].split("@");
                dispatch(
                  InterationNotifier(numero + " => " + novadata[13], "50"),
                );
              }

              if (callhistory.length != 0 && arraycallhistory) {
                let duracaodocall = Moment(now).diff(
                  arraycallhistory[7],
                  "seconds",
                  true,
                );
                let dataformatada = Moment(
                  arraycallhistory[2],
                  "DD/MM/YYYY HH:mm:ss",
                ).format("YYYY-MM-DD HH:mm:ss");

                const arrayAtd = atdsimult.filter(
                  (atd) =>
                    parseInt(atd.idatendimento) === parseInt(novadata[5]),
                );
                if (arrayAtd.length > 0) {
                  UpdateByeAttendant(arrayAtd[0].serviceatd);
                }

                let received = GetInsertCallHistory(
                  novadata[5],
                  informationusers.id,
                );
                received.then(function (result) {
                  axios.get(
                    `${
                      connection_platform.type_connect
                    }://${pathname}:${port}/conn/updatecallhistory?id=${result}&duration=${[
                      1,
                    ]}`,
                  );
                });
                dispatch(
                  InterationNotifier(
                    "Interação Encerrada com " + arraycallhistory[3],
                    "call",
                  ),
                );
                dispatch(
                  addMessage(
                    makeidp(32),
                    "IMS9300: Atendimento Encerrado",
                    novadata[3],
                    time,
                    novadata[5],
                    "0",
                  ),
                );
                dispatch(typingedit(novadata[7], 0));
                dispatch(removeConversation(novadata[5]));
                dispatch(RemoveAtd(novadata[5]));
                if (atdsimult.length <= 1) {
                  dispatch(
                    createStatusAgent(
                      "Encerrou",
                      arraycallhistory[3],
                      Moment().format("DD/MM/YYYY HH:mm:ss"),
                    ),
                  );
                }
                dispatch(GetAnotations([]));
                dispatch(GetMarkstar([]));
                dispatch(GetHistory([]));
                VerifiedReturn(
                  listcallqueue,
                  informationusers,
                  queuepermission,
                  displaynextatd,
                  atendimento,
                  dispatch,
                );
              }
              if (parseInt(novadata[5]) === parseInt(atendimento.idatendimento))
                dispatch(removeAtdUnique());

              dispatch(RemoveAtd(novadata[5]));
              dispatch(removeConversation(novadata[5]));

              listcallqueue.map((list) => {
                if (parseInt(novadata[5]) === parseInt(list.cdrnew)) {
                  RefreshNoAnswer(novadata[5], list.queueid, informationusers);
                  dispatch(RefreshStatusQueue(novadata[5]));
                  dispatch(ActionRefreshNoAnswer(novadata[5]));
                }
              });

              if (status.status === "ChamandoChat") {
                if (atdsimult.length === 1) {
                  dispatch(
                    createStatusAgent(
                      "Encerrou",
                      informationusers.id,
                      Moment().format("DD/MM/YYYY HH:mm:ss"),
                    ),
                  );
                }
              }

              if (
                atdsimult.length > 1 &&
                atendimento.idatendimento === novadata[5]
              ) {
                let i = 0;
                if (atdsimult[0].idatendimento === atendimento.idatendimento)
                  i = 1;
                ProximoAtdSimult(
                  atdsimult[i],
                  messages,
                  atendimento,
                  informationusers,
                  dispatch,
                  ipcurrent,
                  atdsimult,
                );
                console.log("23j4j235jj235");
              } else if (atdsimult.length > 1) {
                // if(atendimento.direction === '2' || atendimento.direction === 1){
                if (atendimento.direction === "2") {
                  dispatch(
                    createStatusAgent(
                      "Atendimento",
                      "S.(" + atendimento.telefone + ")",
                      Moment().format("DD/MM/YYYY HH:mm:ss"),
                    ),
                  );
                } else {
                  dispatch(
                    createStatusAgent(
                      "Atendimento",
                      "E.(" + atendimento.telefone + ")",
                      Moment().format("DD/MM/YYYY HH:mm:ss"),
                    ),
                  );
                }
                let i = 0;
                if (atdsimult[0].idatendimento === atendimento.idatendimento) {
                  i = 0;
                } else {
                  if (novadata[5] === atendimento.idatendimento) {
                    i = 1;
                  }
                  // comentado após o problema, onde a primeira chamada era de whatsapp e receptivo
                  //e o cliente dava # sendo que o operador estava com outra chamada
                  // }else{
                  //  i = 0;
                  // }
                }
                //ALTERADO POIS ACHAMOS QUE NÃO PRECISA DESTA LINHA QUANDO O CLIENTE DESCONECTA E NÃO É ELE O ATENDIMENTO ATUAL
                if (
                  parseInt(novadata[5]) !== parseInt(atdsimult[i].idatendimento)
                ) {
                  const isCurrentAtt =
                    parseInt(novadata[5]) ===
                    parseInt(atendimento.idatendimento);
                  if (isCurrentAtt) {
                    ProximoAtdSimult(
                      atdsimult[i],
                      messages,
                      atendimento,
                      informationusers,
                      dispatch,
                      ipcurrent,
                      atdsimult,
                    );
                  }
                  console.log("23j4j235jj235");
                }
              }
            }
          } else {
            var arraycallhistory = callhistory[novadata[5]];

            if (novadata[7] === "IMSCHAT") {
              if (novadata[5] !== undefined && parseInt(novadata[5]) > 0) {
                UpdateByeAttendantCdr(novadata[5]);
              }

              if (localStorage.getItem("url_iframe") !== "") {
                atdsimult.map((atd) => {
                  if (interactioningdesk.payload) {
                    if (
                      interactioningdesk.payload.destination === atd.telefone
                    ) {
                      let jsonIngDesk = {
                        origin: "ingweb",
                        id: "interactionFailed",
                        payload: {
                          errorId: 1,
                          errorMessage: novadata[13],
                        },
                      };
                      connectionsapi.iframe_ref.current.contentWindow.postMessage(
                        jsonIngDesk,
                        localStorage.getItem("url_iframe"),
                      );
                    }
                  }
                });
              }
            }

            if (callhistory.length != 0 && arraycallhistory) {
              const arrayAtd = atdsimult.filter(
                (atd) => parseInt(atd.idatendimento) === parseInt(novadata[5]),
              );
              if (arrayAtd.length > 0) {
                UpdateByeAttendant(arrayAtd[0].serviceatd);
              }

              let received = GetInsertCallHistory(
                novadata[5],
                informationusers.id,
              );
              received.then(function (result) {
                axios.get(
                  `${
                    connection_platform.type_connect
                  }://${pathname}:${port}/conn/updatecallhistory?id=${result}&duration=${[
                    1,
                  ]}`,
                );
              });

              dispatch(typingedit(novadata[7], 0));
              dispatch(removeConversation(novadata[5]));
              dispatch(RemoveAtd(novadata[5]));
              dispatch(GetAnotations([]));
              dispatch(GetMarkstar([]));
              dispatch(GetHistory([]));
              VerifiedReturn(
                listcallqueue,
                informationusers,
                queuepermission,
                displaynextatd,
                atendimento,
                dispatch,
              );
            }
            if (parseInt(novadata[5]) === parseInt(atendimento.idatendimento))
              dispatch(removeAtdUnique());

            dispatch(RemoveAtd(novadata[5]));
            dispatch(removeConversation(novadata[5]));

            listcallqueue.map((list) => {
              if (parseInt(novadata[5]) === parseInt(list.cdrnew)) {
                RefreshNoAnswer(novadata[5], list.queueid, informationusers);
                dispatch(RefreshStatusQueue(novadata[5]));
                dispatch(ActionRefreshNoAnswer(novadata[5]));
              }
            });

            if (
              atdsimult.length > 1 &&
              atendimento.idatendimento === novadata[5]
            ) {
              let i = 0;
              if (atdsimult[0].idatendimento === atendimento.idatendimento)
                i = 1;
              ProximoAtdSimult(
                atdsimult[i],
                messages,
                atendimento,
                informationusers,
                dispatch,
                ipcurrent,
                atdsimult,
              );
              console.log("23j4j235jj235");
            } else if (atdsimult.length > 1) {
              let i = 0;
              if (atdsimult[0].idatendimento === atendimento.idatendimento) {
                i = 0;
              } else {
                if (novadata[5] === atendimento.idatendimento) {
                  i = 1;
                }
              }

              if (
                parseInt(novadata[5]) !== parseInt(atdsimult[i].idatendimento)
              ) {
                const isCurrentAtt =
                  parseInt(novadata[5]) === parseInt(atendimento.idatendimento);
                if (isCurrentAtt) {
                  ProximoAtdSimult(
                    atdsimult[i],
                    messages,
                    atendimento,
                    informationusers,
                    dispatch,
                    ipcurrent,
                    atdsimult,
                  );
                }
                console.log("23j4j235jj235");
              }
            }
          }
        }
        // Automatic garbage collection will handle novadata
        // event.data is immutable; no need to manually set it to null
        break;
      case "Received: CHATTRANSFERCMPLT":
        var arraycallhistory = callhistory[novadata[3]];
        var hour = Moment().format("YYYY/MM/DD HH:mm:ss");

        const { listQuarentineQueue: standbyQueueInformation } = getState();
        const isThisAttInStandbyQueue =
          !!standbyQueueInformation &&
          !!standbyQueueInformation.list &&
          Array.isArray(standbyQueueInformation.list) &&
          standbyQueueInformation.list.some((standbyItem) => {
            return parseInt(standbyItem.cdrId) === parseInt(novadata[3]);
          });
        if (isThisAttInStandbyQueue) {
          const standbyItem = standbyQueueInformation.list.find(
            (standbyItem) => {
              return parseInt(standbyItem.cdrId) === parseInt(novadata[3]);
            },
          );
          const hasStandbyItem = !!standbyItem;
          if (!!hasStandbyItem) {
            const idAttInTheTransfer = !!standbyItem.contactId
              ? standbyItem.contactId.serviceatd
              : "";
            axios
              .get(
                `${connection_platform.type_connect}://${pathname}:${port}/conn/insertattendantactivity?idatt=${idAttInTheTransfer}&idfunc=18&idsrvin=`,
              )
              .then((response) => {
                const hasErrorInInsertidFunc =
                  !!response && response.status !== 200;
                if (hasErrorInInsertidFunc) {
                  toast.error(
                    "Ocorreu um erro ao inserir o idFunction, tente novamente!",
                  );
                }
              })
              .catch(() => {
                toast.error(
                  "Ocorreu um erro ao inserir o idFunction, tente novamente!",
                );
              });
            axios
              .get(
                `${connection_platform.type_connect}://${pathname}:${port}/conn/updatebyeattreactivate?idatendimento=${idAttInTheTransfer}`,
              )
              .then((response) => {
                const hasErrorInInsertidAtendimento =
                  !!response && response.status !== 200;
                if (hasErrorInInsertidAtendimento) {
                  toast.error(
                    "Ocorreu um erro ao inserir o idAtendimento em updatebyeattreactivate, tente novamente!",
                  );
                }
              })
              .catch(() => {
                toast.error(
                  "Ocorreu um erro ao inserir o idAtendimento em updatebyeattreactivate, tente novamente!",
                );
              });
            dispatch(
              removeItemFromListQuarentineCallQueue(
                "",
                parseInt(novadata[3]),
                parseInt(idAttInTheTransfer),
              ),
            );
          }
        }

        valorDiferenca = parseInt(Math.abs(Math.round(ipcurrent.difftime)));

        listcallqueue.map((list) => {
          if (parseInt(novadata[3]) === parseInt(list.cdrnew)) {
            dispatch(deleteListCallQueue(list.queueid));
            axios.get(
              `${connection_platform.type_connect}://${pathname}:${port}/conn/clearqueue?cdr=${list.cdrid}&queueid=${list.queueid}&novocdr=${list.cdrnew}&usuario=${informationusers.id}&opcao=t&media=${list.mediaid}`,
            );
            queueidfila = 0;
            socket.send(
              "CALLQUEUE\r\n" +
                informationusers.id +
                "\r\nQUEUEID\r\n" +
                list.queueid +
                "\r\nCDRID\r\n" +
                list.cdrid +
                "\r\nTP\r\nRM\r\nCBACKCOUNT\r\n0\r\nTMCBACK\r\n0\r\nCQUEUE\r\n0\r\nUSERNAME\r\n" +
                informationusers.username +
                "\r\nCDRIDNEW\r\n" +
                list.cdridnew +
                "\r\n\r\n",
            );
          }
        });

        if (parseInt(ipcurrent.difftime) < 0) {
          hour = Moment()
            .subtract(valorDiferenca, "seconds")
            .format("YYYY/MM/DD HH:mm:ss");
        } else {
          hour = Moment()
            .add(valorDiferenca, "seconds")
            .format("YYYY/MM/DD HH:mm:ss");
        }

        if (callhistory.length != 0 && arraycallhistory) {
          let duracaodocall = Moment(hour).diff(
            arraycallhistory[7],
            "seconds",
            true,
          );
          let dataformatada = Moment(
            arraycallhistory[2],
            "DD/MM/YYYY HH:mm:ss",
          ).format("YYYY-MM-DD HH:mm:ss");
          dispatch(
            InterationNotifier("Chamada transferida com sucesso", "call"),
          );

          if (parseInt(informationusers.tmoutacw) === 0) {
            let arrayAtd = atdsimult.filter(
              (atd) => parseInt(atd.idatendimento) !== parseInt(novadata[3]),
            );

            if (arrayAtd.length <= 0) {
              dispatch(
                createStatusAgent(
                  "Encerrou",
                  arraycallhistory[3],
                  Moment().format("DD/MM/YYYY HH:mm:ss"),
                ),
              );
            }

            console.log("INGENIUM_TRANSFER_MONITOR : ", novadata[3]);
            dispatch(removeConversation(novadata[3]));
            dispatch(RemoveAtd(novadata[3]));
            dispatch(removeAtdUnique());

            dispatch(
              addMessage(
                makeidp(32),
                "IMS9300: Atendimento Encerrado",
                novadata[5],
                time,
                novadata[3],
                "0",
              ),
            );
            dispatch(typingedit(novadata[7], 0));
          } else {
            console.log("INGENIUM_TRANSFER_MONITOR : ", novadata[3]);
            let atdcurso = atdsimult.filter(
              (atd) => parseInt(atd.idatendimento) === parseInt(novadata[3]),
            );

            console.log("INGENIUM_TRANSFER_MONITOR : ", atdcurso);

            if (atdcurso.length !== 0) {
              atdcurso = atdcurso[0];

              dispatch(EditAcwContact(parseInt(novadata[3])));
              dispatch(
                tratarAfterCallWorkCDR(
                  informationusers.tmoutacw,
                  parseInt(novadata[3]),
                  false,
                ),
              );
              dispatch(
                createStatusAgent(
                  "Aftercallwork",
                  atdcurso.telefone,
                  Moment().format("DD/MM/YYYY HH:mm:ss"),
                ),
              );
            }
          }

          dispatch(GetAnotations([]));
          dispatch(GetMarkstar([]));
          dispatch(GetHistory([]));

          const arrayAtd = atdsimult.filter(
            (atd) => parseInt(atd.idatendimento) === parseInt(novadata[3]),
          );
          if (arrayAtd.length > 0) {
            UpdateByeAttendantNew(arrayAtd[0].serviceatd);
          }

          console.log("INGENIUM_TRANSFER_MONITOR : ");

          let received = GetInsertCallHistory(novadata[3], informationusers.id);
          received.then(function (result) {
            axios.get(
              `${
                connection_platform.type_connect
              }://${pathname}:${port}/conn/updatecallhistory?id=${result}&duration=${[
                1,
              ]}`,
            );
          });

          if (
            atdsimult.length > 1 &&
            atendimento.idatendimento == novadata[5]
          ) {
            console.log("INGENIUM_TRANSFER_MONITOR : ");
            let i = 0;
            if (atdsimult[0].idatendimento == atendimento.idatendimento) i = 1;
            ProximoAtdSimult(
              atdsimult[i],
              messages,
              atendimento,
              informationusers,
              dispatch,
              ipcurrent,
              atdsimult,
            );
            console.log("23j4j235jj235");
          } else if (atdsimult.length > 1) {
            console.log("INGENIUM_TRANSFER_MONITOR : ");
            // if(atendimento.direction === '2' || atendimento.direction === 1){
            if (atendimento.direction === "2") {
              dispatch(
                createStatusAgent(
                  "Atendimento",
                  "S.(" + atendimento.telefone + ")",
                  Moment().format("DD/MM/YYYY HH:mm:ss"),
                ),
              );
            } else {
              dispatch(
                createStatusAgent(
                  "Atendimento",
                  "E.(" + atendimento.telefone + ")",
                  Moment().format("DD/MM/YYYY HH:mm:ss"),
                ),
              );
            }
            let i = 0;
            if (atdsimult[0].idatendimento == atendimento.idatendimento) i = 1;
            ProximoAtdSimult(
              atdsimult[i],
              messages,
              atendimento,
              informationusers,
              dispatch,
              ipcurrent,
              atdsimult,
            );
            console.log("23j4j235jj235");
          }
        }
        // Automatic garbage collection will handle novadata
        // event.data is immutable; no need to manually set it to null
        break;
      case "Received: CALLQUEUE":
        let PROFILEPHOTO = novadata.indexOf("PROFILEPHOTO");
        let REASON = novadata.indexOf("REASON");
        let STRJSON = novadata.indexOf("JSON");
        let score_class = "";
        let score_value = "";

        if (isJson(novadata[STRJSON + 1]) === true) {
          let jsonscore = JSON.parse(novadata[STRJSON + 1]);
          score_class = jsonscore.LASTSCORE.CLASS;
          score_value = jsonscore.LASTSCORE.SCORE;
        }

        if (qtde_fila > 0) {
          if (filaPermissao) {
            filaPermissao.map((queue) => {
              if (parseInt(queue.serviceinid) === parseInt(novadata[23])) {
                //if(novadata[7]=='ADD' && novadata[17]=='1'){
                if (novadata[7] == "ADD") {
                  customerwait = queue.customer_wait;
                  var contactname = novadata[25].split("¿");
                  contactname = contactname[0];
                  if (novadata[17] === "1") {
                    let totalFila = listcallqueue.filter(
                      (queue) => queue.status === "1" || queue.status === 1,
                    );

                    if (currentscreen.screen === "Gestor2") {
                      let groupsDash = groupsrow.filter((filter) =>
                        filtersmanager.filter_manager_grouprow.includes(
                          filter.idgrupofila,
                        ),
                      );
                      let listQueue = [];
                      let listCall = [];

                      for (const group of groupsDash) {
                        let subServices = JSON.parse(group.idsubservico);
                        let servicesChange = subServices.map(
                          (sub) => sub.id_resposta,
                        );

                        listCall.push(...servicesChange);
                      }

                      if (totalFila.length > 0) {
                        listQueue.push(
                          totalFila.filter((call) =>
                            listCall.includes(call.serviceinid),
                          ),
                        );

                        listQueue = listQueue.filter((call) =>
                          filtersmanager.filter_manager_channel.includes(
                            call.mediaid,
                          ),
                        );
                      }
                      const newQueue =
                        listCall.includes(parseInt(novadata[23])) &&
                        filtersmanager.filter_manager_channel.includes(
                          parseInt(novadata[21]),
                        )
                          ? 1
                          : 0;

                      if (newQueue > 0) {
                        totalFila = listQueue.length + newQueue;
                        var text1 = "Existe";
                        var text2 = "chamada";

                        if (totalFila > 1) {
                          text1 = "Existem";
                          text2 = "chamadas";
                        }

                        var texto =
                          text1 + " " + totalFila + " " + text2 + " em fila!";

                        dispatch(InterationNotifier(texto, "call"));
                        if (ipcurrent.audiocall) {
                          var snd = new Audio(connection_platform.audiofila);
                          snd.play();
                        }
                      }
                    } else {
                      totalFila = totalFila.length + 1;
                      var text1 = "Existe";
                      var text2 = "chamada";

                      if (totalFila > 1) {
                        text1 = "Existem";
                        text2 = "chamadas";
                      }

                      var texto =
                        text1 + " " + totalFila + " " + text2 + " em fila!";

                      dispatch(InterationNotifier(texto, "call"));
                      if (ipcurrent.audiocall) {
                        var snd = new Audio(connection_platform.audiofila);
                        snd.play();
                      }
                    }
                  }
                  const dataAtual = Moment(new Date()).format(
                    "DD/MM/YYYY HH:mm:ss",
                  );
                  dispatch(
                    addListCallQueue(
                      novadata[7],
                      novadata[3],
                      parseInt(novadata[23]),
                      novadata[11],
                      novadata[9],
                      dataAtual,
                      // novadata[19],
                      novadata[15],
                      novadata[17],
                      parseInt(novadata[21]),
                      parseInt(novadata[5]),
                      parseInt(novadata[1]),
                      0,
                      customerwait,
                      contactname,
                      novadata[PROFILEPHOTO + 1],
                      score_class,
                      score_value,
                      0,
                    ),
                  );
                }
              }
            });
          }

          if (
            (novadata[7] == "NANS" && novadata[17] == "0") ||
            (novadata[7] == "ADD" && novadata[17] == "0")
          ) {
            dispatch(
              editListCallQueue(
                novadata[7],
                novadata[3],
                parseInt(novadata[23]),
                novadata[11],
                novadata[9],
                novadata[19],
                novadata[15],
                novadata[17],
                parseInt(novadata[21]),
                parseInt(novadata[5]),
                parseInt(novadata[25]),
                customerwait,
                0,
                novadata[PROFILEPHOTO + 1],
                novadata[REASON + 1],
                score_class,
                score_value,
              ),
            );
          } else if (novadata[7] == "CBACK" && novadata[23] == "") {
            dispatch(
              returnListCallQueue(
                novadata[7],
                novadata[3],
                "5",
                parseInt(novadata[19]),
                novadata[17],
                novadata[PROFILEPHOTO + 1],
              ),
            );
          } else if (novadata[7] == "NANS" && novadata[15] == "0") {
            dispatch(
              returnListCallQueueObs(
                novadata[7],
                novadata[3],
                "0",
                novadata[REASON + 1],
              ),
            );
          } else if (novadata[7] == "RM") {
            dispatch(deleteListCallQueue(novadata[3], novadata[17]));
          }
        }
        // Automatic garbage collection will handle novadata
        // event.data is immutable; no need to manually set it to null
        break;
      case "Received: SUP_ACT":
        console.log("INGENIUM_SUP_ACT : ", informationusers);

        if (informationusers.blockfuture) {
          console.log("INGENIUM_SUP_ACT_TRUE : ", informationusers);
          if (document.getElementById("button_future_break"))
            document.getElementById("button_future_break").click();
        }
        if (novadata[7] === "2") {
          let timelogout = Moment().format("DD/MM/YYYY HH:mm:ss") + "-00:00:00";
          let data_hora_atual = Moment().format("YYYY/MM/DD HH:mm:ss");
          let duracaoLoginAtual = Moment(data_hora_atual).diff(
            informationusers.datalogin,
            "seconds",
          );
          let duracaoLoginFinal =
            parseInt(duracaoLoginAtual) + parseInt(informationusers.tmlogin);
          socket.send(
            "REQ\r\n" +
              informationusers.id +
              "\r\nUSERNAME\r\n" +
              informationusers.username +
              "\r\nDISPLAYNAME\r\n" +
              informationusers.displayname +
              "\r\nEXTEN\r\n" +
              informationusers.ramal +
              "\r\nREASON\r\n \r\nSTATUS\r\n \r\nSTATUSID\r\n4\r\nHOUR\r\n" +
              timelogout +
              "\r\nDESCRIPTION\r\n \r\nEMAIL\r\n \r\nGROUP\r\n" +
              informationusers.idgroup +
              "\r\nDTL\r\n" +
              timelogout +
              "\r\nGROUPNAME\r\n" +
              informationusers.grupo +
              "\r\nPSDCOUNT\r\n" +
              parseInt(informationusers.psdcount) +
              "\r\nPSDTMA\r\n" +
              parseInt(informationusers.psdtma) +
              "\r\nMNGGROUP\r\n-1\r\nINCALLCOUNT\r\n" +
              informationusers.incallcount +
              "\r\nINANSCOUNT\r\n" +
              informationusers.inanscount +
              "\r\nINTMANS\r\n" +
              parseInt(informationusers.intmans) +
              "\r\nINSLA\r\n100\r\nOUTCALLCOUNT\r\n" +
              informationusers.outcallcount +
              "\r\nOUTANSCOUNT\r\n" +
              informationusers.outanscount +
              "\r\nOUTTMANS\r\n" +
              informationusers.outtmans +
              "\r\nOUTSLA\r\n100\r\nTMLOGIN\r\n" +
              duracaoLoginFinal +
              "\r\nCOUNTFPAUSE\r\n" +
              parseInt(informationusers.psdfbreak) +
              "\r\nJSON\r\n \r\nFUTUREPAUSE\r\n0\r\nDESCFUTUREPAUSE\r\n \r\nINITIALLOGIN\r\n0\r\n\r\n",
          );

          dispatch(
            createStatusAgent(
              "Deslogue",
              "Deslogue",
              Moment().format("DD/MM/YYYY HH:mm:ss"),
            ),
          );
        }

        if (novadata[7] === "1") {
          dispatch(BlockScreen(true));
          var hourpost = Moment().format("DD/MM/YYYY HH:mm:ss");
          let data_hora_atual = Moment().format("YYYY/MM/DD HH:mm:ss");
          let duracaoLoginAtual = Moment(data_hora_atual).diff(
            informationusers.datalogin,
            "seconds",
          );
          let strPauseFuture = informationusers.blockfuture ? 1 : 0;
          let descPauseFuture = informationusers.blockfuture
            ? descfuturepause
            : " ";
          let duracaoLoginFinal =
            parseInt(duracaoLoginAtual) + parseInt(informationusers.tmlogin);
          socket.send(
            "REQ\r\n" +
              informationusers.id +
              "\r\nUSERNAME\r\n" +
              informationusers.username +
              "\r\nDISPLAYNAME\r\n" +
              informationusers.displayname +
              "\r\nEXTEN\r\n" +
              informationusers.ramal +
              "\r\nREASON\r\nBloqueado pelo Supervisor\r\nSTATUS\r\nBQSUPER\r\nSTATUSID\r\n-1\r\nHOUR\r\n" +
              hourpost +
              "-00:00:00\r\nDESCRIPTION\r\n \r\nEMAIL\r\n \r\nGROUP\r\n" +
              informationusers.idgroup +
              "\r\nGROUPNAME\r\n" +
              informationusers.grupo +
              "\r\nPSDCOUNT\r\n" +
              parseInt(informationusers.psdcount) +
              "\r\nPSDTMA\r\n" +
              parseInt(informationusers.psdtma) +
              "\r\nMNGGROUP\r\n-1\r\nINCALLCOUNT\r\n" +
              parseInt(informationusers.incallcount) +
              "\r\nINANSCOUNT\r\n" +
              parseInt(informationusers.inanscount) +
              "\r\nINTMANS\r\n" +
              parseInt(informationusers.intmans) +
              "\r\nINSLA\r\n100\r\nOUTCALLCOUNT\r\n" +
              parseInt(informationusers.outcallcount) +
              "\r\nOUTANSCOUNT\r\n" +
              parseInt(informationusers.outanscount) +
              "\r\nOUTTMANS\r\n" +
              parseInt(informationusers.outtmans) +
              "\r\nOUTSLA\r\n100\r\nTMLOGIN\r\n" +
              parseInt(duracaoLoginFinal) +
              "\r\nCOUNTFPAUSE\r\n" +
              parseInt(informationusers.psdfbreak) +
              "\r\nFUTUREPAUSE\r\n" +
              strPauseFuture +
              "\r\nDESCFUTUREPAUSE\r\n" +
              descPauseFuture +
              "\r\nINITIALLOGIN\r\n0\r\nMOD\r\n0\r\n\r\n",
          );
          statusAgentIMSDN = "BQSUPER";
          stAgIMSDN = "BQSUPER";
          console.log(
            "INGENIUM_ENVIOSTATUS :",
            new Date().toLocaleString(),
            stAgIMSDN,
          );
          requestStatusAgent =
            "REQ\r\n" +
            informationusers.id +
            "\r\nUSERNAME\r\n" +
            informationusers.username +
            "\r\nDISPLAYNAME\r\n" +
            informationusers.displayname +
            "\r\nEXTEN\r\n" +
            informationusers.ramal +
            "\r\nREASON\r\nBloqueado pelo Supervisor\r\nSTATUS\r\nBQSUPER\r\nSTATUSID\r\n-1\r\nHOUR\r\n" +
            hourpost +
            "-00:00:00\r\nDESCRIPTION\r\n \r\nEMAIL\r\n \r\nGROUP\r\n" +
            informationusers.idgroup +
            "\r\nGROUPNAME\r\n" +
            informationusers.grupo +
            "\r\nPSDCOUNT\r\n" +
            parseInt(informationusers.psdcount) +
            "\r\nPSDTMA\r\n" +
            parseInt(informationusers.psdtma) +
            "\r\nMNGGROUP\r\n-1\r\nINCALLCOUNT\r\n" +
            parseInt(informationusers.incallcount) +
            "\r\nINANSCOUNT\r\n" +
            parseInt(informationusers.inanscount) +
            "\r\nINTMANS\r\n" +
            parseInt(informationusers.intmans) +
            "\r\nINSLA\r\n100\r\nOUTCALLCOUNT\r\n" +
            parseInt(informationusers.outcallcount) +
            "\r\nOUTANSCOUNT\r\n" +
            parseInt(informationusers.outanscount) +
            "\r\nOUTTMANS\r\n" +
            parseInt(informationusers.outtmans) +
            "\r\nOUTSLA\r\n100\r\nTMLOGIN\r\n" +
            parseInt(duracaoLoginFinal) +
            "\r\nCOUNTFPAUSE\r\n" +
            parseInt(informationusers.psdfbreak) +
            "\r\nFUTUREPAUSE\r\n" +
            strPauseFuture +
            "\r\nDESCFUTUREPAUSE\r\n" +
            descPauseFuture +
            "\r\nINITIALLOGIN\r\n0\r\nMOD\r\n0\r\n\r\n";
          clearInterval(statusIntervalAgent);
          envioStatusAgente(14666, informationusers.sipid);

          dispatch(
            createStatusAgent(
              "Pausado",
              "Bloqueado",
              Moment().format("DD/MM/YYYY HH:mm:ss"),
              -1,
            ),
          );
          dispatch(changeBlockStatus());
          axios
            .get(
              `${
                connection_platform.type_connect
              }://${pathname}:${port}/conn/insertblockday?iduser=${
                informationusers.id
              }&reason='${novadata[9]}'&touser=${
                novadata[1]
              }&timeexceed=${0}&exceed=${false}&typeblock=${"1"}`,
            )
            .then((response) => {
              var idreturnblockdescription = response.data.id;

              axios
                .get(
                  `${
                    connection_platform.type_connect
                  }://${pathname}:${port}/conn/insertblockdaysup?iduser=${
                    informationusers.id
                  }&reason='${novadata[9]}'&touser=${
                    novadata[1]
                  }&timeexceed=${0}&exceed=${false}&typeblock=${"1"}`,
                )
                .then((response) => {
                  dispatch(
                    EditBlockUser(
                      idreturnblockdescription,
                      response.data.id,
                      "2",
                      novadata[9],
                    ),
                  );
                })
                .catch((error) => {
                  dispatch(
                    ConnectionsAPI(
                      true,
                      false,
                      true,
                      "Conexão com banco de dados foi perdida :" + error,
                    ),
                  );
                });
            })
            .catch((error) => {
              dispatch(
                ConnectionsAPI(
                  true,
                  false,
                  true,
                  "Conexão com banco de dados foi perdida :" + error,
                ),
              );
            });
          axios.get(
            `${
              connection_platform.type_connect
            }://${pathname}:${port}/conn/insertpausassip?iduser=${
              informationusers.id
            }&sipid=${informationusers.sipid}&status=${"BQ"}`,
          );
        }

        if (novadata[7] === "1001") {
          let post = Moment().format("DD/MM/YYYY HH:mm:ss");

          dispatch(BlockScreen(false));
          let strPauseFuture = 0;
          let descPauseFuture = "";

          let data_hora_atual = Moment().format("YYYY/MM/DD HH:mm:ss");
          let duracaoLoginAtual = Moment(data_hora_atual).diff(
            informationusers.datalogin,
            "seconds",
          );
          let duracaoLoginFinal =
            parseInt(duracaoLoginAtual) + parseInt(informationusers.tmlogin);

          //let InitialLogin = atdsimult.length === 0 ? 0:1
          let InitialLogin = 1;

          // if (atdsimult.length === 0)

          if (atdsimult.length === 0) {
            dispatch(
              createStatusAgent(
                "Encerrou",
                informationusers.id,
                Moment().format("DD/MM/YYYY HH:mm:ss"),
              ),
            );

            socket.send(
              "REQ\r\n" +
                userid +
                "\r\nUSERNAME\r\n" +
                informationusers.username +
                "\r\nDISPLAYNAME\r\n" +
                informationusers.displayname +
                "\r\nEXTEN\r\n" +
                informationusers.ramal +
                "\r\nREASON\r\n \r\nSTATUS\r\nLV\r\nSTATUSID\r\n-1\r\nHOUR\r\n" +
                post +
                "-00:00:00\r\nDESCRIPTION\r\n \r\nEMAIL\r\n \r\nGROUP\r\n" +
                informationusers.idgroup +
                "\r\nDTL\r\n" +
                post +
                "\r\nGROUPNAME\r\n" +
                informationusers.grupo +
                "\r\nPSDCOUNT\r\n" +
                parseInt(informationusers.psdcount) +
                "\r\nPSDTMA\r\n" +
                parseInt(informationusers.psdtma) +
                "\r\nMNGGROUP\r\n-1\r\nINCALLCOUNT\r\n" +
                parseInt(informationusers.incallcount) +
                "\r\nINANSCOUNT\r\n" +
                parseInt(informationusers.inanscount) +
                "\r\nINTMANS\r\n" +
                parseInt(informationusers.intmans) +
                "\r\nINSLA\r\n100\r\nOUTCALLCOUNT\r\n" +
                parseInt(informationusers.outcallcount) +
                "\r\nOUTANSCOUNT\r\n" +
                parseInt(informationusers.outanscount) +
                "\r\nOUTTMANS\r\n" +
                parseInt(informationusers.outtmans) +
                "\r\nOUTSLA\r\n100\r\nTMLOGIN\r\n" +
                parseInt(duracaoLoginFinal) +
                "\r\nCOUNTFPAUSE\r\n" +
                parseInt(informationusers.psdfbreak) +
                "\r\nFUTUREPAUSE\r\n" +
                strPauseFuture +
                "\r\nDESCFUTUREPAUSE\r\n" +
                descPauseFuture +
                "\r\nJSON\r\n \r\nINITIALLOGIN\r\n" +
                InitialLogin +
                "\r\n\r\n",
            );
            statusAgentIMSDN = "LV";
            stAgIMSDN = "LV";
            console.log(
              "INGENIUM_ENVIOSTATUS :",
              new Date().toLocaleString(),
              stAgIMSDN,
            );
            requestStatusAgent =
              "REQ\r\n" +
              userid +
              "\r\nUSERNAME\r\n" +
              informationusers.username +
              "\r\nDISPLAYNAME\r\n" +
              informationusers.displayname +
              "\r\nEXTEN\r\n" +
              informationusers.ramal +
              "\r\nREASON\r\n \r\nSTATUS\r\nLV\r\nSTATUSID\r\n-1\r\nHOUR\r\n" +
              post +
              "-00:00:00\r\nDESCRIPTION\r\n \r\nEMAIL\r\n \r\nGROUP\r\n" +
              informationusers.idgroup +
              "\r\nDTL\r\n" +
              post +
              "\r\nGROUPNAME\r\n" +
              informationusers.grupo +
              "\r\nPSDCOUNT\r\n" +
              parseInt(informationusers.psdcount) +
              "\r\nPSDTMA\r\n" +
              parseInt(informationusers.psdtma) +
              "\r\nMNGGROUP\r\n-1\r\nINCALLCOUNT\r\n" +
              parseInt(informationusers.incallcount) +
              "\r\nINANSCOUNT\r\n" +
              parseInt(informationusers.inanscount) +
              "\r\nINTMANS\r\n" +
              parseInt(informationusers.intmans) +
              "\r\nINSLA\r\n100\r\nOUTCALLCOUNT\r\n" +
              parseInt(informationusers.outcallcount) +
              "\r\nOUTANSCOUNT\r\n" +
              parseInt(informationusers.outanscount) +
              "\r\nOUTTMANS\r\n" +
              parseInt(informationusers.outtmans) +
              "\r\nOUTSLA\r\n100\r\nTMLOGIN\r\n" +
              parseInt(duracaoLoginFinal) +
              "\r\nCOUNTFPAUSE\r\n" +
              parseInt(informationusers.psdfbreak) +
              "\r\nFUTUREPAUSE\r\n" +
              strPauseFuture +
              "\r\nDESCFUTUREPAUSE\r\n" +
              descPauseFuture +
              "\r\nJSON\r\n \r\nINITIALLOGIN\r\n" +
              InitialLogin +
              "\r\n\r\n";
            clearInterval(statusIntervalAgent);
            envioStatusAgente(14891, informationusers.sipid);

            axios.get(
              `${connection_platform.type_connect}://${pathname}:${port}/conn/updateblockuser?idblockdescription=${informationusers.idblockdescription}&idblocksupervision=${informationusers.idblocksupervision}&supreason=${novadata[9]}&supid=${novadata[1]}`,
            );
            axios.get(
              `${
                connection_platform.type_connect
              }://${pathname}:${port}/conn/insertpausassip?iduser=${
                informationusers.id
              }&sipid=${informationusers.sipid}&status=${"LV"}`,
            );
          } else {
            dispatch(
              createStatusAgent(
                "Atendimento",
                "CONSULTA",
                Moment().format("DD/MM/YYYY HH:mm:ss"),
              ),
            );

            if (informationusers.blockfuture) {
              axios
                .get(
                  `${connection_platform.type_connect}://${pathname}:${port}/conn/updatecancelfuturebreak?iduser=${informationusers.id}`,
                )
                .then((response) => {
                  if (response.data === true) {
                    //aqui vou mdnar para o imsdn apenas para alterar a variavel lá para (VER STATUS)

                    console.log("INGENIUM_FUTUREBREAK_CANCEL");
                  }
                });
            }
            let jsonChannelPhoneCall = mountCallsStatus(atdsimult);
            socket.send(
              "REQ\r\n" +
                userid +
                "\r\nUSERNAME\r\n" +
                informationusers.username +
                "\r\nDISPLAYNAME\r\n" +
                informationusers.displayname +
                "\r\nEXTEN\r\n" +
                informationusers.ramal +
                "\r\nREASON\r\n" +
                atendimento.telefone +
                "\r\nSTATUS\r\nAT\r\nSTATUSID\r\n-1\r\nHOUR\r\n" +
                post +
                "-00:00:00\r\nDESCRIPTION\r\n \r\nEMAIL\r\n \r\nGROUP\r\n" +
                informationusers.idgroup +
                "\r\nDTL\r\n" +
                post +
                "\r\nGROUPNAME\r\n" +
                informationusers.grupo +
                "\r\nPSDCOUNT\r\n" +
                parseInt(informationusers.psdcount) +
                "\r\nPSDTMA\r\n" +
                parseInt(informationusers.psdtma) +
                "\r\nMNGGROUP\r\n-1\r\nINCALLCOUNT\r\n" +
                parseInt(informationusers.incallcount) +
                "\r\nINANSCOUNT\r\n" +
                parseInt(informationusers.inanscount) +
                "\r\nINTMANS\r\n" +
                parseInt(informationusers.intmans) +
                "\r\nINSLA\r\n100\r\nOUTCALLCOUNT\r\n" +
                parseInt(informationusers.outcallcount) +
                "\r\nOUTANSCOUNT\r\n" +
                parseInt(informationusers.outanscount) +
                "\r\nOUTTMANS\r\n" +
                parseInt(informationusers.outtmans) +
                "\r\nOUTSLA\r\n100\r\nTMLOGIN\r\n" +
                parseInt(duracaoLoginFinal) +
                "\r\nCOUNTFPAUSE\r\n" +
                parseInt(informationusers.psdfbreak) +
                "\r\nFUTUREPAUSE\r\n" +
                strPauseFuture +
                "\r\nCDRID\r\n" +
                atendimento.idatendimento +
                "\r\nMEDIAID\r\n" +
                atendimento.idmidia +
                "\r\nSRVIN\r\n" +
                atendimento.subservico +
                "\r\nJSON\r\n" +
                jsonChannelPhoneCall +
                "\r\nDESCFUTUREPAUSE\r\n" +
                descPauseFuture +
                "\r\nINITIALLOGIN\r\n" +
                InitialLogin +
                "\r\n\r\n",
            );
            statusAgentIMSDN = "AT";
            stAgIMSDN = "AT";
            console.log(
              "INGENIUM_ENVIOSTATUS :",
              new Date().toLocaleString(),
              stAgIMSDN,
            );
            requestStatusAgent =
              "REQ\r\n" +
              userid +
              "\r\nUSERNAME\r\n" +
              informationusers.username +
              "\r\nDISPLAYNAME\r\n" +
              informationusers.displayname +
              "\r\nEXTEN\r\n" +
              informationusers.ramal +
              "\r\nREASON\r\n \r\nSTATUS\r\nAT\r\nSTATUSID\r\n-1\r\nHOUR\r\n" +
              post +
              "-00:00:00\r\nDESCRIPTION\r\n \r\nEMAIL\r\n \r\nGROUP\r\n" +
              informationusers.idgroup +
              "\r\nDTL\r\n" +
              post +
              "\r\nGROUPNAME\r\n" +
              informationusers.grupo +
              "\r\nPSDCOUNT\r\n" +
              parseInt(informationusers.psdcount) +
              "\r\nPSDTMA\r\n" +
              parseInt(informationusers.psdtma) +
              "\r\nMNGGROUP\r\n-1\r\nINCALLCOUNT\r\n" +
              parseInt(informationusers.incallcount) +
              "\r\nINANSCOUNT\r\n" +
              parseInt(informationusers.inanscount) +
              "\r\nINTMANS\r\n" +
              parseInt(informationusers.intmans) +
              "\r\nINSLA\r\n100\r\nOUTCALLCOUNT\r\n" +
              parseInt(informationusers.outcallcount) +
              "\r\nOUTANSCOUNT\r\n" +
              parseInt(informationusers.outanscount) +
              "\r\nOUTTMANS\r\n" +
              parseInt(informationusers.outtmans) +
              "\r\nOUTSLA\r\n100\r\nTMLOGIN\r\n" +
              parseInt(duracaoLoginFinal) +
              "\r\nCOUNTFPAUSE\r\n" +
              parseInt(informationusers.psdfbreak) +
              "\r\nFUTUREPAUSE\r\n" +
              strPauseFuture +
              "\r\nDESCFUTUREPAUSE\r\n" +
              descPauseFuture +
              "\r\nCDRID\r\n" +
              atendimento.idatendimento +
              "\r\nMEDIAID\r\n" +
              atendimento.idmidia +
              "\r\nSRVIN\r\n" +
              atendimento.subservico +
              "\r\nJSON\r\n" +
              jsonChannelPhoneCall +
              "\r\nDESCFUTUREPAUSE\r\n" +
              descPauseFuture +
              "\r\nINITIALLOGIN\r\n" +
              InitialLogin +
              "\r\n\r\n";
            clearInterval(statusIntervalAgent);
            envioStatusAgente(14891, informationusers.sipid);

            axios.get(
              `${connection_platform.type_connect}://${pathname}:${port}/conn/updateblockuser?idblockdescription=${informationusers.idblockdescription}&idblocksupervision=${informationusers.idblocksupervision}&supreason=${novadata[9]}&supid=${novadata[1]}`,
            );
            axios.get(
              `${
                connection_platform.type_connect
              }://${pathname}:${port}/conn/insertpausassip?iduser=${
                informationusers.id
              }&sipid=${informationusers.sipid}&status=${"AT"}`,
            );
          }
        }
        // Automatic garbage collection will handle novadata
        // event.data is immutable; no need to manually set it to null
        break;
      case "Received: SHUTDOWN":
        dispatch(
          createStatusAgent(
            "Deslogue",
            "Deslogue",
            Moment().format("DD/MM/YYYY HH:mm:ss"),
          ),
        );
        // Automatic garbage collection will handle novadata
        // event.data is immutable; no need to manually set it to null
        break;
      case "Received: WSITYPING":
        dispatch(typingedit(novadata[5], novadata[7]));
        // Automatic garbage collection will handle novadata
        // event.data is immutable; no need to manually set it to null
        break;
      // case 'Received: MSS':

      //  let timefim = "";
      //  valorDiferenca = parseInt(Math.abs(Math.round(ipcurrent.difftime)));
      //  if(parseInt(novadata[39])>0){
      //    let timeIni = Moment().format('YYYY/MM/DD HH:mm:ss');
      //    timeIni = Moment(timeIni).subtract(valorDiferenca,'seconds').format('YYYY/MM/DD HH:mm:ss');
      //    timefim = Moment(timeIni).subtract(parseInt(novadata[39]), 'seconds').format('DD/MM/YYYY HH:mm:ss')
      //  }

      //  dispatch(GetServiceGroup(novadata[1],novadata[3],novadata[5],novadata[7],novadata[9],novadata[11],novadata[13],novadata[15],novadata[17],novadata[19],novadata[21],novadata[23],novadata[25],novadata[27],novadata[29],novadata[31],novadata[33],novadata[35],novadata[37],novadata[39],novadata[41],timefim));
      // break
      case "Received: RTSRV":
        dispatch(changeLoginComplete(true));

        if (novadata[3] !== "") {
          dispatch(GetServiceGroupJson(novadata[3]));
        }
        // Automatic garbage collection will handle novadata
        // event.data is immutable; no need to manually set it to null
        break;
      case "Received: RTCSATNPS":
        dispatch(handleDataCsatNPS(novadata[3]));
        // Automatic garbage collection will handle novadata
        // event.data is immutable; no need to manually set it to null
        break;
      case "Received: RTSTUSERS":
        dispatch(handleDataStatusOperators(JSON.parse(novadata[3])));
        // Automatic garbage collection will handle novadata
        // event.data is immutable; no need to manually set it to null
        break;
      case "Received: RTINTENT":
        dispatch(handleDataIntentions(novadata[3]));
        // Automatic garbage collection will handle novadata
        // event.data is immutable; no need to manually set it to null
        break;
      case "Received: RTPERFORMANCECOMPARE":
        dispatch(handleDataPerfomanceCompare(novadata[3]));
        // Automatic garbage collection will handle novadata
        // event.data is immutable; no need to manually set it to null
        break;

      case "Received: RTPERFORMANCE":
        dispatch(handleDataPerfomance(novadata[3]));
        // Automatic garbage collection will handle novadata
        // event.data is immutable; no need to manually set it to null
        break;
      case "Received: RTGRPQUEUE":
        dispatch(changeGroupsRow(JSON.parse(novadata[3])));
        // Automatic garbage collection will handle novadata
        // event.data is immutable; no need to manually set it to null
        break;
      case "Received: REQSTANDBYACK":
        const hasRightData = novadata.length >= 6;
        if (!hasRightData) {
          toast.error("Ocorreu um erro, tente mais tarde!");
          dispatch(habilitarBotaoAtenderStandby());
          return;
        }
        const infos = novadata[5];
        const hasInfos = !!infos && isJson(infos);
        if (!hasInfos) {
          toast.error("Ocorreu um erro, tente mais tarde!");
          dispatch(habilitarBotaoAtenderStandby());
          return;
        }
        const parsedInfos = JSON.parse(infos);
        const isSuccess = parsedInfos.SUCCESS === 1;
        if (!isSuccess) {
          toast.error("Ocorreu um erro, tente mais tarde!");
          dispatch(habilitarBotaoAtenderStandby());
          return;
        }

        const { informationusers: informationUsersToVerifyIfIsMonitoring } =
          getState();
        const isToMonitoring =
          parsedInfos.MONUSER &&
          parseInt(parsedInfos.MONUSER) !==
            parseInt(informationUsersToVerifyIfIsMonitoring.id);
        if (isToMonitoring) {
          const cdrId = parsedInfos.CDR;
          const isFromStandby =
            parseInt(parsedInfos.ACTION) === 1 ? true : false;
          dispatch(editIsFromStandbyMonitoring(cdrId, isFromStandby));
          dispatch(habilitarBotaoAtenderStandby());
          return;
        }

        const cdrId = parsedInfos.CDR;
        const idAtendimento = parsedInfos.ATDID;
        const standbyId = parsedInfos.STANDBYID;
        const isToInsertInQuarentine = parseInt(parsedInfos.ACTION) === 1;
        const isToRemoveOfQuarentine = parseInt(parsedInfos.ACTION) === 0;

        if (isToInsertInQuarentine) {
          axios
            .get(
              `${connection_platform.type_connect}://${pathname}:${port}/conn/insertattendantactivity?idatt=${idAtendimento}&idfunc=17&idsrvin=`,
            )
            .then((response) => {
              const hasErrorInInsertidFunc =
                !!response && response.status !== 200;
              if (hasErrorInInsertidFunc) {
                toast.error(
                  "Ocorreu um erro ao inserir o idFunction, tente novamente!",
                );
              }
            })
            .catch(() => {
              toast.error(
                "Ocorreu um erro ao inserir o idFunction, tente novamente!",
              );
            });

          const {
            informationusers: InfoUsers,
            atdsimult: AtdSimult,
            messages: Messages,
            ipcurrent: IPCurrent,
            infosToSendToQuarentine,
          } = getState();

          const ContactId = infosToSendToQuarentine.find((atd) => {
            return (
              parseInt(cdrId) === parseInt(atd.idatendimento) &&
              parseInt(idAtendimento) === parseInt(atd.serviceatd)
            );
          });
          const hasContactId = !!ContactId;
          const contactName = hasContactId ? ContactId.cliente : "";
          const hasScoreValue =
            hasContactId &&
            (!!ContactId.score_value || ContactId.score_value === 0);
          const scoreValue = hasScoreValue ? ContactId.score_value : "";
          const hasScoreClass =
            hasContactId &&
            (!!ContactId.score_class || ContactId.score_class === 0);
          const scoreClass = hasScoreClass ? ContactId.score_class : "";
          const dateTime = hasContactId ? ContactId.datatimeatd : "";
          const phoneNumber = hasContactId ? ContactId.telefone : "";
          const midiaId = hasContactId ? ContactId.idmidia : "";

          const hasMoreThanOneAtd = AtdSimult.length > 1;
          if (hasMoreThanOneAtd) {
            let i = 0;
            if (AtdSimult[0].idatendimento == ContactId.idatendimento) i = 1;
            dispatch(CloseAttendant(ContactId, InfoUsers, "quarentine"));
            ProximoAtdSimult(
              AtdSimult[i],
              Messages,
              ContactId,
              InfoUsers,
              dispatch,
              IPCurrent,
              AtdSimult,
            );
            console.log("23j4j235jj235");
          } else {
            dispatch(CloseAttendant(ContactId, InfoUsers, "quarentine"));
          }

          dispatch(
            addListQuarentineCallQueue(
              standbyId,
              cdrId,
              idAtendimento,
              contactName,
              scoreValue,
              scoreClass,
              Moment().format("DD/MM/YYYY HH:mm:ss"),
              phoneNumber,
              midiaId,
              ContactId,
              0,
            ),
          );
          dispatch(removeContactIdsToQuarentine(ContactId));
        }

        if (isToRemoveOfQuarentine) {
          const {
            informationusers: InfoUsers,
            atdsimult: AtdSimult,
            messages: Messages,
            ipcurrent: IPCurrent,
            infosToSendToQuarentine,
          } = getState();
          const ContactId = infosToSendToQuarentine.find((atd) => {
            return (
              parseInt(cdrId) === parseInt(atd.idatendimento) &&
              parseInt(idAtendimento) === parseInt(atd.serviceatd)
            );
          });
          axios
            .get(
              `${connection_platform.type_connect}://${pathname}:${port}/conn/insertattendantactivity?idatt=${idAtendimento}&idfunc=18&idsrvin=`,
            )
            .then((response) => {
              const hasErrorInInsertidFunc =
                !!response && response.status !== 200;
              if (hasErrorInInsertidFunc) {
                toast.error(
                  "Ocorreu um erro ao inserir o idFunction, tente novamente!",
                );
              }
            })
            .catch(() => {
              toast.error(
                "Ocorreu um erro ao inserir o idFunction, tente novamente!",
              );
            });
          //adicionando updatebyeattreactivate
          axios
            .get(
              `${connection_platform.type_connect}://${pathname}:${port}/conn/updatebyeattreactivate?idatendimento=${idAtendimento}`,
            )
            .then((response) => {
              const hasErrorInInsertidAtendimento =
                !!response && response.status !== 200;
              if (hasErrorInInsertidAtendimento) {
                toast.error(
                  "Ocorreu um erro ao inserir o idAtendimento em updatebyeattreactivate, tente novamente!",
                );
              }
            })
            .catch(() => {
              toast.error(
                "Ocorreu um erro ao inserir o idAtendimento em updatebyeattreactivate, tente novamente!",
              );
            });
          //insertatdrv?sipid=${sipid}&iduser=${iduser}
          // InsertPausaRV(InfoUsers.sipid, InfoUsers.id, dispatch);
          dispatch(InsertPausaRVV2(InfoUsers.sipid, InfoUsers.id));
          dispatch(
            getCallFromQuarentineV2(ContactId, InfoUsers, {
              dateTime: Moment().format("DD/MM/YYYY HH:mm:ss"),
            }),
          );
          dispatch(
            removeItemFromListQuarentineCallQueue(
              standbyId,
              cdrId,
              idAtendimento,
            ),
          );
          socket.send(
            "WSIMSGLOGREAD\r\n" +
              InfoUsers.id +
              "\r\nCALLID\r\nXXXXXXXXXXXXXXXXXXX\r\nTOUSER\r\n" +
              novadata[1] +
              "\r\nTOCLIENT\r\n" +
              cdrId +
              "\r\nMSGID\r\n-1\r\nRESULT\r\n" +
              `{'CDRID':${cdrId}}` +
              "\r\n\r\n",
          );
          dispatch(removeContactIdsToQuarentine(ContactId));
          //inserir lógica para alterar menuBot
          try {
            const telefone = Boolean(ContactId) ? ContactId.telefone : "";
            const scripttrunk = Boolean(ContactId) && ContactId.serverid;
            const direction = Boolean(ContactId) && ContactId.direction;
            dispatch(
              obterDadosAdicionaisParaExibirEmDetalhes(
                telefone,
                cdrId,
                scripttrunk,
                direction,
              ),
            );
          } catch (error) {
            console.log("REQSTANDBYACK ADD INFO ERROR: ", error);
          }
        }

        dispatch(habilitarBotaoAtenderStandby());

        break;
      default:
        // Automatic garbage collection will handle novadata
        // event.data is immutable; no need to manually set it to null
        break;
    }
  };
  async function updateUnreadedMessagesStandBy(listQuarentineQueue) {
    const hasListQuarentineQueue =
      !!listQuarentineQueue &&
      !!listQuarentineQueue.list &&
      Array.isArray(listQuarentineQueue.list) &&
      listQuarentineQueue.list.length > 0;
    if (hasListQuarentineQueue) {
      for (const standByCall of listQuarentineQueue.list) {
        const cdrId = standByCall.cdrId;
        let retries = 0;
        const maxRetries = 500;
        let isToTryAgain = true;
        while (isToTryAgain === true && retries < maxRetries) {
          const response = await getNumberOfUnreadedMessages(cdrId);
          const hasData =
            !!response &&
            Array.isArray(response.data) &&
            response.data.length > 0;
          if (hasData) {
            const qtd = parseInt(response.data[0].count)
              ? parseInt(response.data[0].count)
              : 0;
            dispatch(changeNumberOfUnreadedMessagesOfAnItem(cdrId, qtd));
            isToTryAgain = false;
          } else {
            retries++;
            if (retries < maxRetries) {
              await new Promise((resolve) => setTimeout(resolve, 1000)); // Wait 1 second before retrying
            } else {
              console.warn(`Max retries reached for cdrId: ${cdrId}`);
              isToTryAgain = false;
            }
          }
        }
      }
    }
  }
  function start() {
    console.log("💥💥 Chegou no start. Forçando reconexão... INGENIUMPING");
    console.log("INGENIUM_ENVIOSTATUS_RECONNECT : ", stAgIMSDN);

    let post = Moment().format("DD/MM/YYYY HH:mm:ss");

    var valorDiferenca = parseInt(Math.abs(Math.round(ipcurrent.difftime)));

    if (parseInt(ipcurrent.difftime) < 0) {
      post = Moment()
        .subtract(valorDiferenca, "seconds")
        .format("DD/MM/YYYY HH:mm:ss");
    } else {
      post = Moment()
        .add(valorDiferenca, "seconds")
        .format("DD/MM/YYYY HH:mm:ss");
    }

    // tela de reconexão aparece
    // const { isReconnectModalActive } = getState();
    // if (!isReconnectModalActive) {
    //   dispatch(setIsReconnectModalActive(true));
    // }
    reconnectionHandler.startReconnection(getState);
    dispatch(UpdateUserLoginResponse(false));
    noReadHandler.clearIsLoaded();

    const { atdsimult: atendimentosSimultaneos } = getState();
    if (Array.isArray(atendimentosSimultaneos)) {
      atendimentosSimultaneos.forEach((atendimento) => {
        dispatch(removeConversation(parseInt(atendimento.idatendimento)));
      });
    }
    dispatch(ClearAtdSimult());
    dispatch(ClearAtd());
    dispatch(ClearQuarentine());
    // dispatch(ClearMessageALL());
    // const blockscreen =
    //   getState().informationusers && getState().informationusers.blockscreen;
    // dispatch(
    //   createStatusAgent(
    //     blockscreen ? "Pausado" : "Livre",
    //     blockscreen ? "Pausado" : "Livre",
    //     Moment().format("DD/MM/YYYY HH:mm:ss"),
    //     -2,
    //   ),
    // );

    socket.onopen = (event) => {
      const { listQuarentineQueue } = getState();
      updateUnreadedMessagesStandBy(listQuarentineQueue);
      //2024-07-09
      dispatch(ConnectionsAPI(true, true, true, ""));
      dispatch(ListCallQueue(informationusers.id));
      socket.send(
        "REGISTER\r\n" +
          userid +
          "\r\nTYPE\r\n" +
          perfilUser +
          "\r\nCPARK\r\n" +
          acessoFila +
          "\r\nGRP\r\n" +
          stringGrupoFila +
          "&\r\nSUBSRV\r\n" +
          stringSubMonitoria +
          "&\r\nMOD\r\n0\r\nRECONN\r\n0\r\n\r\n",
      );
      console.log(
        "INGENIUM_ENVIOSTATUS_RECONNECT :",
        new Date().toLocaleString(),
        stAgIMSDN,
      );

      if (stAgIMSDN != null && stAgIMSDN !== undefined && stAgIMSDN !== "") {
        axios.get(
          `${connection_platform.type_connect}://${pathname}:${port}/conn/reconnectssip?iduser=${informationusers.id}&sipid=${informationusers.sipid}&status=${stAgIMSDN}`,
        );
      }

      let data_hora_atual = Moment().format("YYYY/MM/DD HH:mm:ss");
      let duracaoLoginAtual = Moment(data_hora_atual).diff(
        informationusers.datalogin,
        "seconds",
      );
      let duracaoLoginFinal =
        parseInt(duracaoLoginAtual) + parseInt(informationusers.tmlogin);

      setTimeout(() => {
        socket.send(requestStatusAgent);
      }, 500);

      let requestStatusAgentStart = requestStatusAgent.replace(
        /INITIALLOGIN\r\n0\r\n/,
        "INITIALLOGIN\r\n1\r\n",
      );

      requestStatusAgentStart = requestStatusAgentStart.replace(
        /STATUS\r\n(?:AT|BQ|RV)\r\n/,
        "STATUS\r\nLV\r\n",
      );

      console.log("INGENIUM_INITIALLOGIN : ", requestStatusAgentStart);

      setTimeout(() => {
        socket.send(requestStatusAgentStart);
      }, 1000);

      clearInterval(statusIntervalAgent);
      envioStatusAgente(15144, informationusers.sipid);

      socket.send("REQAGENTSTATUS\r\n" + userid + "\r\n\r\n");
    };
  }

  function checkAtdCurso(cdrrecebido) {
    const { atdsimult } = getState();
    let checkatdsimult = false;
    atdsimult.map((atd) => {
      if (
        parseInt(atd.idatendimento) === parseInt(cdrrecebido) &&
        parseInt(atd.direction) > 0 &&
        atd.acw !== true
      ) {
        checkatdsimult = true;
      }
      if (
        parseInt(atd.idatendimento) === parseInt(cdrrecebido) &&
        atd.acw === true
      )
        dispatch(EditAcwContactDisabled(cdrrecebido));
    });

    if (checkatdsimult === true) return true;
    else return false;
  }

  socket.onclose = function (evt) {
    //socket.close();
    start();

    //2024-07-09
    if (connection_platform.alertimsdnout) {
      dispatch(ConnectionsAPI(false, true, true, ""));
    } else {
      console.log("A conexão com IMSDN foi perdida  Aguardando...");
    }
  };

  socket.onerror = function (evt) {
    console.log("INGENIUM_IMSDN_ONERROR : ", evt);
    console.log("Error!");
  };

  return socket;
};

export default setupSocket;
